var W4 = Object.defineProperty;
var V4 = (r, a, n) => a in r ? W4(r, a, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[a] = n;
var Xe = (r, a, n) => V4(r, typeof a != "symbol" ? a + "" : a, n);
var Pe = /* @__PURE__ */ ((r) => (r.BOOKING_NAME = "booking-name", r.VIEWER_DATE = "viewer-date", r.VIEWER_FULL = "viewer-full", r.VIEWER_NAME = "viewer-name", r.VIEWER_STAGING = "viewer-staging", r))(Pe || {}), vn = /* @__PURE__ */ ((r) => (r.CONTAIN = "contain", r.COVER = "cover", r))(vn || {}), tt = /* @__PURE__ */ ((r) => (r.RED = "Red", r.BLUE = "Blue", r.GREEN = "Green", r.YELLOW = "Yellow", r.ORANGE = "Orange", r.PINK = "Pink", r.WHITE = "White", r.BLACK = "Black", r.PURPLE = "Purple", r.RED_FLUO = "Fluored", r.BLUE_FLUO = "Fluoblue", r.GREEN_FLUO = "Fluogreen", r.YELLOW_FLUO = "Fluoyellow", r.PINK_FLUO = "Fluopink", r.WHITE_FLUO = "Fluowhite", r.PURPLE_FLUO = "Fluopurple", r.BLACK_WHITE = "Black-White", r.BLACK_BLUE = "Black-Blue", r.BLACK_YELLOW = "Black-Yellow", r.BLACK_GREY = "Black-Grey", r.BLACK_RED = "Black-Red", r.BLACK_GREEN = "Black-Green", r.BLACK_PURPLE = "Black-Purple", r.GREY = "Grey", r.CYAN = "Cyan", r.BROWN = "Brown", r.LIME = "Lime", r))(tt || {});
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.WHITE, tt.BLACK, tt.PURPLE, tt.RED_FLUO, tt.BLUE_FLUO, tt.GREEN_FLUO, tt.YELLOW_FLUO, tt.PINK_FLUO, tt.WHITE_FLUO, tt.PURPLE_FLUO, tt.BLACK_WHITE, tt.BLACK_BLUE, tt.BLACK_YELLOW, tt.BLACK_GREY, tt.BLACK_RED, tt.BLACK_GREEN, // Color.BLACK_PINK,
tt.BLACK_PURPLE;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.WHITE, tt.BLACK, tt.PURPLE;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK;
// Color.WHITE,
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.GREY, tt.CYAN, tt.BROWN, tt.LIME;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.GREY, tt.CYAN, tt.BROWN, tt.LIME, tt.WHITE, tt.BLACK, tt.PURPLE, tt.WHITE_FLUO, tt.RED_FLUO, tt.BLUE_FLUO, tt.GREEN_FLUO, tt.YELLOW_FLUO, tt.PURPLE_FLUO, tt.BLACK_WHITE, tt.BLACK_RED, tt.BLACK_BLUE, tt.BLACK_GREEN, tt.BLACK_YELLOW, tt.BLACK_PURPLE, tt.BLACK_GREY;
var ge = /* @__PURE__ */ ((r) => (r.FOOTBOARD = "footboard", r.LINE = "line", r.LABEL = "label", r.CUSTOM = "custom", r.BENCH = "bench", r.CAR = "car", r.CHIRINGUITO = "chiringuito", r.RECEPTION = "reception", r.DESK = "desk", r.BEACH_VOLLEY = "beach-volley", r.BASKET_FIELD = "basket-field", r.COURT = "court", r.SOCCER_FIELD = "soccer-field", r.LIFEBELT = "lifebelt", r.GYM_BARBELL = "gym-barbell", r.GYM_EXERCISE = "gym-exercise", r.GYM_TREADMILL = "gym-treadmill", r.PALM = "palm", r.PLAYGROUND = "playground", r.POOL = "pool", r.POOL_ROUNDED = "pool-rounded", r.SHOWER = "shower", r.ROWBOAT = "rowboat", r.TENT = "tent", r.TENT_BIG = "tent-big", r.TREE = "tree", r.TREE1 = "tree1", r))(ge || {}), Ar = /* @__PURE__ */ ((r) => (r.UMBRELLA = "umbrella", r.GAZEBO = "gazebo", r.PARKING = "parking", r.BED = "bed", r.BEDS = "beds", r.CABIN = "cabins", r.BOAT = "boat", r.PLAYFIELD = "playfield", r))(Ar || {});
function Br(r, a) {
  throw new Error(
    `Unhandled discriminated union member: ${JSON.stringify(r)}`
  );
}
var Si = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, ga = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
ga.exports;
(function(r, a) {
  (function() {
    var n, o = "4.17.21", c = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", h = "Expected a function", l = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", p = 500, b = "__lodash_placeholder__", w = 1, x = 2, v = 4, _ = 1, S = 2, C = 1, F = 2, d = 4, f = 8, m = 16, E = 32, T = 64, D = 128, I = 256, L = 512, O = 30, N = "...", H = 800, y = 16, P = 1, A = 2, G = 3, U = 1 / 0, K = 9007199254740991, $ = 17976931348623157e292, X = NaN, Q = 4294967295, st = Q - 1, Z = Q >>> 1, at = [
      ["ary", D],
      ["bind", C],
      ["bindKey", F],
      ["curry", f],
      ["curryRight", m],
      ["flip", L],
      ["partial", E],
      ["partialRight", T],
      ["rearg", I]
    ], ht = "[object Arguments]", ct = "[object Array]", W = "[object AsyncFunction]", j = "[object Boolean]", et = "[object Date]", ut = "[object DOMException]", ft = "[object Error]", gt = "[object Function]", Lt = "[object GeneratorFunction]", Et = "[object Map]", mt = "[object Number]", ee = "[object Null]", Pt = "[object Object]", Wt = "[object Promise]", pr = "[object Proxy]", re = "[object RegExp]", Zt = "[object Set]", Jt = "[object String]", Ut = "[object Symbol]", He = "[object Undefined]", ie = "[object WeakMap]", We = "[object WeakSet]", zt = "[object ArrayBuffer]", ne = "[object DataView]", Fe = "[object Float32Array]", pe = "[object Float64Array]", Ze = "[object Int8Array]", Ra = "[object Int16Array]", Ve = "[object Int32Array]", Oe = "[object Uint8Array]", Je = "[object Uint8ClampedArray]", si = "[object Uint16Array]", Ta = "[object Uint32Array]", u1 = /\b__p \+= '';/g, c1 = /\b(__p \+=) '' \+/g, d1 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, el = /&(?:amp|lt|gt|quot|#39);/g, rl = /[&<>"']/g, f1 = RegExp(el.source), g1 = RegExp(rl.source), p1 = /<%-([\s\S]+?)%>/g, _1 = /<%([\s\S]+?)%>/g, il = /<%=([\s\S]+?)%>/g, v1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, y1 = /^\w*$/, m1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Pa = /[\\^$.*+?()[\]{}|]/g, b1 = RegExp(Pa.source), Fa = /^\s+/, w1 = /\s/, S1 = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, C1 = /\{\n\/\* \[wrapped with (.+)\] \*/, x1 = /,? & /, E1 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, A1 = /[()=,{}\[\]\/\s]/, R1 = /\\(\\)?/g, T1 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, nl = /\w*$/, P1 = /^[-+]0x[0-9a-f]+$/i, F1 = /^0b[01]+$/i, O1 = /^\[object .+?Constructor\]$/, k1 = /^0o[0-7]+$/i, I1 = /^(?:0|[1-9]\d*)$/, L1 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Sn = /($^)/, M1 = /['\n\r\u2028\u2029\\]/g, Cn = "\\ud800-\\udfff", N1 = "\\u0300-\\u036f", G1 = "\\ufe20-\\ufe2f", D1 = "\\u20d0-\\u20ff", al = N1 + G1 + D1, sl = "\\u2700-\\u27bf", ol = "a-z\\xdf-\\xf6\\xf8-\\xff", B1 = "\\xac\\xb1\\xd7\\xf7", U1 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", q1 = "\\u2000-\\u206f", H1 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", hl = "A-Z\\xc0-\\xd6\\xd8-\\xde", ll = "\\ufe0e\\ufe0f", ul = B1 + U1 + q1 + H1, Oa = "['’]", W1 = "[" + Cn + "]", cl = "[" + ul + "]", xn = "[" + al + "]", dl = "\\d+", V1 = "[" + sl + "]", fl = "[" + ol + "]", gl = "[^" + Cn + ul + dl + sl + ol + hl + "]", ka = "\\ud83c[\\udffb-\\udfff]", z1 = "(?:" + xn + "|" + ka + ")", pl = "[^" + Cn + "]", Ia = "(?:\\ud83c[\\udde6-\\uddff]){2}", La = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ur = "[" + hl + "]", _l = "\\u200d", vl = "(?:" + fl + "|" + gl + ")", j1 = "(?:" + Ur + "|" + gl + ")", yl = "(?:" + Oa + "(?:d|ll|m|re|s|t|ve))?", ml = "(?:" + Oa + "(?:D|LL|M|RE|S|T|VE))?", bl = z1 + "?", wl = "[" + ll + "]?", K1 = "(?:" + _l + "(?:" + [pl, Ia, La].join("|") + ")" + wl + bl + ")*", Y1 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", X1 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Sl = wl + bl + K1, $1 = "(?:" + [V1, Ia, La].join("|") + ")" + Sl, Z1 = "(?:" + [pl + xn + "?", xn, Ia, La, W1].join("|") + ")", J1 = RegExp(Oa, "g"), Q1 = RegExp(xn, "g"), Ma = RegExp(ka + "(?=" + ka + ")|" + Z1 + Sl, "g"), tg = RegExp([
      Ur + "?" + fl + "+" + yl + "(?=" + [cl, Ur, "$"].join("|") + ")",
      j1 + "+" + ml + "(?=" + [cl, Ur + vl, "$"].join("|") + ")",
      Ur + "?" + vl + "+" + yl,
      Ur + "+" + ml,
      X1,
      Y1,
      dl,
      $1
    ].join("|"), "g"), eg = RegExp("[" + _l + Cn + al + ll + "]"), rg = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ig = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], ng = -1, qt = {};
    qt[Fe] = qt[pe] = qt[Ze] = qt[Ra] = qt[Ve] = qt[Oe] = qt[Je] = qt[si] = qt[Ta] = !0, qt[ht] = qt[ct] = qt[zt] = qt[j] = qt[ne] = qt[et] = qt[ft] = qt[gt] = qt[Et] = qt[mt] = qt[Pt] = qt[re] = qt[Zt] = qt[Jt] = qt[ie] = !1;
    var Bt = {};
    Bt[ht] = Bt[ct] = Bt[zt] = Bt[ne] = Bt[j] = Bt[et] = Bt[Fe] = Bt[pe] = Bt[Ze] = Bt[Ra] = Bt[Ve] = Bt[Et] = Bt[mt] = Bt[Pt] = Bt[re] = Bt[Zt] = Bt[Jt] = Bt[Ut] = Bt[Oe] = Bt[Je] = Bt[si] = Bt[Ta] = !0, Bt[ft] = Bt[gt] = Bt[ie] = !1;
    var ag = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, sg = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, og = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, hg = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, lg = parseFloat, ug = parseInt, Cl = typeof Si == "object" && Si && Si.Object === Object && Si, cg = typeof self == "object" && self && self.Object === Object && self, oe = Cl || cg || Function("return this")(), Na = a && !a.nodeType && a, Rr = Na && !0 && r && !r.nodeType && r, xl = Rr && Rr.exports === Na, Ga = xl && Cl.process, ke = function() {
      try {
        var V = Rr && Rr.require && Rr.require("util").types;
        return V || Ga && Ga.binding && Ga.binding("util");
      } catch {
      }
    }(), El = ke && ke.isArrayBuffer, Al = ke && ke.isDate, Rl = ke && ke.isMap, Tl = ke && ke.isRegExp, Pl = ke && ke.isSet, Fl = ke && ke.isTypedArray;
    function Ce(V, J, Y) {
      switch (Y.length) {
        case 0:
          return V.call(J);
        case 1:
          return V.call(J, Y[0]);
        case 2:
          return V.call(J, Y[0], Y[1]);
        case 3:
          return V.call(J, Y[0], Y[1], Y[2]);
      }
      return V.apply(J, Y);
    }
    function dg(V, J, Y, lt) {
      for (var bt = -1, Mt = V == null ? 0 : V.length; ++bt < Mt; ) {
        var Qt = V[bt];
        J(lt, Qt, Y(Qt), V);
      }
      return lt;
    }
    function Ie(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length; ++Y < lt && J(V[Y], Y, V) !== !1; )
        ;
      return V;
    }
    function fg(V, J) {
      for (var Y = V == null ? 0 : V.length; Y-- && J(V[Y], Y, V) !== !1; )
        ;
      return V;
    }
    function Ol(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length; ++Y < lt; )
        if (!J(V[Y], Y, V))
          return !1;
      return !0;
    }
    function _r(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length, bt = 0, Mt = []; ++Y < lt; ) {
        var Qt = V[Y];
        J(Qt, Y, V) && (Mt[bt++] = Qt);
      }
      return Mt;
    }
    function En(V, J) {
      var Y = V == null ? 0 : V.length;
      return !!Y && qr(V, J, 0) > -1;
    }
    function Da(V, J, Y) {
      for (var lt = -1, bt = V == null ? 0 : V.length; ++lt < bt; )
        if (Y(J, V[lt]))
          return !0;
      return !1;
    }
    function Ht(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length, bt = Array(lt); ++Y < lt; )
        bt[Y] = J(V[Y], Y, V);
      return bt;
    }
    function vr(V, J) {
      for (var Y = -1, lt = J.length, bt = V.length; ++Y < lt; )
        V[bt + Y] = J[Y];
      return V;
    }
    function Ba(V, J, Y, lt) {
      var bt = -1, Mt = V == null ? 0 : V.length;
      for (lt && Mt && (Y = V[++bt]); ++bt < Mt; )
        Y = J(Y, V[bt], bt, V);
      return Y;
    }
    function gg(V, J, Y, lt) {
      var bt = V == null ? 0 : V.length;
      for (lt && bt && (Y = V[--bt]); bt--; )
        Y = J(Y, V[bt], bt, V);
      return Y;
    }
    function Ua(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length; ++Y < lt; )
        if (J(V[Y], Y, V))
          return !0;
      return !1;
    }
    var pg = qa("length");
    function _g(V) {
      return V.split("");
    }
    function vg(V) {
      return V.match(E1) || [];
    }
    function kl(V, J, Y) {
      var lt;
      return Y(V, function(bt, Mt, Qt) {
        if (J(bt, Mt, Qt))
          return lt = Mt, !1;
      }), lt;
    }
    function An(V, J, Y, lt) {
      for (var bt = V.length, Mt = Y + (lt ? 1 : -1); lt ? Mt-- : ++Mt < bt; )
        if (J(V[Mt], Mt, V))
          return Mt;
      return -1;
    }
    function qr(V, J, Y) {
      return J === J ? Pg(V, J, Y) : An(V, Il, Y);
    }
    function yg(V, J, Y, lt) {
      for (var bt = Y - 1, Mt = V.length; ++bt < Mt; )
        if (lt(V[bt], J))
          return bt;
      return -1;
    }
    function Il(V) {
      return V !== V;
    }
    function Ll(V, J) {
      var Y = V == null ? 0 : V.length;
      return Y ? Wa(V, J) / Y : X;
    }
    function qa(V) {
      return function(J) {
        return J == null ? n : J[V];
      };
    }
    function Ha(V) {
      return function(J) {
        return V == null ? n : V[J];
      };
    }
    function Ml(V, J, Y, lt, bt) {
      return bt(V, function(Mt, Qt, Dt) {
        Y = lt ? (lt = !1, Mt) : J(Y, Mt, Qt, Dt);
      }), Y;
    }
    function mg(V, J) {
      var Y = V.length;
      for (V.sort(J); Y--; )
        V[Y] = V[Y].value;
      return V;
    }
    function Wa(V, J) {
      for (var Y, lt = -1, bt = V.length; ++lt < bt; ) {
        var Mt = J(V[lt]);
        Mt !== n && (Y = Y === n ? Mt : Y + Mt);
      }
      return Y;
    }
    function Va(V, J) {
      for (var Y = -1, lt = Array(V); ++Y < V; )
        lt[Y] = J(Y);
      return lt;
    }
    function bg(V, J) {
      return Ht(J, function(Y) {
        return [Y, V[Y]];
      });
    }
    function Nl(V) {
      return V && V.slice(0, Ul(V) + 1).replace(Fa, "");
    }
    function xe(V) {
      return function(J) {
        return V(J);
      };
    }
    function za(V, J) {
      return Ht(J, function(Y) {
        return V[Y];
      });
    }
    function oi(V, J) {
      return V.has(J);
    }
    function Gl(V, J) {
      for (var Y = -1, lt = V.length; ++Y < lt && qr(J, V[Y], 0) > -1; )
        ;
      return Y;
    }
    function Dl(V, J) {
      for (var Y = V.length; Y-- && qr(J, V[Y], 0) > -1; )
        ;
      return Y;
    }
    function wg(V, J) {
      for (var Y = V.length, lt = 0; Y--; )
        V[Y] === J && ++lt;
      return lt;
    }
    var Sg = Ha(ag), Cg = Ha(sg);
    function xg(V) {
      return "\\" + hg[V];
    }
    function Eg(V, J) {
      return V == null ? n : V[J];
    }
    function Hr(V) {
      return eg.test(V);
    }
    function Ag(V) {
      return rg.test(V);
    }
    function Rg(V) {
      for (var J, Y = []; !(J = V.next()).done; )
        Y.push(J.value);
      return Y;
    }
    function ja(V) {
      var J = -1, Y = Array(V.size);
      return V.forEach(function(lt, bt) {
        Y[++J] = [bt, lt];
      }), Y;
    }
    function Bl(V, J) {
      return function(Y) {
        return V(J(Y));
      };
    }
    function yr(V, J) {
      for (var Y = -1, lt = V.length, bt = 0, Mt = []; ++Y < lt; ) {
        var Qt = V[Y];
        (Qt === J || Qt === b) && (V[Y] = b, Mt[bt++] = Y);
      }
      return Mt;
    }
    function Rn(V) {
      var J = -1, Y = Array(V.size);
      return V.forEach(function(lt) {
        Y[++J] = lt;
      }), Y;
    }
    function Tg(V) {
      var J = -1, Y = Array(V.size);
      return V.forEach(function(lt) {
        Y[++J] = [lt, lt];
      }), Y;
    }
    function Pg(V, J, Y) {
      for (var lt = Y - 1, bt = V.length; ++lt < bt; )
        if (V[lt] === J)
          return lt;
      return -1;
    }
    function Fg(V, J, Y) {
      for (var lt = Y + 1; lt--; )
        if (V[lt] === J)
          return lt;
      return lt;
    }
    function Wr(V) {
      return Hr(V) ? kg(V) : pg(V);
    }
    function ze(V) {
      return Hr(V) ? Ig(V) : _g(V);
    }
    function Ul(V) {
      for (var J = V.length; J-- && w1.test(V.charAt(J)); )
        ;
      return J;
    }
    var Og = Ha(og);
    function kg(V) {
      for (var J = Ma.lastIndex = 0; Ma.test(V); )
        ++J;
      return J;
    }
    function Ig(V) {
      return V.match(Ma) || [];
    }
    function Lg(V) {
      return V.match(tg) || [];
    }
    var Mg = function V(J) {
      J = J == null ? oe : Vr.defaults(oe.Object(), J, Vr.pick(oe, ig));
      var Y = J.Array, lt = J.Date, bt = J.Error, Mt = J.Function, Qt = J.Math, Dt = J.Object, Ka = J.RegExp, Ng = J.String, Le = J.TypeError, Tn = Y.prototype, Gg = Mt.prototype, zr = Dt.prototype, Pn = J["__core-js_shared__"], Fn = Gg.toString, Gt = zr.hasOwnProperty, Dg = 0, ql = function() {
        var t = /[^.]+$/.exec(Pn && Pn.keys && Pn.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), On = zr.toString, Bg = Fn.call(Dt), Ug = oe._, qg = Ka(
        "^" + Fn.call(Gt).replace(Pa, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), kn = xl ? J.Buffer : n, mr = J.Symbol, In = J.Uint8Array, Hl = kn ? kn.allocUnsafe : n, Ln = Bl(Dt.getPrototypeOf, Dt), Wl = Dt.create, Vl = zr.propertyIsEnumerable, Mn = Tn.splice, zl = mr ? mr.isConcatSpreadable : n, hi = mr ? mr.iterator : n, Tr = mr ? mr.toStringTag : n, Nn = function() {
        try {
          var t = Ir(Dt, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), Hg = J.clearTimeout !== oe.clearTimeout && J.clearTimeout, Wg = lt && lt.now !== oe.Date.now && lt.now, Vg = J.setTimeout !== oe.setTimeout && J.setTimeout, Gn = Qt.ceil, Dn = Qt.floor, Ya = Dt.getOwnPropertySymbols, zg = kn ? kn.isBuffer : n, jl = J.isFinite, jg = Tn.join, Kg = Bl(Dt.keys, Dt), te = Qt.max, le = Qt.min, Yg = lt.now, Xg = J.parseInt, Kl = Qt.random, $g = Tn.reverse, Xa = Ir(J, "DataView"), li = Ir(J, "Map"), $a = Ir(J, "Promise"), jr = Ir(J, "Set"), ui = Ir(J, "WeakMap"), ci = Ir(Dt, "create"), Bn = ui && new ui(), Kr = {}, Zg = Lr(Xa), Jg = Lr(li), Qg = Lr($a), t2 = Lr(jr), e2 = Lr(ui), Un = mr ? mr.prototype : n, di = Un ? Un.valueOf : n, Yl = Un ? Un.toString : n;
      function k(t) {
        if (jt(t) && !wt(t) && !(t instanceof kt)) {
          if (t instanceof Me)
            return t;
          if (Gt.call(t, "__wrapped__"))
            return Xu(t);
        }
        return new Me(t);
      }
      var Yr = /* @__PURE__ */ function() {
        function t() {
        }
        return function(e) {
          if (!Vt(e))
            return {};
          if (Wl)
            return Wl(e);
          t.prototype = e;
          var i = new t();
          return t.prototype = n, i;
        };
      }();
      function qn() {
      }
      function Me(t, e) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = n;
      }
      k.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: p1,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: _1,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: il,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: k
        }
      }, k.prototype = qn.prototype, k.prototype.constructor = k, Me.prototype = Yr(qn.prototype), Me.prototype.constructor = Me;
      function kt(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
      }
      function r2() {
        var t = new kt(this.__wrapped__);
        return t.__actions__ = _e(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = _e(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = _e(this.__views__), t;
      }
      function i2() {
        if (this.__filtered__) {
          var t = new kt(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function n2() {
        var t = this.__wrapped__.value(), e = this.__dir__, i = wt(t), u = e < 0, R = i ? t.length : 0, M = _p(0, R, this.__views__), B = M.start, q = M.end, z = q - B, rt = u ? q : B - 1, it = this.__iteratees__, nt = it.length, ot = 0, dt = le(z, this.__takeCount__);
        if (!i || !u && R == z && dt == z)
          return yu(t, this.__actions__);
        var _t = [];
        t:
          for (; z-- && ot < dt; ) {
            rt += e;
            for (var Ct = -1, vt = t[rt]; ++Ct < nt; ) {
              var Ft = it[Ct], It = Ft.iteratee, Re = Ft.type, fe = It(vt);
              if (Re == A)
                vt = fe;
              else if (!fe) {
                if (Re == P)
                  continue t;
                break t;
              }
            }
            _t[ot++] = vt;
          }
        return _t;
      }
      kt.prototype = Yr(qn.prototype), kt.prototype.constructor = kt;
      function Pr(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var u = t[e];
          this.set(u[0], u[1]);
        }
      }
      function a2() {
        this.__data__ = ci ? ci(null) : {}, this.size = 0;
      }
      function s2(t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      }
      function o2(t) {
        var e = this.__data__;
        if (ci) {
          var i = e[t];
          return i === g ? n : i;
        }
        return Gt.call(e, t) ? e[t] : n;
      }
      function h2(t) {
        var e = this.__data__;
        return ci ? e[t] !== n : Gt.call(e, t);
      }
      function l2(t, e) {
        var i = this.__data__;
        return this.size += this.has(t) ? 0 : 1, i[t] = ci && e === n ? g : e, this;
      }
      Pr.prototype.clear = a2, Pr.prototype.delete = s2, Pr.prototype.get = o2, Pr.prototype.has = h2, Pr.prototype.set = l2;
      function ir(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var u = t[e];
          this.set(u[0], u[1]);
        }
      }
      function u2() {
        this.__data__ = [], this.size = 0;
      }
      function c2(t) {
        var e = this.__data__, i = Hn(e, t);
        if (i < 0)
          return !1;
        var u = e.length - 1;
        return i == u ? e.pop() : Mn.call(e, i, 1), --this.size, !0;
      }
      function d2(t) {
        var e = this.__data__, i = Hn(e, t);
        return i < 0 ? n : e[i][1];
      }
      function f2(t) {
        return Hn(this.__data__, t) > -1;
      }
      function g2(t, e) {
        var i = this.__data__, u = Hn(i, t);
        return u < 0 ? (++this.size, i.push([t, e])) : i[u][1] = e, this;
      }
      ir.prototype.clear = u2, ir.prototype.delete = c2, ir.prototype.get = d2, ir.prototype.has = f2, ir.prototype.set = g2;
      function nr(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var u = t[e];
          this.set(u[0], u[1]);
        }
      }
      function p2() {
        this.size = 0, this.__data__ = {
          hash: new Pr(),
          map: new (li || ir)(),
          string: new Pr()
        };
      }
      function _2(t) {
        var e = ta(this, t).delete(t);
        return this.size -= e ? 1 : 0, e;
      }
      function v2(t) {
        return ta(this, t).get(t);
      }
      function y2(t) {
        return ta(this, t).has(t);
      }
      function m2(t, e) {
        var i = ta(this, t), u = i.size;
        return i.set(t, e), this.size += i.size == u ? 0 : 1, this;
      }
      nr.prototype.clear = p2, nr.prototype.delete = _2, nr.prototype.get = v2, nr.prototype.has = y2, nr.prototype.set = m2;
      function Fr(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.__data__ = new nr(); ++e < i; )
          this.add(t[e]);
      }
      function b2(t) {
        return this.__data__.set(t, g), this;
      }
      function w2(t) {
        return this.__data__.has(t);
      }
      Fr.prototype.add = Fr.prototype.push = b2, Fr.prototype.has = w2;
      function je(t) {
        var e = this.__data__ = new ir(t);
        this.size = e.size;
      }
      function S2() {
        this.__data__ = new ir(), this.size = 0;
      }
      function C2(t) {
        var e = this.__data__, i = e.delete(t);
        return this.size = e.size, i;
      }
      function x2(t) {
        return this.__data__.get(t);
      }
      function E2(t) {
        return this.__data__.has(t);
      }
      function A2(t, e) {
        var i = this.__data__;
        if (i instanceof ir) {
          var u = i.__data__;
          if (!li || u.length < c - 1)
            return u.push([t, e]), this.size = ++i.size, this;
          i = this.__data__ = new nr(u);
        }
        return i.set(t, e), this.size = i.size, this;
      }
      je.prototype.clear = S2, je.prototype.delete = C2, je.prototype.get = x2, je.prototype.has = E2, je.prototype.set = A2;
      function Xl(t, e) {
        var i = wt(t), u = !i && Mr(t), R = !i && !u && xr(t), M = !i && !u && !R && Jr(t), B = i || u || R || M, q = B ? Va(t.length, Ng) : [], z = q.length;
        for (var rt in t)
          (e || Gt.call(t, rt)) && !(B && // Safari 9 has enumerable `arguments.length` in strict mode.
          (rt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          R && (rt == "offset" || rt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          M && (rt == "buffer" || rt == "byteLength" || rt == "byteOffset") || // Skip index properties.
          hr(rt, z))) && q.push(rt);
        return q;
      }
      function $l(t) {
        var e = t.length;
        return e ? t[os(0, e - 1)] : n;
      }
      function R2(t, e) {
        return ea(_e(t), Or(e, 0, t.length));
      }
      function T2(t) {
        return ea(_e(t));
      }
      function Za(t, e, i) {
        (i !== n && !Ke(t[e], i) || i === n && !(e in t)) && ar(t, e, i);
      }
      function fi(t, e, i) {
        var u = t[e];
        (!(Gt.call(t, e) && Ke(u, i)) || i === n && !(e in t)) && ar(t, e, i);
      }
      function Hn(t, e) {
        for (var i = t.length; i--; )
          if (Ke(t[i][0], e))
            return i;
        return -1;
      }
      function P2(t, e, i, u) {
        return br(t, function(R, M, B) {
          e(u, R, i(R), B);
        }), u;
      }
      function Zl(t, e) {
        return t && tr(e, ae(e), t);
      }
      function F2(t, e) {
        return t && tr(e, ye(e), t);
      }
      function ar(t, e, i) {
        e == "__proto__" && Nn ? Nn(t, e, {
          configurable: !0,
          enumerable: !0,
          value: i,
          writable: !0
        }) : t[e] = i;
      }
      function Ja(t, e) {
        for (var i = -1, u = e.length, R = Y(u), M = t == null; ++i < u; )
          R[i] = M ? n : ks(t, e[i]);
        return R;
      }
      function Or(t, e, i) {
        return t === t && (i !== n && (t = t <= i ? t : i), e !== n && (t = t >= e ? t : e)), t;
      }
      function Ne(t, e, i, u, R, M) {
        var B, q = e & w, z = e & x, rt = e & v;
        if (i && (B = R ? i(t, u, R, M) : i(t)), B !== n)
          return B;
        if (!Vt(t))
          return t;
        var it = wt(t);
        if (it) {
          if (B = yp(t), !q)
            return _e(t, B);
        } else {
          var nt = ue(t), ot = nt == gt || nt == Lt;
          if (xr(t))
            return wu(t, q);
          if (nt == Pt || nt == ht || ot && !R) {
            if (B = z || ot ? {} : Uu(t), !q)
              return z ? op(t, F2(B, t)) : sp(t, Zl(B, t));
          } else {
            if (!Bt[nt])
              return R ? t : {};
            B = mp(t, nt, q);
          }
        }
        M || (M = new je());
        var dt = M.get(t);
        if (dt)
          return dt;
        M.set(t, B), pc(t) ? t.forEach(function(vt) {
          B.add(Ne(vt, e, i, vt, t, M));
        }) : fc(t) && t.forEach(function(vt, Ft) {
          B.set(Ft, Ne(vt, e, i, Ft, t, M));
        });
        var _t = rt ? z ? ys : vs : z ? ye : ae, Ct = it ? n : _t(t);
        return Ie(Ct || t, function(vt, Ft) {
          Ct && (Ft = vt, vt = t[Ft]), fi(B, Ft, Ne(vt, e, i, Ft, t, M));
        }), B;
      }
      function O2(t) {
        var e = ae(t);
        return function(i) {
          return Jl(i, t, e);
        };
      }
      function Jl(t, e, i) {
        var u = i.length;
        if (t == null)
          return !u;
        for (t = Dt(t); u--; ) {
          var R = i[u], M = e[R], B = t[R];
          if (B === n && !(R in t) || !M(B))
            return !1;
        }
        return !0;
      }
      function Ql(t, e, i) {
        if (typeof t != "function")
          throw new Le(h);
        return bi(function() {
          t.apply(n, i);
        }, e);
      }
      function gi(t, e, i, u) {
        var R = -1, M = En, B = !0, q = t.length, z = [], rt = e.length;
        if (!q)
          return z;
        i && (e = Ht(e, xe(i))), u ? (M = Da, B = !1) : e.length >= c && (M = oi, B = !1, e = new Fr(e));
        t:
          for (; ++R < q; ) {
            var it = t[R], nt = i == null ? it : i(it);
            if (it = u || it !== 0 ? it : 0, B && nt === nt) {
              for (var ot = rt; ot--; )
                if (e[ot] === nt)
                  continue t;
              z.push(it);
            } else
              M(e, nt, u) || z.push(it);
          }
        return z;
      }
      var br = Au(Qe), tu = Au(ts, !0);
      function k2(t, e) {
        var i = !0;
        return br(t, function(u, R, M) {
          return i = !!e(u, R, M), i;
        }), i;
      }
      function Wn(t, e, i) {
        for (var u = -1, R = t.length; ++u < R; ) {
          var M = t[u], B = e(M);
          if (B != null && (q === n ? B === B && !Ae(B) : i(B, q)))
            var q = B, z = M;
        }
        return z;
      }
      function I2(t, e, i, u) {
        var R = t.length;
        for (i = St(i), i < 0 && (i = -i > R ? 0 : R + i), u = u === n || u > R ? R : St(u), u < 0 && (u += R), u = i > u ? 0 : vc(u); i < u; )
          t[i++] = e;
        return t;
      }
      function eu(t, e) {
        var i = [];
        return br(t, function(u, R, M) {
          e(u, R, M) && i.push(u);
        }), i;
      }
      function he(t, e, i, u, R) {
        var M = -1, B = t.length;
        for (i || (i = wp), R || (R = []); ++M < B; ) {
          var q = t[M];
          e > 0 && i(q) ? e > 1 ? he(q, e - 1, i, u, R) : vr(R, q) : u || (R[R.length] = q);
        }
        return R;
      }
      var Qa = Ru(), ru = Ru(!0);
      function Qe(t, e) {
        return t && Qa(t, e, ae);
      }
      function ts(t, e) {
        return t && ru(t, e, ae);
      }
      function Vn(t, e) {
        return _r(e, function(i) {
          return lr(t[i]);
        });
      }
      function kr(t, e) {
        e = Sr(e, t);
        for (var i = 0, u = e.length; t != null && i < u; )
          t = t[er(e[i++])];
        return i && i == u ? t : n;
      }
      function iu(t, e, i) {
        var u = e(t);
        return wt(t) ? u : vr(u, i(t));
      }
      function ce(t) {
        return t == null ? t === n ? He : ee : Tr && Tr in Dt(t) ? pp(t) : Tp(t);
      }
      function es(t, e) {
        return t > e;
      }
      function L2(t, e) {
        return t != null && Gt.call(t, e);
      }
      function M2(t, e) {
        return t != null && e in Dt(t);
      }
      function N2(t, e, i) {
        return t >= le(e, i) && t < te(e, i);
      }
      function rs(t, e, i) {
        for (var u = i ? Da : En, R = t[0].length, M = t.length, B = M, q = Y(M), z = 1 / 0, rt = []; B--; ) {
          var it = t[B];
          B && e && (it = Ht(it, xe(e))), z = le(it.length, z), q[B] = !i && (e || R >= 120 && it.length >= 120) ? new Fr(B && it) : n;
        }
        it = t[0];
        var nt = -1, ot = q[0];
        t:
          for (; ++nt < R && rt.length < z; ) {
            var dt = it[nt], _t = e ? e(dt) : dt;
            if (dt = i || dt !== 0 ? dt : 0, !(ot ? oi(ot, _t) : u(rt, _t, i))) {
              for (B = M; --B; ) {
                var Ct = q[B];
                if (!(Ct ? oi(Ct, _t) : u(t[B], _t, i)))
                  continue t;
              }
              ot && ot.push(_t), rt.push(dt);
            }
          }
        return rt;
      }
      function G2(t, e, i, u) {
        return Qe(t, function(R, M, B) {
          e(u, i(R), M, B);
        }), u;
      }
      function pi(t, e, i) {
        e = Sr(e, t), t = Vu(t, e);
        var u = t == null ? t : t[er(De(e))];
        return u == null ? n : Ce(u, t, i);
      }
      function nu(t) {
        return jt(t) && ce(t) == ht;
      }
      function D2(t) {
        return jt(t) && ce(t) == zt;
      }
      function B2(t) {
        return jt(t) && ce(t) == et;
      }
      function _i(t, e, i, u, R) {
        return t === e ? !0 : t == null || e == null || !jt(t) && !jt(e) ? t !== t && e !== e : U2(t, e, i, u, _i, R);
      }
      function U2(t, e, i, u, R, M) {
        var B = wt(t), q = wt(e), z = B ? ct : ue(t), rt = q ? ct : ue(e);
        z = z == ht ? Pt : z, rt = rt == ht ? Pt : rt;
        var it = z == Pt, nt = rt == Pt, ot = z == rt;
        if (ot && xr(t)) {
          if (!xr(e))
            return !1;
          B = !0, it = !1;
        }
        if (ot && !it)
          return M || (M = new je()), B || Jr(t) ? Gu(t, e, i, u, R, M) : fp(t, e, z, i, u, R, M);
        if (!(i & _)) {
          var dt = it && Gt.call(t, "__wrapped__"), _t = nt && Gt.call(e, "__wrapped__");
          if (dt || _t) {
            var Ct = dt ? t.value() : t, vt = _t ? e.value() : e;
            return M || (M = new je()), R(Ct, vt, i, u, M);
          }
        }
        return ot ? (M || (M = new je()), gp(t, e, i, u, R, M)) : !1;
      }
      function q2(t) {
        return jt(t) && ue(t) == Et;
      }
      function is(t, e, i, u) {
        var R = i.length, M = R, B = !u;
        if (t == null)
          return !M;
        for (t = Dt(t); R--; ) {
          var q = i[R];
          if (B && q[2] ? q[1] !== t[q[0]] : !(q[0] in t))
            return !1;
        }
        for (; ++R < M; ) {
          q = i[R];
          var z = q[0], rt = t[z], it = q[1];
          if (B && q[2]) {
            if (rt === n && !(z in t))
              return !1;
          } else {
            var nt = new je();
            if (u)
              var ot = u(rt, it, z, t, e, nt);
            if (!(ot === n ? _i(it, rt, _ | S, u, nt) : ot))
              return !1;
          }
        }
        return !0;
      }
      function au(t) {
        if (!Vt(t) || Cp(t))
          return !1;
        var e = lr(t) ? qg : O1;
        return e.test(Lr(t));
      }
      function H2(t) {
        return jt(t) && ce(t) == re;
      }
      function W2(t) {
        return jt(t) && ue(t) == Zt;
      }
      function V2(t) {
        return jt(t) && oa(t.length) && !!qt[ce(t)];
      }
      function su(t) {
        return typeof t == "function" ? t : t == null ? me : typeof t == "object" ? wt(t) ? lu(t[0], t[1]) : hu(t) : Tc(t);
      }
      function ns(t) {
        if (!mi(t))
          return Kg(t);
        var e = [];
        for (var i in Dt(t))
          Gt.call(t, i) && i != "constructor" && e.push(i);
        return e;
      }
      function z2(t) {
        if (!Vt(t))
          return Rp(t);
        var e = mi(t), i = [];
        for (var u in t)
          u == "constructor" && (e || !Gt.call(t, u)) || i.push(u);
        return i;
      }
      function as(t, e) {
        return t < e;
      }
      function ou(t, e) {
        var i = -1, u = ve(t) ? Y(t.length) : [];
        return br(t, function(R, M, B) {
          u[++i] = e(R, M, B);
        }), u;
      }
      function hu(t) {
        var e = bs(t);
        return e.length == 1 && e[0][2] ? Hu(e[0][0], e[0][1]) : function(i) {
          return i === t || is(i, t, e);
        };
      }
      function lu(t, e) {
        return Ss(t) && qu(e) ? Hu(er(t), e) : function(i) {
          var u = ks(i, t);
          return u === n && u === e ? Is(i, t) : _i(e, u, _ | S);
        };
      }
      function zn(t, e, i, u, R) {
        t !== e && Qa(e, function(M, B) {
          if (R || (R = new je()), Vt(M))
            j2(t, e, B, i, zn, u, R);
          else {
            var q = u ? u(xs(t, B), M, B + "", t, e, R) : n;
            q === n && (q = M), Za(t, B, q);
          }
        }, ye);
      }
      function j2(t, e, i, u, R, M, B) {
        var q = xs(t, i), z = xs(e, i), rt = B.get(z);
        if (rt) {
          Za(t, i, rt);
          return;
        }
        var it = M ? M(q, z, i + "", t, e, B) : n, nt = it === n;
        if (nt) {
          var ot = wt(z), dt = !ot && xr(z), _t = !ot && !dt && Jr(z);
          it = z, ot || dt || _t ? wt(q) ? it = q : Yt(q) ? it = _e(q) : dt ? (nt = !1, it = wu(z, !0)) : _t ? (nt = !1, it = Su(z, !0)) : it = [] : wi(z) || Mr(z) ? (it = q, Mr(q) ? it = yc(q) : (!Vt(q) || lr(q)) && (it = Uu(z))) : nt = !1;
        }
        nt && (B.set(z, it), R(it, z, u, M, B), B.delete(z)), Za(t, i, it);
      }
      function uu(t, e) {
        var i = t.length;
        if (i)
          return e += e < 0 ? i : 0, hr(e, i) ? t[e] : n;
      }
      function cu(t, e, i) {
        e.length ? e = Ht(e, function(M) {
          return wt(M) ? function(B) {
            return kr(B, M.length === 1 ? M[0] : M);
          } : M;
        }) : e = [me];
        var u = -1;
        e = Ht(e, xe(pt()));
        var R = ou(t, function(M, B, q) {
          var z = Ht(e, function(rt) {
            return rt(M);
          });
          return { criteria: z, index: ++u, value: M };
        });
        return mg(R, function(M, B) {
          return ap(M, B, i);
        });
      }
      function K2(t, e) {
        return du(t, e, function(i, u) {
          return Is(t, u);
        });
      }
      function du(t, e, i) {
        for (var u = -1, R = e.length, M = {}; ++u < R; ) {
          var B = e[u], q = kr(t, B);
          i(q, B) && vi(M, Sr(B, t), q);
        }
        return M;
      }
      function Y2(t) {
        return function(e) {
          return kr(e, t);
        };
      }
      function ss(t, e, i, u) {
        var R = u ? yg : qr, M = -1, B = e.length, q = t;
        for (t === e && (e = _e(e)), i && (q = Ht(t, xe(i))); ++M < B; )
          for (var z = 0, rt = e[M], it = i ? i(rt) : rt; (z = R(q, it, z, u)) > -1; )
            q !== t && Mn.call(q, z, 1), Mn.call(t, z, 1);
        return t;
      }
      function fu(t, e) {
        for (var i = t ? e.length : 0, u = i - 1; i--; ) {
          var R = e[i];
          if (i == u || R !== M) {
            var M = R;
            hr(R) ? Mn.call(t, R, 1) : us(t, R);
          }
        }
        return t;
      }
      function os(t, e) {
        return t + Dn(Kl() * (e - t + 1));
      }
      function X2(t, e, i, u) {
        for (var R = -1, M = te(Gn((e - t) / (i || 1)), 0), B = Y(M); M--; )
          B[u ? M : ++R] = t, t += i;
        return B;
      }
      function hs(t, e) {
        var i = "";
        if (!t || e < 1 || e > K)
          return i;
        do
          e % 2 && (i += t), e = Dn(e / 2), e && (t += t);
        while (e);
        return i;
      }
      function At(t, e) {
        return Es(Wu(t, e, me), t + "");
      }
      function $2(t) {
        return $l(Qr(t));
      }
      function Z2(t, e) {
        var i = Qr(t);
        return ea(i, Or(e, 0, i.length));
      }
      function vi(t, e, i, u) {
        if (!Vt(t))
          return t;
        e = Sr(e, t);
        for (var R = -1, M = e.length, B = M - 1, q = t; q != null && ++R < M; ) {
          var z = er(e[R]), rt = i;
          if (z === "__proto__" || z === "constructor" || z === "prototype")
            return t;
          if (R != B) {
            var it = q[z];
            rt = u ? u(it, z, q) : n, rt === n && (rt = Vt(it) ? it : hr(e[R + 1]) ? [] : {});
          }
          fi(q, z, rt), q = q[z];
        }
        return t;
      }
      var gu = Bn ? function(t, e) {
        return Bn.set(t, e), t;
      } : me, J2 = Nn ? function(t, e) {
        return Nn(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Ms(e),
          writable: !0
        });
      } : me;
      function Q2(t) {
        return ea(Qr(t));
      }
      function Ge(t, e, i) {
        var u = -1, R = t.length;
        e < 0 && (e = -e > R ? 0 : R + e), i = i > R ? R : i, i < 0 && (i += R), R = e > i ? 0 : i - e >>> 0, e >>>= 0;
        for (var M = Y(R); ++u < R; )
          M[u] = t[u + e];
        return M;
      }
      function tp(t, e) {
        var i;
        return br(t, function(u, R, M) {
          return i = e(u, R, M), !i;
        }), !!i;
      }
      function jn(t, e, i) {
        var u = 0, R = t == null ? u : t.length;
        if (typeof e == "number" && e === e && R <= Z) {
          for (; u < R; ) {
            var M = u + R >>> 1, B = t[M];
            B !== null && !Ae(B) && (i ? B <= e : B < e) ? u = M + 1 : R = M;
          }
          return R;
        }
        return ls(t, e, me, i);
      }
      function ls(t, e, i, u) {
        var R = 0, M = t == null ? 0 : t.length;
        if (M === 0)
          return 0;
        e = i(e);
        for (var B = e !== e, q = e === null, z = Ae(e), rt = e === n; R < M; ) {
          var it = Dn((R + M) / 2), nt = i(t[it]), ot = nt !== n, dt = nt === null, _t = nt === nt, Ct = Ae(nt);
          if (B)
            var vt = u || _t;
          else
            rt ? vt = _t && (u || ot) : q ? vt = _t && ot && (u || !dt) : z ? vt = _t && ot && !dt && (u || !Ct) : dt || Ct ? vt = !1 : vt = u ? nt <= e : nt < e;
          vt ? R = it + 1 : M = it;
        }
        return le(M, st);
      }
      function pu(t, e) {
        for (var i = -1, u = t.length, R = 0, M = []; ++i < u; ) {
          var B = t[i], q = e ? e(B) : B;
          if (!i || !Ke(q, z)) {
            var z = q;
            M[R++] = B === 0 ? 0 : B;
          }
        }
        return M;
      }
      function _u(t) {
        return typeof t == "number" ? t : Ae(t) ? X : +t;
      }
      function Ee(t) {
        if (typeof t == "string")
          return t;
        if (wt(t))
          return Ht(t, Ee) + "";
        if (Ae(t))
          return Yl ? Yl.call(t) : "";
        var e = t + "";
        return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
      }
      function wr(t, e, i) {
        var u = -1, R = En, M = t.length, B = !0, q = [], z = q;
        if (i)
          B = !1, R = Da;
        else if (M >= c) {
          var rt = e ? null : cp(t);
          if (rt)
            return Rn(rt);
          B = !1, R = oi, z = new Fr();
        } else
          z = e ? [] : q;
        t:
          for (; ++u < M; ) {
            var it = t[u], nt = e ? e(it) : it;
            if (it = i || it !== 0 ? it : 0, B && nt === nt) {
              for (var ot = z.length; ot--; )
                if (z[ot] === nt)
                  continue t;
              e && z.push(nt), q.push(it);
            } else
              R(z, nt, i) || (z !== q && z.push(nt), q.push(it));
          }
        return q;
      }
      function us(t, e) {
        return e = Sr(e, t), t = Vu(t, e), t == null || delete t[er(De(e))];
      }
      function vu(t, e, i, u) {
        return vi(t, e, i(kr(t, e)), u);
      }
      function Kn(t, e, i, u) {
        for (var R = t.length, M = u ? R : -1; (u ? M-- : ++M < R) && e(t[M], M, t); )
          ;
        return i ? Ge(t, u ? 0 : M, u ? M + 1 : R) : Ge(t, u ? M + 1 : 0, u ? R : M);
      }
      function yu(t, e) {
        var i = t;
        return i instanceof kt && (i = i.value()), Ba(e, function(u, R) {
          return R.func.apply(R.thisArg, vr([u], R.args));
        }, i);
      }
      function cs(t, e, i) {
        var u = t.length;
        if (u < 2)
          return u ? wr(t[0]) : [];
        for (var R = -1, M = Y(u); ++R < u; )
          for (var B = t[R], q = -1; ++q < u; )
            q != R && (M[R] = gi(M[R] || B, t[q], e, i));
        return wr(he(M, 1), e, i);
      }
      function mu(t, e, i) {
        for (var u = -1, R = t.length, M = e.length, B = {}; ++u < R; ) {
          var q = u < M ? e[u] : n;
          i(B, t[u], q);
        }
        return B;
      }
      function ds(t) {
        return Yt(t) ? t : [];
      }
      function fs(t) {
        return typeof t == "function" ? t : me;
      }
      function Sr(t, e) {
        return wt(t) ? t : Ss(t, e) ? [t] : Yu(Nt(t));
      }
      var ep = At;
      function Cr(t, e, i) {
        var u = t.length;
        return i = i === n ? u : i, !e && i >= u ? t : Ge(t, e, i);
      }
      var bu = Hg || function(t) {
        return oe.clearTimeout(t);
      };
      function wu(t, e) {
        if (e)
          return t.slice();
        var i = t.length, u = Hl ? Hl(i) : new t.constructor(i);
        return t.copy(u), u;
      }
      function gs(t) {
        var e = new t.constructor(t.byteLength);
        return new In(e).set(new In(t)), e;
      }
      function rp(t, e) {
        var i = e ? gs(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.byteLength);
      }
      function ip(t) {
        var e = new t.constructor(t.source, nl.exec(t));
        return e.lastIndex = t.lastIndex, e;
      }
      function np(t) {
        return di ? Dt(di.call(t)) : {};
      }
      function Su(t, e) {
        var i = e ? gs(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.length);
      }
      function Cu(t, e) {
        if (t !== e) {
          var i = t !== n, u = t === null, R = t === t, M = Ae(t), B = e !== n, q = e === null, z = e === e, rt = Ae(e);
          if (!q && !rt && !M && t > e || M && B && z && !q && !rt || u && B && z || !i && z || !R)
            return 1;
          if (!u && !M && !rt && t < e || rt && i && R && !u && !M || q && i && R || !B && R || !z)
            return -1;
        }
        return 0;
      }
      function ap(t, e, i) {
        for (var u = -1, R = t.criteria, M = e.criteria, B = R.length, q = i.length; ++u < B; ) {
          var z = Cu(R[u], M[u]);
          if (z) {
            if (u >= q)
              return z;
            var rt = i[u];
            return z * (rt == "desc" ? -1 : 1);
          }
        }
        return t.index - e.index;
      }
      function xu(t, e, i, u) {
        for (var R = -1, M = t.length, B = i.length, q = -1, z = e.length, rt = te(M - B, 0), it = Y(z + rt), nt = !u; ++q < z; )
          it[q] = e[q];
        for (; ++R < B; )
          (nt || R < M) && (it[i[R]] = t[R]);
        for (; rt--; )
          it[q++] = t[R++];
        return it;
      }
      function Eu(t, e, i, u) {
        for (var R = -1, M = t.length, B = -1, q = i.length, z = -1, rt = e.length, it = te(M - q, 0), nt = Y(it + rt), ot = !u; ++R < it; )
          nt[R] = t[R];
        for (var dt = R; ++z < rt; )
          nt[dt + z] = e[z];
        for (; ++B < q; )
          (ot || R < M) && (nt[dt + i[B]] = t[R++]);
        return nt;
      }
      function _e(t, e) {
        var i = -1, u = t.length;
        for (e || (e = Y(u)); ++i < u; )
          e[i] = t[i];
        return e;
      }
      function tr(t, e, i, u) {
        var R = !i;
        i || (i = {});
        for (var M = -1, B = e.length; ++M < B; ) {
          var q = e[M], z = u ? u(i[q], t[q], q, i, t) : n;
          z === n && (z = t[q]), R ? ar(i, q, z) : fi(i, q, z);
        }
        return i;
      }
      function sp(t, e) {
        return tr(t, ws(t), e);
      }
      function op(t, e) {
        return tr(t, Du(t), e);
      }
      function Yn(t, e) {
        return function(i, u) {
          var R = wt(i) ? dg : P2, M = e ? e() : {};
          return R(i, t, pt(u, 2), M);
        };
      }
      function Xr(t) {
        return At(function(e, i) {
          var u = -1, R = i.length, M = R > 1 ? i[R - 1] : n, B = R > 2 ? i[2] : n;
          for (M = t.length > 3 && typeof M == "function" ? (R--, M) : n, B && de(i[0], i[1], B) && (M = R < 3 ? n : M, R = 1), e = Dt(e); ++u < R; ) {
            var q = i[u];
            q && t(e, q, u, M);
          }
          return e;
        });
      }
      function Au(t, e) {
        return function(i, u) {
          if (i == null)
            return i;
          if (!ve(i))
            return t(i, u);
          for (var R = i.length, M = e ? R : -1, B = Dt(i); (e ? M-- : ++M < R) && u(B[M], M, B) !== !1; )
            ;
          return i;
        };
      }
      function Ru(t) {
        return function(e, i, u) {
          for (var R = -1, M = Dt(e), B = u(e), q = B.length; q--; ) {
            var z = B[t ? q : ++R];
            if (i(M[z], z, M) === !1)
              break;
          }
          return e;
        };
      }
      function hp(t, e, i) {
        var u = e & C, R = yi(t);
        function M() {
          var B = this && this !== oe && this instanceof M ? R : t;
          return B.apply(u ? i : this, arguments);
        }
        return M;
      }
      function Tu(t) {
        return function(e) {
          e = Nt(e);
          var i = Hr(e) ? ze(e) : n, u = i ? i[0] : e.charAt(0), R = i ? Cr(i, 1).join("") : e.slice(1);
          return u[t]() + R;
        };
      }
      function $r(t) {
        return function(e) {
          return Ba(Ac(Ec(e).replace(J1, "")), t, "");
        };
      }
      function yi(t) {
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return new t();
            case 1:
              return new t(e[0]);
            case 2:
              return new t(e[0], e[1]);
            case 3:
              return new t(e[0], e[1], e[2]);
            case 4:
              return new t(e[0], e[1], e[2], e[3]);
            case 5:
              return new t(e[0], e[1], e[2], e[3], e[4]);
            case 6:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5]);
            case 7:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
          }
          var i = Yr(t.prototype), u = t.apply(i, e);
          return Vt(u) ? u : i;
        };
      }
      function lp(t, e, i) {
        var u = yi(t);
        function R() {
          for (var M = arguments.length, B = Y(M), q = M, z = Zr(R); q--; )
            B[q] = arguments[q];
          var rt = M < 3 && B[0] !== z && B[M - 1] !== z ? [] : yr(B, z);
          if (M -= rt.length, M < i)
            return Iu(
              t,
              e,
              Xn,
              R.placeholder,
              n,
              B,
              rt,
              n,
              n,
              i - M
            );
          var it = this && this !== oe && this instanceof R ? u : t;
          return Ce(it, this, B);
        }
        return R;
      }
      function Pu(t) {
        return function(e, i, u) {
          var R = Dt(e);
          if (!ve(e)) {
            var M = pt(i, 3);
            e = ae(e), i = function(q) {
              return M(R[q], q, R);
            };
          }
          var B = t(e, i, u);
          return B > -1 ? R[M ? e[B] : B] : n;
        };
      }
      function Fu(t) {
        return or(function(e) {
          var i = e.length, u = i, R = Me.prototype.thru;
          for (t && e.reverse(); u--; ) {
            var M = e[u];
            if (typeof M != "function")
              throw new Le(h);
            if (R && !B && Qn(M) == "wrapper")
              var B = new Me([], !0);
          }
          for (u = B ? u : i; ++u < i; ) {
            M = e[u];
            var q = Qn(M), z = q == "wrapper" ? ms(M) : n;
            z && Cs(z[0]) && z[1] == (D | f | E | I) && !z[4].length && z[9] == 1 ? B = B[Qn(z[0])].apply(B, z[3]) : B = M.length == 1 && Cs(M) ? B[q]() : B.thru(M);
          }
          return function() {
            var rt = arguments, it = rt[0];
            if (B && rt.length == 1 && wt(it))
              return B.plant(it).value();
            for (var nt = 0, ot = i ? e[nt].apply(this, rt) : it; ++nt < i; )
              ot = e[nt].call(this, ot);
            return ot;
          };
        });
      }
      function Xn(t, e, i, u, R, M, B, q, z, rt) {
        var it = e & D, nt = e & C, ot = e & F, dt = e & (f | m), _t = e & L, Ct = ot ? n : yi(t);
        function vt() {
          for (var Ft = arguments.length, It = Y(Ft), Re = Ft; Re--; )
            It[Re] = arguments[Re];
          if (dt)
            var fe = Zr(vt), Te = wg(It, fe);
          if (u && (It = xu(It, u, R, dt)), M && (It = Eu(It, M, B, dt)), Ft -= Te, dt && Ft < rt) {
            var Xt = yr(It, fe);
            return Iu(
              t,
              e,
              Xn,
              vt.placeholder,
              i,
              It,
              Xt,
              q,
              z,
              rt - Ft
            );
          }
          var Ye = nt ? i : this, cr = ot ? Ye[t] : t;
          return Ft = It.length, q ? It = Pp(It, q) : _t && Ft > 1 && It.reverse(), it && z < Ft && (It.length = z), this && this !== oe && this instanceof vt && (cr = Ct || yi(cr)), cr.apply(Ye, It);
        }
        return vt;
      }
      function Ou(t, e) {
        return function(i, u) {
          return G2(i, t, e(u), {});
        };
      }
      function $n(t, e) {
        return function(i, u) {
          var R;
          if (i === n && u === n)
            return e;
          if (i !== n && (R = i), u !== n) {
            if (R === n)
              return u;
            typeof i == "string" || typeof u == "string" ? (i = Ee(i), u = Ee(u)) : (i = _u(i), u = _u(u)), R = t(i, u);
          }
          return R;
        };
      }
      function ps(t) {
        return or(function(e) {
          return e = Ht(e, xe(pt())), At(function(i) {
            var u = this;
            return t(e, function(R) {
              return Ce(R, u, i);
            });
          });
        });
      }
      function Zn(t, e) {
        e = e === n ? " " : Ee(e);
        var i = e.length;
        if (i < 2)
          return i ? hs(e, t) : e;
        var u = hs(e, Gn(t / Wr(e)));
        return Hr(e) ? Cr(ze(u), 0, t).join("") : u.slice(0, t);
      }
      function up(t, e, i, u) {
        var R = e & C, M = yi(t);
        function B() {
          for (var q = -1, z = arguments.length, rt = -1, it = u.length, nt = Y(it + z), ot = this && this !== oe && this instanceof B ? M : t; ++rt < it; )
            nt[rt] = u[rt];
          for (; z--; )
            nt[rt++] = arguments[++q];
          return Ce(ot, R ? i : this, nt);
        }
        return B;
      }
      function ku(t) {
        return function(e, i, u) {
          return u && typeof u != "number" && de(e, i, u) && (i = u = n), e = ur(e), i === n ? (i = e, e = 0) : i = ur(i), u = u === n ? e < i ? 1 : -1 : ur(u), X2(e, i, u, t);
        };
      }
      function Jn(t) {
        return function(e, i) {
          return typeof e == "string" && typeof i == "string" || (e = Be(e), i = Be(i)), t(e, i);
        };
      }
      function Iu(t, e, i, u, R, M, B, q, z, rt) {
        var it = e & f, nt = it ? B : n, ot = it ? n : B, dt = it ? M : n, _t = it ? n : M;
        e |= it ? E : T, e &= ~(it ? T : E), e & d || (e &= -4);
        var Ct = [
          t,
          e,
          R,
          dt,
          nt,
          _t,
          ot,
          q,
          z,
          rt
        ], vt = i.apply(n, Ct);
        return Cs(t) && zu(vt, Ct), vt.placeholder = u, ju(vt, t, e);
      }
      function _s(t) {
        var e = Qt[t];
        return function(i, u) {
          if (i = Be(i), u = u == null ? 0 : le(St(u), 292), u && jl(i)) {
            var R = (Nt(i) + "e").split("e"), M = e(R[0] + "e" + (+R[1] + u));
            return R = (Nt(M) + "e").split("e"), +(R[0] + "e" + (+R[1] - u));
          }
          return e(i);
        };
      }
      var cp = jr && 1 / Rn(new jr([, -0]))[1] == U ? function(t) {
        return new jr(t);
      } : Ds;
      function Lu(t) {
        return function(e) {
          var i = ue(e);
          return i == Et ? ja(e) : i == Zt ? Tg(e) : bg(e, t(e));
        };
      }
      function sr(t, e, i, u, R, M, B, q) {
        var z = e & F;
        if (!z && typeof t != "function")
          throw new Le(h);
        var rt = u ? u.length : 0;
        if (rt || (e &= -97, u = R = n), B = B === n ? B : te(St(B), 0), q = q === n ? q : St(q), rt -= R ? R.length : 0, e & T) {
          var it = u, nt = R;
          u = R = n;
        }
        var ot = z ? n : ms(t), dt = [
          t,
          e,
          i,
          u,
          R,
          it,
          nt,
          M,
          B,
          q
        ];
        if (ot && Ap(dt, ot), t = dt[0], e = dt[1], i = dt[2], u = dt[3], R = dt[4], q = dt[9] = dt[9] === n ? z ? 0 : t.length : te(dt[9] - rt, 0), !q && e & (f | m) && (e &= -25), !e || e == C)
          var _t = hp(t, e, i);
        else
          e == f || e == m ? _t = lp(t, e, q) : (e == E || e == (C | E)) && !R.length ? _t = up(t, e, i, u) : _t = Xn.apply(n, dt);
        var Ct = ot ? gu : zu;
        return ju(Ct(_t, dt), t, e);
      }
      function Mu(t, e, i, u) {
        return t === n || Ke(t, zr[i]) && !Gt.call(u, i) ? e : t;
      }
      function Nu(t, e, i, u, R, M) {
        return Vt(t) && Vt(e) && (M.set(e, t), zn(t, e, n, Nu, M), M.delete(e)), t;
      }
      function dp(t) {
        return wi(t) ? n : t;
      }
      function Gu(t, e, i, u, R, M) {
        var B = i & _, q = t.length, z = e.length;
        if (q != z && !(B && z > q))
          return !1;
        var rt = M.get(t), it = M.get(e);
        if (rt && it)
          return rt == e && it == t;
        var nt = -1, ot = !0, dt = i & S ? new Fr() : n;
        for (M.set(t, e), M.set(e, t); ++nt < q; ) {
          var _t = t[nt], Ct = e[nt];
          if (u)
            var vt = B ? u(Ct, _t, nt, e, t, M) : u(_t, Ct, nt, t, e, M);
          if (vt !== n) {
            if (vt)
              continue;
            ot = !1;
            break;
          }
          if (dt) {
            if (!Ua(e, function(Ft, It) {
              if (!oi(dt, It) && (_t === Ft || R(_t, Ft, i, u, M)))
                return dt.push(It);
            })) {
              ot = !1;
              break;
            }
          } else if (!(_t === Ct || R(_t, Ct, i, u, M))) {
            ot = !1;
            break;
          }
        }
        return M.delete(t), M.delete(e), ot;
      }
      function fp(t, e, i, u, R, M, B) {
        switch (i) {
          case ne:
            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
              return !1;
            t = t.buffer, e = e.buffer;
          case zt:
            return !(t.byteLength != e.byteLength || !M(new In(t), new In(e)));
          case j:
          case et:
          case mt:
            return Ke(+t, +e);
          case ft:
            return t.name == e.name && t.message == e.message;
          case re:
          case Jt:
            return t == e + "";
          case Et:
            var q = ja;
          case Zt:
            var z = u & _;
            if (q || (q = Rn), t.size != e.size && !z)
              return !1;
            var rt = B.get(t);
            if (rt)
              return rt == e;
            u |= S, B.set(t, e);
            var it = Gu(q(t), q(e), u, R, M, B);
            return B.delete(t), it;
          case Ut:
            if (di)
              return di.call(t) == di.call(e);
        }
        return !1;
      }
      function gp(t, e, i, u, R, M) {
        var B = i & _, q = vs(t), z = q.length, rt = vs(e), it = rt.length;
        if (z != it && !B)
          return !1;
        for (var nt = z; nt--; ) {
          var ot = q[nt];
          if (!(B ? ot in e : Gt.call(e, ot)))
            return !1;
        }
        var dt = M.get(t), _t = M.get(e);
        if (dt && _t)
          return dt == e && _t == t;
        var Ct = !0;
        M.set(t, e), M.set(e, t);
        for (var vt = B; ++nt < z; ) {
          ot = q[nt];
          var Ft = t[ot], It = e[ot];
          if (u)
            var Re = B ? u(It, Ft, ot, e, t, M) : u(Ft, It, ot, t, e, M);
          if (!(Re === n ? Ft === It || R(Ft, It, i, u, M) : Re)) {
            Ct = !1;
            break;
          }
          vt || (vt = ot == "constructor");
        }
        if (Ct && !vt) {
          var fe = t.constructor, Te = e.constructor;
          fe != Te && "constructor" in t && "constructor" in e && !(typeof fe == "function" && fe instanceof fe && typeof Te == "function" && Te instanceof Te) && (Ct = !1);
        }
        return M.delete(t), M.delete(e), Ct;
      }
      function or(t) {
        return Es(Wu(t, n, Ju), t + "");
      }
      function vs(t) {
        return iu(t, ae, ws);
      }
      function ys(t) {
        return iu(t, ye, Du);
      }
      var ms = Bn ? function(t) {
        return Bn.get(t);
      } : Ds;
      function Qn(t) {
        for (var e = t.name + "", i = Kr[e], u = Gt.call(Kr, e) ? i.length : 0; u--; ) {
          var R = i[u], M = R.func;
          if (M == null || M == t)
            return R.name;
        }
        return e;
      }
      function Zr(t) {
        var e = Gt.call(k, "placeholder") ? k : t;
        return e.placeholder;
      }
      function pt() {
        var t = k.iteratee || Ns;
        return t = t === Ns ? su : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function ta(t, e) {
        var i = t.__data__;
        return Sp(e) ? i[typeof e == "string" ? "string" : "hash"] : i.map;
      }
      function bs(t) {
        for (var e = ae(t), i = e.length; i--; ) {
          var u = e[i], R = t[u];
          e[i] = [u, R, qu(R)];
        }
        return e;
      }
      function Ir(t, e) {
        var i = Eg(t, e);
        return au(i) ? i : n;
      }
      function pp(t) {
        var e = Gt.call(t, Tr), i = t[Tr];
        try {
          t[Tr] = n;
          var u = !0;
        } catch {
        }
        var R = On.call(t);
        return u && (e ? t[Tr] = i : delete t[Tr]), R;
      }
      var ws = Ya ? function(t) {
        return t == null ? [] : (t = Dt(t), _r(Ya(t), function(e) {
          return Vl.call(t, e);
        }));
      } : Bs, Du = Ya ? function(t) {
        for (var e = []; t; )
          vr(e, ws(t)), t = Ln(t);
        return e;
      } : Bs, ue = ce;
      (Xa && ue(new Xa(new ArrayBuffer(1))) != ne || li && ue(new li()) != Et || $a && ue($a.resolve()) != Wt || jr && ue(new jr()) != Zt || ui && ue(new ui()) != ie) && (ue = function(t) {
        var e = ce(t), i = e == Pt ? t.constructor : n, u = i ? Lr(i) : "";
        if (u)
          switch (u) {
            case Zg:
              return ne;
            case Jg:
              return Et;
            case Qg:
              return Wt;
            case t2:
              return Zt;
            case e2:
              return ie;
          }
        return e;
      });
      function _p(t, e, i) {
        for (var u = -1, R = i.length; ++u < R; ) {
          var M = i[u], B = M.size;
          switch (M.type) {
            case "drop":
              t += B;
              break;
            case "dropRight":
              e -= B;
              break;
            case "take":
              e = le(e, t + B);
              break;
            case "takeRight":
              t = te(t, e - B);
              break;
          }
        }
        return { start: t, end: e };
      }
      function vp(t) {
        var e = t.match(C1);
        return e ? e[1].split(x1) : [];
      }
      function Bu(t, e, i) {
        e = Sr(e, t);
        for (var u = -1, R = e.length, M = !1; ++u < R; ) {
          var B = er(e[u]);
          if (!(M = t != null && i(t, B)))
            break;
          t = t[B];
        }
        return M || ++u != R ? M : (R = t == null ? 0 : t.length, !!R && oa(R) && hr(B, R) && (wt(t) || Mr(t)));
      }
      function yp(t) {
        var e = t.length, i = new t.constructor(e);
        return e && typeof t[0] == "string" && Gt.call(t, "index") && (i.index = t.index, i.input = t.input), i;
      }
      function Uu(t) {
        return typeof t.constructor == "function" && !mi(t) ? Yr(Ln(t)) : {};
      }
      function mp(t, e, i) {
        var u = t.constructor;
        switch (e) {
          case zt:
            return gs(t);
          case j:
          case et:
            return new u(+t);
          case ne:
            return rp(t, i);
          case Fe:
          case pe:
          case Ze:
          case Ra:
          case Ve:
          case Oe:
          case Je:
          case si:
          case Ta:
            return Su(t, i);
          case Et:
            return new u();
          case mt:
          case Jt:
            return new u(t);
          case re:
            return ip(t);
          case Zt:
            return new u();
          case Ut:
            return np(t);
        }
      }
      function bp(t, e) {
        var i = e.length;
        if (!i)
          return t;
        var u = i - 1;
        return e[u] = (i > 1 ? "& " : "") + e[u], e = e.join(i > 2 ? ", " : " "), t.replace(S1, `{
/* [wrapped with ` + e + `] */
`);
      }
      function wp(t) {
        return wt(t) || Mr(t) || !!(zl && t && t[zl]);
      }
      function hr(t, e) {
        var i = typeof t;
        return e = e == null ? K : e, !!e && (i == "number" || i != "symbol" && I1.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }
      function de(t, e, i) {
        if (!Vt(i))
          return !1;
        var u = typeof e;
        return (u == "number" ? ve(i) && hr(e, i.length) : u == "string" && e in i) ? Ke(i[e], t) : !1;
      }
      function Ss(t, e) {
        if (wt(t))
          return !1;
        var i = typeof t;
        return i == "number" || i == "symbol" || i == "boolean" || t == null || Ae(t) ? !0 : y1.test(t) || !v1.test(t) || e != null && t in Dt(e);
      }
      function Sp(t) {
        var e = typeof t;
        return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
      }
      function Cs(t) {
        var e = Qn(t), i = k[e];
        if (typeof i != "function" || !(e in kt.prototype))
          return !1;
        if (t === i)
          return !0;
        var u = ms(i);
        return !!u && t === u[0];
      }
      function Cp(t) {
        return !!ql && ql in t;
      }
      var xp = Pn ? lr : Us;
      function mi(t) {
        var e = t && t.constructor, i = typeof e == "function" && e.prototype || zr;
        return t === i;
      }
      function qu(t) {
        return t === t && !Vt(t);
      }
      function Hu(t, e) {
        return function(i) {
          return i == null ? !1 : i[t] === e && (e !== n || t in Dt(i));
        };
      }
      function Ep(t) {
        var e = aa(t, function(u) {
          return i.size === p && i.clear(), u;
        }), i = e.cache;
        return e;
      }
      function Ap(t, e) {
        var i = t[1], u = e[1], R = i | u, M = R < (C | F | D), B = u == D && i == f || u == D && i == I && t[7].length <= e[8] || u == (D | I) && e[7].length <= e[8] && i == f;
        if (!(M || B))
          return t;
        u & C && (t[2] = e[2], R |= i & C ? 0 : d);
        var q = e[3];
        if (q) {
          var z = t[3];
          t[3] = z ? xu(z, q, e[4]) : q, t[4] = z ? yr(t[3], b) : e[4];
        }
        return q = e[5], q && (z = t[5], t[5] = z ? Eu(z, q, e[6]) : q, t[6] = z ? yr(t[5], b) : e[6]), q = e[7], q && (t[7] = q), u & D && (t[8] = t[8] == null ? e[8] : le(t[8], e[8])), t[9] == null && (t[9] = e[9]), t[0] = e[0], t[1] = R, t;
      }
      function Rp(t) {
        var e = [];
        if (t != null)
          for (var i in Dt(t))
            e.push(i);
        return e;
      }
      function Tp(t) {
        return On.call(t);
      }
      function Wu(t, e, i) {
        return e = te(e === n ? t.length - 1 : e, 0), function() {
          for (var u = arguments, R = -1, M = te(u.length - e, 0), B = Y(M); ++R < M; )
            B[R] = u[e + R];
          R = -1;
          for (var q = Y(e + 1); ++R < e; )
            q[R] = u[R];
          return q[e] = i(B), Ce(t, this, q);
        };
      }
      function Vu(t, e) {
        return e.length < 2 ? t : kr(t, Ge(e, 0, -1));
      }
      function Pp(t, e) {
        for (var i = t.length, u = le(e.length, i), R = _e(t); u--; ) {
          var M = e[u];
          t[u] = hr(M, i) ? R[M] : n;
        }
        return t;
      }
      function xs(t, e) {
        if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
          return t[e];
      }
      var zu = Ku(gu), bi = Vg || function(t, e) {
        return oe.setTimeout(t, e);
      }, Es = Ku(J2);
      function ju(t, e, i) {
        var u = e + "";
        return Es(t, bp(u, Fp(vp(u), i)));
      }
      function Ku(t) {
        var e = 0, i = 0;
        return function() {
          var u = Yg(), R = y - (u - i);
          if (i = u, R > 0) {
            if (++e >= H)
              return arguments[0];
          } else
            e = 0;
          return t.apply(n, arguments);
        };
      }
      function ea(t, e) {
        var i = -1, u = t.length, R = u - 1;
        for (e = e === n ? u : e; ++i < e; ) {
          var M = os(i, R), B = t[M];
          t[M] = t[i], t[i] = B;
        }
        return t.length = e, t;
      }
      var Yu = Ep(function(t) {
        var e = [];
        return t.charCodeAt(0) === 46 && e.push(""), t.replace(m1, function(i, u, R, M) {
          e.push(R ? M.replace(R1, "$1") : u || i);
        }), e;
      });
      function er(t) {
        if (typeof t == "string" || Ae(t))
          return t;
        var e = t + "";
        return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
      }
      function Lr(t) {
        if (t != null) {
          try {
            return Fn.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function Fp(t, e) {
        return Ie(at, function(i) {
          var u = "_." + i[0];
          e & i[1] && !En(t, u) && t.push(u);
        }), t.sort();
      }
      function Xu(t) {
        if (t instanceof kt)
          return t.clone();
        var e = new Me(t.__wrapped__, t.__chain__);
        return e.__actions__ = _e(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
      }
      function Op(t, e, i) {
        (i ? de(t, e, i) : e === n) ? e = 1 : e = te(St(e), 0);
        var u = t == null ? 0 : t.length;
        if (!u || e < 1)
          return [];
        for (var R = 0, M = 0, B = Y(Gn(u / e)); R < u; )
          B[M++] = Ge(t, R, R += e);
        return B;
      }
      function kp(t) {
        for (var e = -1, i = t == null ? 0 : t.length, u = 0, R = []; ++e < i; ) {
          var M = t[e];
          M && (R[u++] = M);
        }
        return R;
      }
      function Ip() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var e = Y(t - 1), i = arguments[0], u = t; u--; )
          e[u - 1] = arguments[u];
        return vr(wt(i) ? _e(i) : [i], he(e, 1));
      }
      var Lp = At(function(t, e) {
        return Yt(t) ? gi(t, he(e, 1, Yt, !0)) : [];
      }), Mp = At(function(t, e) {
        var i = De(e);
        return Yt(i) && (i = n), Yt(t) ? gi(t, he(e, 1, Yt, !0), pt(i, 2)) : [];
      }), Np = At(function(t, e) {
        var i = De(e);
        return Yt(i) && (i = n), Yt(t) ? gi(t, he(e, 1, Yt, !0), n, i) : [];
      });
      function Gp(t, e, i) {
        var u = t == null ? 0 : t.length;
        return u ? (e = i || e === n ? 1 : St(e), Ge(t, e < 0 ? 0 : e, u)) : [];
      }
      function Dp(t, e, i) {
        var u = t == null ? 0 : t.length;
        return u ? (e = i || e === n ? 1 : St(e), e = u - e, Ge(t, 0, e < 0 ? 0 : e)) : [];
      }
      function Bp(t, e) {
        return t && t.length ? Kn(t, pt(e, 3), !0, !0) : [];
      }
      function Up(t, e) {
        return t && t.length ? Kn(t, pt(e, 3), !0) : [];
      }
      function qp(t, e, i, u) {
        var R = t == null ? 0 : t.length;
        return R ? (i && typeof i != "number" && de(t, e, i) && (i = 0, u = R), I2(t, e, i, u)) : [];
      }
      function $u(t, e, i) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var R = i == null ? 0 : St(i);
        return R < 0 && (R = te(u + R, 0)), An(t, pt(e, 3), R);
      }
      function Zu(t, e, i) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var R = u - 1;
        return i !== n && (R = St(i), R = i < 0 ? te(u + R, 0) : le(R, u - 1)), An(t, pt(e, 3), R, !0);
      }
      function Ju(t) {
        var e = t == null ? 0 : t.length;
        return e ? he(t, 1) : [];
      }
      function Hp(t) {
        var e = t == null ? 0 : t.length;
        return e ? he(t, U) : [];
      }
      function Wp(t, e) {
        var i = t == null ? 0 : t.length;
        return i ? (e = e === n ? 1 : St(e), he(t, e)) : [];
      }
      function Vp(t) {
        for (var e = -1, i = t == null ? 0 : t.length, u = {}; ++e < i; ) {
          var R = t[e];
          u[R[0]] = R[1];
        }
        return u;
      }
      function Qu(t) {
        return t && t.length ? t[0] : n;
      }
      function zp(t, e, i) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var R = i == null ? 0 : St(i);
        return R < 0 && (R = te(u + R, 0)), qr(t, e, R);
      }
      function jp(t) {
        var e = t == null ? 0 : t.length;
        return e ? Ge(t, 0, -1) : [];
      }
      var Kp = At(function(t) {
        var e = Ht(t, ds);
        return e.length && e[0] === t[0] ? rs(e) : [];
      }), Yp = At(function(t) {
        var e = De(t), i = Ht(t, ds);
        return e === De(i) ? e = n : i.pop(), i.length && i[0] === t[0] ? rs(i, pt(e, 2)) : [];
      }), Xp = At(function(t) {
        var e = De(t), i = Ht(t, ds);
        return e = typeof e == "function" ? e : n, e && i.pop(), i.length && i[0] === t[0] ? rs(i, n, e) : [];
      });
      function $p(t, e) {
        return t == null ? "" : jg.call(t, e);
      }
      function De(t) {
        var e = t == null ? 0 : t.length;
        return e ? t[e - 1] : n;
      }
      function Zp(t, e, i) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var R = u;
        return i !== n && (R = St(i), R = R < 0 ? te(u + R, 0) : le(R, u - 1)), e === e ? Fg(t, e, R) : An(t, Il, R, !0);
      }
      function Jp(t, e) {
        return t && t.length ? uu(t, St(e)) : n;
      }
      var Qp = At(tc);
      function tc(t, e) {
        return t && t.length && e && e.length ? ss(t, e) : t;
      }
      function t_(t, e, i) {
        return t && t.length && e && e.length ? ss(t, e, pt(i, 2)) : t;
      }
      function e_(t, e, i) {
        return t && t.length && e && e.length ? ss(t, e, n, i) : t;
      }
      var r_ = or(function(t, e) {
        var i = t == null ? 0 : t.length, u = Ja(t, e);
        return fu(t, Ht(e, function(R) {
          return hr(R, i) ? +R : R;
        }).sort(Cu)), u;
      });
      function i_(t, e) {
        var i = [];
        if (!(t && t.length))
          return i;
        var u = -1, R = [], M = t.length;
        for (e = pt(e, 3); ++u < M; ) {
          var B = t[u];
          e(B, u, t) && (i.push(B), R.push(u));
        }
        return fu(t, R), i;
      }
      function As(t) {
        return t == null ? t : $g.call(t);
      }
      function n_(t, e, i) {
        var u = t == null ? 0 : t.length;
        return u ? (i && typeof i != "number" && de(t, e, i) ? (e = 0, i = u) : (e = e == null ? 0 : St(e), i = i === n ? u : St(i)), Ge(t, e, i)) : [];
      }
      function a_(t, e) {
        return jn(t, e);
      }
      function s_(t, e, i) {
        return ls(t, e, pt(i, 2));
      }
      function o_(t, e) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var u = jn(t, e);
          if (u < i && Ke(t[u], e))
            return u;
        }
        return -1;
      }
      function h_(t, e) {
        return jn(t, e, !0);
      }
      function l_(t, e, i) {
        return ls(t, e, pt(i, 2), !0);
      }
      function u_(t, e) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var u = jn(t, e, !0) - 1;
          if (Ke(t[u], e))
            return u;
        }
        return -1;
      }
      function c_(t) {
        return t && t.length ? pu(t) : [];
      }
      function d_(t, e) {
        return t && t.length ? pu(t, pt(e, 2)) : [];
      }
      function f_(t) {
        var e = t == null ? 0 : t.length;
        return e ? Ge(t, 1, e) : [];
      }
      function g_(t, e, i) {
        return t && t.length ? (e = i || e === n ? 1 : St(e), Ge(t, 0, e < 0 ? 0 : e)) : [];
      }
      function p_(t, e, i) {
        var u = t == null ? 0 : t.length;
        return u ? (e = i || e === n ? 1 : St(e), e = u - e, Ge(t, e < 0 ? 0 : e, u)) : [];
      }
      function __(t, e) {
        return t && t.length ? Kn(t, pt(e, 3), !1, !0) : [];
      }
      function v_(t, e) {
        return t && t.length ? Kn(t, pt(e, 3)) : [];
      }
      var y_ = At(function(t) {
        return wr(he(t, 1, Yt, !0));
      }), m_ = At(function(t) {
        var e = De(t);
        return Yt(e) && (e = n), wr(he(t, 1, Yt, !0), pt(e, 2));
      }), b_ = At(function(t) {
        var e = De(t);
        return e = typeof e == "function" ? e : n, wr(he(t, 1, Yt, !0), n, e);
      });
      function w_(t) {
        return t && t.length ? wr(t) : [];
      }
      function S_(t, e) {
        return t && t.length ? wr(t, pt(e, 2)) : [];
      }
      function C_(t, e) {
        return e = typeof e == "function" ? e : n, t && t.length ? wr(t, n, e) : [];
      }
      function Rs(t) {
        if (!(t && t.length))
          return [];
        var e = 0;
        return t = _r(t, function(i) {
          if (Yt(i))
            return e = te(i.length, e), !0;
        }), Va(e, function(i) {
          return Ht(t, qa(i));
        });
      }
      function ec(t, e) {
        if (!(t && t.length))
          return [];
        var i = Rs(t);
        return e == null ? i : Ht(i, function(u) {
          return Ce(e, n, u);
        });
      }
      var x_ = At(function(t, e) {
        return Yt(t) ? gi(t, e) : [];
      }), E_ = At(function(t) {
        return cs(_r(t, Yt));
      }), A_ = At(function(t) {
        var e = De(t);
        return Yt(e) && (e = n), cs(_r(t, Yt), pt(e, 2));
      }), R_ = At(function(t) {
        var e = De(t);
        return e = typeof e == "function" ? e : n, cs(_r(t, Yt), n, e);
      }), T_ = At(Rs);
      function P_(t, e) {
        return mu(t || [], e || [], fi);
      }
      function F_(t, e) {
        return mu(t || [], e || [], vi);
      }
      var O_ = At(function(t) {
        var e = t.length, i = e > 1 ? t[e - 1] : n;
        return i = typeof i == "function" ? (t.pop(), i) : n, ec(t, i);
      });
      function rc(t) {
        var e = k(t);
        return e.__chain__ = !0, e;
      }
      function k_(t, e) {
        return e(t), t;
      }
      function ra(t, e) {
        return e(t);
      }
      var I_ = or(function(t) {
        var e = t.length, i = e ? t[0] : 0, u = this.__wrapped__, R = function(M) {
          return Ja(M, t);
        };
        return e > 1 || this.__actions__.length || !(u instanceof kt) || !hr(i) ? this.thru(R) : (u = u.slice(i, +i + (e ? 1 : 0)), u.__actions__.push({
          func: ra,
          args: [R],
          thisArg: n
        }), new Me(u, this.__chain__).thru(function(M) {
          return e && !M.length && M.push(n), M;
        }));
      });
      function L_() {
        return rc(this);
      }
      function M_() {
        return new Me(this.value(), this.__chain__);
      }
      function N_() {
        this.__values__ === n && (this.__values__ = _c(this.value()));
        var t = this.__index__ >= this.__values__.length, e = t ? n : this.__values__[this.__index__++];
        return { done: t, value: e };
      }
      function G_() {
        return this;
      }
      function D_(t) {
        for (var e, i = this; i instanceof qn; ) {
          var u = Xu(i);
          u.__index__ = 0, u.__values__ = n, e ? R.__wrapped__ = u : e = u;
          var R = u;
          i = i.__wrapped__;
        }
        return R.__wrapped__ = t, e;
      }
      function B_() {
        var t = this.__wrapped__;
        if (t instanceof kt) {
          var e = t;
          return this.__actions__.length && (e = new kt(this)), e = e.reverse(), e.__actions__.push({
            func: ra,
            args: [As],
            thisArg: n
          }), new Me(e, this.__chain__);
        }
        return this.thru(As);
      }
      function U_() {
        return yu(this.__wrapped__, this.__actions__);
      }
      var q_ = Yn(function(t, e, i) {
        Gt.call(t, i) ? ++t[i] : ar(t, i, 1);
      });
      function H_(t, e, i) {
        var u = wt(t) ? Ol : k2;
        return i && de(t, e, i) && (e = n), u(t, pt(e, 3));
      }
      function W_(t, e) {
        var i = wt(t) ? _r : eu;
        return i(t, pt(e, 3));
      }
      var V_ = Pu($u), z_ = Pu(Zu);
      function j_(t, e) {
        return he(ia(t, e), 1);
      }
      function K_(t, e) {
        return he(ia(t, e), U);
      }
      function Y_(t, e, i) {
        return i = i === n ? 1 : St(i), he(ia(t, e), i);
      }
      function ic(t, e) {
        var i = wt(t) ? Ie : br;
        return i(t, pt(e, 3));
      }
      function nc(t, e) {
        var i = wt(t) ? fg : tu;
        return i(t, pt(e, 3));
      }
      var X_ = Yn(function(t, e, i) {
        Gt.call(t, i) ? t[i].push(e) : ar(t, i, [e]);
      });
      function $_(t, e, i, u) {
        t = ve(t) ? t : Qr(t), i = i && !u ? St(i) : 0;
        var R = t.length;
        return i < 0 && (i = te(R + i, 0)), ha(t) ? i <= R && t.indexOf(e, i) > -1 : !!R && qr(t, e, i) > -1;
      }
      var Z_ = At(function(t, e, i) {
        var u = -1, R = typeof e == "function", M = ve(t) ? Y(t.length) : [];
        return br(t, function(B) {
          M[++u] = R ? Ce(e, B, i) : pi(B, e, i);
        }), M;
      }), J_ = Yn(function(t, e, i) {
        ar(t, i, e);
      });
      function ia(t, e) {
        var i = wt(t) ? Ht : ou;
        return i(t, pt(e, 3));
      }
      function Q_(t, e, i, u) {
        return t == null ? [] : (wt(e) || (e = e == null ? [] : [e]), i = u ? n : i, wt(i) || (i = i == null ? [] : [i]), cu(t, e, i));
      }
      var t5 = Yn(function(t, e, i) {
        t[i ? 0 : 1].push(e);
      }, function() {
        return [[], []];
      });
      function e5(t, e, i) {
        var u = wt(t) ? Ba : Ml, R = arguments.length < 3;
        return u(t, pt(e, 4), i, R, br);
      }
      function r5(t, e, i) {
        var u = wt(t) ? gg : Ml, R = arguments.length < 3;
        return u(t, pt(e, 4), i, R, tu);
      }
      function i5(t, e) {
        var i = wt(t) ? _r : eu;
        return i(t, sa(pt(e, 3)));
      }
      function n5(t) {
        var e = wt(t) ? $l : $2;
        return e(t);
      }
      function a5(t, e, i) {
        (i ? de(t, e, i) : e === n) ? e = 1 : e = St(e);
        var u = wt(t) ? R2 : Z2;
        return u(t, e);
      }
      function s5(t) {
        var e = wt(t) ? T2 : Q2;
        return e(t);
      }
      function o5(t) {
        if (t == null)
          return 0;
        if (ve(t))
          return ha(t) ? Wr(t) : t.length;
        var e = ue(t);
        return e == Et || e == Zt ? t.size : ns(t).length;
      }
      function h5(t, e, i) {
        var u = wt(t) ? Ua : tp;
        return i && de(t, e, i) && (e = n), u(t, pt(e, 3));
      }
      var l5 = At(function(t, e) {
        if (t == null)
          return [];
        var i = e.length;
        return i > 1 && de(t, e[0], e[1]) ? e = [] : i > 2 && de(e[0], e[1], e[2]) && (e = [e[0]]), cu(t, he(e, 1), []);
      }), na = Wg || function() {
        return oe.Date.now();
      };
      function u5(t, e) {
        if (typeof e != "function")
          throw new Le(h);
        return t = St(t), function() {
          if (--t < 1)
            return e.apply(this, arguments);
        };
      }
      function ac(t, e, i) {
        return e = i ? n : e, e = t && e == null ? t.length : e, sr(t, D, n, n, n, n, e);
      }
      function sc(t, e) {
        var i;
        if (typeof e != "function")
          throw new Le(h);
        return t = St(t), function() {
          return --t > 0 && (i = e.apply(this, arguments)), t <= 1 && (e = n), i;
        };
      }
      var Ts = At(function(t, e, i) {
        var u = C;
        if (i.length) {
          var R = yr(i, Zr(Ts));
          u |= E;
        }
        return sr(t, u, e, i, R);
      }), oc = At(function(t, e, i) {
        var u = C | F;
        if (i.length) {
          var R = yr(i, Zr(oc));
          u |= E;
        }
        return sr(e, u, t, i, R);
      });
      function hc(t, e, i) {
        e = i ? n : e;
        var u = sr(t, f, n, n, n, n, n, e);
        return u.placeholder = hc.placeholder, u;
      }
      function lc(t, e, i) {
        e = i ? n : e;
        var u = sr(t, m, n, n, n, n, n, e);
        return u.placeholder = lc.placeholder, u;
      }
      function uc(t, e, i) {
        var u, R, M, B, q, z, rt = 0, it = !1, nt = !1, ot = !0;
        if (typeof t != "function")
          throw new Le(h);
        e = Be(e) || 0, Vt(i) && (it = !!i.leading, nt = "maxWait" in i, M = nt ? te(Be(i.maxWait) || 0, e) : M, ot = "trailing" in i ? !!i.trailing : ot);
        function dt(Xt) {
          var Ye = u, cr = R;
          return u = R = n, rt = Xt, B = t.apply(cr, Ye), B;
        }
        function _t(Xt) {
          return rt = Xt, q = bi(Ft, e), it ? dt(Xt) : B;
        }
        function Ct(Xt) {
          var Ye = Xt - z, cr = Xt - rt, Pc = e - Ye;
          return nt ? le(Pc, M - cr) : Pc;
        }
        function vt(Xt) {
          var Ye = Xt - z, cr = Xt - rt;
          return z === n || Ye >= e || Ye < 0 || nt && cr >= M;
        }
        function Ft() {
          var Xt = na();
          if (vt(Xt))
            return It(Xt);
          q = bi(Ft, Ct(Xt));
        }
        function It(Xt) {
          return q = n, ot && u ? dt(Xt) : (u = R = n, B);
        }
        function Re() {
          q !== n && bu(q), rt = 0, u = z = R = q = n;
        }
        function fe() {
          return q === n ? B : It(na());
        }
        function Te() {
          var Xt = na(), Ye = vt(Xt);
          if (u = arguments, R = this, z = Xt, Ye) {
            if (q === n)
              return _t(z);
            if (nt)
              return bu(q), q = bi(Ft, e), dt(z);
          }
          return q === n && (q = bi(Ft, e)), B;
        }
        return Te.cancel = Re, Te.flush = fe, Te;
      }
      var c5 = At(function(t, e) {
        return Ql(t, 1, e);
      }), d5 = At(function(t, e, i) {
        return Ql(t, Be(e) || 0, i);
      });
      function f5(t) {
        return sr(t, L);
      }
      function aa(t, e) {
        if (typeof t != "function" || e != null && typeof e != "function")
          throw new Le(h);
        var i = function() {
          var u = arguments, R = e ? e.apply(this, u) : u[0], M = i.cache;
          if (M.has(R))
            return M.get(R);
          var B = t.apply(this, u);
          return i.cache = M.set(R, B) || M, B;
        };
        return i.cache = new (aa.Cache || nr)(), i;
      }
      aa.Cache = nr;
      function sa(t) {
        if (typeof t != "function")
          throw new Le(h);
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, e[0]);
            case 2:
              return !t.call(this, e[0], e[1]);
            case 3:
              return !t.call(this, e[0], e[1], e[2]);
          }
          return !t.apply(this, e);
        };
      }
      function g5(t) {
        return sc(2, t);
      }
      var p5 = ep(function(t, e) {
        e = e.length == 1 && wt(e[0]) ? Ht(e[0], xe(pt())) : Ht(he(e, 1), xe(pt()));
        var i = e.length;
        return At(function(u) {
          for (var R = -1, M = le(u.length, i); ++R < M; )
            u[R] = e[R].call(this, u[R]);
          return Ce(t, this, u);
        });
      }), Ps = At(function(t, e) {
        var i = yr(e, Zr(Ps));
        return sr(t, E, n, e, i);
      }), cc = At(function(t, e) {
        var i = yr(e, Zr(cc));
        return sr(t, T, n, e, i);
      }), _5 = or(function(t, e) {
        return sr(t, I, n, n, n, e);
      });
      function v5(t, e) {
        if (typeof t != "function")
          throw new Le(h);
        return e = e === n ? e : St(e), At(t, e);
      }
      function y5(t, e) {
        if (typeof t != "function")
          throw new Le(h);
        return e = e == null ? 0 : te(St(e), 0), At(function(i) {
          var u = i[e], R = Cr(i, 0, e);
          return u && vr(R, u), Ce(t, this, R);
        });
      }
      function m5(t, e, i) {
        var u = !0, R = !0;
        if (typeof t != "function")
          throw new Le(h);
        return Vt(i) && (u = "leading" in i ? !!i.leading : u, R = "trailing" in i ? !!i.trailing : R), uc(t, e, {
          leading: u,
          maxWait: e,
          trailing: R
        });
      }
      function b5(t) {
        return ac(t, 1);
      }
      function w5(t, e) {
        return Ps(fs(e), t);
      }
      function S5() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return wt(t) ? t : [t];
      }
      function C5(t) {
        return Ne(t, v);
      }
      function x5(t, e) {
        return e = typeof e == "function" ? e : n, Ne(t, v, e);
      }
      function E5(t) {
        return Ne(t, w | v);
      }
      function A5(t, e) {
        return e = typeof e == "function" ? e : n, Ne(t, w | v, e);
      }
      function R5(t, e) {
        return e == null || Jl(t, e, ae(e));
      }
      function Ke(t, e) {
        return t === e || t !== t && e !== e;
      }
      var T5 = Jn(es), P5 = Jn(function(t, e) {
        return t >= e;
      }), Mr = nu(/* @__PURE__ */ function() {
        return arguments;
      }()) ? nu : function(t) {
        return jt(t) && Gt.call(t, "callee") && !Vl.call(t, "callee");
      }, wt = Y.isArray, F5 = El ? xe(El) : D2;
      function ve(t) {
        return t != null && oa(t.length) && !lr(t);
      }
      function Yt(t) {
        return jt(t) && ve(t);
      }
      function O5(t) {
        return t === !0 || t === !1 || jt(t) && ce(t) == j;
      }
      var xr = zg || Us, k5 = Al ? xe(Al) : B2;
      function I5(t) {
        return jt(t) && t.nodeType === 1 && !wi(t);
      }
      function L5(t) {
        if (t == null)
          return !0;
        if (ve(t) && (wt(t) || typeof t == "string" || typeof t.splice == "function" || xr(t) || Jr(t) || Mr(t)))
          return !t.length;
        var e = ue(t);
        if (e == Et || e == Zt)
          return !t.size;
        if (mi(t))
          return !ns(t).length;
        for (var i in t)
          if (Gt.call(t, i))
            return !1;
        return !0;
      }
      function M5(t, e) {
        return _i(t, e);
      }
      function N5(t, e, i) {
        i = typeof i == "function" ? i : n;
        var u = i ? i(t, e) : n;
        return u === n ? _i(t, e, n, i) : !!u;
      }
      function Fs(t) {
        if (!jt(t))
          return !1;
        var e = ce(t);
        return e == ft || e == ut || typeof t.message == "string" && typeof t.name == "string" && !wi(t);
      }
      function G5(t) {
        return typeof t == "number" && jl(t);
      }
      function lr(t) {
        if (!Vt(t))
          return !1;
        var e = ce(t);
        return e == gt || e == Lt || e == W || e == pr;
      }
      function dc(t) {
        return typeof t == "number" && t == St(t);
      }
      function oa(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= K;
      }
      function Vt(t) {
        var e = typeof t;
        return t != null && (e == "object" || e == "function");
      }
      function jt(t) {
        return t != null && typeof t == "object";
      }
      var fc = Rl ? xe(Rl) : q2;
      function D5(t, e) {
        return t === e || is(t, e, bs(e));
      }
      function B5(t, e, i) {
        return i = typeof i == "function" ? i : n, is(t, e, bs(e), i);
      }
      function U5(t) {
        return gc(t) && t != +t;
      }
      function q5(t) {
        if (xp(t))
          throw new bt(s);
        return au(t);
      }
      function H5(t) {
        return t === null;
      }
      function W5(t) {
        return t == null;
      }
      function gc(t) {
        return typeof t == "number" || jt(t) && ce(t) == mt;
      }
      function wi(t) {
        if (!jt(t) || ce(t) != Pt)
          return !1;
        var e = Ln(t);
        if (e === null)
          return !0;
        var i = Gt.call(e, "constructor") && e.constructor;
        return typeof i == "function" && i instanceof i && Fn.call(i) == Bg;
      }
      var Os = Tl ? xe(Tl) : H2;
      function V5(t) {
        return dc(t) && t >= -9007199254740991 && t <= K;
      }
      var pc = Pl ? xe(Pl) : W2;
      function ha(t) {
        return typeof t == "string" || !wt(t) && jt(t) && ce(t) == Jt;
      }
      function Ae(t) {
        return typeof t == "symbol" || jt(t) && ce(t) == Ut;
      }
      var Jr = Fl ? xe(Fl) : V2;
      function z5(t) {
        return t === n;
      }
      function j5(t) {
        return jt(t) && ue(t) == ie;
      }
      function K5(t) {
        return jt(t) && ce(t) == We;
      }
      var Y5 = Jn(as), X5 = Jn(function(t, e) {
        return t <= e;
      });
      function _c(t) {
        if (!t)
          return [];
        if (ve(t))
          return ha(t) ? ze(t) : _e(t);
        if (hi && t[hi])
          return Rg(t[hi]());
        var e = ue(t), i = e == Et ? ja : e == Zt ? Rn : Qr;
        return i(t);
      }
      function ur(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = Be(t), t === U || t === -1 / 0) {
          var e = t < 0 ? -1 : 1;
          return e * $;
        }
        return t === t ? t : 0;
      }
      function St(t) {
        var e = ur(t), i = e % 1;
        return e === e ? i ? e - i : e : 0;
      }
      function vc(t) {
        return t ? Or(St(t), 0, Q) : 0;
      }
      function Be(t) {
        if (typeof t == "number")
          return t;
        if (Ae(t))
          return X;
        if (Vt(t)) {
          var e = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = Vt(e) ? e + "" : e;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = Nl(t);
        var i = F1.test(t);
        return i || k1.test(t) ? ug(t.slice(2), i ? 2 : 8) : P1.test(t) ? X : +t;
      }
      function yc(t) {
        return tr(t, ye(t));
      }
      function $5(t) {
        return t ? Or(St(t), -9007199254740991, K) : t === 0 ? t : 0;
      }
      function Nt(t) {
        return t == null ? "" : Ee(t);
      }
      var Z5 = Xr(function(t, e) {
        if (mi(e) || ve(e)) {
          tr(e, ae(e), t);
          return;
        }
        for (var i in e)
          Gt.call(e, i) && fi(t, i, e[i]);
      }), mc = Xr(function(t, e) {
        tr(e, ye(e), t);
      }), la = Xr(function(t, e, i, u) {
        tr(e, ye(e), t, u);
      }), J5 = Xr(function(t, e, i, u) {
        tr(e, ae(e), t, u);
      }), Q5 = or(Ja);
      function t3(t, e) {
        var i = Yr(t);
        return e == null ? i : Zl(i, e);
      }
      var e3 = At(function(t, e) {
        t = Dt(t);
        var i = -1, u = e.length, R = u > 2 ? e[2] : n;
        for (R && de(e[0], e[1], R) && (u = 1); ++i < u; )
          for (var M = e[i], B = ye(M), q = -1, z = B.length; ++q < z; ) {
            var rt = B[q], it = t[rt];
            (it === n || Ke(it, zr[rt]) && !Gt.call(t, rt)) && (t[rt] = M[rt]);
          }
        return t;
      }), r3 = At(function(t) {
        return t.push(n, Nu), Ce(bc, n, t);
      });
      function i3(t, e) {
        return kl(t, pt(e, 3), Qe);
      }
      function n3(t, e) {
        return kl(t, pt(e, 3), ts);
      }
      function a3(t, e) {
        return t == null ? t : Qa(t, pt(e, 3), ye);
      }
      function s3(t, e) {
        return t == null ? t : ru(t, pt(e, 3), ye);
      }
      function o3(t, e) {
        return t && Qe(t, pt(e, 3));
      }
      function h3(t, e) {
        return t && ts(t, pt(e, 3));
      }
      function l3(t) {
        return t == null ? [] : Vn(t, ae(t));
      }
      function u3(t) {
        return t == null ? [] : Vn(t, ye(t));
      }
      function ks(t, e, i) {
        var u = t == null ? n : kr(t, e);
        return u === n ? i : u;
      }
      function c3(t, e) {
        return t != null && Bu(t, e, L2);
      }
      function Is(t, e) {
        return t != null && Bu(t, e, M2);
      }
      var d3 = Ou(function(t, e, i) {
        e != null && typeof e.toString != "function" && (e = On.call(e)), t[e] = i;
      }, Ms(me)), f3 = Ou(function(t, e, i) {
        e != null && typeof e.toString != "function" && (e = On.call(e)), Gt.call(t, e) ? t[e].push(i) : t[e] = [i];
      }, pt), g3 = At(pi);
      function ae(t) {
        return ve(t) ? Xl(t) : ns(t);
      }
      function ye(t) {
        return ve(t) ? Xl(t, !0) : z2(t);
      }
      function p3(t, e) {
        var i = {};
        return e = pt(e, 3), Qe(t, function(u, R, M) {
          ar(i, e(u, R, M), u);
        }), i;
      }
      function _3(t, e) {
        var i = {};
        return e = pt(e, 3), Qe(t, function(u, R, M) {
          ar(i, R, e(u, R, M));
        }), i;
      }
      var v3 = Xr(function(t, e, i) {
        zn(t, e, i);
      }), bc = Xr(function(t, e, i, u) {
        zn(t, e, i, u);
      }), y3 = or(function(t, e) {
        var i = {};
        if (t == null)
          return i;
        var u = !1;
        e = Ht(e, function(M) {
          return M = Sr(M, t), u || (u = M.length > 1), M;
        }), tr(t, ys(t), i), u && (i = Ne(i, w | x | v, dp));
        for (var R = e.length; R--; )
          us(i, e[R]);
        return i;
      });
      function m3(t, e) {
        return wc(t, sa(pt(e)));
      }
      var b3 = or(function(t, e) {
        return t == null ? {} : K2(t, e);
      });
      function wc(t, e) {
        if (t == null)
          return {};
        var i = Ht(ys(t), function(u) {
          return [u];
        });
        return e = pt(e), du(t, i, function(u, R) {
          return e(u, R[0]);
        });
      }
      function w3(t, e, i) {
        e = Sr(e, t);
        var u = -1, R = e.length;
        for (R || (R = 1, t = n); ++u < R; ) {
          var M = t == null ? n : t[er(e[u])];
          M === n && (u = R, M = i), t = lr(M) ? M.call(t) : M;
        }
        return t;
      }
      function S3(t, e, i) {
        return t == null ? t : vi(t, e, i);
      }
      function C3(t, e, i, u) {
        return u = typeof u == "function" ? u : n, t == null ? t : vi(t, e, i, u);
      }
      var Sc = Lu(ae), Cc = Lu(ye);
      function x3(t, e, i) {
        var u = wt(t), R = u || xr(t) || Jr(t);
        if (e = pt(e, 4), i == null) {
          var M = t && t.constructor;
          R ? i = u ? new M() : [] : Vt(t) ? i = lr(M) ? Yr(Ln(t)) : {} : i = {};
        }
        return (R ? Ie : Qe)(t, function(B, q, z) {
          return e(i, B, q, z);
        }), i;
      }
      function E3(t, e) {
        return t == null ? !0 : us(t, e);
      }
      function A3(t, e, i) {
        return t == null ? t : vu(t, e, fs(i));
      }
      function R3(t, e, i, u) {
        return u = typeof u == "function" ? u : n, t == null ? t : vu(t, e, fs(i), u);
      }
      function Qr(t) {
        return t == null ? [] : za(t, ae(t));
      }
      function T3(t) {
        return t == null ? [] : za(t, ye(t));
      }
      function P3(t, e, i) {
        return i === n && (i = e, e = n), i !== n && (i = Be(i), i = i === i ? i : 0), e !== n && (e = Be(e), e = e === e ? e : 0), Or(Be(t), e, i);
      }
      function F3(t, e, i) {
        return e = ur(e), i === n ? (i = e, e = 0) : i = ur(i), t = Be(t), N2(t, e, i);
      }
      function O3(t, e, i) {
        if (i && typeof i != "boolean" && de(t, e, i) && (e = i = n), i === n && (typeof e == "boolean" ? (i = e, e = n) : typeof t == "boolean" && (i = t, t = n)), t === n && e === n ? (t = 0, e = 1) : (t = ur(t), e === n ? (e = t, t = 0) : e = ur(e)), t > e) {
          var u = t;
          t = e, e = u;
        }
        if (i || t % 1 || e % 1) {
          var R = Kl();
          return le(t + R * (e - t + lg("1e-" + ((R + "").length - 1))), e);
        }
        return os(t, e);
      }
      var k3 = $r(function(t, e, i) {
        return e = e.toLowerCase(), t + (i ? xc(e) : e);
      });
      function xc(t) {
        return Ls(Nt(t).toLowerCase());
      }
      function Ec(t) {
        return t = Nt(t), t && t.replace(L1, Sg).replace(Q1, "");
      }
      function I3(t, e, i) {
        t = Nt(t), e = Ee(e);
        var u = t.length;
        i = i === n ? u : Or(St(i), 0, u);
        var R = i;
        return i -= e.length, i >= 0 && t.slice(i, R) == e;
      }
      function L3(t) {
        return t = Nt(t), t && g1.test(t) ? t.replace(rl, Cg) : t;
      }
      function M3(t) {
        return t = Nt(t), t && b1.test(t) ? t.replace(Pa, "\\$&") : t;
      }
      var N3 = $r(function(t, e, i) {
        return t + (i ? "-" : "") + e.toLowerCase();
      }), G3 = $r(function(t, e, i) {
        return t + (i ? " " : "") + e.toLowerCase();
      }), D3 = Tu("toLowerCase");
      function B3(t, e, i) {
        t = Nt(t), e = St(e);
        var u = e ? Wr(t) : 0;
        if (!e || u >= e)
          return t;
        var R = (e - u) / 2;
        return Zn(Dn(R), i) + t + Zn(Gn(R), i);
      }
      function U3(t, e, i) {
        t = Nt(t), e = St(e);
        var u = e ? Wr(t) : 0;
        return e && u < e ? t + Zn(e - u, i) : t;
      }
      function q3(t, e, i) {
        t = Nt(t), e = St(e);
        var u = e ? Wr(t) : 0;
        return e && u < e ? Zn(e - u, i) + t : t;
      }
      function H3(t, e, i) {
        return i || e == null ? e = 0 : e && (e = +e), Xg(Nt(t).replace(Fa, ""), e || 0);
      }
      function W3(t, e, i) {
        return (i ? de(t, e, i) : e === n) ? e = 1 : e = St(e), hs(Nt(t), e);
      }
      function V3() {
        var t = arguments, e = Nt(t[0]);
        return t.length < 3 ? e : e.replace(t[1], t[2]);
      }
      var z3 = $r(function(t, e, i) {
        return t + (i ? "_" : "") + e.toLowerCase();
      });
      function j3(t, e, i) {
        return i && typeof i != "number" && de(t, e, i) && (e = i = n), i = i === n ? Q : i >>> 0, i ? (t = Nt(t), t && (typeof e == "string" || e != null && !Os(e)) && (e = Ee(e), !e && Hr(t)) ? Cr(ze(t), 0, i) : t.split(e, i)) : [];
      }
      var K3 = $r(function(t, e, i) {
        return t + (i ? " " : "") + Ls(e);
      });
      function Y3(t, e, i) {
        return t = Nt(t), i = i == null ? 0 : Or(St(i), 0, t.length), e = Ee(e), t.slice(i, i + e.length) == e;
      }
      function X3(t, e, i) {
        var u = k.templateSettings;
        i && de(t, e, i) && (e = n), t = Nt(t), e = la({}, e, u, Mu);
        var R = la({}, e.imports, u.imports, Mu), M = ae(R), B = za(R, M), q, z, rt = 0, it = e.interpolate || Sn, nt = "__p += '", ot = Ka(
          (e.escape || Sn).source + "|" + it.source + "|" + (it === il ? T1 : Sn).source + "|" + (e.evaluate || Sn).source + "|$",
          "g"
        ), dt = "//# sourceURL=" + (Gt.call(e, "sourceURL") ? (e.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ng + "]") + `
`;
        t.replace(ot, function(vt, Ft, It, Re, fe, Te) {
          return It || (It = Re), nt += t.slice(rt, Te).replace(M1, xg), Ft && (q = !0, nt += `' +
__e(` + Ft + `) +
'`), fe && (z = !0, nt += `';
` + fe + `;
__p += '`), It && (nt += `' +
((__t = (` + It + `)) == null ? '' : __t) +
'`), rt = Te + vt.length, vt;
        }), nt += `';
`;
        var _t = Gt.call(e, "variable") && e.variable;
        if (!_t)
          nt = `with (obj) {
` + nt + `
}
`;
        else if (A1.test(_t))
          throw new bt(l);
        nt = (z ? nt.replace(u1, "") : nt).replace(c1, "$1").replace(d1, "$1;"), nt = "function(" + (_t || "obj") + `) {
` + (_t ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (q ? ", __e = _.escape" : "") + (z ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + nt + `return __p
}`;
        var Ct = Rc(function() {
          return Mt(M, dt + "return " + nt).apply(n, B);
        });
        if (Ct.source = nt, Fs(Ct))
          throw Ct;
        return Ct;
      }
      function $3(t) {
        return Nt(t).toLowerCase();
      }
      function Z3(t) {
        return Nt(t).toUpperCase();
      }
      function J3(t, e, i) {
        if (t = Nt(t), t && (i || e === n))
          return Nl(t);
        if (!t || !(e = Ee(e)))
          return t;
        var u = ze(t), R = ze(e), M = Gl(u, R), B = Dl(u, R) + 1;
        return Cr(u, M, B).join("");
      }
      function Q3(t, e, i) {
        if (t = Nt(t), t && (i || e === n))
          return t.slice(0, Ul(t) + 1);
        if (!t || !(e = Ee(e)))
          return t;
        var u = ze(t), R = Dl(u, ze(e)) + 1;
        return Cr(u, 0, R).join("");
      }
      function t4(t, e, i) {
        if (t = Nt(t), t && (i || e === n))
          return t.replace(Fa, "");
        if (!t || !(e = Ee(e)))
          return t;
        var u = ze(t), R = Gl(u, ze(e));
        return Cr(u, R).join("");
      }
      function e4(t, e) {
        var i = O, u = N;
        if (Vt(e)) {
          var R = "separator" in e ? e.separator : R;
          i = "length" in e ? St(e.length) : i, u = "omission" in e ? Ee(e.omission) : u;
        }
        t = Nt(t);
        var M = t.length;
        if (Hr(t)) {
          var B = ze(t);
          M = B.length;
        }
        if (i >= M)
          return t;
        var q = i - Wr(u);
        if (q < 1)
          return u;
        var z = B ? Cr(B, 0, q).join("") : t.slice(0, q);
        if (R === n)
          return z + u;
        if (B && (q += z.length - q), Os(R)) {
          if (t.slice(q).search(R)) {
            var rt, it = z;
            for (R.global || (R = Ka(R.source, Nt(nl.exec(R)) + "g")), R.lastIndex = 0; rt = R.exec(it); )
              var nt = rt.index;
            z = z.slice(0, nt === n ? q : nt);
          }
        } else if (t.indexOf(Ee(R), q) != q) {
          var ot = z.lastIndexOf(R);
          ot > -1 && (z = z.slice(0, ot));
        }
        return z + u;
      }
      function r4(t) {
        return t = Nt(t), t && f1.test(t) ? t.replace(el, Og) : t;
      }
      var i4 = $r(function(t, e, i) {
        return t + (i ? " " : "") + e.toUpperCase();
      }), Ls = Tu("toUpperCase");
      function Ac(t, e, i) {
        return t = Nt(t), e = i ? n : e, e === n ? Ag(t) ? Lg(t) : vg(t) : t.match(e) || [];
      }
      var Rc = At(function(t, e) {
        try {
          return Ce(t, n, e);
        } catch (i) {
          return Fs(i) ? i : new bt(i);
        }
      }), n4 = or(function(t, e) {
        return Ie(e, function(i) {
          i = er(i), ar(t, i, Ts(t[i], t));
        }), t;
      });
      function a4(t) {
        var e = t == null ? 0 : t.length, i = pt();
        return t = e ? Ht(t, function(u) {
          if (typeof u[1] != "function")
            throw new Le(h);
          return [i(u[0]), u[1]];
        }) : [], At(function(u) {
          for (var R = -1; ++R < e; ) {
            var M = t[R];
            if (Ce(M[0], this, u))
              return Ce(M[1], this, u);
          }
        });
      }
      function s4(t) {
        return O2(Ne(t, w));
      }
      function Ms(t) {
        return function() {
          return t;
        };
      }
      function o4(t, e) {
        return t == null || t !== t ? e : t;
      }
      var h4 = Fu(), l4 = Fu(!0);
      function me(t) {
        return t;
      }
      function Ns(t) {
        return su(typeof t == "function" ? t : Ne(t, w));
      }
      function u4(t) {
        return hu(Ne(t, w));
      }
      function c4(t, e) {
        return lu(t, Ne(e, w));
      }
      var d4 = At(function(t, e) {
        return function(i) {
          return pi(i, t, e);
        };
      }), f4 = At(function(t, e) {
        return function(i) {
          return pi(t, i, e);
        };
      });
      function Gs(t, e, i) {
        var u = ae(e), R = Vn(e, u);
        i == null && !(Vt(e) && (R.length || !u.length)) && (i = e, e = t, t = this, R = Vn(e, ae(e)));
        var M = !(Vt(i) && "chain" in i) || !!i.chain, B = lr(t);
        return Ie(R, function(q) {
          var z = e[q];
          t[q] = z, B && (t.prototype[q] = function() {
            var rt = this.__chain__;
            if (M || rt) {
              var it = t(this.__wrapped__), nt = it.__actions__ = _e(this.__actions__);
              return nt.push({ func: z, args: arguments, thisArg: t }), it.__chain__ = rt, it;
            }
            return z.apply(t, vr([this.value()], arguments));
          });
        }), t;
      }
      function g4() {
        return oe._ === this && (oe._ = Ug), this;
      }
      function Ds() {
      }
      function p4(t) {
        return t = St(t), At(function(e) {
          return uu(e, t);
        });
      }
      var _4 = ps(Ht), v4 = ps(Ol), y4 = ps(Ua);
      function Tc(t) {
        return Ss(t) ? qa(er(t)) : Y2(t);
      }
      function m4(t) {
        return function(e) {
          return t == null ? n : kr(t, e);
        };
      }
      var b4 = ku(), w4 = ku(!0);
      function Bs() {
        return [];
      }
      function Us() {
        return !1;
      }
      function S4() {
        return {};
      }
      function C4() {
        return "";
      }
      function x4() {
        return !0;
      }
      function E4(t, e) {
        if (t = St(t), t < 1 || t > K)
          return [];
        var i = Q, u = le(t, Q);
        e = pt(e), t -= Q;
        for (var R = Va(u, e); ++i < t; )
          e(i);
        return R;
      }
      function A4(t) {
        return wt(t) ? Ht(t, er) : Ae(t) ? [t] : _e(Yu(Nt(t)));
      }
      function R4(t) {
        var e = ++Dg;
        return Nt(t) + e;
      }
      var T4 = $n(function(t, e) {
        return t + e;
      }, 0), P4 = _s("ceil"), F4 = $n(function(t, e) {
        return t / e;
      }, 1), O4 = _s("floor");
      function k4(t) {
        return t && t.length ? Wn(t, me, es) : n;
      }
      function I4(t, e) {
        return t && t.length ? Wn(t, pt(e, 2), es) : n;
      }
      function L4(t) {
        return Ll(t, me);
      }
      function M4(t, e) {
        return Ll(t, pt(e, 2));
      }
      function N4(t) {
        return t && t.length ? Wn(t, me, as) : n;
      }
      function G4(t, e) {
        return t && t.length ? Wn(t, pt(e, 2), as) : n;
      }
      var D4 = $n(function(t, e) {
        return t * e;
      }, 1), B4 = _s("round"), U4 = $n(function(t, e) {
        return t - e;
      }, 0);
      function q4(t) {
        return t && t.length ? Wa(t, me) : 0;
      }
      function H4(t, e) {
        return t && t.length ? Wa(t, pt(e, 2)) : 0;
      }
      return k.after = u5, k.ary = ac, k.assign = Z5, k.assignIn = mc, k.assignInWith = la, k.assignWith = J5, k.at = Q5, k.before = sc, k.bind = Ts, k.bindAll = n4, k.bindKey = oc, k.castArray = S5, k.chain = rc, k.chunk = Op, k.compact = kp, k.concat = Ip, k.cond = a4, k.conforms = s4, k.constant = Ms, k.countBy = q_, k.create = t3, k.curry = hc, k.curryRight = lc, k.debounce = uc, k.defaults = e3, k.defaultsDeep = r3, k.defer = c5, k.delay = d5, k.difference = Lp, k.differenceBy = Mp, k.differenceWith = Np, k.drop = Gp, k.dropRight = Dp, k.dropRightWhile = Bp, k.dropWhile = Up, k.fill = qp, k.filter = W_, k.flatMap = j_, k.flatMapDeep = K_, k.flatMapDepth = Y_, k.flatten = Ju, k.flattenDeep = Hp, k.flattenDepth = Wp, k.flip = f5, k.flow = h4, k.flowRight = l4, k.fromPairs = Vp, k.functions = l3, k.functionsIn = u3, k.groupBy = X_, k.initial = jp, k.intersection = Kp, k.intersectionBy = Yp, k.intersectionWith = Xp, k.invert = d3, k.invertBy = f3, k.invokeMap = Z_, k.iteratee = Ns, k.keyBy = J_, k.keys = ae, k.keysIn = ye, k.map = ia, k.mapKeys = p3, k.mapValues = _3, k.matches = u4, k.matchesProperty = c4, k.memoize = aa, k.merge = v3, k.mergeWith = bc, k.method = d4, k.methodOf = f4, k.mixin = Gs, k.negate = sa, k.nthArg = p4, k.omit = y3, k.omitBy = m3, k.once = g5, k.orderBy = Q_, k.over = _4, k.overArgs = p5, k.overEvery = v4, k.overSome = y4, k.partial = Ps, k.partialRight = cc, k.partition = t5, k.pick = b3, k.pickBy = wc, k.property = Tc, k.propertyOf = m4, k.pull = Qp, k.pullAll = tc, k.pullAllBy = t_, k.pullAllWith = e_, k.pullAt = r_, k.range = b4, k.rangeRight = w4, k.rearg = _5, k.reject = i5, k.remove = i_, k.rest = v5, k.reverse = As, k.sampleSize = a5, k.set = S3, k.setWith = C3, k.shuffle = s5, k.slice = n_, k.sortBy = l5, k.sortedUniq = c_, k.sortedUniqBy = d_, k.split = j3, k.spread = y5, k.tail = f_, k.take = g_, k.takeRight = p_, k.takeRightWhile = __, k.takeWhile = v_, k.tap = k_, k.throttle = m5, k.thru = ra, k.toArray = _c, k.toPairs = Sc, k.toPairsIn = Cc, k.toPath = A4, k.toPlainObject = yc, k.transform = x3, k.unary = b5, k.union = y_, k.unionBy = m_, k.unionWith = b_, k.uniq = w_, k.uniqBy = S_, k.uniqWith = C_, k.unset = E3, k.unzip = Rs, k.unzipWith = ec, k.update = A3, k.updateWith = R3, k.values = Qr, k.valuesIn = T3, k.without = x_, k.words = Ac, k.wrap = w5, k.xor = E_, k.xorBy = A_, k.xorWith = R_, k.zip = T_, k.zipObject = P_, k.zipObjectDeep = F_, k.zipWith = O_, k.entries = Sc, k.entriesIn = Cc, k.extend = mc, k.extendWith = la, Gs(k, k), k.add = T4, k.attempt = Rc, k.camelCase = k3, k.capitalize = xc, k.ceil = P4, k.clamp = P3, k.clone = C5, k.cloneDeep = E5, k.cloneDeepWith = A5, k.cloneWith = x5, k.conformsTo = R5, k.deburr = Ec, k.defaultTo = o4, k.divide = F4, k.endsWith = I3, k.eq = Ke, k.escape = L3, k.escapeRegExp = M3, k.every = H_, k.find = V_, k.findIndex = $u, k.findKey = i3, k.findLast = z_, k.findLastIndex = Zu, k.findLastKey = n3, k.floor = O4, k.forEach = ic, k.forEachRight = nc, k.forIn = a3, k.forInRight = s3, k.forOwn = o3, k.forOwnRight = h3, k.get = ks, k.gt = T5, k.gte = P5, k.has = c3, k.hasIn = Is, k.head = Qu, k.identity = me, k.includes = $_, k.indexOf = zp, k.inRange = F3, k.invoke = g3, k.isArguments = Mr, k.isArray = wt, k.isArrayBuffer = F5, k.isArrayLike = ve, k.isArrayLikeObject = Yt, k.isBoolean = O5, k.isBuffer = xr, k.isDate = k5, k.isElement = I5, k.isEmpty = L5, k.isEqual = M5, k.isEqualWith = N5, k.isError = Fs, k.isFinite = G5, k.isFunction = lr, k.isInteger = dc, k.isLength = oa, k.isMap = fc, k.isMatch = D5, k.isMatchWith = B5, k.isNaN = U5, k.isNative = q5, k.isNil = W5, k.isNull = H5, k.isNumber = gc, k.isObject = Vt, k.isObjectLike = jt, k.isPlainObject = wi, k.isRegExp = Os, k.isSafeInteger = V5, k.isSet = pc, k.isString = ha, k.isSymbol = Ae, k.isTypedArray = Jr, k.isUndefined = z5, k.isWeakMap = j5, k.isWeakSet = K5, k.join = $p, k.kebabCase = N3, k.last = De, k.lastIndexOf = Zp, k.lowerCase = G3, k.lowerFirst = D3, k.lt = Y5, k.lte = X5, k.max = k4, k.maxBy = I4, k.mean = L4, k.meanBy = M4, k.min = N4, k.minBy = G4, k.stubArray = Bs, k.stubFalse = Us, k.stubObject = S4, k.stubString = C4, k.stubTrue = x4, k.multiply = D4, k.nth = Jp, k.noConflict = g4, k.noop = Ds, k.now = na, k.pad = B3, k.padEnd = U3, k.padStart = q3, k.parseInt = H3, k.random = O3, k.reduce = e5, k.reduceRight = r5, k.repeat = W3, k.replace = V3, k.result = w3, k.round = B4, k.runInContext = V, k.sample = n5, k.size = o5, k.snakeCase = z3, k.some = h5, k.sortedIndex = a_, k.sortedIndexBy = s_, k.sortedIndexOf = o_, k.sortedLastIndex = h_, k.sortedLastIndexBy = l_, k.sortedLastIndexOf = u_, k.startCase = K3, k.startsWith = Y3, k.subtract = U4, k.sum = q4, k.sumBy = H4, k.template = X3, k.times = E4, k.toFinite = ur, k.toInteger = St, k.toLength = vc, k.toLower = $3, k.toNumber = Be, k.toSafeInteger = $5, k.toString = Nt, k.toUpper = Z3, k.trim = J3, k.trimEnd = Q3, k.trimStart = t4, k.truncate = e4, k.unescape = r4, k.uniqueId = R4, k.upperCase = i4, k.upperFirst = Ls, k.each = ic, k.eachRight = nc, k.first = Qu, Gs(k, function() {
        var t = {};
        return Qe(k, function(e, i) {
          Gt.call(k.prototype, i) || (t[i] = e);
        }), t;
      }(), { chain: !1 }), k.VERSION = o, Ie(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        k[t].placeholder = k;
      }), Ie(["drop", "take"], function(t, e) {
        kt.prototype[t] = function(i) {
          i = i === n ? 1 : te(St(i), 0);
          var u = this.__filtered__ && !e ? new kt(this) : this.clone();
          return u.__filtered__ ? u.__takeCount__ = le(i, u.__takeCount__) : u.__views__.push({
            size: le(i, Q),
            type: t + (u.__dir__ < 0 ? "Right" : "")
          }), u;
        }, kt.prototype[t + "Right"] = function(i) {
          return this.reverse()[t](i).reverse();
        };
      }), Ie(["filter", "map", "takeWhile"], function(t, e) {
        var i = e + 1, u = i == P || i == G;
        kt.prototype[t] = function(R) {
          var M = this.clone();
          return M.__iteratees__.push({
            iteratee: pt(R, 3),
            type: i
          }), M.__filtered__ = M.__filtered__ || u, M;
        };
      }), Ie(["head", "last"], function(t, e) {
        var i = "take" + (e ? "Right" : "");
        kt.prototype[t] = function() {
          return this[i](1).value()[0];
        };
      }), Ie(["initial", "tail"], function(t, e) {
        var i = "drop" + (e ? "" : "Right");
        kt.prototype[t] = function() {
          return this.__filtered__ ? new kt(this) : this[i](1);
        };
      }), kt.prototype.compact = function() {
        return this.filter(me);
      }, kt.prototype.find = function(t) {
        return this.filter(t).head();
      }, kt.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, kt.prototype.invokeMap = At(function(t, e) {
        return typeof t == "function" ? new kt(this) : this.map(function(i) {
          return pi(i, t, e);
        });
      }), kt.prototype.reject = function(t) {
        return this.filter(sa(pt(t)));
      }, kt.prototype.slice = function(t, e) {
        t = St(t);
        var i = this;
        return i.__filtered__ && (t > 0 || e < 0) ? new kt(i) : (t < 0 ? i = i.takeRight(-t) : t && (i = i.drop(t)), e !== n && (e = St(e), i = e < 0 ? i.dropRight(-e) : i.take(e - t)), i);
      }, kt.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, kt.prototype.toArray = function() {
        return this.take(Q);
      }, Qe(kt.prototype, function(t, e) {
        var i = /^(?:filter|find|map|reject)|While$/.test(e), u = /^(?:head|last)$/.test(e), R = k[u ? "take" + (e == "last" ? "Right" : "") : e], M = u || /^find/.test(e);
        R && (k.prototype[e] = function() {
          var B = this.__wrapped__, q = u ? [1] : arguments, z = B instanceof kt, rt = q[0], it = z || wt(B), nt = function(Ft) {
            var It = R.apply(k, vr([Ft], q));
            return u && ot ? It[0] : It;
          };
          it && i && typeof rt == "function" && rt.length != 1 && (z = it = !1);
          var ot = this.__chain__, dt = !!this.__actions__.length, _t = M && !ot, Ct = z && !dt;
          if (!M && it) {
            B = Ct ? B : new kt(this);
            var vt = t.apply(B, q);
            return vt.__actions__.push({ func: ra, args: [nt], thisArg: n }), new Me(vt, ot);
          }
          return _t && Ct ? t.apply(this, q) : (vt = this.thru(nt), _t ? u ? vt.value()[0] : vt.value() : vt);
        });
      }), Ie(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var e = Tn[t], i = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", u = /^(?:pop|shift)$/.test(t);
        k.prototype[t] = function() {
          var R = arguments;
          if (u && !this.__chain__) {
            var M = this.value();
            return e.apply(wt(M) ? M : [], R);
          }
          return this[i](function(B) {
            return e.apply(wt(B) ? B : [], R);
          });
        };
      }), Qe(kt.prototype, function(t, e) {
        var i = k[e];
        if (i) {
          var u = i.name + "";
          Gt.call(Kr, u) || (Kr[u] = []), Kr[u].push({ name: e, func: i });
        }
      }), Kr[Xn(n, F).name] = [{
        name: "wrapper",
        func: n
      }], kt.prototype.clone = r2, kt.prototype.reverse = i2, kt.prototype.value = n2, k.prototype.at = I_, k.prototype.chain = L_, k.prototype.commit = M_, k.prototype.next = N_, k.prototype.plant = D_, k.prototype.reverse = B_, k.prototype.toJSON = k.prototype.valueOf = k.prototype.value = U_, k.prototype.first = k.prototype.head, hi && (k.prototype[hi] = G_), k;
    }, Vr = Mg();
    Rr ? ((Rr.exports = Vr)._ = Vr, Na._ = Vr) : oe._ = Vr;
  }).call(Si);
})(ga, ga.exports);
ga.exports;
Object.values(ge);
const z4 = Object.values(Ar), j4 = (r) => z4.includes(r);
var gr = /* @__PURE__ */ ((r) => (r.SPOT = "spot", r.DECORATION = "decoration", r))(gr || {});
function W0(r) {
  return !r || typeof r != "object" ? !1 : "type" in r && "subType" in r ? r.type === "spot" && j4(r.subType) : !1;
}
var ii = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function yn(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var qs, Fc;
function mn() {
  if (Fc) return qs;
  Fc = 1;
  function r(a) {
    var n = typeof a;
    return a != null && (n == "object" || n == "function");
  }
  return qs = r, qs;
}
var Hs, Oc;
function V0() {
  if (Oc) return Hs;
  Oc = 1;
  var r = typeof ii == "object" && ii && ii.Object === Object && ii;
  return Hs = r, Hs;
}
var Ws, kc;
function $e() {
  if (kc) return Ws;
  kc = 1;
  var r = V0(), a = typeof self == "object" && self && self.Object === Object && self, n = r || a || Function("return this")();
  return Ws = n, Ws;
}
var Vs, Ic;
function K4() {
  if (Ic) return Vs;
  Ic = 1;
  var r = $e(), a = function() {
    return r.Date.now();
  };
  return Vs = a, Vs;
}
var zs, Lc;
function Y4() {
  if (Lc) return zs;
  Lc = 1;
  var r = /\s/;
  function a(n) {
    for (var o = n.length; o-- && r.test(n.charAt(o)); )
      ;
    return o;
  }
  return zs = a, zs;
}
var js, Mc;
function X4() {
  if (Mc) return js;
  Mc = 1;
  var r = Y4(), a = /^\s+/;
  function n(o) {
    return o && o.slice(0, r(o) + 1).replace(a, "");
  }
  return js = n, js;
}
var Ks, Nc;
function ma() {
  if (Nc) return Ks;
  Nc = 1;
  var r = $e(), a = r.Symbol;
  return Ks = a, Ks;
}
var Ys, Gc;
function $4() {
  if (Gc) return Ys;
  Gc = 1;
  var r = ma(), a = Object.prototype, n = a.hasOwnProperty, o = a.toString, c = r ? r.toStringTag : void 0;
  function s(h) {
    var l = n.call(h, c), g = h[c];
    try {
      h[c] = void 0;
      var p = !0;
    } catch {
    }
    var b = o.call(h);
    return p && (l ? h[c] = g : delete h[c]), b;
  }
  return Ys = s, Ys;
}
var Xs, Dc;
function Z4() {
  if (Dc) return Xs;
  Dc = 1;
  var r = Object.prototype, a = r.toString;
  function n(o) {
    return a.call(o);
  }
  return Xs = n, Xs;
}
var $s, Bc;
function bn() {
  if (Bc) return $s;
  Bc = 1;
  var r = ma(), a = $4(), n = Z4(), o = "[object Null]", c = "[object Undefined]", s = r ? r.toStringTag : void 0;
  function h(l) {
    return l == null ? l === void 0 ? c : o : s && s in Object(l) ? a(l) : n(l);
  }
  return $s = h, $s;
}
var Zs, Uc;
function wn() {
  if (Uc) return Zs;
  Uc = 1;
  function r(a) {
    return a != null && typeof a == "object";
  }
  return Zs = r, Zs;
}
var Js, qc;
function z0() {
  if (qc) return Js;
  qc = 1;
  var r = bn(), a = wn(), n = "[object Symbol]";
  function o(c) {
    return typeof c == "symbol" || a(c) && r(c) == n;
  }
  return Js = o, Js;
}
var Qs, Hc;
function Kh() {
  if (Hc) return Qs;
  Hc = 1;
  var r = X4(), a = mn(), n = z0(), o = NaN, c = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, h = /^0o[0-7]+$/i, l = parseInt;
  function g(p) {
    if (typeof p == "number")
      return p;
    if (n(p))
      return o;
    if (a(p)) {
      var b = typeof p.valueOf == "function" ? p.valueOf() : p;
      p = a(b) ? b + "" : b;
    }
    if (typeof p != "string")
      return p === 0 ? p : +p;
    p = r(p);
    var w = s.test(p);
    return w || h.test(p) ? l(p.slice(2), w ? 2 : 8) : c.test(p) ? o : +p;
  }
  return Qs = g, Qs;
}
var to, Wc;
function j0() {
  if (Wc) return to;
  Wc = 1;
  var r = mn(), a = K4(), n = Kh(), o = "Expected a function", c = Math.max, s = Math.min;
  function h(l, g, p) {
    var b, w, x, v, _, S, C = 0, F = !1, d = !1, f = !0;
    if (typeof l != "function")
      throw new TypeError(o);
    g = n(g) || 0, r(p) && (F = !!p.leading, d = "maxWait" in p, x = d ? c(n(p.maxWait) || 0, g) : x, f = "trailing" in p ? !!p.trailing : f);
    function m(y) {
      var P = b, A = w;
      return b = w = void 0, C = y, v = l.apply(A, P), v;
    }
    function E(y) {
      return C = y, _ = setTimeout(I, g), F ? m(y) : v;
    }
    function T(y) {
      var P = y - S, A = y - C, G = g - P;
      return d ? s(G, x - A) : G;
    }
    function D(y) {
      var P = y - S, A = y - C;
      return S === void 0 || P >= g || P < 0 || d && A >= x;
    }
    function I() {
      var y = a();
      if (D(y))
        return L(y);
      _ = setTimeout(I, T(y));
    }
    function L(y) {
      return _ = void 0, f && b ? m(y) : (b = w = void 0, v);
    }
    function O() {
      _ !== void 0 && clearTimeout(_), C = 0, b = S = w = _ = void 0;
    }
    function N() {
      return _ === void 0 ? v : L(a());
    }
    function H() {
      var y = a(), P = D(y);
      if (b = arguments, w = this, S = y, P) {
        if (_ === void 0)
          return E(S);
        if (d)
          return clearTimeout(_), _ = setTimeout(I, g), m(S);
      }
      return _ === void 0 && (_ = setTimeout(I, g)), v;
    }
    return H.cancel = O, H.flush = N, H;
  }
  return to = h, to;
}
var eo, Vc;
function J4() {
  if (Vc) return eo;
  Vc = 1;
  var r = j0(), a = mn(), n = "Expected a function";
  function o(c, s, h) {
    var l = !0, g = !0;
    if (typeof c != "function")
      throw new TypeError(n);
    return a(h) && (l = "leading" in h ? !!h.leading : l, g = "trailing" in h ? !!h.trailing : g), r(c, s, {
      leading: l,
      maxWait: s,
      trailing: g
    });
  }
  return eo = o, eo;
}
var Q4 = J4();
const t6 = /* @__PURE__ */ yn(Q4), zc = (r) => {
  let a;
  const n = /* @__PURE__ */ new Set(), o = (p, b) => {
    const w = typeof p == "function" ? p(a) : p;
    if (!Object.is(w, a)) {
      const x = a;
      a = (b != null ? b : typeof w != "object" || w === null) ? w : Object.assign({}, a, w), n.forEach((v) => v(a, x));
    }
  }, c = () => a, l = { setState: o, getState: c, getInitialState: () => g, subscribe: (p) => (n.add(p), () => n.delete(p)) }, g = a = r(o, c, l);
  return l;
}, e6 = (r) => r ? zc(r) : zc, xt = e6(() => ({
  assetsBaseUrl: "",
  background: {
    url: null,
    height: 0,
    width: 0,
    offset: {
      x: 0,
      y: 0
    }
  },
  debug: !1,
  draggable: !0,
  elementsLayerOffsetX: 0,
  elementsMetaData: null,
  fit: vn.COVER,
  isPrintEnabled: !1,
  mapSize: {
    width: 0,
    height: 0
  },
  minScale: 0
}));
function r6(r, a) {
  const n = Math.ceil(r.width / a.width), o = Math.ceil(r.height / a.height), c = a.height, s = a.width, h = [];
  for (let l = 0; l < n; l++)
    for (let g = 0; g < o; g++) {
      const p = l * s, b = g * c;
      h.push({
        spots: [],
        rect: {
          height: c,
          width: s,
          x: p,
          y: b
        },
        visible: !1
      });
    }
  return h;
}
function i6(r, a) {
  return r.x >= a.x && r.y >= a.y && r.x <= a.x + a.width && r.y <= a.y + a.height;
}
function n6(r, a) {
  return !(a.x > r.x + r.width || a.x + a.width < r.x || a.y > r.y + r.height || a.y + a.height < r.y);
}
function a6(r, a) {
  a.forEach((n) => {
    r.forEach((o) => {
      if (i6(n, o.rect)) {
        o.spots.push(n);
        return;
      }
    });
  });
}
function X8(r, a, n) {
  if (r.width <= a.width && r.height <= a.height)
    return [
      {
        spots: n,
        visible: !0,
        rect: {
          height: r.height,
          width: r.width,
          x: 0,
          y: 0
        }
      }
    ];
  const o = r6(r, a);
  return a6(o, n), o;
}
function s6(r, a) {
  const n = [], o = [], { elementsLayerOffsetX: c } = xt.getState();
  return r.forEach((s) => {
    const h = n6(a.rect, {
      ...s.rect,
      x: s.rect.x + c
    });
    if (s.visible === h)
      return;
    const l = s.spots.filter((g) => W0(g));
    if (s.visible = h, s.visible)
      n.push(...l);
    else {
      const g = l.map((p) => p.id);
      o.push(...g);
    }
  }), {
    elementsToAdd: n,
    elementsToRemove: o
  };
}
const $8 = t6(
  async (r, a) => {
    const n = r.getStageInfo(), { elementsToRemove: o, elementsToAdd: c } = s6(
      a,
      n
    );
    o.length > 0 && r.removeElementsById(o), c.length > 0 && await r.addElements(c);
  },
  350
);
var fa = { exports: {} }, Ci = {}, ro = {}, io = {}, jc;
function Rt() {
  return jc || (jc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r._registerNode = r.Konva = r.glob = void 0;
    const a = Math.PI / 180;
    function n() {
      return typeof window != "undefined" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
    }
    r.glob = typeof ii != "undefined" ? ii : typeof window != "undefined" ? window : typeof WorkerGlobalScope != "undefined" ? self : {}, r.Konva = {
      _global: r.glob,
      version: "9.3.16",
      isBrowser: n(),
      isUnminified: /param/.test(function(c) {
      }.toString()),
      dblClickWindow: 400,
      getAngle(c) {
        return r.Konva.angleDeg ? c * a : c;
      },
      enableTrace: !1,
      pointerEventsEnabled: !0,
      autoDrawEnabled: !0,
      hitOnDragEnabled: !1,
      capturePointerEventsEnabled: !1,
      _mouseListenClick: !1,
      _touchListenClick: !1,
      _pointerListenClick: !1,
      _mouseInDblClickWindow: !1,
      _touchInDblClickWindow: !1,
      _pointerInDblClickWindow: !1,
      _mouseDblClickPointerId: null,
      _touchDblClickPointerId: null,
      _pointerDblClickPointerId: null,
      _fixTextRendering: !1,
      pixelRatio: typeof window != "undefined" && window.devicePixelRatio || 1,
      dragDistance: 3,
      angleDeg: !0,
      showWarnings: !0,
      dragButtons: [0, 1],
      isDragging() {
        return r.Konva.DD.isDragging;
      },
      isTransforming() {
        var c;
        return (c = r.Konva.Transformer) === null || c === void 0 ? void 0 : c.isTransforming();
      },
      isDragReady() {
        return !!r.Konva.DD.node;
      },
      releaseCanvasOnDestroy: !0,
      document: r.glob.document,
      _injectGlobal(c) {
        r.glob.Konva = c;
      }
    };
    const o = (c) => {
      r.Konva[c.prototype.getClassName()] = c;
    };
    r._registerNode = o, r.Konva._injectGlobal(r.Konva);
  }(io)), io;
}
var no = {}, Kc;
function Kt() {
  return Kc || (Kc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Util = r.Transform = void 0;
    const a = Rt();
    class n {
      constructor(m = [1, 0, 0, 1, 0, 0]) {
        this.dirty = !1, this.m = m && m.slice() || [1, 0, 0, 1, 0, 0];
      }
      reset() {
        this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
      }
      copy() {
        return new n(this.m);
      }
      copyInto(m) {
        m.m[0] = this.m[0], m.m[1] = this.m[1], m.m[2] = this.m[2], m.m[3] = this.m[3], m.m[4] = this.m[4], m.m[5] = this.m[5];
      }
      point(m) {
        const E = this.m;
        return {
          x: E[0] * m.x + E[2] * m.y + E[4],
          y: E[1] * m.x + E[3] * m.y + E[5]
        };
      }
      translate(m, E) {
        return this.m[4] += this.m[0] * m + this.m[2] * E, this.m[5] += this.m[1] * m + this.m[3] * E, this;
      }
      scale(m, E) {
        return this.m[0] *= m, this.m[1] *= m, this.m[2] *= E, this.m[3] *= E, this;
      }
      rotate(m) {
        const E = Math.cos(m), T = Math.sin(m), D = this.m[0] * E + this.m[2] * T, I = this.m[1] * E + this.m[3] * T, L = this.m[0] * -T + this.m[2] * E, O = this.m[1] * -T + this.m[3] * E;
        return this.m[0] = D, this.m[1] = I, this.m[2] = L, this.m[3] = O, this;
      }
      getTranslation() {
        return {
          x: this.m[4],
          y: this.m[5]
        };
      }
      skew(m, E) {
        const T = this.m[0] + this.m[2] * E, D = this.m[1] + this.m[3] * E, I = this.m[2] + this.m[0] * m, L = this.m[3] + this.m[1] * m;
        return this.m[0] = T, this.m[1] = D, this.m[2] = I, this.m[3] = L, this;
      }
      multiply(m) {
        const E = this.m[0] * m.m[0] + this.m[2] * m.m[1], T = this.m[1] * m.m[0] + this.m[3] * m.m[1], D = this.m[0] * m.m[2] + this.m[2] * m.m[3], I = this.m[1] * m.m[2] + this.m[3] * m.m[3], L = this.m[0] * m.m[4] + this.m[2] * m.m[5] + this.m[4], O = this.m[1] * m.m[4] + this.m[3] * m.m[5] + this.m[5];
        return this.m[0] = E, this.m[1] = T, this.m[2] = D, this.m[3] = I, this.m[4] = L, this.m[5] = O, this;
      }
      invert() {
        const m = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), E = this.m[3] * m, T = -this.m[1] * m, D = -this.m[2] * m, I = this.m[0] * m, L = m * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), O = m * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        return this.m[0] = E, this.m[1] = T, this.m[2] = D, this.m[3] = I, this.m[4] = L, this.m[5] = O, this;
      }
      getMatrix() {
        return this.m;
      }
      decompose() {
        const m = this.m[0], E = this.m[1], T = this.m[2], D = this.m[3], I = this.m[4], L = this.m[5], O = m * D - E * T, N = {
          x: I,
          y: L,
          rotation: 0,
          scaleX: 0,
          scaleY: 0,
          skewX: 0,
          skewY: 0
        };
        if (m != 0 || E != 0) {
          const H = Math.sqrt(m * m + E * E);
          N.rotation = E > 0 ? Math.acos(m / H) : -Math.acos(m / H), N.scaleX = H, N.scaleY = O / H, N.skewX = (m * T + E * D) / O, N.skewY = 0;
        } else if (T != 0 || D != 0) {
          const H = Math.sqrt(T * T + D * D);
          N.rotation = Math.PI / 2 - (D > 0 ? Math.acos(-T / H) : -Math.acos(T / H)), N.scaleX = O / H, N.scaleY = H, N.skewX = 0, N.skewY = (m * T + E * D) / O;
        }
        return N.rotation = r.Util._getRotation(N.rotation), N;
      }
    }
    r.Transform = n;
    let o = "[object Array]", c = "[object Number]", s = "[object String]", h = "[object Boolean]", l = Math.PI / 180, g = 180 / Math.PI, p = "#", b = "", w = "0", x = "Konva warning: ", v = "Konva error: ", _ = "rgb(", S = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 132, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 255, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 203],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [119, 128, 144],
      slategrey: [119, 128, 144],
      snow: [255, 255, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      transparent: [255, 255, 255, 0],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 5]
    }, C = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, F = [];
    const d = typeof requestAnimationFrame != "undefined" && requestAnimationFrame || function(f) {
      setTimeout(f, 60);
    };
    r.Util = {
      _isElement(f) {
        return !!(f && f.nodeType == 1);
      },
      _isFunction(f) {
        return !!(f && f.constructor && f.call && f.apply);
      },
      _isPlainObject(f) {
        return !!f && f.constructor === Object;
      },
      _isArray(f) {
        return Object.prototype.toString.call(f) === o;
      },
      _isNumber(f) {
        return Object.prototype.toString.call(f) === c && !isNaN(f) && isFinite(f);
      },
      _isString(f) {
        return Object.prototype.toString.call(f) === s;
      },
      _isBoolean(f) {
        return Object.prototype.toString.call(f) === h;
      },
      isObject(f) {
        return f instanceof Object;
      },
      isValidSelector(f) {
        if (typeof f != "string")
          return !1;
        const m = f[0];
        return m === "#" || m === "." || m === m.toUpperCase();
      },
      _sign(f) {
        return f === 0 || f > 0 ? 1 : -1;
      },
      requestAnimFrame(f) {
        F.push(f), F.length === 1 && d(function() {
          const m = F;
          F = [], m.forEach(function(E) {
            E();
          });
        });
      },
      createCanvasElement() {
        const f = document.createElement("canvas");
        try {
          f.style = f.style || {};
        } catch {
        }
        return f;
      },
      createImageElement() {
        return document.createElement("img");
      },
      _isInDocument(f) {
        for (; f = f.parentNode; )
          if (f == document)
            return !0;
        return !1;
      },
      _urlToImage(f, m) {
        const E = r.Util.createImageElement();
        E.onload = function() {
          m(E);
        }, E.src = f;
      },
      _rgbToHex(f, m, E) {
        return ((1 << 24) + (f << 16) + (m << 8) + E).toString(16).slice(1);
      },
      _hexToRgb(f) {
        f = f.replace(p, b);
        const m = parseInt(f, 16);
        return {
          r: m >> 16 & 255,
          g: m >> 8 & 255,
          b: m & 255
        };
      },
      getRandomColor() {
        let f = (Math.random() * 16777215 << 0).toString(16);
        for (; f.length < 6; )
          f = w + f;
        return p + f;
      },
      getRGB(f) {
        let m;
        return f in S ? (m = S[f], {
          r: m[0],
          g: m[1],
          b: m[2]
        }) : f[0] === p ? this._hexToRgb(f.substring(1)) : f.substr(0, 4) === _ ? (m = C.exec(f.replace(/ /g, "")), {
          r: parseInt(m[1], 10),
          g: parseInt(m[2], 10),
          b: parseInt(m[3], 10)
        }) : {
          r: 0,
          g: 0,
          b: 0
        };
      },
      colorToRGBA(f) {
        return f = f || "black", r.Util._namedColorToRBA(f) || r.Util._hex3ColorToRGBA(f) || r.Util._hex4ColorToRGBA(f) || r.Util._hex6ColorToRGBA(f) || r.Util._hex8ColorToRGBA(f) || r.Util._rgbColorToRGBA(f) || r.Util._rgbaColorToRGBA(f) || r.Util._hslColorToRGBA(f);
      },
      _namedColorToRBA(f) {
        const m = S[f.toLowerCase()];
        return m ? {
          r: m[0],
          g: m[1],
          b: m[2],
          a: 1
        } : null;
      },
      _rgbColorToRGBA(f) {
        if (f.indexOf("rgb(") === 0) {
          f = f.match(/rgb\(([^)]+)\)/)[1];
          const m = f.split(/ *, */).map(Number);
          return {
            r: m[0],
            g: m[1],
            b: m[2],
            a: 1
          };
        }
      },
      _rgbaColorToRGBA(f) {
        if (f.indexOf("rgba(") === 0) {
          f = f.match(/rgba\(([^)]+)\)/)[1];
          const m = f.split(/ *, */).map((E, T) => E.slice(-1) === "%" ? T === 3 ? parseInt(E) / 100 : parseInt(E) / 100 * 255 : Number(E));
          return {
            r: m[0],
            g: m[1],
            b: m[2],
            a: m[3]
          };
        }
      },
      _hex8ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 9)
          return {
            r: parseInt(f.slice(1, 3), 16),
            g: parseInt(f.slice(3, 5), 16),
            b: parseInt(f.slice(5, 7), 16),
            a: parseInt(f.slice(7, 9), 16) / 255
          };
      },
      _hex6ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 7)
          return {
            r: parseInt(f.slice(1, 3), 16),
            g: parseInt(f.slice(3, 5), 16),
            b: parseInt(f.slice(5, 7), 16),
            a: 1
          };
      },
      _hex4ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 5)
          return {
            r: parseInt(f[1] + f[1], 16),
            g: parseInt(f[2] + f[2], 16),
            b: parseInt(f[3] + f[3], 16),
            a: parseInt(f[4] + f[4], 16) / 255
          };
      },
      _hex3ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 4)
          return {
            r: parseInt(f[1] + f[1], 16),
            g: parseInt(f[2] + f[2], 16),
            b: parseInt(f[3] + f[3], 16),
            a: 1
          };
      },
      _hslColorToRGBA(f) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(f)) {
          const [m, ...E] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(f), T = Number(E[0]) / 360, D = Number(E[1]) / 100, I = Number(E[2]) / 100;
          let L, O, N;
          if (D === 0)
            return N = I * 255, {
              r: Math.round(N),
              g: Math.round(N),
              b: Math.round(N),
              a: 1
            };
          I < 0.5 ? L = I * (1 + D) : L = I + D - I * D;
          const H = 2 * I - L, y = [0, 0, 0];
          for (let P = 0; P < 3; P++)
            O = T + 1 / 3 * -(P - 1), O < 0 && O++, O > 1 && O--, 6 * O < 1 ? N = H + (L - H) * 6 * O : 2 * O < 1 ? N = L : 3 * O < 2 ? N = H + (L - H) * (2 / 3 - O) * 6 : N = H, y[P] = N * 255;
          return {
            r: Math.round(y[0]),
            g: Math.round(y[1]),
            b: Math.round(y[2]),
            a: 1
          };
        }
      },
      haveIntersection(f, m) {
        return !(m.x > f.x + f.width || m.x + m.width < f.x || m.y > f.y + f.height || m.y + m.height < f.y);
      },
      cloneObject(f) {
        const m = {};
        for (const E in f)
          this._isPlainObject(f[E]) ? m[E] = this.cloneObject(f[E]) : this._isArray(f[E]) ? m[E] = this.cloneArray(f[E]) : m[E] = f[E];
        return m;
      },
      cloneArray(f) {
        return f.slice(0);
      },
      degToRad(f) {
        return f * l;
      },
      radToDeg(f) {
        return f * g;
      },
      _degToRad(f) {
        return r.Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), r.Util.degToRad(f);
      },
      _radToDeg(f) {
        return r.Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), r.Util.radToDeg(f);
      },
      _getRotation(f) {
        return a.Konva.angleDeg ? r.Util.radToDeg(f) : f;
      },
      _capitalize(f) {
        return f.charAt(0).toUpperCase() + f.slice(1);
      },
      throw(f) {
        throw new Error(v + f);
      },
      error(f) {
        console.error(v + f);
      },
      warn(f) {
        a.Konva.showWarnings && console.warn(x + f);
      },
      each(f, m) {
        for (const E in f)
          m(E, f[E]);
      },
      _inRange(f, m, E) {
        return m <= f && f < E;
      },
      _getProjectionToSegment(f, m, E, T, D, I) {
        let L, O, N;
        const H = (f - E) * (f - E) + (m - T) * (m - T);
        if (H == 0)
          L = f, O = m, N = (D - E) * (D - E) + (I - T) * (I - T);
        else {
          const y = ((D - f) * (E - f) + (I - m) * (T - m)) / H;
          y < 0 ? (L = f, O = m, N = (f - D) * (f - D) + (m - I) * (m - I)) : y > 1 ? (L = E, O = T, N = (E - D) * (E - D) + (T - I) * (T - I)) : (L = f + y * (E - f), O = m + y * (T - m), N = (L - D) * (L - D) + (O - I) * (O - I));
        }
        return [L, O, N];
      },
      _getProjectionToLine(f, m, E) {
        const T = r.Util.cloneObject(f);
        let D = Number.MAX_VALUE;
        return m.forEach(function(I, L) {
          if (!E && L === m.length - 1)
            return;
          const O = m[(L + 1) % m.length], N = r.Util._getProjectionToSegment(I.x, I.y, O.x, O.y, f.x, f.y), H = N[0], y = N[1], P = N[2];
          P < D && (T.x = H, T.y = y, D = P);
        }), T;
      },
      _prepareArrayForTween(f, m, E) {
        let T, D = [], I = [];
        if (f.length > m.length) {
          const O = m;
          m = f, f = O;
        }
        for (T = 0; T < f.length; T += 2)
          D.push({
            x: f[T],
            y: f[T + 1]
          });
        for (T = 0; T < m.length; T += 2)
          I.push({
            x: m[T],
            y: m[T + 1]
          });
        const L = [];
        return I.forEach(function(O) {
          const N = r.Util._getProjectionToLine(O, D, E);
          L.push(N.x), L.push(N.y);
        }), L;
      },
      _prepareToStringify(f) {
        let m;
        f.visitedByCircularReferenceRemoval = !0;
        for (const E in f)
          if (f.hasOwnProperty(E) && f[E] && typeof f[E] == "object") {
            if (m = Object.getOwnPropertyDescriptor(f, E), f[E].visitedByCircularReferenceRemoval || r.Util._isElement(f[E]))
              if (m.configurable)
                delete f[E];
              else
                return null;
            else if (r.Util._prepareToStringify(f[E]) === null)
              if (m.configurable)
                delete f[E];
              else
                return null;
          }
        return delete f.visitedByCircularReferenceRemoval, f;
      },
      _assign(f, m) {
        for (const E in m)
          f[E] = m[E];
        return f;
      },
      _getFirstPointerId(f) {
        return f.touches ? f.changedTouches[0].identifier : f.pointerId || 999;
      },
      releaseCanvas(...f) {
        a.Konva.releaseCanvasOnDestroy && f.forEach((m) => {
          m.width = 0, m.height = 0;
        });
      },
      drawRoundedRectPath(f, m, E, T) {
        let D = 0, I = 0, L = 0, O = 0;
        typeof T == "number" ? D = I = L = O = Math.min(T, m / 2, E / 2) : (D = Math.min(T[0] || 0, m / 2, E / 2), I = Math.min(T[1] || 0, m / 2, E / 2), O = Math.min(T[2] || 0, m / 2, E / 2), L = Math.min(T[3] || 0, m / 2, E / 2)), f.moveTo(D, 0), f.lineTo(m - I, 0), f.arc(m - I, I, I, Math.PI * 3 / 2, 0, !1), f.lineTo(m, E - O), f.arc(m - O, E - O, O, 0, Math.PI / 2, !1), f.lineTo(L, E), f.arc(L, E - L, L, Math.PI / 2, Math.PI, !1), f.lineTo(0, D), f.arc(D, D, D, Math.PI, Math.PI * 3 / 2, !1);
      }
    };
  }(no)), no;
}
var xi = {}, ao = {}, be = {}, Yc;
function Ot() {
  if (Yc) return be;
  Yc = 1, Object.defineProperty(be, "__esModule", { value: !0 }), be.RGBComponent = o, be.alphaComponent = c, be.getNumberValidator = s, be.getNumberOrArrayOfNumbersValidator = h, be.getNumberOrAutoValidator = l, be.getStringValidator = g, be.getStringOrGradientValidator = p, be.getFunctionValidator = b, be.getNumberArrayValidator = w, be.getBooleanValidator = x, be.getComponentValidator = v;
  const r = Rt(), a = Kt();
  function n(_) {
    return a.Util._isString(_) ? '"' + _ + '"' : Object.prototype.toString.call(_) === "[object Number]" || a.Util._isBoolean(_) ? _ : Object.prototype.toString.call(_);
  }
  function o(_) {
    return _ > 255 ? 255 : _ < 0 ? 0 : Math.round(_);
  }
  function c(_) {
    return _ > 1 ? 1 : _ < 1e-4 ? 1e-4 : _;
  }
  function s() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return a.Util._isNumber(_) || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a number.'), _;
      };
  }
  function h(_) {
    if (r.Konva.isUnminified)
      return function(S, C) {
        const F = a.Util._isNumber(S), d = a.Util._isArray(S) && S.length == _;
        return !F && !d && a.Util.warn(n(S) + ' is a not valid value for "' + C + '" attribute. The value should be a number or Array<number>(' + _ + ")"), S;
      };
  }
  function l() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return a.Util._isNumber(_) || _ === "auto" || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a number or "auto".'), _;
      };
  }
  function g() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return a.Util._isString(_) || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a string.'), _;
      };
  }
  function p() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        const C = a.Util._isString(_), F = Object.prototype.toString.call(_) === "[object CanvasGradient]" || _ && _.addColorStop;
        return C || F || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a string or a native gradient.'), _;
      };
  }
  function b() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return a.Util._isFunction(_) || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a function.'), _;
      };
  }
  function w() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        const C = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        return C && _ instanceof C || (a.Util._isArray(_) ? _.forEach(function(F) {
          a.Util._isNumber(F) || a.Util.warn('"' + S + '" attribute has non numeric element ' + F + ". Make sure that all elements are numbers.");
        }) : a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a array of numbers.')), _;
      };
  }
  function x() {
    if (r.Konva.isUnminified)
      return function(_, S) {
        return _ === !0 || _ === !1 || a.Util.warn(n(_) + ' is a not valid value for "' + S + '" attribute. The value should be a boolean.'), _;
      };
  }
  function v(_) {
    if (r.Konva.isUnminified)
      return function(S, C) {
        return S == null || a.Util.isObject(S) || a.Util.warn(n(S) + ' is a not valid value for "' + C + '" attribute. The value should be an object with properties ' + _), S;
      };
  }
  return be;
}
var Xc;
function Tt() {
  return Xc || (Xc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Factory = void 0;
    const a = Kt(), n = Ot(), o = "get", c = "set";
    r.Factory = {
      addGetterSetter(s, h, l, g, p) {
        r.Factory.addGetter(s, h, l), r.Factory.addSetter(s, h, g, p), r.Factory.addOverloadedGetterSetter(s, h);
      },
      addGetter(s, h, l) {
        const g = o + a.Util._capitalize(h);
        s.prototype[g] = s.prototype[g] || function() {
          const p = this.attrs[h];
          return p === void 0 ? l : p;
        };
      },
      addSetter(s, h, l, g) {
        const p = c + a.Util._capitalize(h);
        s.prototype[p] || r.Factory.overWriteSetter(s, h, l, g);
      },
      overWriteSetter(s, h, l, g) {
        const p = c + a.Util._capitalize(h);
        s.prototype[p] = function(b) {
          return l && b !== void 0 && b !== null && (b = l.call(this, b, h)), this._setAttr(h, b), g && g.call(this), this;
        };
      },
      addComponentsGetterSetter(s, h, l, g, p) {
        let b = l.length, w = a.Util._capitalize, x = o + w(h), v = c + w(h), _, S;
        s.prototype[x] = function() {
          const F = {};
          for (_ = 0; _ < b; _++)
            S = l[_], F[S] = this.getAttr(h + w(S));
          return F;
        };
        const C = (0, n.getComponentValidator)(l);
        s.prototype[v] = function(F) {
          let d = this.attrs[h], f;
          g && (F = g.call(this, F)), C && C.call(this, F, h);
          for (f in F)
            F.hasOwnProperty(f) && this._setAttr(h + w(f), F[f]);
          return F || l.forEach((m) => {
            this._setAttr(h + w(m), void 0);
          }), this._fireChangeEvent(h, d, F), p && p.call(this), this;
        }, r.Factory.addOverloadedGetterSetter(s, h);
      },
      addOverloadedGetterSetter(s, h) {
        const l = a.Util._capitalize(h), g = c + l, p = o + l;
        s.prototype[h] = function() {
          return arguments.length ? (this[g](arguments[0]), this) : this[p]();
        };
      },
      addDeprecatedGetterSetter(s, h, l, g) {
        a.Util.error("Adding deprecated " + h);
        const p = o + a.Util._capitalize(h), b = h + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
        s.prototype[p] = function() {
          a.Util.error(b);
          const w = this.attrs[h];
          return w === void 0 ? l : w;
        }, r.Factory.addSetter(s, h, g, function() {
          a.Util.error(b);
        }), r.Factory.addOverloadedGetterSetter(s, h);
      },
      backCompat(s, h) {
        a.Util.each(h, function(l, g) {
          const p = s.prototype[g], b = o + a.Util._capitalize(l), w = c + a.Util._capitalize(l);
          function x() {
            p.apply(this, arguments), a.Util.error('"' + l + '" method is deprecated and will be removed soon. Use ""' + g + '" instead.');
          }
          s.prototype[l] = x, s.prototype[b] = x, s.prototype[w] = x;
        });
      },
      afterSetFilter() {
        this._filterUpToDate = !1;
      }
    };
  }(ao)), ao;
}
var dr = {}, fr = {}, $c;
function K0() {
  if ($c) return fr;
  $c = 1, Object.defineProperty(fr, "__esModule", { value: !0 }), fr.HitContext = fr.SceneContext = fr.Context = void 0;
  const r = Kt(), a = Rt();
  function n(F) {
    let d = [], f = F.length, m = r.Util, E, T;
    for (E = 0; E < f; E++)
      T = F[E], m._isNumber(T) ? T = Math.round(T * 1e3) / 1e3 : m._isString(T) || (T = T + ""), d.push(T);
    return d;
  }
  const o = ",", c = "(", s = ")", h = "([", l = "])", g = ";", p = "()", b = "=", w = [
    "arc",
    "arcTo",
    "beginPath",
    "bezierCurveTo",
    "clearRect",
    "clip",
    "closePath",
    "createLinearGradient",
    "createPattern",
    "createRadialGradient",
    "drawImage",
    "ellipse",
    "fill",
    "fillText",
    "getImageData",
    "createImageData",
    "lineTo",
    "moveTo",
    "putImageData",
    "quadraticCurveTo",
    "rect",
    "roundRect",
    "restore",
    "rotate",
    "save",
    "scale",
    "setLineDash",
    "setTransform",
    "stroke",
    "strokeText",
    "transform",
    "translate"
  ], x = [
    "fillStyle",
    "strokeStyle",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "letterSpacing",
    "lineCap",
    "lineDashOffset",
    "lineJoin",
    "lineWidth",
    "miterLimit",
    "direction",
    "font",
    "textAlign",
    "textBaseline",
    "globalAlpha",
    "globalCompositeOperation",
    "imageSmoothingEnabled"
  ], v = 100;
  let _ = class {
    constructor(d) {
      this.canvas = d, a.Konva.enableTrace && (this.traceArr = [], this._enableTrace());
    }
    fillShape(d) {
      d.fillEnabled() && this._fill(d);
    }
    _fill(d) {
    }
    strokeShape(d) {
      d.hasStroke() && this._stroke(d);
    }
    _stroke(d) {
    }
    fillStrokeShape(d) {
      d.attrs.fillAfterStrokeEnabled ? (this.strokeShape(d), this.fillShape(d)) : (this.fillShape(d), this.strokeShape(d));
    }
    getTrace(d, f) {
      let m = this.traceArr, E = m.length, T = "", D, I, L, O;
      for (D = 0; D < E; D++)
        I = m[D], L = I.method, L ? (O = I.args, T += L, d ? T += p : r.Util._isArray(O[0]) ? T += h + O.join(o) + l : (f && (O = O.map((N) => typeof N == "number" ? Math.floor(N) : N)), T += c + O.join(o) + s)) : (T += I.property, d || (T += b + I.val)), T += g;
      return T;
    }
    clearTrace() {
      this.traceArr = [];
    }
    _trace(d) {
      let f = this.traceArr, m;
      f.push(d), m = f.length, m >= v && f.shift();
    }
    reset() {
      const d = this.getCanvas().getPixelRatio();
      this.setTransform(1 * d, 0, 0, 1 * d, 0, 0);
    }
    getCanvas() {
      return this.canvas;
    }
    clear(d) {
      const f = this.getCanvas();
      d ? this.clearRect(d.x || 0, d.y || 0, d.width || 0, d.height || 0) : this.clearRect(0, 0, f.getWidth() / f.pixelRatio, f.getHeight() / f.pixelRatio);
    }
    _applyLineCap(d) {
      const f = d.attrs.lineCap;
      f && this.setAttr("lineCap", f);
    }
    _applyOpacity(d) {
      const f = d.getAbsoluteOpacity();
      f !== 1 && this.setAttr("globalAlpha", f);
    }
    _applyLineJoin(d) {
      const f = d.attrs.lineJoin;
      f && this.setAttr("lineJoin", f);
    }
    setAttr(d, f) {
      this._context[d] = f;
    }
    arc(d, f, m, E, T, D) {
      this._context.arc(d, f, m, E, T, D);
    }
    arcTo(d, f, m, E, T) {
      this._context.arcTo(d, f, m, E, T);
    }
    beginPath() {
      this._context.beginPath();
    }
    bezierCurveTo(d, f, m, E, T, D) {
      this._context.bezierCurveTo(d, f, m, E, T, D);
    }
    clearRect(d, f, m, E) {
      this._context.clearRect(d, f, m, E);
    }
    clip(...d) {
      this._context.clip.apply(this._context, d);
    }
    closePath() {
      this._context.closePath();
    }
    createImageData(d, f) {
      const m = arguments;
      if (m.length === 2)
        return this._context.createImageData(d, f);
      if (m.length === 1)
        return this._context.createImageData(d);
    }
    createLinearGradient(d, f, m, E) {
      return this._context.createLinearGradient(d, f, m, E);
    }
    createPattern(d, f) {
      return this._context.createPattern(d, f);
    }
    createRadialGradient(d, f, m, E, T, D) {
      return this._context.createRadialGradient(d, f, m, E, T, D);
    }
    drawImage(d, f, m, E, T, D, I, L, O) {
      const N = arguments, H = this._context;
      N.length === 3 ? H.drawImage(d, f, m) : N.length === 5 ? H.drawImage(d, f, m, E, T) : N.length === 9 && H.drawImage(d, f, m, E, T, D, I, L, O);
    }
    ellipse(d, f, m, E, T, D, I, L) {
      this._context.ellipse(d, f, m, E, T, D, I, L);
    }
    isPointInPath(d, f, m, E) {
      return m ? this._context.isPointInPath(m, d, f, E) : this._context.isPointInPath(d, f, E);
    }
    fill(...d) {
      this._context.fill.apply(this._context, d);
    }
    fillRect(d, f, m, E) {
      this._context.fillRect(d, f, m, E);
    }
    strokeRect(d, f, m, E) {
      this._context.strokeRect(d, f, m, E);
    }
    fillText(d, f, m, E) {
      E ? this._context.fillText(d, f, m, E) : this._context.fillText(d, f, m);
    }
    measureText(d) {
      return this._context.measureText(d);
    }
    getImageData(d, f, m, E) {
      return this._context.getImageData(d, f, m, E);
    }
    lineTo(d, f) {
      this._context.lineTo(d, f);
    }
    moveTo(d, f) {
      this._context.moveTo(d, f);
    }
    rect(d, f, m, E) {
      this._context.rect(d, f, m, E);
    }
    roundRect(d, f, m, E, T) {
      this._context.roundRect(d, f, m, E, T);
    }
    putImageData(d, f, m) {
      this._context.putImageData(d, f, m);
    }
    quadraticCurveTo(d, f, m, E) {
      this._context.quadraticCurveTo(d, f, m, E);
    }
    restore() {
      this._context.restore();
    }
    rotate(d) {
      this._context.rotate(d);
    }
    save() {
      this._context.save();
    }
    scale(d, f) {
      this._context.scale(d, f);
    }
    setLineDash(d) {
      this._context.setLineDash ? this._context.setLineDash(d) : "mozDash" in this._context ? this._context.mozDash = d : "webkitLineDash" in this._context && (this._context.webkitLineDash = d);
    }
    getLineDash() {
      return this._context.getLineDash();
    }
    setTransform(d, f, m, E, T, D) {
      this._context.setTransform(d, f, m, E, T, D);
    }
    stroke(d) {
      d ? this._context.stroke(d) : this._context.stroke();
    }
    strokeText(d, f, m, E) {
      this._context.strokeText(d, f, m, E);
    }
    transform(d, f, m, E, T, D) {
      this._context.transform(d, f, m, E, T, D);
    }
    translate(d, f) {
      this._context.translate(d, f);
    }
    _enableTrace() {
      let d = this, f = w.length, m = this.setAttr, E, T;
      const D = function(I) {
        let L = d[I], O;
        d[I] = function() {
          return T = n(Array.prototype.slice.call(arguments, 0)), O = L.apply(d, arguments), d._trace({
            method: I,
            args: T
          }), O;
        };
      };
      for (E = 0; E < f; E++)
        D(w[E]);
      d.setAttr = function() {
        m.apply(d, arguments);
        const I = arguments[0];
        let L = arguments[1];
        (I === "shadowOffsetX" || I === "shadowOffsetY" || I === "shadowBlur") && (L = L / this.canvas.getPixelRatio()), d._trace({
          property: I,
          val: L
        });
      };
    }
    _applyGlobalCompositeOperation(d) {
      const f = d.attrs.globalCompositeOperation;
      !f || f === "source-over" || this.setAttr("globalCompositeOperation", f);
    }
  };
  fr.Context = _, x.forEach(function(F) {
    Object.defineProperty(_.prototype, F, {
      get() {
        return this._context[F];
      },
      set(d) {
        this._context[F] = d;
      }
    });
  });
  class S extends _ {
    constructor(d, { willReadFrequently: f = !1 } = {}) {
      super(d), this._context = d._canvas.getContext("2d", {
        willReadFrequently: f
      });
    }
    _fillColor(d) {
      const f = d.fill();
      this.setAttr("fillStyle", f), d._fillFunc(this);
    }
    _fillPattern(d) {
      this.setAttr("fillStyle", d._getFillPattern()), d._fillFunc(this);
    }
    _fillLinearGradient(d) {
      const f = d._getLinearGradient();
      f && (this.setAttr("fillStyle", f), d._fillFunc(this));
    }
    _fillRadialGradient(d) {
      const f = d._getRadialGradient();
      f && (this.setAttr("fillStyle", f), d._fillFunc(this));
    }
    _fill(d) {
      const f = d.fill(), m = d.getFillPriority();
      if (f && m === "color") {
        this._fillColor(d);
        return;
      }
      const E = d.getFillPatternImage();
      if (E && m === "pattern") {
        this._fillPattern(d);
        return;
      }
      const T = d.getFillLinearGradientColorStops();
      if (T && m === "linear-gradient") {
        this._fillLinearGradient(d);
        return;
      }
      const D = d.getFillRadialGradientColorStops();
      if (D && m === "radial-gradient") {
        this._fillRadialGradient(d);
        return;
      }
      f ? this._fillColor(d) : E ? this._fillPattern(d) : T ? this._fillLinearGradient(d) : D && this._fillRadialGradient(d);
    }
    _strokeLinearGradient(d) {
      const f = d.getStrokeLinearGradientStartPoint(), m = d.getStrokeLinearGradientEndPoint(), E = d.getStrokeLinearGradientColorStops(), T = this.createLinearGradient(f.x, f.y, m.x, m.y);
      if (E) {
        for (let D = 0; D < E.length; D += 2)
          T.addColorStop(E[D], E[D + 1]);
        this.setAttr("strokeStyle", T);
      }
    }
    _stroke(d) {
      const f = d.dash(), m = d.getStrokeScaleEnabled();
      if (d.hasStroke()) {
        if (!m) {
          this.save();
          const T = this.getCanvas().getPixelRatio();
          this.setTransform(T, 0, 0, T, 0, 0);
        }
        this._applyLineCap(d), f && d.dashEnabled() && (this.setLineDash(f), this.setAttr("lineDashOffset", d.dashOffset())), this.setAttr("lineWidth", d.strokeWidth()), d.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)"), d.getStrokeLinearGradientColorStops() ? this._strokeLinearGradient(d) : this.setAttr("strokeStyle", d.stroke()), d._strokeFunc(this), m || this.restore();
      }
    }
    _applyShadow(d) {
      var f, m, E;
      const T = (f = d.getShadowRGBA()) !== null && f !== void 0 ? f : "black", D = (m = d.getShadowBlur()) !== null && m !== void 0 ? m : 5, I = (E = d.getShadowOffset()) !== null && E !== void 0 ? E : {
        x: 0,
        y: 0
      }, L = d.getAbsoluteScale(), O = this.canvas.getPixelRatio(), N = L.x * O, H = L.y * O;
      this.setAttr("shadowColor", T), this.setAttr("shadowBlur", D * Math.min(Math.abs(N), Math.abs(H))), this.setAttr("shadowOffsetX", I.x * N), this.setAttr("shadowOffsetY", I.y * H);
    }
  }
  fr.SceneContext = S;
  class C extends _ {
    constructor(d) {
      super(d), this._context = d._canvas.getContext("2d", {
        willReadFrequently: !0
      });
    }
    _fill(d) {
      this.save(), this.setAttr("fillStyle", d.colorKey), d._fillFuncHit(this), this.restore();
    }
    strokeShape(d) {
      d.hasHitStroke() && this._stroke(d);
    }
    _stroke(d) {
      if (d.hasHitStroke()) {
        const f = d.getStrokeScaleEnabled();
        if (!f) {
          this.save();
          const T = this.getCanvas().getPixelRatio();
          this.setTransform(T, 0, 0, T, 0, 0);
        }
        this._applyLineCap(d);
        const m = d.hitStrokeWidth(), E = m === "auto" ? d.strokeWidth() : m;
        this.setAttr("lineWidth", E), this.setAttr("strokeStyle", d.colorKey), d._strokeFuncHit(this), f || this.restore();
      }
    }
  }
  return fr.HitContext = C, fr;
}
var Zc;
function ba() {
  if (Zc) return dr;
  Zc = 1, Object.defineProperty(dr, "__esModule", { value: !0 }), dr.HitCanvas = dr.SceneCanvas = dr.Canvas = void 0;
  const r = Kt(), a = K0(), n = Rt(), o = Tt(), c = Ot();
  let s;
  function h() {
    if (s)
      return s;
    const b = r.Util.createCanvasElement(), w = b.getContext("2d");
    return s = function() {
      const x = n.Konva._global.devicePixelRatio || 1, v = w.webkitBackingStorePixelRatio || w.mozBackingStorePixelRatio || w.msBackingStorePixelRatio || w.oBackingStorePixelRatio || w.backingStorePixelRatio || 1;
      return x / v;
    }(), r.Util.releaseCanvas(b), s;
  }
  let l = class {
    constructor(w) {
      this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
      const v = (w || {}).pixelRatio || n.Konva.pixelRatio || h();
      this.pixelRatio = v, this._canvas = r.Util.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
    }
    getContext() {
      return this.context;
    }
    getPixelRatio() {
      return this.pixelRatio;
    }
    setPixelRatio(w) {
      const x = this.pixelRatio;
      this.pixelRatio = w, this.setSize(this.getWidth() / x, this.getHeight() / x);
    }
    setWidth(w) {
      this.width = this._canvas.width = w * this.pixelRatio, this._canvas.style.width = w + "px";
      const x = this.pixelRatio;
      this.getContext()._context.scale(x, x);
    }
    setHeight(w) {
      this.height = this._canvas.height = w * this.pixelRatio, this._canvas.style.height = w + "px";
      const x = this.pixelRatio;
      this.getContext()._context.scale(x, x);
    }
    getWidth() {
      return this.width;
    }
    getHeight() {
      return this.height;
    }
    setSize(w, x) {
      this.setWidth(w || 0), this.setHeight(x || 0);
    }
    toDataURL(w, x) {
      try {
        return this._canvas.toDataURL(w, x);
      } catch {
        try {
          return this._canvas.toDataURL();
        } catch (_) {
          return r.Util.error("Unable to get data URL. " + _.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
        }
      }
    }
  };
  dr.Canvas = l, o.Factory.addGetterSetter(l, "pixelRatio", void 0, (0, c.getNumberValidator)());
  class g extends l {
    constructor(w = { width: 0, height: 0, willReadFrequently: !1 }) {
      super(w), this.context = new a.SceneContext(this, {
        willReadFrequently: w.willReadFrequently
      }), this.setSize(w.width, w.height);
    }
  }
  dr.SceneCanvas = g;
  class p extends l {
    constructor(w = { width: 0, height: 0 }) {
      super(w), this.hitCanvas = !0, this.context = new a.HitContext(this), this.setSize(w.width, w.height);
    }
  }
  return dr.HitCanvas = p, dr;
}
var so = {}, Jc;
function Yh() {
  return Jc || (Jc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.DD = void 0;
    const a = Rt(), n = Kt();
    r.DD = {
      get isDragging() {
        let o = !1;
        return r.DD._dragElements.forEach((c) => {
          c.dragStatus === "dragging" && (o = !0);
        }), o;
      },
      justDragged: !1,
      get node() {
        let o;
        return r.DD._dragElements.forEach((c) => {
          o = c.node;
        }), o;
      },
      _dragElements: /* @__PURE__ */ new Map(),
      _drag(o) {
        const c = [];
        r.DD._dragElements.forEach((s, h) => {
          const { node: l } = s, g = l.getStage();
          g.setPointersPositions(o), s.pointerId === void 0 && (s.pointerId = n.Util._getFirstPointerId(o));
          const p = g._changedPointerPositions.find((b) => b.id === s.pointerId);
          if (p) {
            if (s.dragStatus !== "dragging") {
              const b = l.dragDistance();
              if (Math.max(Math.abs(p.x - s.startPointerPos.x), Math.abs(p.y - s.startPointerPos.y)) < b || (l.startDrag({ evt: o }), !l.isDragging()))
                return;
            }
            l._setDragPosition(o, s), c.push(l);
          }
        }), c.forEach((s) => {
          s.fire("dragmove", {
            type: "dragmove",
            target: s,
            evt: o
          }, !0);
        });
      },
      _endDragBefore(o) {
        const c = [];
        r.DD._dragElements.forEach((s) => {
          const { node: h } = s, l = h.getStage();
          if (o && l.setPointersPositions(o), !l._changedPointerPositions.find((b) => b.id === s.pointerId))
            return;
          (s.dragStatus === "dragging" || s.dragStatus === "stopped") && (r.DD.justDragged = !0, a.Konva._mouseListenClick = !1, a.Konva._touchListenClick = !1, a.Konva._pointerListenClick = !1, s.dragStatus = "stopped");
          const p = s.node.getLayer() || s.node instanceof a.Konva.Stage && s.node;
          p && c.indexOf(p) === -1 && c.push(p);
        }), c.forEach((s) => {
          s.draw();
        });
      },
      _endDragAfter(o) {
        r.DD._dragElements.forEach((c, s) => {
          c.dragStatus === "stopped" && c.node.fire("dragend", {
            type: "dragend",
            target: c.node,
            evt: o
          }, !0), c.dragStatus !== "dragging" && r.DD._dragElements.delete(s);
        });
      }
    }, a.Konva.isBrowser && (window.addEventListener("mouseup", r.DD._endDragBefore, !0), window.addEventListener("touchend", r.DD._endDragBefore, !0), window.addEventListener("touchcancel", r.DD._endDragBefore, !0), window.addEventListener("mousemove", r.DD._drag), window.addEventListener("touchmove", r.DD._drag), window.addEventListener("mouseup", r.DD._endDragAfter, !1), window.addEventListener("touchend", r.DD._endDragAfter, !1), window.addEventListener("touchcancel", r.DD._endDragAfter, !1));
  }(so)), so;
}
var Qc;
function $t() {
  if (Qc) return xi;
  Qc = 1, Object.defineProperty(xi, "__esModule", { value: !0 }), xi.Node = void 0;
  const r = Kt(), a = Tt(), n = ba(), o = Rt(), c = Yh(), s = Ot(), h = "absoluteOpacity", l = "allEventListeners", g = "absoluteTransform", p = "absoluteScale", b = "canvas", w = "Change", x = "children", v = "konva", _ = "listening", S = "mouseenter", C = "mouseleave", F = "set", d = "Shape", f = " ", m = "stage", E = "transform", T = "Stage", D = "visible", I = [
    "xChange.konva",
    "yChange.konva",
    "scaleXChange.konva",
    "scaleYChange.konva",
    "skewXChange.konva",
    "skewYChange.konva",
    "rotationChange.konva",
    "offsetXChange.konva",
    "offsetYChange.konva",
    "transformsEnabledChange.konva"
  ].join(f);
  let L = 1, O = class zh {
    constructor(y) {
      this._id = L++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(y), this._shouldFireChangeEvents = !0;
    }
    hasChildren() {
      return !1;
    }
    _clearCache(y) {
      (y === E || y === g) && this._cache.get(y) ? this._cache.get(y).dirty = !0 : y ? this._cache.delete(y) : this._cache.clear();
    }
    _getCache(y, P) {
      let A = this._cache.get(y);
      return (A === void 0 || (y === E || y === g) && A.dirty === !0) && (A = P.call(this), this._cache.set(y, A)), A;
    }
    _calculate(y, P, A) {
      if (!this._attachedDepsListeners.get(y)) {
        const G = P.map((U) => U + "Change.konva").join(f);
        this.on(G, () => {
          this._clearCache(y);
        }), this._attachedDepsListeners.set(y, !0);
      }
      return this._getCache(y, A);
    }
    _getCanvasCache() {
      return this._cache.get(b);
    }
    _clearSelfAndDescendantCache(y) {
      this._clearCache(y), y === g && this.fire("absoluteTransformChange");
    }
    clearCache() {
      if (this._cache.has(b)) {
        const { scene: y, filter: P, hit: A } = this._cache.get(b);
        r.Util.releaseCanvas(y, P, A), this._cache.delete(b);
      }
      return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
    }
    cache(y) {
      const P = y || {};
      let A = {};
      (P.x === void 0 || P.y === void 0 || P.width === void 0 || P.height === void 0) && (A = this.getClientRect({
        skipTransform: !0,
        relativeTo: this.getParent() || void 0
      }));
      let G = Math.ceil(P.width || A.width), U = Math.ceil(P.height || A.height), K = P.pixelRatio, $ = P.x === void 0 ? Math.floor(A.x) : P.x, X = P.y === void 0 ? Math.floor(A.y) : P.y, Q = P.offset || 0, st = P.drawBorder || !1, Z = P.hitCanvasPixelRatio || 1;
      if (!G || !U) {
        r.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
        return;
      }
      const at = Math.abs(Math.round(A.x) - $) > 0.5 ? 1 : 0, ht = Math.abs(Math.round(A.y) - X) > 0.5 ? 1 : 0;
      G += Q * 2 + at, U += Q * 2 + ht, $ -= Q, X -= Q;
      const ct = new n.SceneCanvas({
        pixelRatio: K,
        width: G,
        height: U
      }), W = new n.SceneCanvas({
        pixelRatio: K,
        width: 0,
        height: 0,
        willReadFrequently: !0
      }), j = new n.HitCanvas({
        pixelRatio: Z,
        width: G,
        height: U
      }), et = ct.getContext(), ut = j.getContext();
      return j.isCache = !0, ct.isCache = !0, this._cache.delete(b), this._filterUpToDate = !1, P.imageSmoothingEnabled === !1 && (ct.getContext()._context.imageSmoothingEnabled = !1, W.getContext()._context.imageSmoothingEnabled = !1), et.save(), ut.save(), et.translate(-$, -X), ut.translate(-$, -X), this._isUnderCache = !0, this._clearSelfAndDescendantCache(h), this._clearSelfAndDescendantCache(p), this.drawScene(ct, this), this.drawHit(j, this), this._isUnderCache = !1, et.restore(), ut.restore(), st && (et.save(), et.beginPath(), et.rect(0, 0, G, U), et.closePath(), et.setAttr("strokeStyle", "red"), et.setAttr("lineWidth", 5), et.stroke(), et.restore()), this._cache.set(b, {
        scene: ct,
        filter: W,
        hit: j,
        x: $,
        y: X
      }), this._requestDraw(), this;
    }
    isCached() {
      return this._cache.has(b);
    }
    getClientRect(y) {
      throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(y, P) {
      const A = [
        { x: y.x, y: y.y },
        { x: y.x + y.width, y: y.y },
        { x: y.x + y.width, y: y.y + y.height },
        { x: y.x, y: y.y + y.height }
      ];
      let G = 1 / 0, U = 1 / 0, K = -1 / 0, $ = -1 / 0;
      const X = this.getAbsoluteTransform(P);
      return A.forEach(function(Q) {
        const st = X.point(Q);
        G === void 0 && (G = K = st.x, U = $ = st.y), G = Math.min(G, st.x), U = Math.min(U, st.y), K = Math.max(K, st.x), $ = Math.max($, st.y);
      }), {
        x: G,
        y: U,
        width: K - G,
        height: $ - U
      };
    }
    _drawCachedSceneCanvas(y) {
      y.save(), y._applyOpacity(this), y._applyGlobalCompositeOperation(this);
      const P = this._getCanvasCache();
      y.translate(P.x, P.y);
      const A = this._getCachedSceneCanvas(), G = A.pixelRatio;
      y.drawImage(A._canvas, 0, 0, A.width / G, A.height / G), y.restore();
    }
    _drawCachedHitCanvas(y) {
      const P = this._getCanvasCache(), A = P.hit;
      y.save(), y.translate(P.x, P.y), y.drawImage(A._canvas, 0, 0, A.width / A.pixelRatio, A.height / A.pixelRatio), y.restore();
    }
    _getCachedSceneCanvas() {
      let y = this.filters(), P = this._getCanvasCache(), A = P.scene, G = P.filter, U = G.getContext(), K, $, X, Q;
      if (y) {
        if (!this._filterUpToDate) {
          const st = A.pixelRatio;
          G.setSize(A.width / A.pixelRatio, A.height / A.pixelRatio);
          try {
            for (K = y.length, U.clear(), U.drawImage(A._canvas, 0, 0, A.getWidth() / st, A.getHeight() / st), $ = U.getImageData(0, 0, G.getWidth(), G.getHeight()), X = 0; X < K; X++) {
              if (Q = y[X], typeof Q != "function") {
                r.Util.error("Filter should be type of function, but got " + typeof Q + " instead. Please check correct filters");
                continue;
              }
              Q.call(this, $), U.putImageData($, 0, 0);
            }
          } catch (Z) {
            r.Util.error("Unable to apply filter. " + Z.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
          }
          this._filterUpToDate = !0;
        }
        return G;
      }
      return A;
    }
    on(y, P) {
      if (this._cache && this._cache.delete(l), arguments.length === 3)
        return this._delegate.apply(this, arguments);
      let A = y.split(f), G = A.length, U, K, $, X, Q;
      for (U = 0; U < G; U++)
        K = A[U], $ = K.split("."), X = $[0], Q = $[1] || "", this.eventListeners[X] || (this.eventListeners[X] = []), this.eventListeners[X].push({
          name: Q,
          handler: P
        });
      return this;
    }
    off(y, P) {
      let A = (y || "").split(f), G = A.length, U, K, $, X, Q, st;
      if (this._cache && this._cache.delete(l), !y)
        for (K in this.eventListeners)
          this._off(K);
      for (U = 0; U < G; U++)
        if ($ = A[U], X = $.split("."), Q = X[0], st = X[1], Q)
          this.eventListeners[Q] && this._off(Q, st, P);
        else
          for (K in this.eventListeners)
            this._off(K, st, P);
      return this;
    }
    dispatchEvent(y) {
      const P = {
        target: this,
        type: y.type,
        evt: y
      };
      return this.fire(y.type, P), this;
    }
    addEventListener(y, P) {
      return this.on(y, function(A) {
        P.call(this, A.evt);
      }), this;
    }
    removeEventListener(y) {
      return this.off(y), this;
    }
    _delegate(y, P, A) {
      const G = this;
      this.on(y, function(U) {
        const K = U.target.findAncestors(P, !0, G);
        for (let $ = 0; $ < K.length; $++)
          U = r.Util.cloneObject(U), U.currentTarget = K[$], A.call(K[$], U);
      });
    }
    remove() {
      return this.isDragging() && this.stopDrag(), c.DD._dragElements.delete(this._id), this._remove(), this;
    }
    _clearCaches() {
      this._clearSelfAndDescendantCache(g), this._clearSelfAndDescendantCache(h), this._clearSelfAndDescendantCache(p), this._clearSelfAndDescendantCache(m), this._clearSelfAndDescendantCache(D), this._clearSelfAndDescendantCache(_);
    }
    _remove() {
      this._clearCaches();
      const y = this.getParent();
      y && y.children && (y.children.splice(this.index, 1), y._setChildrenIndices(), this.parent = null);
    }
    destroy() {
      return this.remove(), this.clearCache(), this;
    }
    getAttr(y) {
      const P = "get" + r.Util._capitalize(y);
      return r.Util._isFunction(this[P]) ? this[P]() : this.attrs[y];
    }
    getAncestors() {
      let y = this.getParent(), P = [];
      for (; y; )
        P.push(y), y = y.getParent();
      return P;
    }
    getAttrs() {
      return this.attrs || {};
    }
    setAttrs(y) {
      return this._batchTransformChanges(() => {
        let P, A;
        if (!y)
          return this;
        for (P in y)
          P !== x && (A = F + r.Util._capitalize(P), r.Util._isFunction(this[A]) ? this[A](y[P]) : this._setAttr(P, y[P]));
      }), this;
    }
    isListening() {
      return this._getCache(_, this._isListening);
    }
    _isListening(y) {
      if (!this.listening())
        return !1;
      const A = this.getParent();
      return A && A !== y && this !== y ? A._isListening(y) : !0;
    }
    isVisible() {
      return this._getCache(D, this._isVisible);
    }
    _isVisible(y) {
      if (!this.visible())
        return !1;
      const A = this.getParent();
      return A && A !== y && this !== y ? A._isVisible(y) : !0;
    }
    shouldDrawHit(y, P = !1) {
      if (y)
        return this._isVisible(y) && this._isListening(y);
      const A = this.getLayer();
      let G = !1;
      c.DD._dragElements.forEach((K) => {
        K.dragStatus === "dragging" && (K.node.nodeType === "Stage" || K.node.getLayer() === A) && (G = !0);
      });
      const U = !P && !o.Konva.hitOnDragEnabled && (G || o.Konva.isTransforming());
      return this.isListening() && this.isVisible() && !U;
    }
    show() {
      return this.visible(!0), this;
    }
    hide() {
      return this.visible(!1), this;
    }
    getZIndex() {
      return this.index || 0;
    }
    getAbsoluteZIndex() {
      let y = this.getDepth(), P = this, A = 0, G, U, K, $;
      function X(st) {
        for (G = [], U = st.length, K = 0; K < U; K++)
          $ = st[K], A++, $.nodeType !== d && (G = G.concat($.getChildren().slice())), $._id === P._id && (K = U);
        G.length > 0 && G[0].getDepth() <= y && X(G);
      }
      const Q = this.getStage();
      return P.nodeType !== T && Q && X(Q.getChildren()), A;
    }
    getDepth() {
      let y = 0, P = this.parent;
      for (; P; )
        y++, P = P.parent;
      return y;
    }
    _batchTransformChanges(y) {
      this._batchingTransformChange = !0, y(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache(E), this._clearSelfAndDescendantCache(g)), this._needClearTransformCache = !1;
    }
    setPosition(y) {
      return this._batchTransformChanges(() => {
        this.x(y.x), this.y(y.y);
      }), this;
    }
    getPosition() {
      return {
        x: this.x(),
        y: this.y()
      };
    }
    getRelativePointerPosition() {
      const y = this.getStage();
      if (!y)
        return null;
      const P = y.getPointerPosition();
      if (!P)
        return null;
      const A = this.getAbsoluteTransform().copy();
      return A.invert(), A.point(P);
    }
    getAbsolutePosition(y) {
      let P = !1, A = this.parent;
      for (; A; ) {
        if (A.isCached()) {
          P = !0;
          break;
        }
        A = A.parent;
      }
      P && !y && (y = !0);
      const G = this.getAbsoluteTransform(y).getMatrix(), U = new r.Transform(), K = this.offset();
      return U.m = G.slice(), U.translate(K.x, K.y), U.getTranslation();
    }
    setAbsolutePosition(y) {
      const { x: P, y: A, ...G } = this._clearTransform();
      this.attrs.x = P, this.attrs.y = A, this._clearCache(E);
      const U = this._getAbsoluteTransform().copy();
      return U.invert(), U.translate(y.x, y.y), y = {
        x: this.attrs.x + U.getTranslation().x,
        y: this.attrs.y + U.getTranslation().y
      }, this._setTransform(G), this.setPosition({ x: y.x, y: y.y }), this._clearCache(E), this._clearSelfAndDescendantCache(g), this;
    }
    _setTransform(y) {
      let P;
      for (P in y)
        this.attrs[P] = y[P];
    }
    _clearTransform() {
      const y = {
        x: this.x(),
        y: this.y(),
        rotation: this.rotation(),
        scaleX: this.scaleX(),
        scaleY: this.scaleY(),
        offsetX: this.offsetX(),
        offsetY: this.offsetY(),
        skewX: this.skewX(),
        skewY: this.skewY()
      };
      return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, y;
    }
    move(y) {
      let P = y.x, A = y.y, G = this.x(), U = this.y();
      return P !== void 0 && (G += P), A !== void 0 && (U += A), this.setPosition({ x: G, y: U }), this;
    }
    _eachAncestorReverse(y, P) {
      let A = [], G = this.getParent(), U, K;
      if (!(P && P._id === this._id)) {
        for (A.unshift(this); G && (!P || G._id !== P._id); )
          A.unshift(G), G = G.parent;
        for (U = A.length, K = 0; K < U; K++)
          y(A[K]);
      }
    }
    rotate(y) {
      return this.rotation(this.rotation() + y), this;
    }
    moveToTop() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveToTop function is ignored."), !1;
      const y = this.index, P = this.parent.getChildren().length;
      return y < P - 1 ? (this.parent.children.splice(y, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveUp() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveUp function is ignored."), !1;
      const y = this.index, P = this.parent.getChildren().length;
      return y < P - 1 ? (this.parent.children.splice(y, 1), this.parent.children.splice(y + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveDown() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveDown function is ignored."), !1;
      const y = this.index;
      return y > 0 ? (this.parent.children.splice(y, 1), this.parent.children.splice(y - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveToBottom() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveToBottom function is ignored."), !1;
      const y = this.index;
      return y > 0 ? (this.parent.children.splice(y, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    setZIndex(y) {
      if (!this.parent)
        return r.Util.warn("Node has no parent. zIndex parameter is ignored."), this;
      (y < 0 || y >= this.parent.children.length) && r.Util.warn("Unexpected value " + y + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
      const P = this.index;
      return this.parent.children.splice(P, 1), this.parent.children.splice(y, 0, this), this.parent._setChildrenIndices(), this;
    }
    getAbsoluteOpacity() {
      return this._getCache(h, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
      let y = this.opacity();
      const P = this.getParent();
      return P && !P._isUnderCache && (y *= P.getAbsoluteOpacity()), y;
    }
    moveTo(y) {
      return this.getParent() !== y && (this._remove(), y.add(this)), this;
    }
    toObject() {
      let y = this.getAttrs(), P, A, G, U, K;
      const $ = {
        attrs: {},
        className: this.getClassName()
      };
      for (P in y)
        A = y[P], K = r.Util.isObject(A) && !r.Util._isPlainObject(A) && !r.Util._isArray(A), !K && (G = typeof this[P] == "function" && this[P], delete y[P], U = G ? G.call(this) : null, y[P] = A, U !== A && ($.attrs[P] = A));
      return r.Util._prepareToStringify($);
    }
    toJSON() {
      return JSON.stringify(this.toObject());
    }
    getParent() {
      return this.parent;
    }
    findAncestors(y, P, A) {
      const G = [];
      P && this._isMatch(y) && G.push(this);
      let U = this.parent;
      for (; U; ) {
        if (U === A)
          return G;
        U._isMatch(y) && G.push(U), U = U.parent;
      }
      return G;
    }
    isAncestorOf(y) {
      return !1;
    }
    findAncestor(y, P, A) {
      return this.findAncestors(y, P, A)[0];
    }
    _isMatch(y) {
      if (!y)
        return !1;
      if (typeof y == "function")
        return y(this);
      let P = y.replace(/ /g, "").split(","), A = P.length, G, U;
      for (G = 0; G < A; G++)
        if (U = P[G], r.Util.isValidSelector(U) || (r.Util.warn('Selector "' + U + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), r.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), r.Util.warn("Konva is awesome, right?")), U.charAt(0) === "#") {
          if (this.id() === U.slice(1))
            return !0;
        } else if (U.charAt(0) === ".") {
          if (this.hasName(U.slice(1)))
            return !0;
        } else if (this.className === U || this.nodeType === U)
          return !0;
      return !1;
    }
    getLayer() {
      const y = this.getParent();
      return y ? y.getLayer() : null;
    }
    getStage() {
      return this._getCache(m, this._getStage);
    }
    _getStage() {
      const y = this.getParent();
      return y ? y.getStage() : null;
    }
    fire(y, P = {}, A) {
      return P.target = P.target || this, A ? this._fireAndBubble(y, P) : this._fire(y, P), this;
    }
    getAbsoluteTransform(y) {
      return y ? this._getAbsoluteTransform(y) : this._getCache(g, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(y) {
      let P;
      if (y)
        return P = new r.Transform(), this._eachAncestorReverse(function(A) {
          const G = A.transformsEnabled();
          G === "all" ? P.multiply(A.getTransform()) : G === "position" && P.translate(A.x() - A.offsetX(), A.y() - A.offsetY());
        }, y), P;
      {
        P = this._cache.get(g) || new r.Transform(), this.parent ? this.parent.getAbsoluteTransform().copyInto(P) : P.reset();
        const A = this.transformsEnabled();
        if (A === "all")
          P.multiply(this.getTransform());
        else if (A === "position") {
          const G = this.attrs.x || 0, U = this.attrs.y || 0, K = this.attrs.offsetX || 0, $ = this.attrs.offsetY || 0;
          P.translate(G - K, U - $);
        }
        return P.dirty = !1, P;
      }
    }
    getAbsoluteScale(y) {
      let P = this;
      for (; P; )
        P._isUnderCache && (y = P), P = P.getParent();
      const G = this.getAbsoluteTransform(y).decompose();
      return {
        x: G.scaleX,
        y: G.scaleY
      };
    }
    getAbsoluteRotation() {
      return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
      return this._getCache(E, this._getTransform);
    }
    _getTransform() {
      var y, P;
      const A = this._cache.get(E) || new r.Transform();
      A.reset();
      const G = this.x(), U = this.y(), K = o.Konva.getAngle(this.rotation()), $ = (y = this.attrs.scaleX) !== null && y !== void 0 ? y : 1, X = (P = this.attrs.scaleY) !== null && P !== void 0 ? P : 1, Q = this.attrs.skewX || 0, st = this.attrs.skewY || 0, Z = this.attrs.offsetX || 0, at = this.attrs.offsetY || 0;
      return (G !== 0 || U !== 0) && A.translate(G, U), K !== 0 && A.rotate(K), (Q !== 0 || st !== 0) && A.skew(Q, st), ($ !== 1 || X !== 1) && A.scale($, X), (Z !== 0 || at !== 0) && A.translate(-1 * Z, -1 * at), A.dirty = !1, A;
    }
    clone(y) {
      let P = r.Util.cloneObject(this.attrs), A, G, U, K, $;
      for (A in y)
        P[A] = y[A];
      const X = new this.constructor(P);
      for (A in this.eventListeners)
        for (G = this.eventListeners[A], U = G.length, K = 0; K < U; K++)
          $ = G[K], $.name.indexOf(v) < 0 && (X.eventListeners[A] || (X.eventListeners[A] = []), X.eventListeners[A].push($));
      return X;
    }
    _toKonvaCanvas(y) {
      y = y || {};
      const P = this.getClientRect(), A = this.getStage(), G = y.x !== void 0 ? y.x : Math.floor(P.x), U = y.y !== void 0 ? y.y : Math.floor(P.y), K = y.pixelRatio || 1, $ = new n.SceneCanvas({
        width: y.width || Math.ceil(P.width) || (A ? A.width() : 0),
        height: y.height || Math.ceil(P.height) || (A ? A.height() : 0),
        pixelRatio: K
      }), X = $.getContext(), Q = new n.SceneCanvas({
        width: $.width / $.pixelRatio + Math.abs(G),
        height: $.height / $.pixelRatio + Math.abs(U),
        pixelRatio: $.pixelRatio
      });
      return y.imageSmoothingEnabled === !1 && (X._context.imageSmoothingEnabled = !1), X.save(), (G || U) && X.translate(-1 * G, -1 * U), this.drawScene($, void 0, Q), X.restore(), $;
    }
    toCanvas(y) {
      return this._toKonvaCanvas(y)._canvas;
    }
    toDataURL(y) {
      y = y || {};
      const P = y.mimeType || null, A = y.quality || null, G = this._toKonvaCanvas(y).toDataURL(P, A);
      return y.callback && y.callback(G), G;
    }
    toImage(y) {
      return new Promise((P, A) => {
        try {
          const G = y == null ? void 0 : y.callback;
          G && delete y.callback, r.Util._urlToImage(this.toDataURL(y), function(U) {
            P(U), G == null || G(U);
          });
        } catch (G) {
          A(G);
        }
      });
    }
    toBlob(y) {
      return new Promise((P, A) => {
        try {
          const G = y == null ? void 0 : y.callback;
          G && delete y.callback, this.toCanvas(y).toBlob((U) => {
            P(U), G == null || G(U);
          }, y == null ? void 0 : y.mimeType, y == null ? void 0 : y.quality);
        } catch (G) {
          A(G);
        }
      });
    }
    setSize(y) {
      return this.width(y.width), this.height(y.height), this;
    }
    getSize() {
      return {
        width: this.width(),
        height: this.height()
      };
    }
    getClassName() {
      return this.className || this.nodeType;
    }
    getType() {
      return this.nodeType;
    }
    getDragDistance() {
      return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : o.Konva.dragDistance;
    }
    _off(y, P, A) {
      let G = this.eventListeners[y], U, K, $;
      for (U = 0; U < G.length; U++)
        if (K = G[U].name, $ = G[U].handler, (K !== "konva" || P === "konva") && (!P || K === P) && (!A || A === $)) {
          if (G.splice(U, 1), G.length === 0) {
            delete this.eventListeners[y];
            break;
          }
          U--;
        }
    }
    _fireChangeEvent(y, P, A) {
      this._fire(y + w, {
        oldVal: P,
        newVal: A
      });
    }
    addName(y) {
      if (!this.hasName(y)) {
        const P = this.name(), A = P ? P + " " + y : y;
        this.name(A);
      }
      return this;
    }
    hasName(y) {
      if (!y)
        return !1;
      const P = this.name();
      return P ? (P || "").split(/\s/g).indexOf(y) !== -1 : !1;
    }
    removeName(y) {
      const P = (this.name() || "").split(/\s/g), A = P.indexOf(y);
      return A !== -1 && (P.splice(A, 1), this.name(P.join(" "))), this;
    }
    setAttr(y, P) {
      const A = this[F + r.Util._capitalize(y)];
      return r.Util._isFunction(A) ? A.call(this, P) : this._setAttr(y, P), this;
    }
    _requestDraw() {
      if (o.Konva.autoDrawEnabled) {
        const y = this.getLayer() || this.getStage();
        y == null || y.batchDraw();
      }
    }
    _setAttr(y, P) {
      const A = this.attrs[y];
      A === P && !r.Util.isObject(P) || (P == null ? delete this.attrs[y] : this.attrs[y] = P, this._shouldFireChangeEvents && this._fireChangeEvent(y, A, P), this._requestDraw());
    }
    _setComponentAttr(y, P, A) {
      let G;
      A !== void 0 && (G = this.attrs[y], G || (this.attrs[y] = this.getAttr(y)), this.attrs[y][P] = A, this._fireChangeEvent(y, G, A));
    }
    _fireAndBubble(y, P, A) {
      if (P && this.nodeType === d && (P.target = this), !((y === S || y === C) && (A && (this === A || this.isAncestorOf && this.isAncestorOf(A)) || this.nodeType === "Stage" && !A))) {
        this._fire(y, P);
        const U = (y === S || y === C) && A && A.isAncestorOf && A.isAncestorOf(this) && !A.isAncestorOf(this.parent);
        (P && !P.cancelBubble || !P) && this.parent && this.parent.isListening() && !U && (A && A.parent ? this._fireAndBubble.call(this.parent, y, P, A) : this._fireAndBubble.call(this.parent, y, P));
      }
    }
    _getProtoListeners(y) {
      var P, A, G;
      const U = (P = this._cache.get(l)) !== null && P !== void 0 ? P : {};
      let K = U == null ? void 0 : U[y];
      if (K === void 0) {
        K = [];
        let $ = Object.getPrototypeOf(this);
        for (; $; ) {
          const X = (G = (A = $.eventListeners) === null || A === void 0 ? void 0 : A[y]) !== null && G !== void 0 ? G : [];
          K.push(...X), $ = Object.getPrototypeOf($);
        }
        U[y] = K, this._cache.set(l, U);
      }
      return K;
    }
    _fire(y, P) {
      P = P || {}, P.currentTarget = this, P.type = y;
      const A = this._getProtoListeners(y);
      if (A)
        for (var G = 0; G < A.length; G++)
          A[G].handler.call(this, P);
      const U = this.eventListeners[y];
      if (U)
        for (var G = 0; G < U.length; G++)
          U[G].handler.call(this, P);
    }
    draw() {
      return this.drawScene(), this.drawHit(), this;
    }
    _createDragElement(y) {
      const P = y ? y.pointerId : void 0, A = this.getStage(), G = this.getAbsolutePosition();
      if (!A)
        return;
      const U = A._getPointerById(P) || A._changedPointerPositions[0] || G;
      c.DD._dragElements.set(this._id, {
        node: this,
        startPointerPos: U,
        offset: {
          x: U.x - G.x,
          y: U.y - G.y
        },
        dragStatus: "ready",
        pointerId: P
      });
    }
    startDrag(y, P = !0) {
      c.DD._dragElements.has(this._id) || this._createDragElement(y);
      const A = c.DD._dragElements.get(this._id);
      A.dragStatus = "dragging", this.fire("dragstart", {
        type: "dragstart",
        target: this,
        evt: y && y.evt
      }, P);
    }
    _setDragPosition(y, P) {
      const A = this.getStage()._getPointerById(P.pointerId);
      if (!A)
        return;
      let G = {
        x: A.x - P.offset.x,
        y: A.y - P.offset.y
      };
      const U = this.dragBoundFunc();
      if (U !== void 0) {
        const K = U.call(this, G, y);
        K ? G = K : r.Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
      }
      (!this._lastPos || this._lastPos.x !== G.x || this._lastPos.y !== G.y) && (this.setAbsolutePosition(G), this._requestDraw()), this._lastPos = G;
    }
    stopDrag(y) {
      const P = c.DD._dragElements.get(this._id);
      P && (P.dragStatus = "stopped"), c.DD._endDragBefore(y), c.DD._endDragAfter(y);
    }
    setDraggable(y) {
      this._setAttr("draggable", y), this._dragChange();
    }
    isDragging() {
      const y = c.DD._dragElements.get(this._id);
      return y ? y.dragStatus === "dragging" : !1;
    }
    _listenDrag() {
      this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(y) {
        if (!(!(y.evt.button !== void 0) || o.Konva.dragButtons.indexOf(y.evt.button) >= 0) || this.isDragging())
          return;
        let G = !1;
        c.DD._dragElements.forEach((U) => {
          this.isAncestorOf(U.node) && (G = !0);
        }), G || this._createDragElement(y);
      });
    }
    _dragChange() {
      if (this.attrs.draggable)
        this._listenDrag();
      else {
        if (this._dragCleanup(), !this.getStage())
          return;
        const P = c.DD._dragElements.get(this._id), A = P && P.dragStatus === "dragging", G = P && P.dragStatus === "ready";
        A ? this.stopDrag() : G && c.DD._dragElements.delete(this._id);
      }
    }
    _dragCleanup() {
      this.off("mousedown.konva"), this.off("touchstart.konva");
    }
    isClientRectOnScreen(y = { x: 0, y: 0 }) {
      const P = this.getStage();
      if (!P)
        return !1;
      const A = {
        x: -y.x,
        y: -y.y,
        width: P.width() + 2 * y.x,
        height: P.height() + 2 * y.y
      };
      return r.Util.haveIntersection(A, this.getClientRect());
    }
    static create(y, P) {
      return r.Util._isString(y) && (y = JSON.parse(y)), this._createNode(y, P);
    }
    static _createNode(y, P) {
      let A = zh.prototype.getClassName.call(y), G = y.children, U, K, $;
      P && (y.attrs.container = P), o.Konva[A] || (r.Util.warn('Can not find a node with class name "' + A + '". Fallback to "Shape".'), A = "Shape");
      const X = o.Konva[A];
      if (U = new X(y.attrs), G)
        for (K = G.length, $ = 0; $ < K; $++)
          U.add(zh._createNode(G[$]));
      return U;
    }
  };
  xi.Node = O, O.prototype.nodeType = "Node", O.prototype._attrsAffectingSize = [], O.prototype.eventListeners = {}, O.prototype.on.call(O.prototype, I, function() {
    if (this._batchingTransformChange) {
      this._needClearTransformCache = !0;
      return;
    }
    this._clearCache(E), this._clearSelfAndDescendantCache(g);
  }), O.prototype.on.call(O.prototype, "visibleChange.konva", function() {
    this._clearSelfAndDescendantCache(D);
  }), O.prototype.on.call(O.prototype, "listeningChange.konva", function() {
    this._clearSelfAndDescendantCache(_);
  }), O.prototype.on.call(O.prototype, "opacityChange.konva", function() {
    this._clearSelfAndDescendantCache(h);
  });
  const N = a.Factory.addGetterSetter;
  return N(O, "zIndex"), N(O, "absolutePosition"), N(O, "position"), N(O, "x", 0, (0, s.getNumberValidator)()), N(O, "y", 0, (0, s.getNumberValidator)()), N(O, "globalCompositeOperation", "source-over", (0, s.getStringValidator)()), N(O, "opacity", 1, (0, s.getNumberValidator)()), N(O, "name", "", (0, s.getStringValidator)()), N(O, "id", "", (0, s.getStringValidator)()), N(O, "rotation", 0, (0, s.getNumberValidator)()), a.Factory.addComponentsGetterSetter(O, "scale", ["x", "y"]), N(O, "scaleX", 1, (0, s.getNumberValidator)()), N(O, "scaleY", 1, (0, s.getNumberValidator)()), a.Factory.addComponentsGetterSetter(O, "skew", ["x", "y"]), N(O, "skewX", 0, (0, s.getNumberValidator)()), N(O, "skewY", 0, (0, s.getNumberValidator)()), a.Factory.addComponentsGetterSetter(O, "offset", ["x", "y"]), N(O, "offsetX", 0, (0, s.getNumberValidator)()), N(O, "offsetY", 0, (0, s.getNumberValidator)()), N(O, "dragDistance", null, (0, s.getNumberValidator)()), N(O, "width", 0, (0, s.getNumberValidator)()), N(O, "height", 0, (0, s.getNumberValidator)()), N(O, "listening", !0, (0, s.getBooleanValidator)()), N(O, "preventDefault", !0, (0, s.getBooleanValidator)()), N(O, "filters", null, function(H) {
    return this._filterUpToDate = !1, H;
  }), N(O, "visible", !0, (0, s.getBooleanValidator)()), N(O, "transformsEnabled", "all", (0, s.getStringValidator)()), N(O, "size"), N(O, "dragBoundFunc"), N(O, "draggable", !1, (0, s.getBooleanValidator)()), a.Factory.backCompat(O, {
    rotateDeg: "rotate",
    setRotationDeg: "setRotation",
    getRotationDeg: "getRotation"
  }), xi;
}
var Ei = {}, td;
function wa() {
  if (td) return Ei;
  td = 1, Object.defineProperty(Ei, "__esModule", { value: !0 }), Ei.Container = void 0;
  const r = Tt(), a = $t(), n = Ot();
  let o = class extends a.Node {
    constructor() {
      super(...arguments), this.children = [];
    }
    getChildren(s) {
      if (!s)
        return this.children || [];
      const h = this.children || [], l = [];
      return h.forEach(function(g) {
        s(g) && l.push(g);
      }), l;
    }
    hasChildren() {
      return this.getChildren().length > 0;
    }
    removeChildren() {
      return this.getChildren().forEach((s) => {
        s.parent = null, s.index = 0, s.remove();
      }), this.children = [], this._requestDraw(), this;
    }
    destroyChildren() {
      return this.getChildren().forEach((s) => {
        s.parent = null, s.index = 0, s.destroy();
      }), this.children = [], this._requestDraw(), this;
    }
    add(...s) {
      if (s.length === 0)
        return this;
      if (s.length > 1) {
        for (let l = 0; l < s.length; l++)
          this.add(s[l]);
        return this;
      }
      const h = s[0];
      return h.getParent() ? (h.moveTo(this), this) : (this._validateAdd(h), h.index = this.getChildren().length, h.parent = this, h._clearCaches(), this.getChildren().push(h), this._fire("add", {
        child: h
      }), this._requestDraw(), this);
    }
    destroy() {
      return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
    }
    find(s) {
      return this._generalFind(s, !1);
    }
    findOne(s) {
      const h = this._generalFind(s, !0);
      return h.length > 0 ? h[0] : void 0;
    }
    _generalFind(s, h) {
      const l = [];
      return this._descendants((g) => {
        const p = g._isMatch(s);
        return p && l.push(g), !!(p && h);
      }), l;
    }
    _descendants(s) {
      let h = !1;
      const l = this.getChildren();
      for (const g of l) {
        if (h = s(g), h)
          return !0;
        if (g.hasChildren() && (h = g._descendants(s), h))
          return !0;
      }
      return !1;
    }
    toObject() {
      const s = a.Node.prototype.toObject.call(this);
      return s.children = [], this.getChildren().forEach((h) => {
        s.children.push(h.toObject());
      }), s;
    }
    isAncestorOf(s) {
      let h = s.getParent();
      for (; h; ) {
        if (h._id === this._id)
          return !0;
        h = h.getParent();
      }
      return !1;
    }
    clone(s) {
      const h = a.Node.prototype.clone.call(this, s);
      return this.getChildren().forEach(function(l) {
        h.add(l.clone());
      }), h;
    }
    getAllIntersections(s) {
      const h = [];
      return this.find("Shape").forEach((l) => {
        l.isVisible() && l.intersects(s) && h.push(l);
      }), h;
    }
    _clearSelfAndDescendantCache(s) {
      var h;
      super._clearSelfAndDescendantCache(s), !this.isCached() && ((h = this.children) === null || h === void 0 || h.forEach(function(l) {
        l._clearSelfAndDescendantCache(s);
      }));
    }
    _setChildrenIndices() {
      var s;
      (s = this.children) === null || s === void 0 || s.forEach(function(h, l) {
        h.index = l;
      }), this._requestDraw();
    }
    drawScene(s, h, l) {
      const g = this.getLayer(), p = s || g && g.getCanvas(), b = p && p.getContext(), w = this._getCanvasCache(), x = w && w.scene, v = p && p.isCache;
      if (!this.isVisible() && !v)
        return this;
      if (x) {
        b.save();
        const _ = this.getAbsoluteTransform(h).getMatrix();
        b.transform(_[0], _[1], _[2], _[3], _[4], _[5]), this._drawCachedSceneCanvas(b), b.restore();
      } else
        this._drawChildren("drawScene", p, h, l);
      return this;
    }
    drawHit(s, h) {
      if (!this.shouldDrawHit(h))
        return this;
      const l = this.getLayer(), g = s || l && l.hitCanvas, p = g && g.getContext(), b = this._getCanvasCache();
      if (b && b.hit) {
        p.save();
        const x = this.getAbsoluteTransform(h).getMatrix();
        p.transform(x[0], x[1], x[2], x[3], x[4], x[5]), this._drawCachedHitCanvas(p), p.restore();
      } else
        this._drawChildren("drawHit", g, h);
      return this;
    }
    _drawChildren(s, h, l, g) {
      var p;
      const b = h && h.getContext(), w = this.clipWidth(), x = this.clipHeight(), v = this.clipFunc(), _ = typeof w == "number" && typeof x == "number" || v, S = l === this;
      if (_) {
        b.save();
        const F = this.getAbsoluteTransform(l);
        let d = F.getMatrix();
        b.transform(d[0], d[1], d[2], d[3], d[4], d[5]), b.beginPath();
        let f;
        if (v)
          f = v.call(this, b, this);
        else {
          const m = this.clipX(), E = this.clipY();
          b.rect(m || 0, E || 0, w, x);
        }
        b.clip.apply(b, f), d = F.copy().invert().getMatrix(), b.transform(d[0], d[1], d[2], d[3], d[4], d[5]);
      }
      const C = !S && this.globalCompositeOperation() !== "source-over" && s === "drawScene";
      C && (b.save(), b._applyGlobalCompositeOperation(this)), (p = this.children) === null || p === void 0 || p.forEach(function(F) {
        F[s](h, l, g);
      }), C && b.restore(), _ && b.restore();
    }
    getClientRect(s = {}) {
      var h;
      const l = s.skipTransform, g = s.relativeTo;
      let p, b, w, x, v = {
        x: 1 / 0,
        y: 1 / 0,
        width: 0,
        height: 0
      };
      const _ = this;
      (h = this.children) === null || h === void 0 || h.forEach(function(F) {
        if (!F.visible())
          return;
        const d = F.getClientRect({
          relativeTo: _,
          skipShadow: s.skipShadow,
          skipStroke: s.skipStroke
        });
        d.width === 0 && d.height === 0 || (p === void 0 ? (p = d.x, b = d.y, w = d.x + d.width, x = d.y + d.height) : (p = Math.min(p, d.x), b = Math.min(b, d.y), w = Math.max(w, d.x + d.width), x = Math.max(x, d.y + d.height)));
      });
      const S = this.find("Shape");
      let C = !1;
      for (let F = 0; F < S.length; F++)
        if (S[F]._isVisible(this)) {
          C = !0;
          break;
        }
      return C && p !== void 0 ? v = {
        x: p,
        y: b,
        width: w - p,
        height: x - b
      } : v = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, l ? v : this._transformedRect(v, g);
    }
  };
  return Ei.Container = o, r.Factory.addComponentsGetterSetter(o, "clip", [
    "x",
    "y",
    "width",
    "height"
  ]), r.Factory.addGetterSetter(o, "clipX", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipY", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipWidth", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipHeight", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipFunc"), Ei;
}
var oo = {}, Er = {}, ed;
function Y0() {
  if (ed) return Er;
  ed = 1, Object.defineProperty(Er, "__esModule", { value: !0 }), Er.getCapturedShape = o, Er.createEvent = c, Er.hasPointerCapture = s, Er.setPointerCapture = h, Er.releaseCapture = l;
  const r = Rt(), a = /* @__PURE__ */ new Map(), n = r.Konva._global.PointerEvent !== void 0;
  function o(g) {
    return a.get(g);
  }
  function c(g) {
    return {
      evt: g,
      pointerId: g.pointerId
    };
  }
  function s(g, p) {
    return a.get(g) === p;
  }
  function h(g, p) {
    l(g), p.getStage() && (a.set(g, p), n && p._fire("gotpointercapture", c(new PointerEvent("gotpointercapture"))));
  }
  function l(g, p) {
    const b = a.get(g);
    if (!b)
      return;
    const w = b.getStage();
    w && w.content, a.delete(g), n && b._fire("lostpointercapture", c(new PointerEvent("lostpointercapture")));
  }
  return Er;
}
var rd;
function o6() {
  return rd || (rd = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Stage = r.stages = void 0;
    const a = Kt(), n = Tt(), o = wa(), c = Rt(), s = ba(), h = Yh(), l = Rt(), g = Y0(), p = "Stage", b = "string", w = "px", x = "mouseout", v = "mouseleave", _ = "mouseover", S = "mouseenter", C = "mousemove", F = "mousedown", d = "mouseup", f = "pointermove", m = "pointerdown", E = "pointerup", T = "pointercancel", D = "lostpointercapture", I = "pointerout", L = "pointerleave", O = "pointerover", N = "pointerenter", H = "contextmenu", y = "touchstart", P = "touchend", A = "touchmove", G = "touchcancel", U = "wheel", K = 5, $ = [
      [S, "_pointerenter"],
      [F, "_pointerdown"],
      [C, "_pointermove"],
      [d, "_pointerup"],
      [v, "_pointerleave"],
      [y, "_pointerdown"],
      [A, "_pointermove"],
      [P, "_pointerup"],
      [G, "_pointercancel"],
      [_, "_pointerover"],
      [U, "_wheel"],
      [H, "_contextmenu"],
      [m, "_pointerdown"],
      [f, "_pointermove"],
      [E, "_pointerup"],
      [T, "_pointercancel"],
      [D, "_lostpointercapture"]
    ], X = {
      mouse: {
        [I]: x,
        [L]: v,
        [O]: _,
        [N]: S,
        [f]: C,
        [m]: F,
        [E]: d,
        [T]: "mousecancel",
        pointerclick: "click",
        pointerdblclick: "dblclick"
      },
      touch: {
        [I]: "touchout",
        [L]: "touchleave",
        [O]: "touchover",
        [N]: "touchenter",
        [f]: A,
        [m]: y,
        [E]: P,
        [T]: G,
        pointerclick: "tap",
        pointerdblclick: "dbltap"
      },
      pointer: {
        [I]: I,
        [L]: L,
        [O]: O,
        [N]: N,
        [f]: f,
        [m]: m,
        [E]: E,
        [T]: T,
        pointerclick: "pointerclick",
        pointerdblclick: "pointerdblclick"
      }
    }, Q = (ct) => ct.indexOf("pointer") >= 0 ? "pointer" : ct.indexOf("touch") >= 0 ? "touch" : "mouse", st = (ct) => {
      const W = Q(ct);
      if (W === "pointer")
        return c.Konva.pointerEventsEnabled && X.pointer;
      if (W === "touch")
        return X.touch;
      if (W === "mouse")
        return X.mouse;
    };
    function Z(ct = {}) {
      return (ct.clipFunc || ct.clipWidth || ct.clipHeight) && a.Util.warn("Stage does not support clipping. Please use clip for Layers or Groups."), ct;
    }
    const at = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
    r.stages = [];
    class ht extends o.Container {
      constructor(W) {
        super(Z(W)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), r.stages.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
          Z(this.attrs);
        }), this._checkVisibility();
      }
      _validateAdd(W) {
        const j = W.getType() === "Layer", et = W.getType() === "FastLayer";
        j || et || a.Util.throw("You may only add layers to the stage.");
      }
      _checkVisibility() {
        if (!this.content)
          return;
        const W = this.visible() ? "" : "none";
        this.content.style.display = W;
      }
      setContainer(W) {
        if (typeof W === b) {
          if (W.charAt(0) === ".") {
            const et = W.slice(1);
            W = document.getElementsByClassName(et)[0];
          } else {
            var j;
            W.charAt(0) !== "#" ? j = W : j = W.slice(1), W = document.getElementById(j);
          }
          if (!W)
            throw "Can not find container in document with id " + j;
        }
        return this._setAttr("container", W), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), W.appendChild(this.content)), this;
      }
      shouldDrawHit() {
        return !0;
      }
      clear() {
        let W = this.children, j = W.length, et;
        for (et = 0; et < j; et++)
          W[et].clear();
        return this;
      }
      clone(W) {
        return W || (W = {}), W.container = typeof document != "undefined" && document.createElement("div"), o.Container.prototype.clone.call(this, W);
      }
      destroy() {
        super.destroy();
        const W = this.content;
        W && a.Util._isInDocument(W) && this.container().removeChild(W);
        const j = r.stages.indexOf(this);
        return j > -1 && r.stages.splice(j, 1), a.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
      }
      getPointerPosition() {
        const W = this._pointerPositions[0] || this._changedPointerPositions[0];
        return W ? {
          x: W.x,
          y: W.y
        } : (a.Util.warn(at), null);
      }
      _getPointerById(W) {
        return this._pointerPositions.find((j) => j.id === W);
      }
      getPointersPositions() {
        return this._pointerPositions;
      }
      getStage() {
        return this;
      }
      getContent() {
        return this.content;
      }
      _toKonvaCanvas(W) {
        W = W || {}, W.x = W.x || 0, W.y = W.y || 0, W.width = W.width || this.width(), W.height = W.height || this.height();
        const j = new s.SceneCanvas({
          width: W.width,
          height: W.height,
          pixelRatio: W.pixelRatio || 1
        }), et = j.getContext()._context, ut = this.children;
        return (W.x || W.y) && et.translate(-1 * W.x, -1 * W.y), ut.forEach(function(ft) {
          if (!ft.isVisible())
            return;
          const gt = ft._toKonvaCanvas(W);
          et.drawImage(gt._canvas, W.x, W.y, gt.getWidth() / gt.getPixelRatio(), gt.getHeight() / gt.getPixelRatio());
        }), j;
      }
      getIntersection(W) {
        if (!W)
          return null;
        let j = this.children, et = j.length, ut = et - 1, ft;
        for (ft = ut; ft >= 0; ft--) {
          const gt = j[ft].getIntersection(W);
          if (gt)
            return gt;
        }
        return null;
      }
      _resizeDOM() {
        const W = this.width(), j = this.height();
        this.content && (this.content.style.width = W + w, this.content.style.height = j + w), this.bufferCanvas.setSize(W, j), this.bufferHitCanvas.setSize(W, j), this.children.forEach((et) => {
          et.setSize({ width: W, height: j }), et.draw();
        });
      }
      add(W, ...j) {
        if (arguments.length > 1) {
          for (let ut = 0; ut < arguments.length; ut++)
            this.add(arguments[ut]);
          return this;
        }
        super.add(W);
        const et = this.children.length;
        return et > K && a.Util.warn("The stage has " + et + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), W.setSize({ width: this.width(), height: this.height() }), W.draw(), c.Konva.isBrowser && this.content.appendChild(W.canvas._canvas), this;
      }
      getParent() {
        return null;
      }
      getLayer() {
        return null;
      }
      hasPointerCapture(W) {
        return g.hasPointerCapture(W, this);
      }
      setPointerCapture(W) {
        g.setPointerCapture(W, this);
      }
      releaseCapture(W) {
        g.releaseCapture(W, this);
      }
      getLayers() {
        return this.children;
      }
      _bindContentEvents() {
        c.Konva.isBrowser && $.forEach(([W, j]) => {
          this.content.addEventListener(W, (et) => {
            this[j](et);
          }, { passive: !1 });
        });
      }
      _pointerenter(W) {
        this.setPointersPositions(W);
        const j = st(W.type);
        j && this._fire(j.pointerenter, {
          evt: W,
          target: this,
          currentTarget: this
        });
      }
      _pointerover(W) {
        this.setPointersPositions(W);
        const j = st(W.type);
        j && this._fire(j.pointerover, {
          evt: W,
          target: this,
          currentTarget: this
        });
      }
      _getTargetShape(W) {
        let j = this[W + "targetShape"];
        return j && !j.getStage() && (j = null), j;
      }
      _pointerleave(W) {
        const j = st(W.type), et = Q(W.type);
        if (!j)
          return;
        this.setPointersPositions(W);
        const ut = this._getTargetShape(et), ft = !(c.Konva.isDragging() || c.Konva.isTransforming()) || c.Konva.hitOnDragEnabled;
        ut && ft ? (ut._fireAndBubble(j.pointerout, { evt: W }), ut._fireAndBubble(j.pointerleave, { evt: W }), this._fire(j.pointerleave, {
          evt: W,
          target: this,
          currentTarget: this
        }), this[et + "targetShape"] = null) : ft && (this._fire(j.pointerleave, {
          evt: W,
          target: this,
          currentTarget: this
        }), this._fire(j.pointerout, {
          evt: W,
          target: this,
          currentTarget: this
        })), this.pointerPos = null, this._pointerPositions = [];
      }
      _pointerdown(W) {
        const j = st(W.type), et = Q(W.type);
        if (!j)
          return;
        this.setPointersPositions(W);
        let ut = !1;
        this._changedPointerPositions.forEach((ft) => {
          const gt = this.getIntersection(ft);
          if (h.DD.justDragged = !1, c.Konva["_" + et + "ListenClick"] = !0, !gt || !gt.isListening()) {
            this[et + "ClickStartShape"] = void 0;
            return;
          }
          c.Konva.capturePointerEventsEnabled && gt.setPointerCapture(ft.id), this[et + "ClickStartShape"] = gt, gt._fireAndBubble(j.pointerdown, {
            evt: W,
            pointerId: ft.id
          }), ut = !0;
          const Lt = W.type.indexOf("touch") >= 0;
          gt.preventDefault() && W.cancelable && Lt && W.preventDefault();
        }), ut || this._fire(j.pointerdown, {
          evt: W,
          target: this,
          currentTarget: this,
          pointerId: this._pointerPositions[0].id
        });
      }
      _pointermove(W) {
        const j = st(W.type), et = Q(W.type);
        if (!j || (c.Konva.isDragging() && h.DD.node.preventDefault() && W.cancelable && W.preventDefault(), this.setPointersPositions(W), !(!(c.Konva.isDragging() || c.Konva.isTransforming()) || c.Konva.hitOnDragEnabled)))
          return;
        const ft = {};
        let gt = !1;
        const Lt = this._getTargetShape(et);
        this._changedPointerPositions.forEach((Et) => {
          const mt = g.getCapturedShape(Et.id) || this.getIntersection(Et), ee = Et.id, Pt = { evt: W, pointerId: ee }, Wt = Lt !== mt;
          if (Wt && Lt && (Lt._fireAndBubble(j.pointerout, { ...Pt }, mt), Lt._fireAndBubble(j.pointerleave, { ...Pt }, mt)), mt) {
            if (ft[mt._id])
              return;
            ft[mt._id] = !0;
          }
          mt && mt.isListening() ? (gt = !0, Wt && (mt._fireAndBubble(j.pointerover, { ...Pt }, Lt), mt._fireAndBubble(j.pointerenter, { ...Pt }, Lt), this[et + "targetShape"] = mt), mt._fireAndBubble(j.pointermove, { ...Pt })) : Lt && (this._fire(j.pointerover, {
            evt: W,
            target: this,
            currentTarget: this,
            pointerId: ee
          }), this[et + "targetShape"] = null);
        }), gt || this._fire(j.pointermove, {
          evt: W,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        });
      }
      _pointerup(W) {
        const j = st(W.type), et = Q(W.type);
        if (!j)
          return;
        this.setPointersPositions(W);
        const ut = this[et + "ClickStartShape"], ft = this[et + "ClickEndShape"], gt = {};
        let Lt = !1;
        this._changedPointerPositions.forEach((Et) => {
          const mt = g.getCapturedShape(Et.id) || this.getIntersection(Et);
          if (mt) {
            if (mt.releaseCapture(Et.id), gt[mt._id])
              return;
            gt[mt._id] = !0;
          }
          const ee = Et.id, Pt = { evt: W, pointerId: ee };
          let Wt = !1;
          c.Konva["_" + et + "InDblClickWindow"] ? (Wt = !0, clearTimeout(this[et + "DblTimeout"])) : h.DD.justDragged || (c.Konva["_" + et + "InDblClickWindow"] = !0, clearTimeout(this[et + "DblTimeout"])), this[et + "DblTimeout"] = setTimeout(function() {
            c.Konva["_" + et + "InDblClickWindow"] = !1;
          }, c.Konva.dblClickWindow), mt && mt.isListening() ? (Lt = !0, this[et + "ClickEndShape"] = mt, mt._fireAndBubble(j.pointerup, { ...Pt }), c.Konva["_" + et + "ListenClick"] && ut && ut === mt && (mt._fireAndBubble(j.pointerclick, { ...Pt }), Wt && ft && ft === mt && mt._fireAndBubble(j.pointerdblclick, { ...Pt }))) : (this[et + "ClickEndShape"] = null, c.Konva["_" + et + "ListenClick"] && this._fire(j.pointerclick, {
            evt: W,
            target: this,
            currentTarget: this,
            pointerId: ee
          }), Wt && this._fire(j.pointerdblclick, {
            evt: W,
            target: this,
            currentTarget: this,
            pointerId: ee
          }));
        }), Lt || this._fire(j.pointerup, {
          evt: W,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        }), c.Konva["_" + et + "ListenClick"] = !1, W.cancelable && et !== "touch" && W.preventDefault();
      }
      _contextmenu(W) {
        this.setPointersPositions(W);
        const j = this.getIntersection(this.getPointerPosition());
        j && j.isListening() ? j._fireAndBubble(H, { evt: W }) : this._fire(H, {
          evt: W,
          target: this,
          currentTarget: this
        });
      }
      _wheel(W) {
        this.setPointersPositions(W);
        const j = this.getIntersection(this.getPointerPosition());
        j && j.isListening() ? j._fireAndBubble(U, { evt: W }) : this._fire(U, {
          evt: W,
          target: this,
          currentTarget: this
        });
      }
      _pointercancel(W) {
        this.setPointersPositions(W);
        const j = g.getCapturedShape(W.pointerId) || this.getIntersection(this.getPointerPosition());
        j && j._fireAndBubble(E, g.createEvent(W)), g.releaseCapture(W.pointerId);
      }
      _lostpointercapture(W) {
        g.releaseCapture(W.pointerId);
      }
      setPointersPositions(W) {
        let j = this._getContentPosition(), et = null, ut = null;
        W = W || window.event, W.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(W.touches, (ft) => {
          this._pointerPositions.push({
            id: ft.identifier,
            x: (ft.clientX - j.left) / j.scaleX,
            y: (ft.clientY - j.top) / j.scaleY
          });
        }), Array.prototype.forEach.call(W.changedTouches || W.touches, (ft) => {
          this._changedPointerPositions.push({
            id: ft.identifier,
            x: (ft.clientX - j.left) / j.scaleX,
            y: (ft.clientY - j.top) / j.scaleY
          });
        })) : (et = (W.clientX - j.left) / j.scaleX, ut = (W.clientY - j.top) / j.scaleY, this.pointerPos = {
          x: et,
          y: ut
        }, this._pointerPositions = [{ x: et, y: ut, id: a.Util._getFirstPointerId(W) }], this._changedPointerPositions = [
          { x: et, y: ut, id: a.Util._getFirstPointerId(W) }
        ]);
      }
      _setPointerPosition(W) {
        a.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(W);
      }
      _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect)
          return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
          };
        const W = this.content.getBoundingClientRect();
        return {
          top: W.top,
          left: W.left,
          scaleX: W.width / this.content.clientWidth || 1,
          scaleY: W.height / this.content.clientHeight || 1
        };
      }
      _buildDOM() {
        if (this.bufferCanvas = new s.SceneCanvas({
          width: this.width(),
          height: this.height()
        }), this.bufferHitCanvas = new s.HitCanvas({
          pixelRatio: 1,
          width: this.width(),
          height: this.height()
        }), !c.Konva.isBrowser)
          return;
        const W = this.container();
        if (!W)
          throw "Stage has no container. A container is required.";
        W.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), W.appendChild(this.content), this._resizeDOM();
      }
      cache() {
        return a.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
      }
      clearCache() {
        return this;
      }
      batchDraw() {
        return this.getChildren().forEach(function(W) {
          W.batchDraw();
        }), this;
      }
    }
    r.Stage = ht, ht.prototype.nodeType = p, (0, l._registerNode)(ht), n.Factory.addGetterSetter(ht, "container"), c.Konva.isBrowser && document.addEventListener("visibilitychange", () => {
      r.stages.forEach((ct) => {
        ct.batchDraw();
      });
    });
  }(oo)), oo;
}
var Ai = {}, ho = {}, id;
function se() {
  return id || (id = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Shape = r.shapes = void 0;
    const a = Rt(), n = Kt(), o = Tt(), c = $t(), s = Ot(), h = Rt(), l = Y0(), g = "hasShadow", p = "shadowRGBA", b = "patternImage", w = "linearGradient", x = "radialGradient";
    let v;
    function _() {
      return v || (v = n.Util.createCanvasElement().getContext("2d"), v);
    }
    r.shapes = {};
    function S(L) {
      const O = this.attrs.fillRule;
      O ? L.fill(O) : L.fill();
    }
    function C(L) {
      L.stroke();
    }
    function F(L) {
      const O = this.attrs.fillRule;
      O ? L.fill(O) : L.fill();
    }
    function d(L) {
      L.stroke();
    }
    function f() {
      this._clearCache(g);
    }
    function m() {
      this._clearCache(p);
    }
    function E() {
      this._clearCache(b);
    }
    function T() {
      this._clearCache(w);
    }
    function D() {
      this._clearCache(x);
    }
    class I extends c.Node {
      constructor(O) {
        super(O);
        let N;
        for (; N = n.Util.getRandomColor(), !(N && !(N in r.shapes)); )
          ;
        this.colorKey = N, r.shapes[N] = this;
      }
      getContext() {
        return n.Util.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
      }
      getCanvas() {
        return n.Util.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
      }
      getSceneFunc() {
        return this.attrs.sceneFunc || this._sceneFunc;
      }
      getHitFunc() {
        return this.attrs.hitFunc || this._hitFunc;
      }
      hasShadow() {
        return this._getCache(g, this._hasShadow);
      }
      _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
      }
      _getFillPattern() {
        return this._getCache(b, this.__getFillPattern);
      }
      __getFillPattern() {
        if (this.fillPatternImage()) {
          const N = _().createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
          if (N && N.setTransform) {
            const H = new n.Transform();
            H.translate(this.fillPatternX(), this.fillPatternY()), H.rotate(a.Konva.getAngle(this.fillPatternRotation())), H.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), H.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
            const y = H.getMatrix(), P = typeof DOMMatrix == "undefined" ? {
              a: y[0],
              b: y[1],
              c: y[2],
              d: y[3],
              e: y[4],
              f: y[5]
            } : new DOMMatrix(y);
            N.setTransform(P);
          }
          return N;
        }
      }
      _getLinearGradient() {
        return this._getCache(w, this.__getLinearGradient);
      }
      __getLinearGradient() {
        const O = this.fillLinearGradientColorStops();
        if (O) {
          const N = _(), H = this.fillLinearGradientStartPoint(), y = this.fillLinearGradientEndPoint(), P = N.createLinearGradient(H.x, H.y, y.x, y.y);
          for (let A = 0; A < O.length; A += 2)
            P.addColorStop(O[A], O[A + 1]);
          return P;
        }
      }
      _getRadialGradient() {
        return this._getCache(x, this.__getRadialGradient);
      }
      __getRadialGradient() {
        const O = this.fillRadialGradientColorStops();
        if (O) {
          const N = _(), H = this.fillRadialGradientStartPoint(), y = this.fillRadialGradientEndPoint(), P = N.createRadialGradient(H.x, H.y, this.fillRadialGradientStartRadius(), y.x, y.y, this.fillRadialGradientEndRadius());
          for (let A = 0; A < O.length; A += 2)
            P.addColorStop(O[A], O[A + 1]);
          return P;
        }
      }
      getShadowRGBA() {
        return this._getCache(p, this._getShadowRGBA);
      }
      _getShadowRGBA() {
        if (!this.hasShadow())
          return;
        const O = n.Util.colorToRGBA(this.shadowColor());
        if (O)
          return "rgba(" + O.r + "," + O.g + "," + O.b + "," + O.a * (this.shadowOpacity() || 1) + ")";
      }
      hasFill() {
        return this._calculate("hasFill", [
          "fillEnabled",
          "fill",
          "fillPatternImage",
          "fillLinearGradientColorStops",
          "fillRadialGradientColorStops"
        ], () => this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
      }
      hasStroke() {
        return this._calculate("hasStroke", [
          "strokeEnabled",
          "strokeWidth",
          "stroke",
          "strokeLinearGradientColorStops"
        ], () => this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
      }
      hasHitStroke() {
        const O = this.hitStrokeWidth();
        return O === "auto" ? this.hasStroke() : this.strokeEnabled() && !!O;
      }
      intersects(O) {
        const N = this.getStage();
        if (!N)
          return !1;
        const H = N.bufferHitCanvas;
        return H.getContext().clear(), this.drawHit(H, void 0, !0), H.context.getImageData(Math.round(O.x), Math.round(O.y), 1, 1).data[3] > 0;
      }
      destroy() {
        return c.Node.prototype.destroy.call(this), delete r.shapes[this.colorKey], delete this.colorKey, this;
      }
      _useBufferCanvas(O) {
        var N;
        if (!((N = this.attrs.perfectDrawEnabled) !== null && N !== void 0 ? N : !0))
          return !1;
        const y = O || this.hasFill(), P = this.hasStroke(), A = this.getAbsoluteOpacity() !== 1;
        if (y && P && A)
          return !0;
        const G = this.hasShadow(), U = this.shadowForStrokeEnabled();
        return !!(y && P && G && U);
      }
      setStrokeHitEnabled(O) {
        n.Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), O ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
      }
      getStrokeHitEnabled() {
        return this.hitStrokeWidth() !== 0;
      }
      getSelfRect() {
        const O = this.size();
        return {
          x: this._centroid ? -O.width / 2 : 0,
          y: this._centroid ? -O.height / 2 : 0,
          width: O.width,
          height: O.height
        };
      }
      getClientRect(O = {}) {
        let N = !1, H = this.getParent();
        for (; H; ) {
          if (H.isCached()) {
            N = !0;
            break;
          }
          H = H.getParent();
        }
        const y = O.skipTransform, P = O.relativeTo || N && this.getStage() || void 0, A = this.getSelfRect(), U = !O.skipStroke && this.hasStroke() && this.strokeWidth() || 0, K = A.width + U, $ = A.height + U, X = !O.skipShadow && this.hasShadow(), Q = X ? this.shadowOffsetX() : 0, st = X ? this.shadowOffsetY() : 0, Z = K + Math.abs(Q), at = $ + Math.abs(st), ht = X && this.shadowBlur() || 0, ct = Z + ht * 2, W = at + ht * 2, j = {
          width: ct,
          height: W,
          x: -(U / 2 + ht) + Math.min(Q, 0) + A.x,
          y: -(U / 2 + ht) + Math.min(st, 0) + A.y
        };
        return y ? j : this._transformedRect(j, P);
      }
      drawScene(O, N, H) {
        const y = this.getLayer();
        let P = O || y.getCanvas(), A = P.getContext(), G = this._getCanvasCache(), U = this.getSceneFunc(), K = this.hasShadow(), $, X;
        const Q = P.isCache, st = N === this;
        if (!this.isVisible() && !st)
          return this;
        if (G) {
          A.save();
          const at = this.getAbsoluteTransform(N).getMatrix();
          return A.transform(at[0], at[1], at[2], at[3], at[4], at[5]), this._drawCachedSceneCanvas(A), A.restore(), this;
        }
        if (!U)
          return this;
        if (A.save(), this._useBufferCanvas() && !Q) {
          $ = this.getStage();
          const at = H || $.bufferCanvas;
          X = at.getContext(), X.clear(), X.save(), X._applyLineJoin(this);
          var Z = this.getAbsoluteTransform(N).getMatrix();
          X.transform(Z[0], Z[1], Z[2], Z[3], Z[4], Z[5]), U.call(this, X, this), X.restore();
          const ht = at.pixelRatio;
          K && A._applyShadow(this), A._applyOpacity(this), A._applyGlobalCompositeOperation(this), A.drawImage(at._canvas, 0, 0, at.width / ht, at.height / ht);
        } else {
          if (A._applyLineJoin(this), !st) {
            var Z = this.getAbsoluteTransform(N).getMatrix();
            A.transform(Z[0], Z[1], Z[2], Z[3], Z[4], Z[5]), A._applyOpacity(this), A._applyGlobalCompositeOperation(this);
          }
          K && A._applyShadow(this), U.call(this, A, this);
        }
        return A.restore(), this;
      }
      drawHit(O, N, H = !1) {
        if (!this.shouldDrawHit(N, H))
          return this;
        const y = this.getLayer(), P = O || y.hitCanvas, A = P && P.getContext(), G = this.hitFunc() || this.sceneFunc(), U = this._getCanvasCache(), K = U && U.hit;
        if (this.colorKey || n.Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), K) {
          A.save();
          const X = this.getAbsoluteTransform(N).getMatrix();
          return A.transform(X[0], X[1], X[2], X[3], X[4], X[5]), this._drawCachedHitCanvas(A), A.restore(), this;
        }
        if (!G)
          return this;
        if (A.save(), A._applyLineJoin(this), !(this === N)) {
          const X = this.getAbsoluteTransform(N).getMatrix();
          A.transform(X[0], X[1], X[2], X[3], X[4], X[5]);
        }
        return G.call(this, A, this), A.restore(), this;
      }
      drawHitFromCache(O = 0) {
        let N = this._getCanvasCache(), H = this._getCachedSceneCanvas(), y = N.hit, P = y.getContext(), A = y.getWidth(), G = y.getHeight(), U, K, $, X, Q, st;
        P.clear(), P.drawImage(H._canvas, 0, 0, A, G);
        try {
          for (U = P.getImageData(0, 0, A, G), K = U.data, $ = K.length, X = n.Util._hexToRgb(this.colorKey), Q = 0; Q < $; Q += 4)
            st = K[Q + 3], st > O ? (K[Q] = X.r, K[Q + 1] = X.g, K[Q + 2] = X.b, K[Q + 3] = 255) : K[Q + 3] = 0;
          P.putImageData(U, 0, 0);
        } catch (Z) {
          n.Util.error("Unable to draw hit graph from cached scene canvas. " + Z.message);
        }
        return this;
      }
      hasPointerCapture(O) {
        return l.hasPointerCapture(O, this);
      }
      setPointerCapture(O) {
        l.setPointerCapture(O, this);
      }
      releaseCapture(O) {
        l.releaseCapture(O, this);
      }
    }
    r.Shape = I, I.prototype._fillFunc = S, I.prototype._strokeFunc = C, I.prototype._fillFuncHit = F, I.prototype._strokeFuncHit = d, I.prototype._centroid = !1, I.prototype.nodeType = "Shape", (0, h._registerNode)(I), I.prototype.eventListeners = {}, I.prototype.on.call(I.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", f), I.prototype.on.call(I.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", m), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", E), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", T), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", D), o.Factory.addGetterSetter(I, "stroke", void 0, (0, s.getStringOrGradientValidator)()), o.Factory.addGetterSetter(I, "strokeWidth", 2, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillAfterStrokeEnabled", !1), o.Factory.addGetterSetter(I, "hitStrokeWidth", "auto", (0, s.getNumberOrAutoValidator)()), o.Factory.addGetterSetter(I, "strokeHitEnabled", !0, (0, s.getBooleanValidator)()), o.Factory.addGetterSetter(I, "perfectDrawEnabled", !0, (0, s.getBooleanValidator)()), o.Factory.addGetterSetter(I, "shadowForStrokeEnabled", !0, (0, s.getBooleanValidator)()), o.Factory.addGetterSetter(I, "lineJoin"), o.Factory.addGetterSetter(I, "lineCap"), o.Factory.addGetterSetter(I, "sceneFunc"), o.Factory.addGetterSetter(I, "hitFunc"), o.Factory.addGetterSetter(I, "dash"), o.Factory.addGetterSetter(I, "dashOffset", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowColor", void 0, (0, s.getStringValidator)()), o.Factory.addGetterSetter(I, "shadowBlur", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowOpacity", 1, (0, s.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "shadowOffset", ["x", "y"]), o.Factory.addGetterSetter(I, "shadowOffsetX", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowOffsetY", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternImage"), o.Factory.addGetterSetter(I, "fill", void 0, (0, s.getStringOrGradientValidator)()), o.Factory.addGetterSetter(I, "fillPatternX", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternY", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillLinearGradientColorStops"), o.Factory.addGetterSetter(I, "strokeLinearGradientColorStops"), o.Factory.addGetterSetter(I, "fillRadialGradientStartRadius", 0), o.Factory.addGetterSetter(I, "fillRadialGradientEndRadius", 0), o.Factory.addGetterSetter(I, "fillRadialGradientColorStops"), o.Factory.addGetterSetter(I, "fillPatternRepeat", "repeat"), o.Factory.addGetterSetter(I, "fillEnabled", !0), o.Factory.addGetterSetter(I, "strokeEnabled", !0), o.Factory.addGetterSetter(I, "shadowEnabled", !0), o.Factory.addGetterSetter(I, "dashEnabled", !0), o.Factory.addGetterSetter(I, "strokeScaleEnabled", !0), o.Factory.addGetterSetter(I, "fillPriority", "color"), o.Factory.addComponentsGetterSetter(I, "fillPatternOffset", ["x", "y"]), o.Factory.addGetterSetter(I, "fillPatternOffsetX", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternOffsetY", 0, (0, s.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "fillPatternScale", ["x", "y"]), o.Factory.addGetterSetter(I, "fillPatternScaleX", 1, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternScaleY", 1, (0, s.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "fillLinearGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addComponentsGetterSetter(I, "strokeLinearGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillLinearGradientStartPointX", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientStartPointX", 0), o.Factory.addGetterSetter(I, "fillLinearGradientStartPointY", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillLinearGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addComponentsGetterSetter(I, "strokeLinearGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillLinearGradientEndPointX", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientEndPointX", 0), o.Factory.addGetterSetter(I, "fillLinearGradientEndPointY", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientEndPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillRadialGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillRadialGradientStartPointX", 0), o.Factory.addGetterSetter(I, "fillRadialGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillRadialGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillRadialGradientEndPointX", 0), o.Factory.addGetterSetter(I, "fillRadialGradientEndPointY", 0), o.Factory.addGetterSetter(I, "fillPatternRotation", 0), o.Factory.addGetterSetter(I, "fillRule", void 0, (0, s.getStringValidator)()), o.Factory.backCompat(I, {
      dashArray: "dash",
      getDashArray: "getDash",
      setDashArray: "getDash",
      drawFunc: "sceneFunc",
      getDrawFunc: "getSceneFunc",
      setDrawFunc: "setSceneFunc",
      drawHitFunc: "hitFunc",
      getDrawHitFunc: "getHitFunc",
      setDrawHitFunc: "setHitFunc"
    });
  }(ho)), ho;
}
var nd;
function X0() {
  if (nd) return Ai;
  nd = 1, Object.defineProperty(Ai, "__esModule", { value: !0 }), Ai.Layer = void 0;
  const r = Kt(), a = wa(), n = $t(), o = Tt(), c = ba(), s = Ot(), h = se(), l = Rt(), g = "#", p = "beforeDraw", b = "draw", w = [
    { x: 0, y: 0 },
    { x: -1, y: -1 },
    { x: 1, y: -1 },
    { x: 1, y: 1 },
    { x: -1, y: 1 }
  ], x = w.length;
  let v = class extends a.Container {
    constructor(S) {
      super(S), this.canvas = new c.SceneCanvas(), this.hitCanvas = new c.HitCanvas({
        pixelRatio: 1
      }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
    }
    createPNGStream() {
      return this.canvas._canvas.createPNGStream();
    }
    getCanvas() {
      return this.canvas;
    }
    getNativeCanvasElement() {
      return this.canvas._canvas;
    }
    getHitCanvas() {
      return this.hitCanvas;
    }
    getContext() {
      return this.getCanvas().getContext();
    }
    clear(S) {
      return this.getContext().clear(S), this.getHitCanvas().getContext().clear(S), this;
    }
    setZIndex(S) {
      super.setZIndex(S);
      const C = this.getStage();
      return C && C.content && (C.content.removeChild(this.getNativeCanvasElement()), S < C.children.length - 1 ? C.content.insertBefore(this.getNativeCanvasElement(), C.children[S + 1].getCanvas()._canvas) : C.content.appendChild(this.getNativeCanvasElement())), this;
    }
    moveToTop() {
      n.Node.prototype.moveToTop.call(this);
      const S = this.getStage();
      return S && S.content && (S.content.removeChild(this.getNativeCanvasElement()), S.content.appendChild(this.getNativeCanvasElement())), !0;
    }
    moveUp() {
      if (!n.Node.prototype.moveUp.call(this))
        return !1;
      const C = this.getStage();
      return !C || !C.content ? !1 : (C.content.removeChild(this.getNativeCanvasElement()), this.index < C.children.length - 1 ? C.content.insertBefore(this.getNativeCanvasElement(), C.children[this.index + 1].getCanvas()._canvas) : C.content.appendChild(this.getNativeCanvasElement()), !0);
    }
    moveDown() {
      if (n.Node.prototype.moveDown.call(this)) {
        const S = this.getStage();
        if (S) {
          const C = S.children;
          S.content && (S.content.removeChild(this.getNativeCanvasElement()), S.content.insertBefore(this.getNativeCanvasElement(), C[this.index + 1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    moveToBottom() {
      if (n.Node.prototype.moveToBottom.call(this)) {
        const S = this.getStage();
        if (S) {
          const C = S.children;
          S.content && (S.content.removeChild(this.getNativeCanvasElement()), S.content.insertBefore(this.getNativeCanvasElement(), C[1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    getLayer() {
      return this;
    }
    remove() {
      const S = this.getNativeCanvasElement();
      return n.Node.prototype.remove.call(this), S && S.parentNode && r.Util._isInDocument(S) && S.parentNode.removeChild(S), this;
    }
    getStage() {
      return this.parent;
    }
    setSize({ width: S, height: C }) {
      return this.canvas.setSize(S, C), this.hitCanvas.setSize(S, C), this._setSmoothEnabled(), this;
    }
    _validateAdd(S) {
      const C = S.getType();
      C !== "Group" && C !== "Shape" && r.Util.throw("You may only add groups and shapes to a layer.");
    }
    _toKonvaCanvas(S) {
      return S = S || {}, S.width = S.width || this.getWidth(), S.height = S.height || this.getHeight(), S.x = S.x !== void 0 ? S.x : this.x(), S.y = S.y !== void 0 ? S.y : this.y(), n.Node.prototype._toKonvaCanvas.call(this, S);
    }
    _checkVisibility() {
      this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
    }
    _setSmoothEnabled() {
      this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
      if (this.parent)
        return this.parent.width();
    }
    setWidth() {
      r.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
      if (this.parent)
        return this.parent.height();
    }
    setHeight() {
      r.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
      return this._waitingForDraw || (this._waitingForDraw = !0, r.Util.requestAnimFrame(() => {
        this.draw(), this._waitingForDraw = !1;
      })), this;
    }
    getIntersection(S) {
      if (!this.isListening() || !this.isVisible())
        return null;
      let C = 1, F = !1;
      for (; ; ) {
        for (let d = 0; d < x; d++) {
          const f = w[d], m = this._getIntersection({
            x: S.x + f.x * C,
            y: S.y + f.y * C
          }), E = m.shape;
          if (E)
            return E;
          if (F = !!m.antialiased, !m.antialiased)
            break;
        }
        if (F)
          C += 1;
        else
          return null;
      }
    }
    _getIntersection(S) {
      const C = this.hitCanvas.pixelRatio, F = this.hitCanvas.context.getImageData(Math.round(S.x * C), Math.round(S.y * C), 1, 1).data, d = F[3];
      if (d === 255) {
        const f = r.Util._rgbToHex(F[0], F[1], F[2]), m = h.shapes[g + f];
        return m ? {
          shape: m
        } : {
          antialiased: !0
        };
      } else if (d > 0)
        return {
          antialiased: !0
        };
      return {};
    }
    drawScene(S, C) {
      const F = this.getLayer(), d = S || F && F.getCanvas();
      return this._fire(p, {
        node: this
      }), this.clearBeforeDraw() && d.getContext().clear(), a.Container.prototype.drawScene.call(this, d, C), this._fire(b, {
        node: this
      }), this;
    }
    drawHit(S, C) {
      const F = this.getLayer(), d = S || F && F.hitCanvas;
      return F && F.clearBeforeDraw() && F.getHitCanvas().getContext().clear(), a.Container.prototype.drawHit.call(this, d, C), this;
    }
    enableHitGraph() {
      return this.hitGraphEnabled(!0), this;
    }
    disableHitGraph() {
      return this.hitGraphEnabled(!1), this;
    }
    setHitGraphEnabled(S) {
      r.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(S);
    }
    getHitGraphEnabled(S) {
      return r.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
    }
    toggleHitCanvas() {
      if (!this.parent || !this.parent.content)
        return;
      const S = this.parent;
      !!this.hitCanvas._canvas.parentNode ? S.content.removeChild(this.hitCanvas._canvas) : S.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
      return r.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
    }
  };
  return Ai.Layer = v, v.prototype.nodeType = "Layer", (0, l._registerNode)(v), o.Factory.addGetterSetter(v, "imageSmoothingEnabled", !0), o.Factory.addGetterSetter(v, "clearBeforeDraw", !0), o.Factory.addGetterSetter(v, "hitGraphEnabled", !0, (0, s.getBooleanValidator)()), Ai;
}
var Ri = {}, ad;
function h6() {
  if (ad) return Ri;
  ad = 1, Object.defineProperty(Ri, "__esModule", { value: !0 }), Ri.FastLayer = void 0;
  const r = Kt(), a = X0(), n = Rt();
  let o = class extends a.Layer {
    constructor(s) {
      super(s), this.listening(!1), r.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
  };
  return Ri.FastLayer = o, o.prototype.nodeType = "FastLayer", (0, n._registerNode)(o), Ri;
}
var Ti = {}, sd;
function Xh() {
  if (sd) return Ti;
  sd = 1, Object.defineProperty(Ti, "__esModule", { value: !0 }), Ti.Group = void 0;
  const r = Kt(), a = wa(), n = Rt();
  let o = class extends a.Container {
    _validateAdd(s) {
      const h = s.getType();
      h !== "Group" && h !== "Shape" && r.Util.throw("You may only add groups and shapes to groups.");
    }
  };
  return Ti.Group = o, o.prototype.nodeType = "Group", (0, n._registerNode)(o), Ti;
}
var Pi = {}, od;
function $h() {
  if (od) return Pi;
  od = 1, Object.defineProperty(Pi, "__esModule", { value: !0 }), Pi.Animation = void 0;
  const r = Rt(), a = Kt(), n = function() {
    return r.glob.performance && r.glob.performance.now ? function() {
      return r.glob.performance.now();
    } : function() {
      return (/* @__PURE__ */ new Date()).getTime();
    };
  }();
  let o = class ri {
    constructor(s, h) {
      this.id = ri.animIdCounter++, this.frame = {
        time: 0,
        timeDiff: 0,
        lastTime: n(),
        frameRate: 0
      }, this.func = s, this.setLayers(h);
    }
    setLayers(s) {
      let h = [];
      return s && (h = Array.isArray(s) ? s : [s]), this.layers = h, this;
    }
    getLayers() {
      return this.layers;
    }
    addLayer(s) {
      const h = this.layers, l = h.length;
      for (let g = 0; g < l; g++)
        if (h[g]._id === s._id)
          return !1;
      return this.layers.push(s), !0;
    }
    isRunning() {
      const h = ri.animations, l = h.length;
      for (let g = 0; g < l; g++)
        if (h[g].id === this.id)
          return !0;
      return !1;
    }
    start() {
      return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = n(), ri._addAnimation(this), this;
    }
    stop() {
      return ri._removeAnimation(this), this;
    }
    _updateFrameObject(s) {
      this.frame.timeDiff = s - this.frame.lastTime, this.frame.lastTime = s, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
    }
    static _addAnimation(s) {
      this.animations.push(s), this._handleAnimation();
    }
    static _removeAnimation(s) {
      const h = s.id, l = this.animations, g = l.length;
      for (let p = 0; p < g; p++)
        if (l[p].id === h) {
          this.animations.splice(p, 1);
          break;
        }
    }
    static _runFrames() {
      const s = {}, h = this.animations;
      for (let l = 0; l < h.length; l++) {
        const g = h[l], p = g.layers, b = g.func;
        g._updateFrameObject(n());
        const w = p.length;
        let x;
        if (b ? x = b.call(g, g.frame) !== !1 : x = !0, !!x)
          for (let v = 0; v < w; v++) {
            const _ = p[v];
            _._id !== void 0 && (s[_._id] = _);
          }
      }
      for (const l in s)
        s.hasOwnProperty(l) && s[l].batchDraw();
    }
    static _animationLoop() {
      const s = ri;
      s.animations.length ? (s._runFrames(), a.Util.requestAnimFrame(s._animationLoop)) : s.animRunning = !1;
    }
    static _handleAnimation() {
      this.animRunning || (this.animRunning = !0, a.Util.requestAnimFrame(this._animationLoop));
    }
  };
  return Pi.Animation = o, o.animations = [], o.animIdCounter = 0, o.animRunning = !1, Pi;
}
var lo = {}, hd;
function l6() {
  return hd || (hd = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Easings = r.Tween = void 0;
    const a = Kt(), n = $h(), o = $t(), c = Rt();
    let s = {
      node: 1,
      duration: 1,
      easing: 1,
      onFinish: 1,
      yoyo: 1
    }, h = 1, l = 2, g = 3, p = 0, b = ["fill", "stroke", "shadowColor"];
    class w {
      constructor(_, S, C, F, d, f, m) {
        this.prop = _, this.propFunc = S, this.begin = F, this._pos = F, this.duration = f, this._change = 0, this.prevPos = 0, this.yoyo = m, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = C, this._change = d - this.begin, this.pause();
      }
      fire(_) {
        const S = this[_];
        S && S();
      }
      setTime(_) {
        _ > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : _ < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = _, this.update());
      }
      getTime() {
        return this._time;
      }
      setPosition(_) {
        this.prevPos = this._pos, this.propFunc(_), this._pos = _;
      }
      getPosition(_) {
        return _ === void 0 && (_ = this._time), this.func(_, this.begin, this._change, this.duration);
      }
      play() {
        this.state = l, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
      }
      reverse() {
        this.state = g, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
      }
      seek(_) {
        this.pause(), this._time = _, this.update(), this.fire("onSeek");
      }
      reset() {
        this.pause(), this._time = 0, this.update(), this.fire("onReset");
      }
      finish() {
        this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
      }
      update() {
        this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
      }
      onEnterFrame() {
        const _ = this.getTimer() - this._startTime;
        this.state === l ? this.setTime(_) : this.state === g && this.setTime(this.duration - _);
      }
      pause() {
        this.state = h, this.fire("onPause");
      }
      getTimer() {
        return (/* @__PURE__ */ new Date()).getTime();
      }
    }
    class x {
      constructor(_) {
        let S = this, C = _.node, F = C._id, d, f = _.easing || r.Easings.Linear, m = !!_.yoyo, E;
        typeof _.duration == "undefined" ? d = 0.3 : _.duration === 0 ? d = 1e-3 : d = _.duration, this.node = C, this._id = p++;
        const T = C.getLayer() || (C instanceof c.Konva.Stage ? C.getLayers() : null);
        T || a.Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new n.Animation(function() {
          S.tween.onEnterFrame();
        }, T), this.tween = new w(E, function(D) {
          S._tweenFunc(D);
        }, f, 0, 1, d * 1e3, m), this._addListeners(), x.attrs[F] || (x.attrs[F] = {}), x.attrs[F][this._id] || (x.attrs[F][this._id] = {}), x.tweens[F] || (x.tweens[F] = {});
        for (E in _)
          s[E] === void 0 && this._addAttr(E, _[E]);
        this.reset(), this.onFinish = _.onFinish, this.onReset = _.onReset, this.onUpdate = _.onUpdate;
      }
      _addAttr(_, S) {
        let C = this.node, F = C._id, d, f, m, E, T, D, I, L;
        if (m = x.tweens[F][_], m && delete x.attrs[F][m][_], d = C.getAttr(_), a.Util._isArray(S))
          if (f = [], T = Math.max(S.length, d.length), _ === "points" && S.length !== d.length && (S.length > d.length ? (I = d, d = a.Util._prepareArrayForTween(d, S, C.closed())) : (D = S, S = a.Util._prepareArrayForTween(S, d, C.closed()))), _.indexOf("fill") === 0)
            for (E = 0; E < T; E++)
              if (E % 2 === 0)
                f.push(S[E] - d[E]);
              else {
                const O = a.Util.colorToRGBA(d[E]);
                L = a.Util.colorToRGBA(S[E]), d[E] = O, f.push({
                  r: L.r - O.r,
                  g: L.g - O.g,
                  b: L.b - O.b,
                  a: L.a - O.a
                });
              }
          else
            for (E = 0; E < T; E++)
              f.push(S[E] - d[E]);
        else b.indexOf(_) !== -1 ? (d = a.Util.colorToRGBA(d), L = a.Util.colorToRGBA(S), f = {
          r: L.r - d.r,
          g: L.g - d.g,
          b: L.b - d.b,
          a: L.a - d.a
        }) : f = S - d;
        x.attrs[F][this._id][_] = {
          start: d,
          diff: f,
          end: S,
          trueEnd: D,
          trueStart: I
        }, x.tweens[F][_] = this._id;
      }
      _tweenFunc(_) {
        let S = this.node, C = x.attrs[S._id][this._id], F, d, f, m, E, T, D, I;
        for (F in C) {
          if (d = C[F], f = d.start, m = d.diff, I = d.end, a.Util._isArray(f))
            if (E = [], D = Math.max(f.length, I.length), F.indexOf("fill") === 0)
              for (T = 0; T < D; T++)
                T % 2 === 0 ? E.push((f[T] || 0) + m[T] * _) : E.push("rgba(" + Math.round(f[T].r + m[T].r * _) + "," + Math.round(f[T].g + m[T].g * _) + "," + Math.round(f[T].b + m[T].b * _) + "," + (f[T].a + m[T].a * _) + ")");
            else
              for (T = 0; T < D; T++)
                E.push((f[T] || 0) + m[T] * _);
          else b.indexOf(F) !== -1 ? E = "rgba(" + Math.round(f.r + m.r * _) + "," + Math.round(f.g + m.g * _) + "," + Math.round(f.b + m.b * _) + "," + (f.a + m.a * _) + ")" : E = f + m * _;
          S.setAttr(F, E);
        }
      }
      _addListeners() {
        this.tween.onPlay = () => {
          this.anim.start();
        }, this.tween.onReverse = () => {
          this.anim.start();
        }, this.tween.onPause = () => {
          this.anim.stop();
        }, this.tween.onFinish = () => {
          const _ = this.node, S = x.attrs[_._id][this._id];
          S.points && S.points.trueEnd && _.setAttr("points", S.points.trueEnd), this.onFinish && this.onFinish.call(this);
        }, this.tween.onReset = () => {
          const _ = this.node, S = x.attrs[_._id][this._id];
          S.points && S.points.trueStart && _.points(S.points.trueStart), this.onReset && this.onReset();
        }, this.tween.onUpdate = () => {
          this.onUpdate && this.onUpdate.call(this);
        };
      }
      play() {
        return this.tween.play(), this;
      }
      reverse() {
        return this.tween.reverse(), this;
      }
      reset() {
        return this.tween.reset(), this;
      }
      seek(_) {
        return this.tween.seek(_ * 1e3), this;
      }
      pause() {
        return this.tween.pause(), this;
      }
      finish() {
        return this.tween.finish(), this;
      }
      destroy() {
        let _ = this.node._id, S = this._id, C = x.tweens[_], F;
        this.pause();
        for (F in C)
          delete x.tweens[_][F];
        delete x.attrs[_][S];
      }
    }
    r.Tween = x, x.attrs = {}, x.tweens = {}, o.Node.prototype.to = function(v) {
      const _ = v.onFinish;
      v.node = this, v.onFinish = function() {
        this.destroy(), _ && _();
      }, new x(v).play();
    }, r.Easings = {
      BackEaseIn(v, _, S, C) {
        return S * (v /= C) * v * ((1.70158 + 1) * v - 1.70158) + _;
      },
      BackEaseOut(v, _, S, C) {
        return S * ((v = v / C - 1) * v * ((1.70158 + 1) * v + 1.70158) + 1) + _;
      },
      BackEaseInOut(v, _, S, C) {
        let F = 1.70158;
        return (v /= C / 2) < 1 ? S / 2 * (v * v * (((F *= 1.525) + 1) * v - F)) + _ : S / 2 * ((v -= 2) * v * (((F *= 1.525) + 1) * v + F) + 2) + _;
      },
      ElasticEaseIn(v, _, S, C, F, d) {
        let f = 0;
        return v === 0 ? _ : (v /= C) === 1 ? _ + S : (d || (d = C * 0.3), !F || F < Math.abs(S) ? (F = S, f = d / 4) : f = d / (2 * Math.PI) * Math.asin(S / F), -(F * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * C - f) * (2 * Math.PI) / d)) + _);
      },
      ElasticEaseOut(v, _, S, C, F, d) {
        let f = 0;
        return v === 0 ? _ : (v /= C) === 1 ? _ + S : (d || (d = C * 0.3), !F || F < Math.abs(S) ? (F = S, f = d / 4) : f = d / (2 * Math.PI) * Math.asin(S / F), F * Math.pow(2, -10 * v) * Math.sin((v * C - f) * (2 * Math.PI) / d) + S + _);
      },
      ElasticEaseInOut(v, _, S, C, F, d) {
        let f = 0;
        return v === 0 ? _ : (v /= C / 2) === 2 ? _ + S : (d || (d = C * (0.3 * 1.5)), !F || F < Math.abs(S) ? (F = S, f = d / 4) : f = d / (2 * Math.PI) * Math.asin(S / F), v < 1 ? -0.5 * (F * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * C - f) * (2 * Math.PI) / d)) + _ : F * Math.pow(2, -10 * (v -= 1)) * Math.sin((v * C - f) * (2 * Math.PI) / d) * 0.5 + S + _);
      },
      BounceEaseOut(v, _, S, C) {
        return (v /= C) < 1 / 2.75 ? S * (7.5625 * v * v) + _ : v < 2 / 2.75 ? S * (7.5625 * (v -= 1.5 / 2.75) * v + 0.75) + _ : v < 2.5 / 2.75 ? S * (7.5625 * (v -= 2.25 / 2.75) * v + 0.9375) + _ : S * (7.5625 * (v -= 2.625 / 2.75) * v + 0.984375) + _;
      },
      BounceEaseIn(v, _, S, C) {
        return S - r.Easings.BounceEaseOut(C - v, 0, S, C) + _;
      },
      BounceEaseInOut(v, _, S, C) {
        return v < C / 2 ? r.Easings.BounceEaseIn(v * 2, 0, S, C) * 0.5 + _ : r.Easings.BounceEaseOut(v * 2 - C, 0, S, C) * 0.5 + S * 0.5 + _;
      },
      EaseIn(v, _, S, C) {
        return S * (v /= C) * v + _;
      },
      EaseOut(v, _, S, C) {
        return -S * (v /= C) * (v - 2) + _;
      },
      EaseInOut(v, _, S, C) {
        return (v /= C / 2) < 1 ? S / 2 * v * v + _ : -S / 2 * (--v * (v - 2) - 1) + _;
      },
      StrongEaseIn(v, _, S, C) {
        return S * (v /= C) * v * v * v * v + _;
      },
      StrongEaseOut(v, _, S, C) {
        return S * ((v = v / C - 1) * v * v * v * v + 1) + _;
      },
      StrongEaseInOut(v, _, S, C) {
        return (v /= C / 2) < 1 ? S / 2 * v * v * v * v * v + _ : S / 2 * ((v -= 2) * v * v * v * v + 2) + _;
      },
      Linear(v, _, S, C) {
        return S * v / C + _;
      }
    };
  }(lo)), lo;
}
var ld;
function u6() {
  return ld || (ld = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Konva = void 0;
    const a = Rt(), n = Kt(), o = $t(), c = wa(), s = o6(), h = X0(), l = h6(), g = Xh(), p = Yh(), b = se(), w = $h(), x = l6(), v = K0(), _ = ba();
    r.Konva = n.Util._assign(a.Konva, {
      Util: n.Util,
      Transform: n.Transform,
      Node: o.Node,
      Container: c.Container,
      Stage: s.Stage,
      stages: s.stages,
      Layer: h.Layer,
      FastLayer: l.FastLayer,
      Group: g.Group,
      DD: p.DD,
      Shape: b.Shape,
      shapes: b.shapes,
      Animation: w.Animation,
      Tween: x.Tween,
      Easings: x.Easings,
      Context: v.Context,
      Canvas: _.Canvas
    }), r.default = r.Konva;
  }(ro)), ro;
}
var Fi = {}, ud;
function c6() {
  if (ud) return Fi;
  ud = 1, Object.defineProperty(Fi, "__esModule", { value: !0 }), Fi.Arc = void 0;
  const r = Tt(), a = se(), n = Rt(), o = Ot(), c = Rt();
  let s = class extends a.Shape {
    _sceneFunc(l) {
      const g = n.Konva.getAngle(this.angle()), p = this.clockwise();
      l.beginPath(), l.arc(0, 0, this.outerRadius(), 0, g, p), l.arc(0, 0, this.innerRadius(), g, 0, !p), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(l) {
      this.outerRadius(l / 2);
    }
    setHeight(l) {
      this.outerRadius(l / 2);
    }
    getSelfRect() {
      const l = this.innerRadius(), g = this.outerRadius(), p = this.clockwise(), b = n.Konva.getAngle(p ? 360 - this.angle() : this.angle()), w = Math.cos(Math.min(b, Math.PI)), x = 1, v = Math.sin(Math.min(Math.max(Math.PI, b), 3 * Math.PI / 2)), _ = Math.sin(Math.min(b, Math.PI / 2)), S = w * (w > 0 ? l : g), C = x * g, F = v * (v > 0 ? l : g), d = _ * (_ > 0 ? g : l);
      return {
        x: S,
        y: p ? -1 * d : F,
        width: C - S,
        height: d - F
      };
    }
  };
  return Fi.Arc = s, s.prototype._centroid = !0, s.prototype.className = "Arc", s.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, c._registerNode)(s), r.Factory.addGetterSetter(s, "innerRadius", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "outerRadius", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "angle", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "clockwise", !1, (0, o.getBooleanValidator)()), Fi;
}
var Oi = {}, ki = {}, cd;
function $0() {
  if (cd) return ki;
  cd = 1, Object.defineProperty(ki, "__esModule", { value: !0 }), ki.Line = void 0;
  const r = Tt(), a = Rt(), n = se(), o = Ot();
  function c(l, g, p, b, w, x, v) {
    const _ = Math.sqrt(Math.pow(p - l, 2) + Math.pow(b - g, 2)), S = Math.sqrt(Math.pow(w - p, 2) + Math.pow(x - b, 2)), C = v * _ / (_ + S), F = v * S / (_ + S), d = p - C * (w - l), f = b - C * (x - g), m = p + F * (w - l), E = b + F * (x - g);
    return [d, f, m, E];
  }
  function s(l, g) {
    const p = l.length, b = [];
    for (let w = 2; w < p - 2; w += 2) {
      const x = c(l[w - 2], l[w - 1], l[w], l[w + 1], l[w + 2], l[w + 3], g);
      isNaN(x[0]) || (b.push(x[0]), b.push(x[1]), b.push(l[w]), b.push(l[w + 1]), b.push(x[2]), b.push(x[3]));
    }
    return b;
  }
  let h = class extends n.Shape {
    constructor(g) {
      super(g), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
        this._clearCache("tensionPoints");
      });
    }
    _sceneFunc(g) {
      let p = this.points(), b = p.length, w = this.tension(), x = this.closed(), v = this.bezier(), _, S, C;
      if (b) {
        if (g.beginPath(), g.moveTo(p[0], p[1]), w !== 0 && b > 4) {
          for (_ = this.getTensionPoints(), S = _.length, C = x ? 0 : 4, x || g.quadraticCurveTo(_[0], _[1], _[2], _[3]); C < S - 2; )
            g.bezierCurveTo(_[C++], _[C++], _[C++], _[C++], _[C++], _[C++]);
          x || g.quadraticCurveTo(_[S - 2], _[S - 1], p[b - 2], p[b - 1]);
        } else if (v)
          for (C = 2; C < b; )
            g.bezierCurveTo(p[C++], p[C++], p[C++], p[C++], p[C++], p[C++]);
        else
          for (C = 2; C < b; C += 2)
            g.lineTo(p[C], p[C + 1]);
        x ? (g.closePath(), g.fillStrokeShape(this)) : g.strokeShape(this);
      }
    }
    getTensionPoints() {
      return this._getCache("tensionPoints", this._getTensionPoints);
    }
    _getTensionPoints() {
      return this.closed() ? this._getTensionPointsClosed() : s(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
      const g = this.points(), p = g.length, b = this.tension(), w = c(g[p - 2], g[p - 1], g[0], g[1], g[2], g[3], b), x = c(g[p - 4], g[p - 3], g[p - 2], g[p - 1], g[0], g[1], b), v = s(g, b);
      return [w[2], w[3]].concat(v).concat([
        x[0],
        x[1],
        g[p - 2],
        g[p - 1],
        x[2],
        x[3],
        w[0],
        w[1],
        g[0],
        g[1]
      ]);
    }
    getWidth() {
      return this.getSelfRect().width;
    }
    getHeight() {
      return this.getSelfRect().height;
    }
    getSelfRect() {
      let g = this.points();
      if (g.length < 4)
        return {
          x: g[0] || 0,
          y: g[1] || 0,
          width: 0,
          height: 0
        };
      this.tension() !== 0 ? g = [
        g[0],
        g[1],
        ...this._getTensionPoints(),
        g[g.length - 2],
        g[g.length - 1]
      ] : g = this.points();
      let p = g[0], b = g[0], w = g[1], x = g[1], v, _;
      for (let S = 0; S < g.length / 2; S++)
        v = g[S * 2], _ = g[S * 2 + 1], p = Math.min(p, v), b = Math.max(b, v), w = Math.min(w, _), x = Math.max(x, _);
      return {
        x: p,
        y: w,
        width: b - p,
        height: x - w
      };
    }
  };
  return ki.Line = h, h.prototype.className = "Line", h.prototype._attrsAffectingSize = ["points", "bezier", "tension"], (0, a._registerNode)(h), r.Factory.addGetterSetter(h, "closed", !1), r.Factory.addGetterSetter(h, "bezier", !1), r.Factory.addGetterSetter(h, "tension", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(h, "points", [], (0, o.getNumberArrayValidator)()), ki;
}
var Ii = {}, uo = {}, dd;
function d6() {
  return dd || (dd = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.t2length = r.getQuadraticArcLength = r.getCubicArcLength = r.binomialCoefficients = r.cValues = r.tValues = void 0, r.tValues = [
      [],
      [],
      [
        -0.5773502691896257,
        0.5773502691896257
      ],
      [
        0,
        -0.7745966692414834,
        0.7745966692414834
      ],
      [
        -0.33998104358485626,
        0.33998104358485626,
        -0.8611363115940526,
        0.8611363115940526
      ],
      [
        0,
        -0.5384693101056831,
        0.5384693101056831,
        -0.906179845938664,
        0.906179845938664
      ],
      [
        0.6612093864662645,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969,
        -0.932469514203152,
        0.932469514203152
      ],
      [
        0,
        0.4058451513773972,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993945,
        -0.9491079123427585,
        0.9491079123427585
      ],
      [
        -0.1834346424956498,
        0.1834346424956498,
        -0.525532409916329,
        0.525532409916329,
        -0.7966664774136267,
        0.7966664774136267,
        -0.9602898564975363,
        0.9602898564975363
      ],
      [
        0,
        -0.8360311073266358,
        0.8360311073266358,
        -0.9681602395076261,
        0.9681602395076261,
        -0.3242534234038089,
        0.3242534234038089,
        -0.6133714327005904,
        0.6133714327005904
      ],
      [
        -0.14887433898163122,
        0.14887433898163122,
        -0.4333953941292472,
        0.4333953941292472,
        -0.6794095682990244,
        0.6794095682990244,
        -0.8650633666889845,
        0.8650633666889845,
        -0.9739065285171717,
        0.9739065285171717
      ],
      [
        0,
        -0.26954315595234496,
        0.26954315595234496,
        -0.5190961292068118,
        0.5190961292068118,
        -0.7301520055740494,
        0.7301520055740494,
        -0.8870625997680953,
        0.8870625997680953,
        -0.978228658146057,
        0.978228658146057
      ],
      [
        -0.1252334085114689,
        0.1252334085114689,
        -0.3678314989981802,
        0.3678314989981802,
        -0.5873179542866175,
        0.5873179542866175,
        -0.7699026741943047,
        0.7699026741943047,
        -0.9041172563704749,
        0.9041172563704749,
        -0.9815606342467192,
        0.9815606342467192
      ],
      [
        0,
        -0.2304583159551348,
        0.2304583159551348,
        -0.44849275103644687,
        0.44849275103644687,
        -0.6423493394403402,
        0.6423493394403402,
        -0.8015780907333099,
        0.8015780907333099,
        -0.9175983992229779,
        0.9175983992229779,
        -0.9841830547185881,
        0.9841830547185881
      ],
      [
        -0.10805494870734367,
        0.10805494870734367,
        -0.31911236892788974,
        0.31911236892788974,
        -0.5152486363581541,
        0.5152486363581541,
        -0.6872929048116855,
        0.6872929048116855,
        -0.827201315069765,
        0.827201315069765,
        -0.9284348836635735,
        0.9284348836635735,
        -0.9862838086968123,
        0.9862838086968123
      ],
      [
        0,
        -0.20119409399743451,
        0.20119409399743451,
        -0.3941513470775634,
        0.3941513470775634,
        -0.5709721726085388,
        0.5709721726085388,
        -0.7244177313601701,
        0.7244177313601701,
        -0.8482065834104272,
        0.8482065834104272,
        -0.937273392400706,
        0.937273392400706,
        -0.9879925180204854,
        0.9879925180204854
      ],
      [
        -0.09501250983763744,
        0.09501250983763744,
        -0.2816035507792589,
        0.2816035507792589,
        -0.45801677765722737,
        0.45801677765722737,
        -0.6178762444026438,
        0.6178762444026438,
        -0.755404408355003,
        0.755404408355003,
        -0.8656312023878318,
        0.8656312023878318,
        -0.9445750230732326,
        0.9445750230732326,
        -0.9894009349916499,
        0.9894009349916499
      ],
      [
        0,
        -0.17848418149584785,
        0.17848418149584785,
        -0.3512317634538763,
        0.3512317634538763,
        -0.5126905370864769,
        0.5126905370864769,
        -0.6576711592166907,
        0.6576711592166907,
        -0.7815140038968014,
        0.7815140038968014,
        -0.8802391537269859,
        0.8802391537269859,
        -0.9506755217687678,
        0.9506755217687678,
        -0.9905754753144174,
        0.9905754753144174
      ],
      [
        -0.0847750130417353,
        0.0847750130417353,
        -0.2518862256915055,
        0.2518862256915055,
        -0.41175116146284263,
        0.41175116146284263,
        -0.5597708310739475,
        0.5597708310739475,
        -0.6916870430603532,
        0.6916870430603532,
        -0.8037049589725231,
        0.8037049589725231,
        -0.8926024664975557,
        0.8926024664975557,
        -0.9558239495713977,
        0.9558239495713977,
        -0.9915651684209309,
        0.9915651684209309
      ],
      [
        0,
        -0.16035864564022537,
        0.16035864564022537,
        -0.31656409996362983,
        0.31656409996362983,
        -0.46457074137596094,
        0.46457074137596094,
        -0.600545304661681,
        0.600545304661681,
        -0.7209661773352294,
        0.7209661773352294,
        -0.8227146565371428,
        0.8227146565371428,
        -0.9031559036148179,
        0.9031559036148179,
        -0.96020815213483,
        0.96020815213483,
        -0.9924068438435844,
        0.9924068438435844
      ],
      [
        -0.07652652113349734,
        0.07652652113349734,
        -0.22778585114164507,
        0.22778585114164507,
        -0.37370608871541955,
        0.37370608871541955,
        -0.5108670019508271,
        0.5108670019508271,
        -0.636053680726515,
        0.636053680726515,
        -0.7463319064601508,
        0.7463319064601508,
        -0.8391169718222188,
        0.8391169718222188,
        -0.912234428251326,
        0.912234428251326,
        -0.9639719272779138,
        0.9639719272779138,
        -0.9931285991850949,
        0.9931285991850949
      ],
      [
        0,
        -0.1455618541608951,
        0.1455618541608951,
        -0.2880213168024011,
        0.2880213168024011,
        -0.4243421202074388,
        0.4243421202074388,
        -0.5516188358872198,
        0.5516188358872198,
        -0.6671388041974123,
        0.6671388041974123,
        -0.7684399634756779,
        0.7684399634756779,
        -0.8533633645833173,
        0.8533633645833173,
        -0.9200993341504008,
        0.9200993341504008,
        -0.9672268385663063,
        0.9672268385663063,
        -0.9937521706203895,
        0.9937521706203895
      ],
      [
        -0.06973927331972223,
        0.06973927331972223,
        -0.20786042668822127,
        0.20786042668822127,
        -0.34193582089208424,
        0.34193582089208424,
        -0.469355837986757,
        0.469355837986757,
        -0.5876404035069116,
        0.5876404035069116,
        -0.6944872631866827,
        0.6944872631866827,
        -0.7878168059792081,
        0.7878168059792081,
        -0.8658125777203002,
        0.8658125777203002,
        -0.926956772187174,
        0.926956772187174,
        -0.9700604978354287,
        0.9700604978354287,
        -0.9942945854823992,
        0.9942945854823992
      ],
      [
        0,
        -0.1332568242984661,
        0.1332568242984661,
        -0.26413568097034495,
        0.26413568097034495,
        -0.3903010380302908,
        0.3903010380302908,
        -0.5095014778460075,
        0.5095014778460075,
        -0.6196098757636461,
        0.6196098757636461,
        -0.7186613631319502,
        0.7186613631319502,
        -0.8048884016188399,
        0.8048884016188399,
        -0.8767523582704416,
        0.8767523582704416,
        -0.9329710868260161,
        0.9329710868260161,
        -0.9725424712181152,
        0.9725424712181152,
        -0.9947693349975522,
        0.9947693349975522
      ],
      [
        -0.06405689286260563,
        0.06405689286260563,
        -0.1911188674736163,
        0.1911188674736163,
        -0.3150426796961634,
        0.3150426796961634,
        -0.4337935076260451,
        0.4337935076260451,
        -0.5454214713888396,
        0.5454214713888396,
        -0.6480936519369755,
        0.6480936519369755,
        -0.7401241915785544,
        0.7401241915785544,
        -0.820001985973903,
        0.820001985973903,
        -0.8864155270044011,
        0.8864155270044011,
        -0.9382745520027328,
        0.9382745520027328,
        -0.9747285559713095,
        0.9747285559713095,
        -0.9951872199970213,
        0.9951872199970213
      ]
    ], r.cValues = [
      [],
      [],
      [1, 1],
      [
        0.8888888888888888,
        0.5555555555555556,
        0.5555555555555556
      ],
      [
        0.6521451548625461,
        0.6521451548625461,
        0.34785484513745385,
        0.34785484513745385
      ],
      [
        0.5688888888888889,
        0.47862867049936647,
        0.47862867049936647,
        0.23692688505618908,
        0.23692688505618908
      ],
      [
        0.3607615730481386,
        0.3607615730481386,
        0.46791393457269104,
        0.46791393457269104,
        0.17132449237917036,
        0.17132449237917036
      ],
      [
        0.4179591836734694,
        0.3818300505051189,
        0.3818300505051189,
        0.27970539148927664,
        0.27970539148927664,
        0.1294849661688697,
        0.1294849661688697
      ],
      [
        0.362683783378362,
        0.362683783378362,
        0.31370664587788727,
        0.31370664587788727,
        0.22238103445337448,
        0.22238103445337448,
        0.10122853629037626,
        0.10122853629037626
      ],
      [
        0.3302393550012598,
        0.1806481606948574,
        0.1806481606948574,
        0.08127438836157441,
        0.08127438836157441,
        0.31234707704000286,
        0.31234707704000286,
        0.26061069640293544,
        0.26061069640293544
      ],
      [
        0.29552422471475287,
        0.29552422471475287,
        0.26926671930999635,
        0.26926671930999635,
        0.21908636251598204,
        0.21908636251598204,
        0.1494513491505806,
        0.1494513491505806,
        0.06667134430868814,
        0.06667134430868814
      ],
      [
        0.2729250867779006,
        0.26280454451024665,
        0.26280454451024665,
        0.23319376459199048,
        0.23319376459199048,
        0.18629021092773426,
        0.18629021092773426,
        0.1255803694649046,
        0.1255803694649046,
        0.05566856711617366,
        0.05566856711617366
      ],
      [
        0.24914704581340277,
        0.24914704581340277,
        0.2334925365383548,
        0.2334925365383548,
        0.20316742672306592,
        0.20316742672306592,
        0.16007832854334622,
        0.16007832854334622,
        0.10693932599531843,
        0.10693932599531843,
        0.04717533638651183,
        0.04717533638651183
      ],
      [
        0.2325515532308739,
        0.22628318026289723,
        0.22628318026289723,
        0.2078160475368885,
        0.2078160475368885,
        0.17814598076194574,
        0.17814598076194574,
        0.13887351021978725,
        0.13887351021978725,
        0.09212149983772845,
        0.09212149983772845,
        0.04048400476531588,
        0.04048400476531588
      ],
      [
        0.2152638534631578,
        0.2152638534631578,
        0.2051984637212956,
        0.2051984637212956,
        0.18553839747793782,
        0.18553839747793782,
        0.15720316715819355,
        0.15720316715819355,
        0.12151857068790319,
        0.12151857068790319,
        0.08015808715976021,
        0.08015808715976021,
        0.03511946033175186,
        0.03511946033175186
      ],
      [
        0.2025782419255613,
        0.19843148532711158,
        0.19843148532711158,
        0.1861610000155622,
        0.1861610000155622,
        0.16626920581699392,
        0.16626920581699392,
        0.13957067792615432,
        0.13957067792615432,
        0.10715922046717194,
        0.10715922046717194,
        0.07036604748810812,
        0.07036604748810812,
        0.03075324199611727,
        0.03075324199611727
      ],
      [
        0.1894506104550685,
        0.1894506104550685,
        0.18260341504492358,
        0.18260341504492358,
        0.16915651939500254,
        0.16915651939500254,
        0.14959598881657674,
        0.14959598881657674,
        0.12462897125553388,
        0.12462897125553388,
        0.09515851168249279,
        0.09515851168249279,
        0.062253523938647894,
        0.062253523938647894,
        0.027152459411754096,
        0.027152459411754096
      ],
      [
        0.17944647035620653,
        0.17656270536699264,
        0.17656270536699264,
        0.16800410215645004,
        0.16800410215645004,
        0.15404576107681028,
        0.15404576107681028,
        0.13513636846852548,
        0.13513636846852548,
        0.11188384719340397,
        0.11188384719340397,
        0.08503614831717918,
        0.08503614831717918,
        0.0554595293739872,
        0.0554595293739872,
        0.02414830286854793,
        0.02414830286854793
      ],
      [
        0.1691423829631436,
        0.1691423829631436,
        0.16427648374583273,
        0.16427648374583273,
        0.15468467512626524,
        0.15468467512626524,
        0.14064291467065065,
        0.14064291467065065,
        0.12255520671147846,
        0.12255520671147846,
        0.10094204410628717,
        0.10094204410628717,
        0.07642573025488905,
        0.07642573025488905,
        0.0497145488949698,
        0.0497145488949698,
        0.02161601352648331,
        0.02161601352648331
      ],
      [
        0.1610544498487837,
        0.15896884339395434,
        0.15896884339395434,
        0.15276604206585967,
        0.15276604206585967,
        0.1426067021736066,
        0.1426067021736066,
        0.12875396253933621,
        0.12875396253933621,
        0.11156664554733399,
        0.11156664554733399,
        0.09149002162245,
        0.09149002162245,
        0.06904454273764123,
        0.06904454273764123,
        0.0448142267656996,
        0.0448142267656996,
        0.019461788229726478,
        0.019461788229726478
      ],
      [
        0.15275338713072584,
        0.15275338713072584,
        0.14917298647260374,
        0.14917298647260374,
        0.14209610931838204,
        0.14209610931838204,
        0.13168863844917664,
        0.13168863844917664,
        0.11819453196151841,
        0.11819453196151841,
        0.10193011981724044,
        0.10193011981724044,
        0.08327674157670475,
        0.08327674157670475,
        0.06267204833410907,
        0.06267204833410907,
        0.04060142980038694,
        0.04060142980038694,
        0.017614007139152118,
        0.017614007139152118
      ],
      [
        0.14608113364969041,
        0.14452440398997005,
        0.14452440398997005,
        0.13988739479107315,
        0.13988739479107315,
        0.13226893863333747,
        0.13226893863333747,
        0.12183141605372853,
        0.12183141605372853,
        0.10879729916714838,
        0.10879729916714838,
        0.09344442345603386,
        0.09344442345603386,
        0.0761001136283793,
        0.0761001136283793,
        0.057134425426857205,
        0.057134425426857205,
        0.036953789770852494,
        0.036953789770852494,
        0.016017228257774335,
        0.016017228257774335
      ],
      [
        0.13925187285563198,
        0.13925187285563198,
        0.13654149834601517,
        0.13654149834601517,
        0.13117350478706238,
        0.13117350478706238,
        0.12325237681051242,
        0.12325237681051242,
        0.11293229608053922,
        0.11293229608053922,
        0.10041414444288096,
        0.10041414444288096,
        0.08594160621706773,
        0.08594160621706773,
        0.06979646842452049,
        0.06979646842452049,
        0.052293335152683286,
        0.052293335152683286,
        0.03377490158481415,
        0.03377490158481415,
        0.0146279952982722,
        0.0146279952982722
      ],
      [
        0.13365457218610619,
        0.1324620394046966,
        0.1324620394046966,
        0.12890572218808216,
        0.12890572218808216,
        0.12304908430672953,
        0.12304908430672953,
        0.11499664022241136,
        0.11499664022241136,
        0.10489209146454141,
        0.10489209146454141,
        0.09291576606003515,
        0.09291576606003515,
        0.07928141177671895,
        0.07928141177671895,
        0.06423242140852585,
        0.06423242140852585,
        0.04803767173108467,
        0.04803767173108467,
        0.030988005856979445,
        0.030988005856979445,
        0.013411859487141771,
        0.013411859487141771
      ],
      [
        0.12793819534675216,
        0.12793819534675216,
        0.1258374563468283,
        0.1258374563468283,
        0.12167047292780339,
        0.12167047292780339,
        0.1155056680537256,
        0.1155056680537256,
        0.10744427011596563,
        0.10744427011596563,
        0.09761865210411388,
        0.09761865210411388,
        0.08619016153195327,
        0.08619016153195327,
        0.0733464814110803,
        0.0733464814110803,
        0.05929858491543678,
        0.05929858491543678,
        0.04427743881741981,
        0.04427743881741981,
        0.028531388628933663,
        0.028531388628933663,
        0.0123412297999872,
        0.0123412297999872
      ]
    ], r.binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
    const a = (h, l, g) => {
      let p, b;
      const x = g / 2;
      p = 0;
      for (let v = 0; v < 20; v++)
        b = x * r.tValues[20][v] + x, p += r.cValues[20][v] * o(h, l, b);
      return x * p;
    };
    r.getCubicArcLength = a;
    const n = (h, l, g) => {
      g === void 0 && (g = 1);
      const p = h[0] - 2 * h[1] + h[2], b = l[0] - 2 * l[1] + l[2], w = 2 * h[1] - 2 * h[0], x = 2 * l[1] - 2 * l[0], v = 4 * (p * p + b * b), _ = 4 * (p * w + b * x), S = w * w + x * x;
      if (v === 0)
        return g * Math.sqrt(Math.pow(h[2] - h[0], 2) + Math.pow(l[2] - l[0], 2));
      const C = _ / (2 * v), F = S / v, d = g + C, f = F - C * C, m = d * d + f > 0 ? Math.sqrt(d * d + f) : 0, E = C * C + f > 0 ? Math.sqrt(C * C + f) : 0, T = C + Math.sqrt(C * C + f) !== 0 ? f * Math.log(Math.abs((d + m) / (C + E))) : 0;
      return Math.sqrt(v) / 2 * (d * m - C * E + T);
    };
    r.getQuadraticArcLength = n;
    function o(h, l, g) {
      const p = c(1, g, h), b = c(1, g, l), w = p * p + b * b;
      return Math.sqrt(w);
    }
    const c = (h, l, g) => {
      const p = g.length - 1;
      let b, w;
      if (p === 0)
        return 0;
      if (h === 0) {
        w = 0;
        for (let x = 0; x <= p; x++)
          w += r.binomialCoefficients[p][x] * Math.pow(1 - l, p - x) * Math.pow(l, x) * g[x];
        return w;
      } else {
        b = new Array(p);
        for (let x = 0; x < p; x++)
          b[x] = p * (g[x + 1] - g[x]);
        return c(h - 1, l, b);
      }
    }, s = (h, l, g) => {
      let p = 1, b = h / l, w = (h - g(b)) / l, x = 0;
      for (; p > 1e-3; ) {
        const v = g(b + w), _ = Math.abs(h - v) / l;
        if (_ < p)
          p = _, b += w;
        else {
          const S = g(b - w), C = Math.abs(h - S) / l;
          C < p ? (p = C, b -= w) : w /= 2;
        }
        if (x++, x > 500)
          break;
      }
      return b;
    };
    r.t2length = s;
  }(uo)), uo;
}
var fd;
function Zh() {
  if (fd) return Ii;
  fd = 1, Object.defineProperty(Ii, "__esModule", { value: !0 }), Ii.Path = void 0;
  const r = Tt(), a = se(), n = Rt(), o = d6();
  let c = class we extends a.Shape {
    constructor(h) {
      super(h), this.dataArray = [], this.pathLength = 0, this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute();
      });
    }
    _readDataAttribute() {
      this.dataArray = we.parsePathData(this.data()), this.pathLength = we.getPathLength(this.dataArray);
    }
    _sceneFunc(h) {
      const l = this.dataArray;
      h.beginPath();
      let g = !1;
      for (let m = 0; m < l.length; m++) {
        const E = l[m].command, T = l[m].points;
        switch (E) {
          case "L":
            h.lineTo(T[0], T[1]);
            break;
          case "M":
            h.moveTo(T[0], T[1]);
            break;
          case "C":
            h.bezierCurveTo(T[0], T[1], T[2], T[3], T[4], T[5]);
            break;
          case "Q":
            h.quadraticCurveTo(T[0], T[1], T[2], T[3]);
            break;
          case "A":
            var p = T[0], b = T[1], w = T[2], x = T[3], v = T[4], _ = T[5], S = T[6], C = T[7], F = w > x ? w : x, d = w > x ? 1 : w / x, f = w > x ? x / w : 1;
            h.translate(p, b), h.rotate(S), h.scale(d, f), h.arc(0, 0, F, v, v + _, 1 - C), h.scale(1 / d, 1 / f), h.rotate(-S), h.translate(-p, -b);
            break;
          case "z":
            g = !0, h.closePath();
            break;
        }
      }
      !g && !this.hasFill() ? h.strokeShape(this) : h.fillStrokeShape(this);
    }
    getSelfRect() {
      let h = [];
      this.dataArray.forEach(function(v) {
        if (v.command === "A") {
          const _ = v.points[4], S = v.points[5], C = v.points[4] + S;
          let F = Math.PI / 180;
          if (Math.abs(_ - C) < F && (F = Math.abs(_ - C)), S < 0)
            for (let d = _ - F; d > C; d -= F) {
              const f = we.getPointOnEllipticalArc(v.points[0], v.points[1], v.points[2], v.points[3], d, 0);
              h.push(f.x, f.y);
            }
          else
            for (let d = _ + F; d < C; d += F) {
              const f = we.getPointOnEllipticalArc(v.points[0], v.points[1], v.points[2], v.points[3], d, 0);
              h.push(f.x, f.y);
            }
        } else if (v.command === "C")
          for (let _ = 0; _ <= 1; _ += 0.01) {
            const S = we.getPointOnCubicBezier(_, v.start.x, v.start.y, v.points[0], v.points[1], v.points[2], v.points[3], v.points[4], v.points[5]);
            h.push(S.x, S.y);
          }
        else
          h = h.concat(v.points);
      });
      let l = h[0], g = h[0], p = h[1], b = h[1], w, x;
      for (let v = 0; v < h.length / 2; v++)
        w = h[v * 2], x = h[v * 2 + 1], isNaN(w) || (l = Math.min(l, w), g = Math.max(g, w)), isNaN(x) || (p = Math.min(p, x), b = Math.max(b, x));
      return {
        x: l,
        y: p,
        width: g - l,
        height: b - p
      };
    }
    getLength() {
      return this.pathLength;
    }
    getPointAtLength(h) {
      return we.getPointAtLengthOfDataArray(h, this.dataArray);
    }
    static getLineLength(h, l, g, p) {
      return Math.sqrt((g - h) * (g - h) + (p - l) * (p - l));
    }
    static getPathLength(h) {
      let l = 0;
      for (let g = 0; g < h.length; ++g)
        l += h[g].pathLength;
      return l;
    }
    static getPointAtLengthOfDataArray(h, l) {
      let g, p = 0, b = l.length;
      if (!b)
        return null;
      for (; p < b && h > l[p].pathLength; )
        h -= l[p].pathLength, ++p;
      if (p === b)
        return g = l[p - 1].points.slice(-2), {
          x: g[0],
          y: g[1]
        };
      if (h < 0.01)
        return g = l[p].points.slice(0, 2), {
          x: g[0],
          y: g[1]
        };
      const w = l[p], x = w.points;
      switch (w.command) {
        case "L":
          return we.getPointOnLine(h, w.start.x, w.start.y, x[0], x[1]);
        case "C":
          return we.getPointOnCubicBezier((0, o.t2length)(h, we.getPathLength(l), (m) => (0, o.getCubicArcLength)([w.start.x, x[0], x[2], x[4]], [w.start.y, x[1], x[3], x[5]], m)), w.start.x, w.start.y, x[0], x[1], x[2], x[3], x[4], x[5]);
        case "Q":
          return we.getPointOnQuadraticBezier((0, o.t2length)(h, we.getPathLength(l), (m) => (0, o.getQuadraticArcLength)([w.start.x, x[0], x[2]], [w.start.y, x[1], x[3]], m)), w.start.x, w.start.y, x[0], x[1], x[2], x[3]);
        case "A":
          var v = x[0], _ = x[1], S = x[2], C = x[3], F = x[4], d = x[5], f = x[6];
          return F += d * h / w.pathLength, we.getPointOnEllipticalArc(v, _, S, C, F, f);
      }
      return null;
    }
    static getPointOnLine(h, l, g, p, b, w, x) {
      w = w != null ? w : l, x = x != null ? x : g;
      const v = this.getLineLength(l, g, p, b);
      if (v < 1e-10)
        return { x: l, y: g };
      if (p === l)
        return { x: w, y: x + (b > g ? h : -h) };
      const _ = (b - g) / (p - l), S = Math.sqrt(h * h / (1 + _ * _)) * (p < l ? -1 : 1), C = _ * S;
      if (Math.abs(x - g - _ * (w - l)) < 1e-10)
        return { x: w + S, y: x + C };
      const F = ((w - l) * (p - l) + (x - g) * (b - g)) / (v * v), d = l + F * (p - l), f = g + F * (b - g), m = this.getLineLength(w, x, d, f), E = Math.sqrt(h * h - m * m), T = Math.sqrt(E * E / (1 + _ * _)) * (p < l ? -1 : 1), D = _ * T;
      return { x: d + T, y: f + D };
    }
    static getPointOnCubicBezier(h, l, g, p, b, w, x, v, _) {
      function S(E) {
        return E * E * E;
      }
      function C(E) {
        return 3 * E * E * (1 - E);
      }
      function F(E) {
        return 3 * E * (1 - E) * (1 - E);
      }
      function d(E) {
        return (1 - E) * (1 - E) * (1 - E);
      }
      const f = v * S(h) + w * C(h) + p * F(h) + l * d(h), m = _ * S(h) + x * C(h) + b * F(h) + g * d(h);
      return {
        x: f,
        y: m
      };
    }
    static getPointOnQuadraticBezier(h, l, g, p, b, w, x) {
      function v(d) {
        return d * d;
      }
      function _(d) {
        return 2 * d * (1 - d);
      }
      function S(d) {
        return (1 - d) * (1 - d);
      }
      const C = w * v(h) + p * _(h) + l * S(h), F = x * v(h) + b * _(h) + g * S(h);
      return {
        x: C,
        y: F
      };
    }
    static getPointOnEllipticalArc(h, l, g, p, b, w) {
      const x = Math.cos(w), v = Math.sin(w), _ = {
        x: g * Math.cos(b),
        y: p * Math.sin(b)
      };
      return {
        x: h + (_.x * x - _.y * v),
        y: l + (_.x * v + _.y * x)
      };
    }
    static parsePathData(h) {
      if (!h)
        return [];
      let l = h;
      const g = [
        "m",
        "M",
        "l",
        "L",
        "v",
        "V",
        "h",
        "H",
        "z",
        "Z",
        "c",
        "C",
        "q",
        "Q",
        "t",
        "T",
        "s",
        "S",
        "a",
        "A"
      ];
      l = l.replace(new RegExp(" ", "g"), ",");
      for (var p = 0; p < g.length; p++)
        l = l.replace(new RegExp(g[p], "g"), "|" + g[p]);
      const b = l.split("|"), w = [], x = [];
      let v = 0, _ = 0;
      const S = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
      let C;
      for (p = 1; p < b.length; p++) {
        let y = b[p], P = y.charAt(0);
        for (y = y.slice(1), x.length = 0; C = S.exec(y); )
          x.push(C[0]);
        const A = [];
        for (let G = 0, U = x.length; G < U; G++) {
          if (x[G] === "00") {
            A.push(0, 0);
            continue;
          }
          const K = parseFloat(x[G]);
          isNaN(K) ? A.push(0) : A.push(K);
        }
        for (; A.length > 0 && !isNaN(A[0]); ) {
          let G = "", U = [];
          const K = v, $ = _;
          var F, d, f, m, E, T, D, I, L, O;
          switch (P) {
            case "l":
              v += A.shift(), _ += A.shift(), G = "L", U.push(v, _);
              break;
            case "L":
              v = A.shift(), _ = A.shift(), U.push(v, _);
              break;
            case "m":
              var N = A.shift(), H = A.shift();
              if (v += N, _ += H, G = "M", w.length > 2 && w[w.length - 1].command === "z") {
                for (let X = w.length - 2; X >= 0; X--)
                  if (w[X].command === "M") {
                    v = w[X].points[0] + N, _ = w[X].points[1] + H;
                    break;
                  }
              }
              U.push(v, _), P = "l";
              break;
            case "M":
              v = A.shift(), _ = A.shift(), G = "M", U.push(v, _), P = "L";
              break;
            case "h":
              v += A.shift(), G = "L", U.push(v, _);
              break;
            case "H":
              v = A.shift(), G = "L", U.push(v, _);
              break;
            case "v":
              _ += A.shift(), G = "L", U.push(v, _);
              break;
            case "V":
              _ = A.shift(), G = "L", U.push(v, _);
              break;
            case "C":
              U.push(A.shift(), A.shift(), A.shift(), A.shift()), v = A.shift(), _ = A.shift(), U.push(v, _);
              break;
            case "c":
              U.push(v + A.shift(), _ + A.shift(), v + A.shift(), _ + A.shift()), v += A.shift(), _ += A.shift(), G = "C", U.push(v, _);
              break;
            case "S":
              d = v, f = _, F = w[w.length - 1], F.command === "C" && (d = v + (v - F.points[2]), f = _ + (_ - F.points[3])), U.push(d, f, A.shift(), A.shift()), v = A.shift(), _ = A.shift(), G = "C", U.push(v, _);
              break;
            case "s":
              d = v, f = _, F = w[w.length - 1], F.command === "C" && (d = v + (v - F.points[2]), f = _ + (_ - F.points[3])), U.push(d, f, v + A.shift(), _ + A.shift()), v += A.shift(), _ += A.shift(), G = "C", U.push(v, _);
              break;
            case "Q":
              U.push(A.shift(), A.shift()), v = A.shift(), _ = A.shift(), U.push(v, _);
              break;
            case "q":
              U.push(v + A.shift(), _ + A.shift()), v += A.shift(), _ += A.shift(), G = "Q", U.push(v, _);
              break;
            case "T":
              d = v, f = _, F = w[w.length - 1], F.command === "Q" && (d = v + (v - F.points[0]), f = _ + (_ - F.points[1])), v = A.shift(), _ = A.shift(), G = "Q", U.push(d, f, v, _);
              break;
            case "t":
              d = v, f = _, F = w[w.length - 1], F.command === "Q" && (d = v + (v - F.points[0]), f = _ + (_ - F.points[1])), v += A.shift(), _ += A.shift(), G = "Q", U.push(d, f, v, _);
              break;
            case "A":
              m = A.shift(), E = A.shift(), T = A.shift(), D = A.shift(), I = A.shift(), L = v, O = _, v = A.shift(), _ = A.shift(), G = "A", U = this.convertEndpointToCenterParameterization(L, O, v, _, D, I, m, E, T);
              break;
            case "a":
              m = A.shift(), E = A.shift(), T = A.shift(), D = A.shift(), I = A.shift(), L = v, O = _, v += A.shift(), _ += A.shift(), G = "A", U = this.convertEndpointToCenterParameterization(L, O, v, _, D, I, m, E, T);
              break;
          }
          w.push({
            command: G || P,
            points: U,
            start: {
              x: K,
              y: $
            },
            pathLength: this.calcLength(K, $, G || P, U)
          });
        }
        (P === "z" || P === "Z") && w.push({
          command: "z",
          points: [],
          start: void 0,
          pathLength: 0
        });
      }
      return w;
    }
    static calcLength(h, l, g, p) {
      let b, w, x, v;
      const _ = we;
      switch (g) {
        case "L":
          return _.getLineLength(h, l, p[0], p[1]);
        case "C":
          return (0, o.getCubicArcLength)([h, p[0], p[2], p[4]], [l, p[1], p[3], p[5]], 1);
        case "Q":
          return (0, o.getQuadraticArcLength)([h, p[0], p[2]], [l, p[1], p[3]], 1);
        case "A":
          b = 0;
          var S = p[4], C = p[5], F = p[4] + C, d = Math.PI / 180;
          if (Math.abs(S - F) < d && (d = Math.abs(S - F)), w = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], S, 0), C < 0)
            for (v = S - d; v > F; v -= d)
              x = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], v, 0), b += _.getLineLength(w.x, w.y, x.x, x.y), w = x;
          else
            for (v = S + d; v < F; v += d)
              x = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], v, 0), b += _.getLineLength(w.x, w.y, x.x, x.y), w = x;
          return x = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], F, 0), b += _.getLineLength(w.x, w.y, x.x, x.y), b;
      }
      return 0;
    }
    static convertEndpointToCenterParameterization(h, l, g, p, b, w, x, v, _) {
      const S = _ * (Math.PI / 180), C = Math.cos(S) * (h - g) / 2 + Math.sin(S) * (l - p) / 2, F = -1 * Math.sin(S) * (h - g) / 2 + Math.cos(S) * (l - p) / 2, d = C * C / (x * x) + F * F / (v * v);
      d > 1 && (x *= Math.sqrt(d), v *= Math.sqrt(d));
      let f = Math.sqrt((x * x * (v * v) - x * x * (F * F) - v * v * (C * C)) / (x * x * (F * F) + v * v * (C * C)));
      b === w && (f *= -1), isNaN(f) && (f = 0);
      const m = f * x * F / v, E = f * -v * C / x, T = (h + g) / 2 + Math.cos(S) * m - Math.sin(S) * E, D = (l + p) / 2 + Math.sin(S) * m + Math.cos(S) * E, I = function(A) {
        return Math.sqrt(A[0] * A[0] + A[1] * A[1]);
      }, L = function(A, G) {
        return (A[0] * G[0] + A[1] * G[1]) / (I(A) * I(G));
      }, O = function(A, G) {
        return (A[0] * G[1] < A[1] * G[0] ? -1 : 1) * Math.acos(L(A, G));
      }, N = O([1, 0], [(C - m) / x, (F - E) / v]), H = [(C - m) / x, (F - E) / v], y = [(-1 * C - m) / x, (-1 * F - E) / v];
      let P = O(H, y);
      return L(H, y) <= -1 && (P = Math.PI), L(H, y) >= 1 && (P = 0), w === 0 && P > 0 && (P = P - 2 * Math.PI), w === 1 && P < 0 && (P = P + 2 * Math.PI), [T, D, x, v, N, P, S, w];
    }
  };
  return Ii.Path = c, c.prototype.className = "Path", c.prototype._attrsAffectingSize = ["data"], (0, n._registerNode)(c), r.Factory.addGetterSetter(c, "data"), Ii;
}
var gd;
function f6() {
  if (gd) return Oi;
  gd = 1, Object.defineProperty(Oi, "__esModule", { value: !0 }), Oi.Arrow = void 0;
  const r = Tt(), a = $0(), n = Ot(), o = Rt(), c = Zh();
  let s = class extends a.Line {
    _sceneFunc(l) {
      super._sceneFunc(l);
      const g = Math.PI * 2, p = this.points();
      let b = p;
      const w = this.tension() !== 0 && p.length > 4;
      w && (b = this.getTensionPoints());
      const x = this.pointerLength(), v = p.length;
      let _, S;
      if (w) {
        const d = [
          b[b.length - 4],
          b[b.length - 3],
          b[b.length - 2],
          b[b.length - 1],
          p[v - 2],
          p[v - 1]
        ], f = c.Path.calcLength(b[b.length - 4], b[b.length - 3], "C", d), m = c.Path.getPointOnQuadraticBezier(Math.min(1, 1 - x / f), d[0], d[1], d[2], d[3], d[4], d[5]);
        _ = p[v - 2] - m.x, S = p[v - 1] - m.y;
      } else
        _ = p[v - 2] - p[v - 4], S = p[v - 1] - p[v - 3];
      const C = (Math.atan2(S, _) + g) % g, F = this.pointerWidth();
      this.pointerAtEnding() && (l.save(), l.beginPath(), l.translate(p[v - 2], p[v - 1]), l.rotate(C), l.moveTo(0, 0), l.lineTo(-x, F / 2), l.lineTo(-x, -F / 2), l.closePath(), l.restore(), this.__fillStroke(l)), this.pointerAtBeginning() && (l.save(), l.beginPath(), l.translate(p[0], p[1]), w ? (_ = (b[0] + b[2]) / 2 - p[0], S = (b[1] + b[3]) / 2 - p[1]) : (_ = p[2] - p[0], S = p[3] - p[1]), l.rotate((Math.atan2(-S, -_) + g) % g), l.moveTo(0, 0), l.lineTo(-x, F / 2), l.lineTo(-x, -F / 2), l.closePath(), l.restore(), this.__fillStroke(l));
    }
    __fillStroke(l) {
      const g = this.dashEnabled();
      g && (this.attrs.dashEnabled = !1, l.setLineDash([])), l.fillStrokeShape(this), g && (this.attrs.dashEnabled = !0);
    }
    getSelfRect() {
      const l = super.getSelfRect(), g = this.pointerWidth() / 2;
      return {
        x: l.x - g,
        y: l.y - g,
        width: l.width + g * 2,
        height: l.height + g * 2
      };
    }
  };
  return Oi.Arrow = s, s.prototype.className = "Arrow", (0, o._registerNode)(s), r.Factory.addGetterSetter(s, "pointerLength", 10, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(s, "pointerWidth", 10, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(s, "pointerAtBeginning", !1), r.Factory.addGetterSetter(s, "pointerAtEnding", !0), Oi;
}
var Li = {}, pd;
function g6() {
  if (pd) return Li;
  pd = 1, Object.defineProperty(Li, "__esModule", { value: !0 }), Li.Circle = void 0;
  const r = Tt(), a = se(), n = Ot(), o = Rt();
  let c = class extends a.Shape {
    _sceneFunc(h) {
      h.beginPath(), h.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), h.closePath(), h.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(h) {
      this.radius() !== h / 2 && this.radius(h / 2);
    }
    setHeight(h) {
      this.radius() !== h / 2 && this.radius(h / 2);
    }
  };
  return Li.Circle = c, c.prototype._centroid = !0, c.prototype.className = "Circle", c.prototype._attrsAffectingSize = ["radius"], (0, o._registerNode)(c), r.Factory.addGetterSetter(c, "radius", 0, (0, n.getNumberValidator)()), Li;
}
var Mi = {}, _d;
function p6() {
  if (_d) return Mi;
  _d = 1, Object.defineProperty(Mi, "__esModule", { value: !0 }), Mi.Ellipse = void 0;
  const r = Tt(), a = se(), n = Ot(), o = Rt();
  let c = class extends a.Shape {
    _sceneFunc(h) {
      const l = this.radiusX(), g = this.radiusY();
      h.beginPath(), h.save(), l !== g && h.scale(1, g / l), h.arc(0, 0, l, 0, Math.PI * 2, !1), h.restore(), h.closePath(), h.fillStrokeShape(this);
    }
    getWidth() {
      return this.radiusX() * 2;
    }
    getHeight() {
      return this.radiusY() * 2;
    }
    setWidth(h) {
      this.radiusX(h / 2);
    }
    setHeight(h) {
      this.radiusY(h / 2);
    }
  };
  return Mi.Ellipse = c, c.prototype.className = "Ellipse", c.prototype._centroid = !0, c.prototype._attrsAffectingSize = ["radiusX", "radiusY"], (0, o._registerNode)(c), r.Factory.addComponentsGetterSetter(c, "radius", ["x", "y"]), r.Factory.addGetterSetter(c, "radiusX", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(c, "radiusY", 0, (0, n.getNumberValidator)()), Mi;
}
var Ni = {}, vd;
function _6() {
  if (vd) return Ni;
  vd = 1, Object.defineProperty(Ni, "__esModule", { value: !0 }), Ni.Image = void 0;
  const r = Kt(), a = Tt(), n = se(), o = Rt(), c = Ot();
  let s = class Z0 extends n.Shape {
    constructor(l) {
      super(l), this.on("imageChange.konva", () => {
        this._setImageLoad();
      }), this._setImageLoad();
    }
    _setImageLoad() {
      const l = this.image();
      l && l.complete || l && l.readyState === 4 || l && l.addEventListener && l.addEventListener("load", () => {
        this._requestDraw();
      });
    }
    _useBufferCanvas() {
      const l = !!this.cornerRadius(), g = this.hasShadow();
      return l && g ? !0 : super._useBufferCanvas(!0);
    }
    _sceneFunc(l) {
      const g = this.getWidth(), p = this.getHeight(), b = this.cornerRadius(), w = this.attrs.image;
      let x;
      if (w) {
        const v = this.attrs.cropWidth, _ = this.attrs.cropHeight;
        v && _ ? x = [
          w,
          this.cropX(),
          this.cropY(),
          v,
          _,
          0,
          0,
          g,
          p
        ] : x = [w, 0, 0, g, p];
      }
      (this.hasFill() || this.hasStroke() || b) && (l.beginPath(), b ? r.Util.drawRoundedRectPath(l, g, p, b) : l.rect(0, 0, g, p), l.closePath(), l.fillStrokeShape(this)), w && (b && l.clip(), l.drawImage.apply(l, x));
    }
    _hitFunc(l) {
      const g = this.width(), p = this.height(), b = this.cornerRadius();
      l.beginPath(), b ? r.Util.drawRoundedRectPath(l, g, p, b) : l.rect(0, 0, g, p), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      var l, g;
      return (l = this.attrs.width) !== null && l !== void 0 ? l : (g = this.image()) === null || g === void 0 ? void 0 : g.width;
    }
    getHeight() {
      var l, g;
      return (l = this.attrs.height) !== null && l !== void 0 ? l : (g = this.image()) === null || g === void 0 ? void 0 : g.height;
    }
    static fromURL(l, g, p = null) {
      const b = r.Util.createImageElement();
      b.onload = function() {
        const w = new Z0({
          image: b
        });
        g(w);
      }, b.onerror = p, b.crossOrigin = "Anonymous", b.src = l;
    }
  };
  return Ni.Image = s, s.prototype.className = "Image", (0, o._registerNode)(s), a.Factory.addGetterSetter(s, "cornerRadius", 0, (0, c.getNumberOrArrayOfNumbersValidator)(4)), a.Factory.addGetterSetter(s, "image"), a.Factory.addComponentsGetterSetter(s, "crop", ["x", "y", "width", "height"]), a.Factory.addGetterSetter(s, "cropX", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(s, "cropY", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(s, "cropWidth", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(s, "cropHeight", 0, (0, c.getNumberValidator)()), Ni;
}
var Nr = {}, yd;
function v6() {
  if (yd) return Nr;
  yd = 1, Object.defineProperty(Nr, "__esModule", { value: !0 }), Nr.Tag = Nr.Label = void 0;
  const r = Tt(), a = se(), n = Xh(), o = Ot(), c = Rt(), s = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "padding",
    "lineHeight",
    "text",
    "width",
    "height",
    "pointerDirection",
    "pointerWidth",
    "pointerHeight"
  ], h = "Change.konva", l = "none", g = "up", p = "right", b = "down", w = "left", x = s.length;
  let v = class extends n.Group {
    constructor(C) {
      super(C), this.on("add.konva", function(F) {
        this._addListeners(F.child), this._sync();
      });
    }
    getText() {
      return this.find("Text")[0];
    }
    getTag() {
      return this.find("Tag")[0];
    }
    _addListeners(C) {
      let F = this, d;
      const f = function() {
        F._sync();
      };
      for (d = 0; d < x; d++)
        C.on(s[d] + h, f);
    }
    getWidth() {
      return this.getText().width();
    }
    getHeight() {
      return this.getText().height();
    }
    _sync() {
      let C = this.getText(), F = this.getTag(), d, f, m, E, T, D, I;
      if (C && F) {
        switch (d = C.width(), f = C.height(), m = F.pointerDirection(), E = F.pointerWidth(), I = F.pointerHeight(), T = 0, D = 0, m) {
          case g:
            T = d / 2, D = -1 * I;
            break;
          case p:
            T = d + E, D = f / 2;
            break;
          case b:
            T = d / 2, D = f + I;
            break;
          case w:
            T = -1 * E, D = f / 2;
            break;
        }
        F.setAttrs({
          x: -1 * T,
          y: -1 * D,
          width: d,
          height: f
        }), C.setAttrs({
          x: -1 * T,
          y: -1 * D
        });
      }
    }
  };
  Nr.Label = v, v.prototype.className = "Label", (0, c._registerNode)(v);
  class _ extends a.Shape {
    _sceneFunc(C) {
      const F = this.width(), d = this.height(), f = this.pointerDirection(), m = this.pointerWidth(), E = this.pointerHeight(), T = this.cornerRadius();
      let D = 0, I = 0, L = 0, O = 0;
      typeof T == "number" ? D = I = L = O = Math.min(T, F / 2, d / 2) : (D = Math.min(T[0] || 0, F / 2, d / 2), I = Math.min(T[1] || 0, F / 2, d / 2), O = Math.min(T[2] || 0, F / 2, d / 2), L = Math.min(T[3] || 0, F / 2, d / 2)), C.beginPath(), C.moveTo(D, 0), f === g && (C.lineTo((F - m) / 2, 0), C.lineTo(F / 2, -1 * E), C.lineTo((F + m) / 2, 0)), C.lineTo(F - I, 0), C.arc(F - I, I, I, Math.PI * 3 / 2, 0, !1), f === p && (C.lineTo(F, (d - E) / 2), C.lineTo(F + m, d / 2), C.lineTo(F, (d + E) / 2)), C.lineTo(F, d - O), C.arc(F - O, d - O, O, 0, Math.PI / 2, !1), f === b && (C.lineTo((F + m) / 2, d), C.lineTo(F / 2, d + E), C.lineTo((F - m) / 2, d)), C.lineTo(L, d), C.arc(L, d - L, L, Math.PI / 2, Math.PI, !1), f === w && (C.lineTo(0, (d + E) / 2), C.lineTo(-1 * m, d / 2), C.lineTo(0, (d - E) / 2)), C.lineTo(0, D), C.arc(D, D, D, Math.PI, Math.PI * 3 / 2, !1), C.closePath(), C.fillStrokeShape(this);
    }
    getSelfRect() {
      let C = 0, F = 0, d = this.pointerWidth(), f = this.pointerHeight(), m = this.pointerDirection(), E = this.width(), T = this.height();
      return m === g ? (F -= f, T += f) : m === b ? T += f : m === w ? (C -= d * 1.5, E += d) : m === p && (E += d * 1.5), {
        x: C,
        y: F,
        width: E,
        height: T
      };
    }
  }
  return Nr.Tag = _, _.prototype.className = "Tag", (0, c._registerNode)(_), r.Factory.addGetterSetter(_, "pointerDirection", l), r.Factory.addGetterSetter(_, "pointerWidth", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(_, "pointerHeight", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(_, "cornerRadius", 0, (0, o.getNumberOrArrayOfNumbersValidator)(4)), Nr;
}
var Gi = {}, md;
function J0() {
  if (md) return Gi;
  md = 1, Object.defineProperty(Gi, "__esModule", { value: !0 }), Gi.Rect = void 0;
  const r = Tt(), a = se(), n = Rt(), o = Kt(), c = Ot();
  let s = class extends a.Shape {
    _sceneFunc(l) {
      const g = this.cornerRadius(), p = this.width(), b = this.height();
      l.beginPath(), g ? o.Util.drawRoundedRectPath(l, p, b, g) : l.rect(0, 0, p, b), l.closePath(), l.fillStrokeShape(this);
    }
  };
  return Gi.Rect = s, s.prototype.className = "Rect", (0, n._registerNode)(s), r.Factory.addGetterSetter(s, "cornerRadius", 0, (0, c.getNumberOrArrayOfNumbersValidator)(4)), Gi;
}
var Di = {}, bd;
function y6() {
  if (bd) return Di;
  bd = 1, Object.defineProperty(Di, "__esModule", { value: !0 }), Di.RegularPolygon = void 0;
  const r = Tt(), a = se(), n = Ot(), o = Rt();
  let c = class extends a.Shape {
    _sceneFunc(h) {
      const l = this._getPoints();
      h.beginPath(), h.moveTo(l[0].x, l[0].y);
      for (let g = 1; g < l.length; g++)
        h.lineTo(l[g].x, l[g].y);
      h.closePath(), h.fillStrokeShape(this);
    }
    _getPoints() {
      const h = this.attrs.sides, l = this.attrs.radius || 0, g = [];
      for (let p = 0; p < h; p++)
        g.push({
          x: l * Math.sin(p * 2 * Math.PI / h),
          y: -1 * l * Math.cos(p * 2 * Math.PI / h)
        });
      return g;
    }
    getSelfRect() {
      const h = this._getPoints();
      let l = h[0].x, g = h[0].y, p = h[0].x, b = h[0].y;
      return h.forEach((w) => {
        l = Math.min(l, w.x), g = Math.max(g, w.x), p = Math.min(p, w.y), b = Math.max(b, w.y);
      }), {
        x: l,
        y: p,
        width: g - l,
        height: b - p
      };
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(h) {
      this.radius(h / 2);
    }
    setHeight(h) {
      this.radius(h / 2);
    }
  };
  return Di.RegularPolygon = c, c.prototype.className = "RegularPolygon", c.prototype._centroid = !0, c.prototype._attrsAffectingSize = ["radius"], (0, o._registerNode)(c), r.Factory.addGetterSetter(c, "radius", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(c, "sides", 0, (0, n.getNumberValidator)()), Di;
}
var Bi = {}, wd;
function m6() {
  if (wd) return Bi;
  wd = 1, Object.defineProperty(Bi, "__esModule", { value: !0 }), Bi.Ring = void 0;
  const r = Tt(), a = se(), n = Ot(), o = Rt(), c = Math.PI * 2;
  let s = class extends a.Shape {
    _sceneFunc(l) {
      l.beginPath(), l.arc(0, 0, this.innerRadius(), 0, c, !1), l.moveTo(this.outerRadius(), 0), l.arc(0, 0, this.outerRadius(), c, 0, !0), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(l) {
      this.outerRadius(l / 2);
    }
    setHeight(l) {
      this.outerRadius(l / 2);
    }
  };
  return Bi.Ring = s, s.prototype.className = "Ring", s.prototype._centroid = !0, s.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, o._registerNode)(s), r.Factory.addGetterSetter(s, "innerRadius", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(s, "outerRadius", 0, (0, n.getNumberValidator)()), Bi;
}
var Ui = {}, Sd;
function b6() {
  if (Sd) return Ui;
  Sd = 1, Object.defineProperty(Ui, "__esModule", { value: !0 }), Ui.Sprite = void 0;
  const r = Tt(), a = se(), n = $h(), o = Ot(), c = Rt();
  let s = class extends a.Shape {
    constructor(l) {
      super(l), this._updated = !0, this.anim = new n.Animation(() => {
        const g = this._updated;
        return this._updated = !1, g;
      }), this.on("animationChange.konva", function() {
        this.frameIndex(0);
      }), this.on("frameIndexChange.konva", function() {
        this._updated = !0;
      }), this.on("frameRateChange.konva", function() {
        this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
      });
    }
    _sceneFunc(l) {
      const g = this.animation(), p = this.frameIndex(), b = p * 4, w = this.animations()[g], x = this.frameOffsets(), v = w[b + 0], _ = w[b + 1], S = w[b + 2], C = w[b + 3], F = this.image();
      if ((this.hasFill() || this.hasStroke()) && (l.beginPath(), l.rect(0, 0, S, C), l.closePath(), l.fillStrokeShape(this)), F)
        if (x) {
          const d = x[g], f = p * 2;
          l.drawImage(F, v, _, S, C, d[f + 0], d[f + 1], S, C);
        } else
          l.drawImage(F, v, _, S, C, 0, 0, S, C);
    }
    _hitFunc(l) {
      const g = this.animation(), p = this.frameIndex(), b = p * 4, w = this.animations()[g], x = this.frameOffsets(), v = w[b + 2], _ = w[b + 3];
      if (l.beginPath(), x) {
        const S = x[g], C = p * 2;
        l.rect(S[C + 0], S[C + 1], v, _);
      } else
        l.rect(0, 0, v, _);
      l.closePath(), l.fillShape(this);
    }
    _useBufferCanvas() {
      return super._useBufferCanvas(!0);
    }
    _setInterval() {
      const l = this;
      this.interval = setInterval(function() {
        l._updateIndex();
      }, 1e3 / this.frameRate());
    }
    start() {
      if (this.isRunning())
        return;
      const l = this.getLayer();
      this.anim.setLayers(l), this._setInterval(), this.anim.start();
    }
    stop() {
      this.anim.stop(), clearInterval(this.interval);
    }
    isRunning() {
      return this.anim.isRunning();
    }
    _updateIndex() {
      const l = this.frameIndex(), g = this.animation(), p = this.animations(), b = p[g], w = b.length / 4;
      l < w - 1 ? this.frameIndex(l + 1) : this.frameIndex(0);
    }
  };
  return Ui.Sprite = s, s.prototype.className = "Sprite", (0, c._registerNode)(s), r.Factory.addGetterSetter(s, "animation"), r.Factory.addGetterSetter(s, "animations"), r.Factory.addGetterSetter(s, "frameOffsets"), r.Factory.addGetterSetter(s, "image"), r.Factory.addGetterSetter(s, "frameIndex", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "frameRate", 17, (0, o.getNumberValidator)()), r.Factory.backCompat(s, {
    index: "frameIndex",
    getIndex: "getFrameIndex",
    setIndex: "setFrameIndex"
  }), Ui;
}
var qi = {}, Cd;
function w6() {
  if (Cd) return qi;
  Cd = 1, Object.defineProperty(qi, "__esModule", { value: !0 }), qi.Star = void 0;
  const r = Tt(), a = se(), n = Ot(), o = Rt();
  let c = class extends a.Shape {
    _sceneFunc(h) {
      const l = this.innerRadius(), g = this.outerRadius(), p = this.numPoints();
      h.beginPath(), h.moveTo(0, 0 - g);
      for (let b = 1; b < p * 2; b++) {
        const w = b % 2 === 0 ? g : l, x = w * Math.sin(b * Math.PI / p), v = -1 * w * Math.cos(b * Math.PI / p);
        h.lineTo(x, v);
      }
      h.closePath(), h.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(h) {
      this.outerRadius(h / 2);
    }
    setHeight(h) {
      this.outerRadius(h / 2);
    }
  };
  return qi.Star = c, c.prototype.className = "Star", c.prototype._centroid = !0, c.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, o._registerNode)(c), r.Factory.addGetterSetter(c, "numPoints", 5, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(c, "innerRadius", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(c, "outerRadius", 0, (0, n.getNumberValidator)()), qi;
}
var ti = {}, xd;
function Q0() {
  if (xd) return ti;
  xd = 1, Object.defineProperty(ti, "__esModule", { value: !0 }), ti.Text = void 0, ti.stringToArray = h;
  const r = Kt(), a = Tt(), n = se(), o = Rt(), c = Ot(), s = Rt();
  function h(st) {
    return [...st].reduce((Z, at, ht, ct) => (/\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?(?:\u200D\p{Emoji_Presentation})+/u.test(at) ? Z.push(at) : /\p{Regional_Indicator}{2}/u.test(at + (ct[ht + 1] || "")) ? Z.push(at + ct[ht + 1]) : ht > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(at) ? Z[Z.length - 1] += at : Z.push(at), Z), []);
  }
  const l = "auto", g = "center", p = "inherit", b = "justify", w = "Change.konva", x = "2d", v = "-", _ = "left", S = "text", C = "Text", F = "top", d = "bottom", f = "middle", m = "normal", E = "px ", T = " ", D = "right", I = "rtl", L = "word", O = "char", N = "none", H = "…", y = [
    "direction",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "padding",
    "align",
    "verticalAlign",
    "lineHeight",
    "text",
    "width",
    "height",
    "wrap",
    "ellipsis",
    "letterSpacing"
  ], P = y.length;
  function A(st) {
    return st.split(",").map((Z) => {
      Z = Z.trim();
      const at = Z.indexOf(" ") >= 0, ht = Z.indexOf('"') >= 0 || Z.indexOf("'") >= 0;
      return at && !ht && (Z = `"${Z}"`), Z;
    }).join(", ");
  }
  let G;
  function U() {
    return G || (G = r.Util.createCanvasElement().getContext(x), G);
  }
  function K(st) {
    st.fillText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function $(st) {
    st.setAttr("miterLimit", 2), st.strokeText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function X(st) {
    return st = st || {}, !st.fillLinearGradientColorStops && !st.fillRadialGradientColorStops && !st.fillPatternImage && (st.fill = st.fill || "black"), st;
  }
  let Q = class extends n.Shape {
    constructor(Z) {
      super(X(Z)), this._partialTextX = 0, this._partialTextY = 0;
      for (let at = 0; at < P; at++)
        this.on(y[at] + w, this._setTextData);
      this._setTextData();
    }
    _sceneFunc(Z) {
      const at = this.textArr, ht = at.length;
      if (!this.text())
        return;
      let ct = this.padding(), W = this.fontSize(), j = this.lineHeight() * W, et = this.verticalAlign(), ut = this.direction(), ft = 0, gt = this.align(), Lt = this.getWidth(), Et = this.letterSpacing(), mt = this.fill(), ee = this.textDecoration(), Pt = ee.indexOf("underline") !== -1, Wt = ee.indexOf("line-through") !== -1, pr;
      ut = ut === p ? Z.direction : ut;
      let re = j / 2, Zt = f;
      if (o.Konva._fixTextRendering) {
        const Ze = this.measureSize("M");
        Zt = "alphabetic", re = (Ze.fontBoundingBoxAscent - Ze.fontBoundingBoxDescent) / 2 + j / 2;
      }
      var Jt = 0, Ut = 0;
      for (ut === I && Z.setAttr("direction", ut), Z.setAttr("font", this._getContextFont()), Z.setAttr("textBaseline", Zt), Z.setAttr("textAlign", _), et === f ? ft = (this.getHeight() - ht * j - ct * 2) / 2 : et === d && (ft = this.getHeight() - ht * j - ct * 2), Z.translate(ct, ft + ct), pr = 0; pr < ht; pr++) {
        var Jt = 0, Ut = 0, He = at[pr], ie = He.text, We = He.width, zt = He.lastInParagraph, ne, Fe, pe;
        if (Z.save(), gt === D ? Jt += Lt - We - ct * 2 : gt === g && (Jt += (Lt - We - ct * 2) / 2), Pt) {
          Z.save(), Z.beginPath();
          const Ve = o.Konva._fixTextRendering ? Math.round(W / 4) : Math.round(W / 2), Oe = Jt, Je = re + Ut + Ve;
          Z.moveTo(Oe, Je), ne = ie.split(" ").length - 1, Fe = ne === 0, pe = gt === b && !zt ? Lt - ct * 2 : We, Z.lineTo(Oe + Math.round(pe), Je), Z.lineWidth = W / 15;
          const si = this._getLinearGradient();
          Z.strokeStyle = si || mt, Z.stroke(), Z.restore();
        }
        if (Wt) {
          Z.save(), Z.beginPath();
          const Ve = o.Konva._fixTextRendering ? -Math.round(W / 4) : 0;
          Z.moveTo(Jt, re + Ut + Ve), ne = ie.split(" ").length - 1, Fe = ne === 0, pe = gt === b && zt && !Fe ? Lt - ct * 2 : We, Z.lineTo(Jt + Math.round(pe), re + Ut + Ve), Z.lineWidth = W / 15;
          const Oe = this._getLinearGradient();
          Z.strokeStyle = Oe || mt, Z.stroke(), Z.restore();
        }
        if (ut !== I && (Et !== 0 || gt === b)) {
          ne = ie.split(" ").length - 1;
          const Ve = h(ie);
          for (let Oe = 0; Oe < Ve.length; Oe++) {
            const Je = Ve[Oe];
            Je === " " && !zt && gt === b && (Jt += (Lt - ct * 2 - We) / ne), this._partialTextX = Jt, this._partialTextY = re + Ut, this._partialText = Je, Z.fillStrokeShape(this), Jt += this.measureSize(Je).width + Et;
          }
        } else
          Et !== 0 && Z.setAttr("letterSpacing", `${Et}px`), this._partialTextX = Jt, this._partialTextY = re + Ut, this._partialText = ie, Z.fillStrokeShape(this);
        Z.restore(), ht > 1 && (re += j);
      }
    }
    _hitFunc(Z) {
      const at = this.getWidth(), ht = this.getHeight();
      Z.beginPath(), Z.rect(0, 0, at, ht), Z.closePath(), Z.fillStrokeShape(this);
    }
    setText(Z) {
      const at = r.Util._isString(Z) ? Z : Z == null ? "" : Z + "";
      return this._setAttr(S, at), this;
    }
    getWidth() {
      return this.attrs.width === l || this.attrs.width === void 0 ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
      return this.attrs.height === l || this.attrs.height === void 0 ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return r.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    measureSize(Z) {
      var at, ht, ct, W, j, et, ut, ft, gt, Lt, Et;
      let mt = U(), ee = this.fontSize(), Pt;
      mt.save(), mt.font = this._getContextFont(), Pt = mt.measureText(Z), mt.restore();
      const Wt = ee / 100;
      return {
        actualBoundingBoxAscent: (at = Pt.actualBoundingBoxAscent) !== null && at !== void 0 ? at : 71.58203125 * Wt,
        actualBoundingBoxDescent: (ht = Pt.actualBoundingBoxDescent) !== null && ht !== void 0 ? ht : 0,
        actualBoundingBoxLeft: (ct = Pt.actualBoundingBoxLeft) !== null && ct !== void 0 ? ct : -7.421875 * Wt,
        actualBoundingBoxRight: (W = Pt.actualBoundingBoxRight) !== null && W !== void 0 ? W : 75.732421875 * Wt,
        alphabeticBaseline: (j = Pt.alphabeticBaseline) !== null && j !== void 0 ? j : 0,
        emHeightAscent: (et = Pt.emHeightAscent) !== null && et !== void 0 ? et : 100 * Wt,
        emHeightDescent: (ut = Pt.emHeightDescent) !== null && ut !== void 0 ? ut : -20 * Wt,
        fontBoundingBoxAscent: (ft = Pt.fontBoundingBoxAscent) !== null && ft !== void 0 ? ft : 91 * Wt,
        fontBoundingBoxDescent: (gt = Pt.fontBoundingBoxDescent) !== null && gt !== void 0 ? gt : 21 * Wt,
        hangingBaseline: (Lt = Pt.hangingBaseline) !== null && Lt !== void 0 ? Lt : 72.80000305175781 * Wt,
        ideographicBaseline: (Et = Pt.ideographicBaseline) !== null && Et !== void 0 ? Et : -21 * Wt,
        width: Pt.width,
        height: ee
      };
    }
    _getContextFont() {
      return this.fontStyle() + T + this.fontVariant() + T + (this.fontSize() + E) + A(this.fontFamily());
    }
    _addTextLine(Z) {
      this.align() === b && (Z = Z.trim());
      const ht = this._getTextWidth(Z);
      return this.textArr.push({
        text: Z,
        width: ht,
        lastInParagraph: !1
      });
    }
    _getTextWidth(Z) {
      const at = this.letterSpacing(), ht = Z.length;
      return U().measureText(Z).width + (ht ? at * (ht - 1) : 0);
    }
    _setTextData() {
      let Z = this.text().split(`
`), at = +this.fontSize(), ht = 0, ct = this.lineHeight() * at, W = this.attrs.width, j = this.attrs.height, et = W !== l && W !== void 0, ut = j !== l && j !== void 0, ft = this.padding(), gt = W - ft * 2, Lt = j - ft * 2, Et = 0, mt = this.wrap(), ee = mt !== N, Pt = mt !== O && ee, Wt = this.ellipsis();
      this.textArr = [], U().font = this._getContextFont();
      const pr = Wt ? this._getTextWidth(H) : 0;
      for (let Zt = 0, Jt = Z.length; Zt < Jt; ++Zt) {
        let Ut = Z[Zt], He = this._getTextWidth(Ut);
        if (et && He > gt)
          for (; Ut.length > 0; ) {
            let ie = 0, We = Ut.length, zt = "", ne = 0;
            for (; ie < We; ) {
              const Fe = ie + We >>> 1, pe = Ut.slice(0, Fe + 1), Ze = this._getTextWidth(pe) + pr;
              Ze <= gt ? (ie = Fe + 1, zt = pe, ne = Ze) : We = Fe;
            }
            if (zt) {
              if (Pt) {
                var re;
                const pe = Ut[zt.length];
                (pe === T || pe === v) && ne <= gt ? re = zt.length : re = Math.max(zt.lastIndexOf(T), zt.lastIndexOf(v)) + 1, re > 0 && (ie = re, zt = zt.slice(0, ie), ne = this._getTextWidth(zt));
              }
              if (zt = zt.trimRight(), this._addTextLine(zt), ht = Math.max(ht, ne), Et += ct, this._shouldHandleEllipsis(Et)) {
                this._tryToAddEllipsisToLastLine();
                break;
              }
              if (Ut = Ut.slice(ie), Ut = Ut.trimLeft(), Ut.length > 0 && (He = this._getTextWidth(Ut), He <= gt)) {
                this._addTextLine(Ut), Et += ct, ht = Math.max(ht, He);
                break;
              }
            } else
              break;
          }
        else
          this._addTextLine(Ut), Et += ct, ht = Math.max(ht, He), this._shouldHandleEllipsis(Et) && Zt < Jt - 1 && this._tryToAddEllipsisToLastLine();
        if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), ut && Et + ct > Lt)
          break;
      }
      this.textHeight = at, this.textWidth = ht;
    }
    _shouldHandleEllipsis(Z) {
      const at = +this.fontSize(), ht = this.lineHeight() * at, ct = this.attrs.height, W = ct !== l && ct !== void 0, j = this.padding(), et = ct - j * 2;
      return !(this.wrap() !== N) || W && Z + ht > et;
    }
    _tryToAddEllipsisToLastLine() {
      const Z = this.attrs.width, at = Z !== l && Z !== void 0, ht = this.padding(), ct = Z - ht * 2, W = this.ellipsis(), j = this.textArr[this.textArr.length - 1];
      !j || !W || (at && (this._getTextWidth(j.text + H) < ct || (j.text = j.text.slice(0, j.text.length - 3))), this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(j.text + H));
    }
    getStrokeScaleEnabled() {
      return !0;
    }
    _useBufferCanvas() {
      const Z = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1, at = this.hasShadow();
      return Z && at ? !0 : super._useBufferCanvas();
    }
  };
  return ti.Text = Q, Q.prototype._fillFunc = K, Q.prototype._strokeFunc = $, Q.prototype.className = C, Q.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "padding",
    "wrap",
    "lineHeight",
    "letterSpacing"
  ], (0, s._registerNode)(Q), a.Factory.overWriteSetter(Q, "width", (0, c.getNumberOrAutoValidator)()), a.Factory.overWriteSetter(Q, "height", (0, c.getNumberOrAutoValidator)()), a.Factory.addGetterSetter(Q, "direction", p), a.Factory.addGetterSetter(Q, "fontFamily", "Arial"), a.Factory.addGetterSetter(Q, "fontSize", 12, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(Q, "fontStyle", m), a.Factory.addGetterSetter(Q, "fontVariant", m), a.Factory.addGetterSetter(Q, "padding", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(Q, "align", _), a.Factory.addGetterSetter(Q, "verticalAlign", F), a.Factory.addGetterSetter(Q, "lineHeight", 1, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(Q, "wrap", L), a.Factory.addGetterSetter(Q, "ellipsis", !1, (0, c.getBooleanValidator)()), a.Factory.addGetterSetter(Q, "letterSpacing", 0, (0, c.getNumberValidator)()), a.Factory.addGetterSetter(Q, "text", "", (0, c.getStringValidator)()), a.Factory.addGetterSetter(Q, "textDecoration", ""), ti;
}
var Hi = {}, Ed;
function S6() {
  if (Ed) return Hi;
  Ed = 1, Object.defineProperty(Hi, "__esModule", { value: !0 }), Hi.TextPath = void 0;
  const r = Kt(), a = Tt(), n = se(), o = Zh(), c = Q0(), s = Ot(), h = Rt(), l = "", g = "normal";
  function p(x) {
    x.fillText(this.partialText, 0, 0);
  }
  function b(x) {
    x.strokeText(this.partialText, 0, 0);
  }
  let w = class extends n.Shape {
    constructor(v) {
      super(v), this.dummyCanvas = r.Util.createCanvasElement(), this.dataArray = [], this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute(), this._setTextData();
      }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
    }
    _getTextPathLength() {
      return o.Path.getPathLength(this.dataArray);
    }
    _getPointAtLength(v) {
      if (!this.attrs.data)
        return null;
      const _ = this.pathLength;
      return v - 1 > _ ? null : o.Path.getPointAtLengthOfDataArray(v, this.dataArray);
    }
    _readDataAttribute() {
      this.dataArray = o.Path.parsePathData(this.attrs.data), this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(v) {
      v.setAttr("font", this._getContextFont()), v.setAttr("textBaseline", this.textBaseline()), v.setAttr("textAlign", "left"), v.save();
      const _ = this.textDecoration(), S = this.fill(), C = this.fontSize(), F = this.glyphInfo;
      _ === "underline" && v.beginPath();
      for (let d = 0; d < F.length; d++) {
        v.save();
        const f = F[d].p0;
        v.translate(f.x, f.y), v.rotate(F[d].rotation), this.partialText = F[d].text, v.fillStrokeShape(this), _ === "underline" && (d === 0 && v.moveTo(0, C / 2 + 1), v.lineTo(C, C / 2 + 1)), v.restore();
      }
      _ === "underline" && (v.strokeStyle = S, v.lineWidth = C / 20, v.stroke()), v.restore();
    }
    _hitFunc(v) {
      v.beginPath();
      const _ = this.glyphInfo;
      if (_.length >= 1) {
        const S = _[0].p0;
        v.moveTo(S.x, S.y);
      }
      for (let S = 0; S < _.length; S++) {
        const C = _[S].p1;
        v.lineTo(C.x, C.y);
      }
      v.setAttr("lineWidth", this.fontSize()), v.setAttr("strokeStyle", this.colorKey), v.stroke();
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return r.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    setText(v) {
      return c.Text.prototype.setText.call(this, v);
    }
    _getContextFont() {
      return c.Text.prototype._getContextFont.call(this);
    }
    _getTextSize(v) {
      const S = this.dummyCanvas.getContext("2d");
      S.save(), S.font = this._getContextFont();
      const C = S.measureText(v);
      return S.restore(), {
        width: C.width,
        height: parseInt(`${this.fontSize()}`, 10)
      };
    }
    _setTextData() {
      const { width: v, height: _ } = this._getTextSize(this.attrs.text);
      if (this.textWidth = v, this.textHeight = _, this.glyphInfo = [], !this.attrs.data)
        return null;
      const S = this.letterSpacing(), C = this.align(), F = this.kerningFunc(), d = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * S, 0);
      let f = 0;
      C === "center" && (f = Math.max(0, this.pathLength / 2 - d / 2)), C === "right" && (f = Math.max(0, this.pathLength - d));
      const m = (0, c.stringToArray)(this.text());
      let E = f;
      for (let T = 0; T < m.length; T++) {
        const D = this._getPointAtLength(E);
        if (!D)
          return;
        let I = this._getTextSize(m[T]).width + S;
        if (m[T] === " " && C === "justify") {
          const P = this.text().split(" ").length - 1;
          I += (this.pathLength - d) / P;
        }
        const L = this._getPointAtLength(E + I);
        if (!L)
          return;
        const O = o.Path.getLineLength(D.x, D.y, L.x, L.y);
        let N = 0;
        if (F)
          try {
            N = F(m[T - 1], m[T]) * this.fontSize();
          } catch {
            N = 0;
          }
        D.x += N, L.x += N, this.textWidth += N;
        const H = o.Path.getPointOnLine(N + O / 2, D.x, D.y, L.x, L.y), y = Math.atan2(L.y - D.y, L.x - D.x);
        this.glyphInfo.push({
          transposeX: H.x,
          transposeY: H.y,
          text: m[T],
          rotation: y,
          p0: D,
          p1: L
        }), E += I;
      }
    }
    getSelfRect() {
      if (!this.glyphInfo.length)
        return {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      const v = [];
      this.glyphInfo.forEach(function(E) {
        v.push(E.p0.x), v.push(E.p0.y), v.push(E.p1.x), v.push(E.p1.y);
      });
      let _ = v[0] || 0, S = v[0] || 0, C = v[1] || 0, F = v[1] || 0, d, f;
      for (let E = 0; E < v.length / 2; E++)
        d = v[E * 2], f = v[E * 2 + 1], _ = Math.min(_, d), S = Math.max(S, d), C = Math.min(C, f), F = Math.max(F, f);
      const m = this.fontSize();
      return {
        x: _ - m / 2,
        y: C - m / 2,
        width: S - _ + m,
        height: F - C + m
      };
    }
    destroy() {
      return r.Util.releaseCanvas(this.dummyCanvas), super.destroy();
    }
  };
  return Hi.TextPath = w, w.prototype._fillFunc = p, w.prototype._strokeFunc = b, w.prototype._fillFuncHit = p, w.prototype._strokeFuncHit = b, w.prototype.className = "TextPath", w.prototype._attrsAffectingSize = ["text", "fontSize", "data"], (0, h._registerNode)(w), a.Factory.addGetterSetter(w, "data"), a.Factory.addGetterSetter(w, "fontFamily", "Arial"), a.Factory.addGetterSetter(w, "fontSize", 12, (0, s.getNumberValidator)()), a.Factory.addGetterSetter(w, "fontStyle", g), a.Factory.addGetterSetter(w, "align", "left"), a.Factory.addGetterSetter(w, "letterSpacing", 0, (0, s.getNumberValidator)()), a.Factory.addGetterSetter(w, "textBaseline", "middle"), a.Factory.addGetterSetter(w, "fontVariant", g), a.Factory.addGetterSetter(w, "text", l), a.Factory.addGetterSetter(w, "textDecoration", null), a.Factory.addGetterSetter(w, "kerningFunc", null), Hi;
}
var Wi = {}, Ad;
function C6() {
  if (Ad) return Wi;
  Ad = 1, Object.defineProperty(Wi, "__esModule", { value: !0 }), Wi.Transformer = void 0;
  const r = Kt(), a = Tt(), n = $t(), o = se(), c = J0(), s = Xh(), h = Rt(), l = Ot(), g = Rt(), p = "tr-konva", b = [
    "resizeEnabledChange",
    "rotateAnchorOffsetChange",
    "rotateEnabledChange",
    "enabledAnchorsChange",
    "anchorSizeChange",
    "borderEnabledChange",
    "borderStrokeChange",
    "borderStrokeWidthChange",
    "borderDashChange",
    "anchorStrokeChange",
    "anchorStrokeWidthChange",
    "anchorFillChange",
    "anchorCornerRadiusChange",
    "ignoreStrokeChange",
    "anchorStyleFuncChange"
  ].map((I) => I + `.${p}`).join(" "), w = "nodesRect", x = [
    "widthChange",
    "heightChange",
    "scaleXChange",
    "scaleYChange",
    "skewXChange",
    "skewYChange",
    "rotationChange",
    "offsetXChange",
    "offsetYChange",
    "transformsEnabledChange",
    "strokeWidthChange"
  ], v = {
    "top-left": -45,
    "top-center": 0,
    "top-right": 45,
    "middle-right": -90,
    "middle-left": 90,
    "bottom-left": -135,
    "bottom-center": 180,
    "bottom-right": 135
  }, _ = "ontouchstart" in h.Konva._global;
  function S(I, L, O) {
    if (I === "rotater")
      return O;
    L += r.Util.degToRad(v[I] || 0);
    const N = (r.Util.radToDeg(L) % 360 + 360) % 360;
    return r.Util._inRange(N, 315 + 22.5, 360) || r.Util._inRange(N, 0, 22.5) ? "ns-resize" : r.Util._inRange(N, 45 - 22.5, 45 + 22.5) ? "nesw-resize" : r.Util._inRange(N, 90 - 22.5, 90 + 22.5) ? "ew-resize" : r.Util._inRange(N, 135 - 22.5, 135 + 22.5) ? "nwse-resize" : r.Util._inRange(N, 180 - 22.5, 180 + 22.5) ? "ns-resize" : r.Util._inRange(N, 225 - 22.5, 225 + 22.5) ? "nesw-resize" : r.Util._inRange(N, 270 - 22.5, 270 + 22.5) ? "ew-resize" : r.Util._inRange(N, 315 - 22.5, 315 + 22.5) ? "nwse-resize" : (r.Util.error("Transformer has unknown angle for cursor detection: " + N), "pointer");
  }
  const C = [
    "top-left",
    "top-center",
    "top-right",
    "middle-right",
    "middle-left",
    "bottom-left",
    "bottom-center",
    "bottom-right"
  ];
  function F(I) {
    return {
      x: I.x + I.width / 2 * Math.cos(I.rotation) + I.height / 2 * Math.sin(-I.rotation),
      y: I.y + I.height / 2 * Math.cos(I.rotation) + I.width / 2 * Math.sin(I.rotation)
    };
  }
  function d(I, L, O) {
    const N = O.x + (I.x - O.x) * Math.cos(L) - (I.y - O.y) * Math.sin(L), H = O.y + (I.x - O.x) * Math.sin(L) + (I.y - O.y) * Math.cos(L);
    return {
      ...I,
      rotation: I.rotation + L,
      x: N,
      y: H
    };
  }
  function f(I, L) {
    const O = F(I);
    return d(I, L, O);
  }
  function m(I, L, O) {
    let N = L;
    for (let H = 0; H < I.length; H++) {
      const y = h.Konva.getAngle(I[H]), P = Math.abs(y - L) % (Math.PI * 2);
      Math.min(P, Math.PI * 2 - P) < O && (N = y);
    }
    return N;
  }
  let E = 0, T = class extends s.Group {
    constructor(L) {
      super(L), this._movingAnchorName = null, this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on(b, this.update), this.getNode() && this.update();
    }
    attachTo(L) {
      return this.setNode(L), this;
    }
    setNode(L) {
      return r.Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([L]);
    }
    getNode() {
      return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
      return p + this._id;
    }
    setNodes(L = []) {
      this._nodes && this._nodes.length && this.detach();
      const O = L.filter((H) => H.isAncestorOf(this) ? (r.Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
      return this._nodes = L = O, L.length === 1 && this.useSingleNodeRotation() ? this.rotation(L[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((H) => {
        const y = () => {
          this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
        }, P = H._attrsAffectingSize.map((A) => A + "Change." + this._getEventNamespace()).join(" ");
        H.on(P, y), H.on(x.map((A) => A + `.${this._getEventNamespace()}`).join(" "), y), H.on(`absoluteTransformChange.${this._getEventNamespace()}`, y), this._proxyDrag(H);
      }), this._resetTransformCache(), !!this.findOne(".top-left") && this.update(), this;
    }
    _proxyDrag(L) {
      let O;
      L.on(`dragstart.${this._getEventNamespace()}`, (N) => {
        O = L.getAbsolutePosition(), !this.isDragging() && L !== this.findOne(".back") && this.startDrag(N, !1);
      }), L.on(`dragmove.${this._getEventNamespace()}`, (N) => {
        if (!O)
          return;
        const H = L.getAbsolutePosition(), y = H.x - O.x, P = H.y - O.y;
        this.nodes().forEach((A) => {
          if (A === L || A.isDragging())
            return;
          const G = A.getAbsolutePosition();
          A.setAbsolutePosition({
            x: G.x + y,
            y: G.y + P
          }), A.startDrag(N);
        }), O = null;
      });
    }
    getNodes() {
      return this._nodes || [];
    }
    getActiveAnchor() {
      return this._movingAnchorName;
    }
    detach() {
      this._nodes && this._nodes.forEach((L) => {
        L.off("." + this._getEventNamespace());
      }), this._nodes = [], this._resetTransformCache();
    }
    _resetTransformCache() {
      this._clearCache(w), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
    }
    _getNodeRect() {
      return this._getCache(w, this.__getNodeRect);
    }
    __getNodeShape(L, O = this.rotation(), N) {
      const H = L.getClientRect({
        skipTransform: !0,
        skipShadow: !0,
        skipStroke: this.ignoreStroke()
      }), y = L.getAbsoluteScale(N), P = L.getAbsolutePosition(N), A = H.x * y.x - L.offsetX() * y.x, G = H.y * y.y - L.offsetY() * y.y, U = (h.Konva.getAngle(L.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), K = {
        x: P.x + A * Math.cos(U) + G * Math.sin(-U),
        y: P.y + G * Math.cos(U) + A * Math.sin(U),
        width: H.width * y.x,
        height: H.height * y.y,
        rotation: U
      };
      return d(K, -h.Konva.getAngle(O), {
        x: 0,
        y: 0
      });
    }
    __getNodeRect() {
      if (!this.getNode())
        return {
          x: -1e8,
          y: -1e8,
          width: 0,
          height: 0,
          rotation: 0
        };
      const O = [];
      this.nodes().map((U) => {
        const K = U.getClientRect({
          skipTransform: !0,
          skipShadow: !0,
          skipStroke: this.ignoreStroke()
        }), $ = [
          { x: K.x, y: K.y },
          { x: K.x + K.width, y: K.y },
          { x: K.x + K.width, y: K.y + K.height },
          { x: K.x, y: K.y + K.height }
        ], X = U.getAbsoluteTransform();
        $.forEach(function(Q) {
          const st = X.point(Q);
          O.push(st);
        });
      });
      const N = new r.Transform();
      N.rotate(-h.Konva.getAngle(this.rotation()));
      let H = 1 / 0, y = 1 / 0, P = -1 / 0, A = -1 / 0;
      O.forEach(function(U) {
        const K = N.point(U);
        H === void 0 && (H = P = K.x, y = A = K.y), H = Math.min(H, K.x), y = Math.min(y, K.y), P = Math.max(P, K.x), A = Math.max(A, K.y);
      }), N.invert();
      const G = N.point({ x: H, y });
      return {
        x: G.x,
        y: G.y,
        width: P - H,
        height: A - y,
        rotation: h.Konva.getAngle(this.rotation())
      };
    }
    getX() {
      return this._getNodeRect().x;
    }
    getY() {
      return this._getNodeRect().y;
    }
    getWidth() {
      return this._getNodeRect().width;
    }
    getHeight() {
      return this._getNodeRect().height;
    }
    _createElements() {
      this._createBack(), C.forEach((L) => {
        this._createAnchor(L);
      }), this._createAnchor("rotater");
    }
    _createAnchor(L) {
      const O = new c.Rect({
        stroke: "rgb(0, 161, 255)",
        fill: "white",
        strokeWidth: 1,
        name: L + " _anchor",
        dragDistance: 0,
        draggable: !0,
        hitStrokeWidth: _ ? 10 : "auto"
      }), N = this;
      O.on("mousedown touchstart", function(H) {
        N._handleMouseDown(H);
      }), O.on("dragstart", (H) => {
        O.stopDrag(), H.cancelBubble = !0;
      }), O.on("dragend", (H) => {
        H.cancelBubble = !0;
      }), O.on("mouseenter", () => {
        const H = h.Konva.getAngle(this.rotation()), y = this.rotateAnchorCursor(), P = S(L, H, y);
        O.getStage().content && (O.getStage().content.style.cursor = P), this._cursorChange = !0;
      }), O.on("mouseout", () => {
        O.getStage().content && (O.getStage().content.style.cursor = ""), this._cursorChange = !1;
      }), this.add(O);
    }
    _createBack() {
      const L = new o.Shape({
        name: "back",
        width: 0,
        height: 0,
        draggable: !0,
        sceneFunc(O, N) {
          const H = N.getParent(), y = H.padding();
          O.beginPath(), O.rect(-y, -y, N.width() + y * 2, N.height() + y * 2), O.moveTo(N.width() / 2, -y), H.rotateEnabled() && H.rotateLineVisible() && O.lineTo(N.width() / 2, -H.rotateAnchorOffset() * r.Util._sign(N.height()) - y), O.fillStrokeShape(N);
        },
        hitFunc: (O, N) => {
          if (!this.shouldOverdrawWholeArea())
            return;
          const H = this.padding();
          O.beginPath(), O.rect(-H, -H, N.width() + H * 2, N.height() + H * 2), O.fillStrokeShape(N);
        }
      });
      this.add(L), this._proxyDrag(L), L.on("dragstart", (O) => {
        O.cancelBubble = !0;
      }), L.on("dragmove", (O) => {
        O.cancelBubble = !0;
      }), L.on("dragend", (O) => {
        O.cancelBubble = !0;
      }), this.on("dragmove", (O) => {
        this.update();
      });
    }
    _handleMouseDown(L) {
      if (this._transforming)
        return;
      this._movingAnchorName = L.target.name().split(" ")[0];
      const O = this._getNodeRect(), N = O.width, H = O.height, y = Math.sqrt(Math.pow(N, 2) + Math.pow(H, 2));
      this.sin = Math.abs(H / y), this.cos = Math.abs(N / y), typeof window != "undefined" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
      const P = L.target.getAbsolutePosition(), A = L.target.getStage().getPointerPosition();
      this._anchorDragOffset = {
        x: A.x - P.x,
        y: A.y - P.y
      }, E++, this._fire("transformstart", { evt: L.evt, target: this.getNode() }), this._nodes.forEach((G) => {
        G._fire("transformstart", { evt: L.evt, target: G });
      });
    }
    _handleMouseMove(L) {
      let O, N, H;
      const y = this.findOne("." + this._movingAnchorName), P = y.getStage();
      P.setPointersPositions(L);
      const A = P.getPointerPosition();
      let G = {
        x: A.x - this._anchorDragOffset.x,
        y: A.y - this._anchorDragOffset.y
      };
      const U = y.getAbsolutePosition();
      this.anchorDragBoundFunc() && (G = this.anchorDragBoundFunc()(U, G, L)), y.setAbsolutePosition(G);
      const K = y.getAbsolutePosition();
      if (U.x === K.x && U.y === K.y)
        return;
      if (this._movingAnchorName === "rotater") {
        const et = this._getNodeRect();
        O = y.x() - et.width / 2, N = -y.y() + et.height / 2;
        let ut = Math.atan2(-N, O) + Math.PI / 2;
        et.height < 0 && (ut -= Math.PI);
        const gt = h.Konva.getAngle(this.rotation()) + ut, Lt = h.Konva.getAngle(this.rotationSnapTolerance()), mt = m(this.rotationSnaps(), gt, Lt) - et.rotation, ee = f(et, mt);
        this._fitNodesInto(ee, L);
        return;
      }
      const $ = this.shiftBehavior();
      let X;
      $ === "inverted" ? X = this.keepRatio() && !L.shiftKey : $ === "none" ? X = this.keepRatio() : X = this.keepRatio() || L.shiftKey;
      var ht = this.centeredScaling() || L.altKey;
      if (this._movingAnchorName === "top-left") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-right").x(),
            y: this.findOne(".bottom-right").y()
          };
          H = Math.sqrt(Math.pow(Q.x - y.x(), 2) + Math.pow(Q.y - y.y(), 2));
          var st = this.findOne(".top-left").x() > Q.x ? -1 : 1, Z = this.findOne(".top-left").y() > Q.y ? -1 : 1;
          O = H * this.cos * st, N = H * this.sin * Z, this.findOne(".top-left").x(Q.x - O), this.findOne(".top-left").y(Q.y - N);
        }
      } else if (this._movingAnchorName === "top-center")
        this.findOne(".top-left").y(y.y());
      else if (this._movingAnchorName === "top-right") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-left").x(),
            y: this.findOne(".bottom-left").y()
          };
          H = Math.sqrt(Math.pow(y.x() - Q.x, 2) + Math.pow(Q.y - y.y(), 2));
          var st = this.findOne(".top-right").x() < Q.x ? -1 : 1, Z = this.findOne(".top-right").y() > Q.y ? -1 : 1;
          O = H * this.cos * st, N = H * this.sin * Z, this.findOne(".top-right").x(Q.x + O), this.findOne(".top-right").y(Q.y - N);
        }
        var at = y.position();
        this.findOne(".top-left").y(at.y), this.findOne(".bottom-right").x(at.x);
      } else if (this._movingAnchorName === "middle-left")
        this.findOne(".top-left").x(y.x());
      else if (this._movingAnchorName === "middle-right")
        this.findOne(".bottom-right").x(y.x());
      else if (this._movingAnchorName === "bottom-left") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-right").x(),
            y: this.findOne(".top-right").y()
          };
          H = Math.sqrt(Math.pow(Q.x - y.x(), 2) + Math.pow(y.y() - Q.y, 2));
          var st = Q.x < y.x() ? -1 : 1, Z = y.y() < Q.y ? -1 : 1;
          O = H * this.cos * st, N = H * this.sin * Z, y.x(Q.x - O), y.y(Q.y + N);
        }
        at = y.position(), this.findOne(".top-left").x(at.x), this.findOne(".bottom-right").y(at.y);
      } else if (this._movingAnchorName === "bottom-center")
        this.findOne(".bottom-right").y(y.y());
      else if (this._movingAnchorName === "bottom-right") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-left").x(),
            y: this.findOne(".top-left").y()
          };
          H = Math.sqrt(Math.pow(y.x() - Q.x, 2) + Math.pow(y.y() - Q.y, 2));
          var st = this.findOne(".bottom-right").x() < Q.x ? -1 : 1, Z = this.findOne(".bottom-right").y() < Q.y ? -1 : 1;
          O = H * this.cos * st, N = H * this.sin * Z, this.findOne(".bottom-right").x(Q.x + O), this.findOne(".bottom-right").y(Q.y + N);
        }
      } else
        console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
      var ht = this.centeredScaling() || L.altKey;
      if (ht) {
        const et = this.findOne(".top-left"), ut = this.findOne(".bottom-right"), ft = et.x(), gt = et.y(), Lt = this.getWidth() - ut.x(), Et = this.getHeight() - ut.y();
        ut.move({
          x: -ft,
          y: -gt
        }), et.move({
          x: Lt,
          y: Et
        });
      }
      const ct = this.findOne(".top-left").getAbsolutePosition();
      O = ct.x, N = ct.y;
      const W = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), j = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
      this._fitNodesInto({
        x: O,
        y: N,
        width: W,
        height: j,
        rotation: h.Konva.getAngle(this.rotation())
      }, L);
    }
    _handleMouseUp(L) {
      this._removeEvents(L);
    }
    getAbsoluteTransform() {
      return this.getTransform();
    }
    _removeEvents(L) {
      var O;
      if (this._transforming) {
        this._transforming = !1, typeof window != "undefined" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
        const N = this.getNode();
        E--, this._fire("transformend", { evt: L, target: N }), (O = this.getLayer()) === null || O === void 0 || O.batchDraw(), N && this._nodes.forEach((H) => {
          var y;
          H._fire("transformend", { evt: L, target: H }), (y = H.getLayer()) === null || y === void 0 || y.batchDraw();
        }), this._movingAnchorName = null;
      }
    }
    _fitNodesInto(L, O) {
      const N = this._getNodeRect(), H = 1;
      if (r.Util._inRange(L.width, -this.padding() * 2 - H, H)) {
        this.update();
        return;
      }
      if (r.Util._inRange(L.height, -this.padding() * 2 - H, H)) {
        this.update();
        return;
      }
      const y = new r.Transform();
      if (y.rotate(h.Konva.getAngle(this.rotation())), this._movingAnchorName && L.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
        const X = y.point({
          x: -this.padding() * 2,
          y: 0
        });
        L.x += X.x, L.y += X.y, L.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y;
      } else if (this._movingAnchorName && L.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
        const X = y.point({
          x: this.padding() * 2,
          y: 0
        });
        this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, L.width += this.padding() * 2;
      }
      if (this._movingAnchorName && L.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
        const X = y.point({
          x: 0,
          y: -this.padding() * 2
        });
        L.x += X.x, L.y += X.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, L.height += this.padding() * 2;
      } else if (this._movingAnchorName && L.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
        const X = y.point({
          x: 0,
          y: this.padding() * 2
        });
        this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, L.height += this.padding() * 2;
      }
      if (this.boundBoxFunc()) {
        const X = this.boundBoxFunc()(N, L);
        X ? L = X : r.Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
      }
      const P = 1e7, A = new r.Transform();
      A.translate(N.x, N.y), A.rotate(N.rotation), A.scale(N.width / P, N.height / P);
      const G = new r.Transform(), U = L.width / P, K = L.height / P;
      this.flipEnabled() === !1 ? (G.translate(L.x, L.y), G.rotate(L.rotation), G.translate(L.width < 0 ? L.width : 0, L.height < 0 ? L.height : 0), G.scale(Math.abs(U), Math.abs(K))) : (G.translate(L.x, L.y), G.rotate(L.rotation), G.scale(U, K));
      const $ = G.multiply(A.invert());
      this._nodes.forEach((X) => {
        var Q;
        const st = X.getParent().getAbsoluteTransform(), Z = X.getTransform().copy();
        Z.translate(X.offsetX(), X.offsetY());
        const at = new r.Transform();
        at.multiply(st.copy().invert()).multiply($).multiply(st).multiply(Z);
        const ht = at.decompose();
        X.setAttrs(ht), (Q = X.getLayer()) === null || Q === void 0 || Q.batchDraw();
      }), this.rotation(r.Util._getRotation(L.rotation)), this._nodes.forEach((X) => {
        this._fire("transform", { evt: O, target: X }), X._fire("transform", { evt: O, target: X });
      }), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
    }
    forceUpdate() {
      this._resetTransformCache(), this.update();
    }
    _batchChangeChild(L, O) {
      this.findOne(L).setAttrs(O);
    }
    update() {
      var L;
      const O = this._getNodeRect();
      this.rotation(r.Util._getRotation(O.rotation));
      const N = O.width, H = O.height, y = this.enabledAnchors(), P = this.resizeEnabled(), A = this.padding(), G = this.anchorSize(), U = this.find("._anchor");
      U.forEach(($) => {
        $.setAttrs({
          width: G,
          height: G,
          offsetX: G / 2,
          offsetY: G / 2,
          stroke: this.anchorStroke(),
          strokeWidth: this.anchorStrokeWidth(),
          fill: this.anchorFill(),
          cornerRadius: this.anchorCornerRadius()
        });
      }), this._batchChangeChild(".top-left", {
        x: 0,
        y: 0,
        offsetX: G / 2 + A,
        offsetY: G / 2 + A,
        visible: P && y.indexOf("top-left") >= 0
      }), this._batchChangeChild(".top-center", {
        x: N / 2,
        y: 0,
        offsetY: G / 2 + A,
        visible: P && y.indexOf("top-center") >= 0
      }), this._batchChangeChild(".top-right", {
        x: N,
        y: 0,
        offsetX: G / 2 - A,
        offsetY: G / 2 + A,
        visible: P && y.indexOf("top-right") >= 0
      }), this._batchChangeChild(".middle-left", {
        x: 0,
        y: H / 2,
        offsetX: G / 2 + A,
        visible: P && y.indexOf("middle-left") >= 0
      }), this._batchChangeChild(".middle-right", {
        x: N,
        y: H / 2,
        offsetX: G / 2 - A,
        visible: P && y.indexOf("middle-right") >= 0
      }), this._batchChangeChild(".bottom-left", {
        x: 0,
        y: H,
        offsetX: G / 2 + A,
        offsetY: G / 2 - A,
        visible: P && y.indexOf("bottom-left") >= 0
      }), this._batchChangeChild(".bottom-center", {
        x: N / 2,
        y: H,
        offsetY: G / 2 - A,
        visible: P && y.indexOf("bottom-center") >= 0
      }), this._batchChangeChild(".bottom-right", {
        x: N,
        y: H,
        offsetX: G / 2 - A,
        offsetY: G / 2 - A,
        visible: P && y.indexOf("bottom-right") >= 0
      }), this._batchChangeChild(".rotater", {
        x: N / 2,
        y: -this.rotateAnchorOffset() * r.Util._sign(H) - A,
        visible: this.rotateEnabled()
      }), this._batchChangeChild(".back", {
        width: N,
        height: H,
        visible: this.borderEnabled(),
        stroke: this.borderStroke(),
        strokeWidth: this.borderStrokeWidth(),
        dash: this.borderDash(),
        x: 0,
        y: 0
      });
      const K = this.anchorStyleFunc();
      K && U.forEach(($) => {
        K($);
      }), (L = this.getLayer()) === null || L === void 0 || L.batchDraw();
    }
    isTransforming() {
      return this._transforming;
    }
    stopTransform() {
      if (this._transforming) {
        this._removeEvents();
        const L = this.findOne("." + this._movingAnchorName);
        L && L.stopDrag();
      }
    }
    destroy() {
      return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), s.Group.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
    }
    toObject() {
      return n.Node.prototype.toObject.call(this);
    }
    clone(L) {
      return n.Node.prototype.clone.call(this, L);
    }
    getClientRect() {
      return this.nodes().length > 0 ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 };
    }
  };
  Wi.Transformer = T, T.isTransforming = () => E > 0;
  function D(I) {
    return I instanceof Array || r.Util.warn("enabledAnchors value should be an array"), I instanceof Array && I.forEach(function(L) {
      C.indexOf(L) === -1 && r.Util.warn("Unknown anchor name: " + L + ". Available names are: " + C.join(", "));
    }), I || [];
  }
  return T.prototype.className = "Transformer", (0, g._registerNode)(T), a.Factory.addGetterSetter(T, "enabledAnchors", C, D), a.Factory.addGetterSetter(T, "flipEnabled", !0, (0, l.getBooleanValidator)()), a.Factory.addGetterSetter(T, "resizeEnabled", !0), a.Factory.addGetterSetter(T, "anchorSize", 10, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "rotateEnabled", !0), a.Factory.addGetterSetter(T, "rotateLineVisible", !0), a.Factory.addGetterSetter(T, "rotationSnaps", []), a.Factory.addGetterSetter(T, "rotateAnchorOffset", 50, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "rotateAnchorCursor", "crosshair"), a.Factory.addGetterSetter(T, "rotationSnapTolerance", 5, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderEnabled", !0), a.Factory.addGetterSetter(T, "anchorStroke", "rgb(0, 161, 255)"), a.Factory.addGetterSetter(T, "anchorStrokeWidth", 1, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "anchorFill", "white"), a.Factory.addGetterSetter(T, "anchorCornerRadius", 0, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderStroke", "rgb(0, 161, 255)"), a.Factory.addGetterSetter(T, "borderStrokeWidth", 1, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderDash"), a.Factory.addGetterSetter(T, "keepRatio", !0), a.Factory.addGetterSetter(T, "shiftBehavior", "default"), a.Factory.addGetterSetter(T, "centeredScaling", !1), a.Factory.addGetterSetter(T, "ignoreStroke", !1), a.Factory.addGetterSetter(T, "padding", 0, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "node"), a.Factory.addGetterSetter(T, "nodes"), a.Factory.addGetterSetter(T, "boundBoxFunc"), a.Factory.addGetterSetter(T, "anchorDragBoundFunc"), a.Factory.addGetterSetter(T, "anchorStyleFunc"), a.Factory.addGetterSetter(T, "shouldOverdrawWholeArea", !1), a.Factory.addGetterSetter(T, "useSingleNodeRotation", !0), a.Factory.backCompat(T, {
    lineEnabled: "borderEnabled",
    rotateHandlerOffset: "rotateAnchorOffset",
    enabledHandlers: "enabledAnchors"
  }), Wi;
}
var Vi = {}, Rd;
function x6() {
  if (Rd) return Vi;
  Rd = 1, Object.defineProperty(Vi, "__esModule", { value: !0 }), Vi.Wedge = void 0;
  const r = Tt(), a = se(), n = Rt(), o = Ot(), c = Rt();
  let s = class extends a.Shape {
    _sceneFunc(l) {
      l.beginPath(), l.arc(0, 0, this.radius(), 0, n.Konva.getAngle(this.angle()), this.clockwise()), l.lineTo(0, 0), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(l) {
      this.radius(l / 2);
    }
    setHeight(l) {
      this.radius(l / 2);
    }
  };
  return Vi.Wedge = s, s.prototype.className = "Wedge", s.prototype._centroid = !0, s.prototype._attrsAffectingSize = ["radius"], (0, c._registerNode)(s), r.Factory.addGetterSetter(s, "radius", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "angle", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "clockwise", !1), r.Factory.backCompat(s, {
    angleDeg: "angle",
    getAngleDeg: "getAngle",
    setAngleDeg: "setAngle"
  }), Vi;
}
var zi = {}, Td;
function E6() {
  if (Td) return zi;
  Td = 1, Object.defineProperty(zi, "__esModule", { value: !0 }), zi.Blur = void 0;
  const r = Tt(), a = $t(), n = Ot();
  function o() {
    this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
  const c = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
  ], s = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
  ];
  function h(g, p) {
    const b = g.data, w = g.width, x = g.height;
    let v, _, S, C, F, d, f, m, E, T, D, I, L, O, N, H, y, P, A, G, U, K, $, X, Q = p + p + 1, st = w - 1, Z = x - 1, at = p + 1, ht = at * (at + 1) / 2, ct = new o(), W = null, j = ct, et = null, ut = null, ft = c[p], gt = s[p];
    for (S = 1; S < Q; S++)
      j = j.next = new o(), S === at && (W = j);
    for (j.next = ct, f = d = 0, _ = 0; _ < x; _++) {
      for (H = y = P = A = m = E = T = D = 0, I = at * (G = b[d]), L = at * (U = b[d + 1]), O = at * (K = b[d + 2]), N = at * ($ = b[d + 3]), m += ht * G, E += ht * U, T += ht * K, D += ht * $, j = ct, S = 0; S < at; S++)
        j.r = G, j.g = U, j.b = K, j.a = $, j = j.next;
      for (S = 1; S < at; S++)
        C = d + ((st < S ? st : S) << 2), m += (j.r = G = b[C]) * (X = at - S), E += (j.g = U = b[C + 1]) * X, T += (j.b = K = b[C + 2]) * X, D += (j.a = $ = b[C + 3]) * X, H += G, y += U, P += K, A += $, j = j.next;
      for (et = ct, ut = W, v = 0; v < w; v++)
        b[d + 3] = $ = D * ft >> gt, $ !== 0 ? ($ = 255 / $, b[d] = (m * ft >> gt) * $, b[d + 1] = (E * ft >> gt) * $, b[d + 2] = (T * ft >> gt) * $) : b[d] = b[d + 1] = b[d + 2] = 0, m -= I, E -= L, T -= O, D -= N, I -= et.r, L -= et.g, O -= et.b, N -= et.a, C = f + ((C = v + p + 1) < st ? C : st) << 2, H += et.r = b[C], y += et.g = b[C + 1], P += et.b = b[C + 2], A += et.a = b[C + 3], m += H, E += y, T += P, D += A, et = et.next, I += G = ut.r, L += U = ut.g, O += K = ut.b, N += $ = ut.a, H -= G, y -= U, P -= K, A -= $, ut = ut.next, d += 4;
      f += w;
    }
    for (v = 0; v < w; v++) {
      for (y = P = A = H = E = T = D = m = 0, d = v << 2, I = at * (G = b[d]), L = at * (U = b[d + 1]), O = at * (K = b[d + 2]), N = at * ($ = b[d + 3]), m += ht * G, E += ht * U, T += ht * K, D += ht * $, j = ct, S = 0; S < at; S++)
        j.r = G, j.g = U, j.b = K, j.a = $, j = j.next;
      for (F = w, S = 1; S <= p; S++)
        d = F + v << 2, m += (j.r = G = b[d]) * (X = at - S), E += (j.g = U = b[d + 1]) * X, T += (j.b = K = b[d + 2]) * X, D += (j.a = $ = b[d + 3]) * X, H += G, y += U, P += K, A += $, j = j.next, S < Z && (F += w);
      for (d = v, et = ct, ut = W, _ = 0; _ < x; _++)
        C = d << 2, b[C + 3] = $ = D * ft >> gt, $ > 0 ? ($ = 255 / $, b[C] = (m * ft >> gt) * $, b[C + 1] = (E * ft >> gt) * $, b[C + 2] = (T * ft >> gt) * $) : b[C] = b[C + 1] = b[C + 2] = 0, m -= I, E -= L, T -= O, D -= N, I -= et.r, L -= et.g, O -= et.b, N -= et.a, C = v + ((C = _ + at) < Z ? C : Z) * w << 2, m += H += et.r = b[C], E += y += et.g = b[C + 1], T += P += et.b = b[C + 2], D += A += et.a = b[C + 3], et = et.next, I += G = ut.r, L += U = ut.g, O += K = ut.b, N += $ = ut.a, H -= G, y -= U, P -= K, A -= $, ut = ut.next, d += w;
    }
  }
  const l = function(p) {
    const b = Math.round(this.blurRadius());
    b > 0 && h(p, b);
  };
  return zi.Blur = l, r.Factory.addGetterSetter(a.Node, "blurRadius", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), zi;
}
var ji = {}, Pd;
function A6() {
  if (Pd) return ji;
  Pd = 1, Object.defineProperty(ji, "__esModule", { value: !0 }), ji.Brighten = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(c) {
    let s = this.brightness() * 255, h = c.data, l = h.length, g;
    for (g = 0; g < l; g += 4)
      h[g] += s, h[g + 1] += s, h[g + 2] += s;
  };
  return ji.Brighten = o, r.Factory.addGetterSetter(a.Node, "brightness", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), ji;
}
var Ki = {}, Fd;
function R6() {
  if (Fd) return Ki;
  Fd = 1, Object.defineProperty(Ki, "__esModule", { value: !0 }), Ki.Contrast = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(c) {
    const s = Math.pow((this.contrast() + 100) / 100, 2);
    let h = c.data, l = h.length, g = 150, p = 150, b = 150, w;
    for (w = 0; w < l; w += 4)
      g = h[w], p = h[w + 1], b = h[w + 2], g /= 255, g -= 0.5, g *= s, g += 0.5, g *= 255, p /= 255, p -= 0.5, p *= s, p += 0.5, p *= 255, b /= 255, b -= 0.5, b *= s, b += 0.5, b *= 255, g = g < 0 ? 0 : g > 255 ? 255 : g, p = p < 0 ? 0 : p > 255 ? 255 : p, b = b < 0 ? 0 : b > 255 ? 255 : b, h[w] = g, h[w + 1] = p, h[w + 2] = b;
  };
  return Ki.Contrast = o, r.Factory.addGetterSetter(a.Node, "contrast", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Ki;
}
var Yi = {}, Od;
function T6() {
  if (Od) return Yi;
  Od = 1, Object.defineProperty(Yi, "__esModule", { value: !0 }), Yi.Emboss = void 0;
  const r = Tt(), a = $t(), n = Kt(), o = Ot(), c = function(s) {
    let h = this.embossStrength() * 10, l = this.embossWhiteLevel() * 255, g = this.embossDirection(), p = this.embossBlend(), b = 0, w = 0, x = s.data, v = s.width, _ = s.height, S = v * 4, C = _;
    switch (g) {
      case "top-left":
        b = -1, w = -1;
        break;
      case "top":
        b = -1, w = 0;
        break;
      case "top-right":
        b = -1, w = 1;
        break;
      case "right":
        b = 0, w = 1;
        break;
      case "bottom-right":
        b = 1, w = 1;
        break;
      case "bottom":
        b = 1, w = 0;
        break;
      case "bottom-left":
        b = 1, w = -1;
        break;
      case "left":
        b = 0, w = -1;
        break;
      default:
        n.Util.error("Unknown emboss direction: " + g);
    }
    do {
      const F = (C - 1) * S;
      let d = b;
      C + d < 1 && (d = 0), C + d > _ && (d = 0);
      const f = (C - 1 + d) * v * 4;
      let m = v;
      do {
        const E = F + (m - 1) * 4;
        let T = w;
        m + T < 1 && (T = 0), m + T > v && (T = 0);
        const D = f + (m - 1 + T) * 4, I = x[E] - x[D], L = x[E + 1] - x[D + 1], O = x[E + 2] - x[D + 2];
        let N = I;
        const H = N > 0 ? N : -N, y = L > 0 ? L : -L, P = O > 0 ? O : -O;
        if (y > H && (N = L), P > H && (N = O), N *= h, p) {
          const A = x[E] + N, G = x[E + 1] + N, U = x[E + 2] + N;
          x[E] = A > 255 ? 255 : A < 0 ? 0 : A, x[E + 1] = G > 255 ? 255 : G < 0 ? 0 : G, x[E + 2] = U > 255 ? 255 : U < 0 ? 0 : U;
        } else {
          let A = l - N;
          A < 0 ? A = 0 : A > 255 && (A = 255), x[E] = x[E + 1] = x[E + 2] = A;
        }
      } while (--m);
    } while (--C);
  };
  return Yi.Emboss = c, r.Factory.addGetterSetter(a.Node, "embossStrength", 0.5, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossWhiteLevel", 0.5, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossDirection", "top-left", null, r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossBlend", !1, null, r.Factory.afterSetFilter), Yi;
}
var Xi = {}, kd;
function P6() {
  if (kd) return Xi;
  kd = 1, Object.defineProperty(Xi, "__esModule", { value: !0 }), Xi.Enhance = void 0;
  const r = Tt(), a = $t(), n = Ot();
  function o(s, h, l, g, p) {
    let b = l - h, w = p - g, x;
    return b === 0 ? g + w / 2 : w === 0 ? g : (x = (s - h) / b, x = w * x + g, x);
  }
  const c = function(s) {
    let h = s.data, l = h.length, g = h[0], p = g, b, w = h[1], x = w, v, _ = h[2], S = _, C, F;
    const d = this.enhance();
    if (d === 0)
      return;
    for (F = 0; F < l; F += 4)
      b = h[F + 0], b < g ? g = b : b > p && (p = b), v = h[F + 1], v < w ? w = v : v > x && (x = v), C = h[F + 2], C < _ ? _ = C : C > S && (S = C);
    p === g && (p = 255, g = 0), x === w && (x = 255, w = 0), S === _ && (S = 255, _ = 0);
    let f, m, E, T, D, I, L, O, N;
    for (d > 0 ? (m = p + d * (255 - p), E = g - d * (g - 0), D = x + d * (255 - x), I = w - d * (w - 0), O = S + d * (255 - S), N = _ - d * (_ - 0)) : (f = (p + g) * 0.5, m = p + d * (p - f), E = g + d * (g - f), T = (x + w) * 0.5, D = x + d * (x - T), I = w + d * (w - T), L = (S + _) * 0.5, O = S + d * (S - L), N = _ + d * (_ - L)), F = 0; F < l; F += 4)
      h[F + 0] = o(h[F + 0], g, p, E, m), h[F + 1] = o(h[F + 1], w, x, I, D), h[F + 2] = o(h[F + 2], _, S, N, O);
  };
  return Xi.Enhance = c, r.Factory.addGetterSetter(a.Node, "enhance", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Xi;
}
var $i = {}, Id;
function F6() {
  if (Id) return $i;
  Id = 1, Object.defineProperty($i, "__esModule", { value: !0 }), $i.Grayscale = void 0;
  const r = function(a) {
    let n = a.data, o = n.length, c, s;
    for (c = 0; c < o; c += 4)
      s = 0.34 * n[c] + 0.5 * n[c + 1] + 0.16 * n[c + 2], n[c] = s, n[c + 1] = s, n[c + 2] = s;
  };
  return $i.Grayscale = r, $i;
}
var Zi = {}, Ld;
function O6() {
  if (Ld) return Zi;
  Ld = 1, Object.defineProperty(Zi, "__esModule", { value: !0 }), Zi.HSL = void 0;
  const r = Tt(), a = $t(), n = Ot();
  r.Factory.addGetterSetter(a.Node, "hue", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "saturation", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "luminance", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter);
  const o = function(c) {
    let s = c.data, h = s.length, l = 1, g = Math.pow(2, this.saturation()), p = Math.abs(this.hue() + 360) % 360, b = this.luminance() * 127, w;
    const x = l * g * Math.cos(p * Math.PI / 180), v = l * g * Math.sin(p * Math.PI / 180), _ = 0.299 * l + 0.701 * x + 0.167 * v, S = 0.587 * l - 0.587 * x + 0.33 * v, C = 0.114 * l - 0.114 * x - 0.497 * v, F = 0.299 * l - 0.299 * x - 0.328 * v, d = 0.587 * l + 0.413 * x + 0.035 * v, f = 0.114 * l - 0.114 * x + 0.293 * v, m = 0.299 * l - 0.3 * x + 1.25 * v, E = 0.587 * l - 0.586 * x - 1.05 * v, T = 0.114 * l + 0.886 * x - 0.2 * v;
    let D, I, L, O;
    for (w = 0; w < h; w += 4)
      D = s[w + 0], I = s[w + 1], L = s[w + 2], O = s[w + 3], s[w + 0] = _ * D + S * I + C * L + b, s[w + 1] = F * D + d * I + f * L + b, s[w + 2] = m * D + E * I + T * L + b, s[w + 3] = O;
  };
  return Zi.HSL = o, Zi;
}
var Ji = {}, Md;
function k6() {
  if (Md) return Ji;
  Md = 1, Object.defineProperty(Ji, "__esModule", { value: !0 }), Ji.HSV = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(c) {
    const s = c.data, h = s.length, l = Math.pow(2, this.value()), g = Math.pow(2, this.saturation()), p = Math.abs(this.hue() + 360) % 360, b = l * g * Math.cos(p * Math.PI / 180), w = l * g * Math.sin(p * Math.PI / 180), x = 0.299 * l + 0.701 * b + 0.167 * w, v = 0.587 * l - 0.587 * b + 0.33 * w, _ = 0.114 * l - 0.114 * b - 0.497 * w, S = 0.299 * l - 0.299 * b - 0.328 * w, C = 0.587 * l + 0.413 * b + 0.035 * w, F = 0.114 * l - 0.114 * b + 0.293 * w, d = 0.299 * l - 0.3 * b + 1.25 * w, f = 0.587 * l - 0.586 * b - 1.05 * w, m = 0.114 * l + 0.886 * b - 0.2 * w;
    let E, T, D, I;
    for (let L = 0; L < h; L += 4)
      E = s[L + 0], T = s[L + 1], D = s[L + 2], I = s[L + 3], s[L + 0] = x * E + v * T + _ * D, s[L + 1] = S * E + C * T + F * D, s[L + 2] = d * E + f * T + m * D, s[L + 3] = I;
  };
  return Ji.HSV = o, r.Factory.addGetterSetter(a.Node, "hue", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "saturation", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "value", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Ji;
}
var Qi = {}, Nd;
function I6() {
  if (Nd) return Qi;
  Nd = 1, Object.defineProperty(Qi, "__esModule", { value: !0 }), Qi.Invert = void 0;
  const r = function(a) {
    let n = a.data, o = n.length, c;
    for (c = 0; c < o; c += 4)
      n[c] = 255 - n[c], n[c + 1] = 255 - n[c + 1], n[c + 2] = 255 - n[c + 2];
  };
  return Qi.Invert = r, Qi;
}
var tn = {}, Gd;
function L6() {
  if (Gd) return tn;
  Gd = 1, Object.defineProperty(tn, "__esModule", { value: !0 }), tn.Kaleidoscope = void 0;
  const r = Tt(), a = $t(), n = Kt(), o = Ot(), c = function(l, g, p) {
    let b = l.data, w = g.data, x = l.width, v = l.height, _ = p.polarCenterX || x / 2, S = p.polarCenterY || v / 2, C, F, d, f = 0, m = 0, E = 0, T = 0, D, I = Math.sqrt(_ * _ + S * S);
    F = x - _, d = v - S, D = Math.sqrt(F * F + d * d), I = D > I ? D : I;
    let L = v, O = x, N, H, y = 360 / O * Math.PI / 180, P, A;
    for (H = 0; H < O; H += 1)
      for (P = Math.sin(H * y), A = Math.cos(H * y), N = 0; N < L; N += 1)
        F = Math.floor(_ + I * N / L * A), d = Math.floor(S + I * N / L * P), C = (d * x + F) * 4, f = b[C + 0], m = b[C + 1], E = b[C + 2], T = b[C + 3], C = (H + N * x) * 4, w[C + 0] = f, w[C + 1] = m, w[C + 2] = E, w[C + 3] = T;
  }, s = function(l, g, p) {
    let b = l.data, w = g.data, x = l.width, v = l.height, _ = p.polarCenterX || x / 2, S = p.polarCenterY || v / 2, C, F, d, f, m, E = 0, T = 0, D = 0, I = 0, L, O = Math.sqrt(_ * _ + S * S);
    F = x - _, d = v - S, L = Math.sqrt(F * F + d * d), O = L > O ? L : O;
    let N = v, H = x, y, P, A = 0, G, U;
    for (F = 0; F < x; F += 1)
      for (d = 0; d < v; d += 1)
        f = F - _, m = d - S, y = Math.sqrt(f * f + m * m) * N / O, P = (Math.atan2(m, f) * 180 / Math.PI + 360 + A) % 360, P = P * H / 360, G = Math.floor(P), U = Math.floor(y), C = (U * x + G) * 4, E = b[C + 0], T = b[C + 1], D = b[C + 2], I = b[C + 3], C = (d * x + F) * 4, w[C + 0] = E, w[C + 1] = T, w[C + 2] = D, w[C + 3] = I;
  }, h = function(l) {
    const g = l.width, p = l.height;
    let b, w, x, v, _, S, C, F, d, f, m = Math.round(this.kaleidoscopePower());
    const E = Math.round(this.kaleidoscopeAngle()), T = Math.floor(g * (E % 360) / 360);
    if (m < 1)
      return;
    const D = n.Util.createCanvasElement();
    D.width = g, D.height = p;
    const I = D.getContext("2d").getImageData(0, 0, g, p);
    n.Util.releaseCanvas(D), c(l, I, {
      polarCenterX: g / 2,
      polarCenterY: p / 2
    });
    let L = g / Math.pow(2, m);
    for (; L <= 8; )
      L = L * 2, m -= 1;
    L = Math.ceil(L);
    let O = L, N = 0, H = O, y = 1;
    for (T + L > g && (N = O, H = 0, y = -1), w = 0; w < p; w += 1)
      for (b = N; b !== H; b += y)
        x = Math.round(b + T) % g, d = (g * w + x) * 4, _ = I.data[d + 0], S = I.data[d + 1], C = I.data[d + 2], F = I.data[d + 3], f = (g * w + b) * 4, I.data[f + 0] = _, I.data[f + 1] = S, I.data[f + 2] = C, I.data[f + 3] = F;
    for (w = 0; w < p; w += 1)
      for (O = Math.floor(L), v = 0; v < m; v += 1) {
        for (b = 0; b < O + 1; b += 1)
          d = (g * w + b) * 4, _ = I.data[d + 0], S = I.data[d + 1], C = I.data[d + 2], F = I.data[d + 3], f = (g * w + O * 2 - b - 1) * 4, I.data[f + 0] = _, I.data[f + 1] = S, I.data[f + 2] = C, I.data[f + 3] = F;
        O *= 2;
      }
    s(I, l, {});
  };
  return tn.Kaleidoscope = h, r.Factory.addGetterSetter(a.Node, "kaleidoscopePower", 2, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "kaleidoscopeAngle", 0, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), tn;
}
var en = {}, Dd;
function M6() {
  if (Dd) return en;
  Dd = 1, Object.defineProperty(en, "__esModule", { value: !0 }), en.Mask = void 0;
  const r = Tt(), a = $t(), n = Ot();
  function o(x, v, _) {
    let S = (_ * x.width + v) * 4;
    const C = [];
    return C.push(x.data[S++], x.data[S++], x.data[S++], x.data[S++]), C;
  }
  function c(x, v) {
    return Math.sqrt(Math.pow(x[0] - v[0], 2) + Math.pow(x[1] - v[1], 2) + Math.pow(x[2] - v[2], 2));
  }
  function s(x) {
    const v = [0, 0, 0];
    for (let _ = 0; _ < x.length; _++)
      v[0] += x[_][0], v[1] += x[_][1], v[2] += x[_][2];
    return v[0] /= x.length, v[1] /= x.length, v[2] /= x.length, v;
  }
  function h(x, v) {
    const _ = o(x, 0, 0), S = o(x, x.width - 1, 0), C = o(x, 0, x.height - 1), F = o(x, x.width - 1, x.height - 1), d = v || 10;
    if (c(_, S) < d && c(S, F) < d && c(F, C) < d && c(C, _) < d) {
      const f = s([S, _, F, C]), m = [];
      for (let E = 0; E < x.width * x.height; E++) {
        const T = c(f, [
          x.data[E * 4],
          x.data[E * 4 + 1],
          x.data[E * 4 + 2]
        ]);
        m[E] = T < d ? 0 : 255;
      }
      return m;
    }
  }
  function l(x, v) {
    for (let _ = 0; _ < x.width * x.height; _++)
      x.data[4 * _ + 3] = v[_];
  }
  function g(x, v, _) {
    const S = [1, 1, 1, 1, 0, 1, 1, 1, 1], C = Math.round(Math.sqrt(S.length)), F = Math.floor(C / 2), d = [];
    for (let f = 0; f < _; f++)
      for (let m = 0; m < v; m++) {
        const E = f * v + m;
        let T = 0;
        for (let D = 0; D < C; D++)
          for (let I = 0; I < C; I++) {
            const L = f + D - F, O = m + I - F;
            if (L >= 0 && L < _ && O >= 0 && O < v) {
              const N = L * v + O, H = S[D * C + I];
              T += x[N] * H;
            }
          }
        d[E] = T === 255 * 8 ? 255 : 0;
      }
    return d;
  }
  function p(x, v, _) {
    const S = [1, 1, 1, 1, 1, 1, 1, 1, 1], C = Math.round(Math.sqrt(S.length)), F = Math.floor(C / 2), d = [];
    for (let f = 0; f < _; f++)
      for (let m = 0; m < v; m++) {
        const E = f * v + m;
        let T = 0;
        for (let D = 0; D < C; D++)
          for (let I = 0; I < C; I++) {
            const L = f + D - F, O = m + I - F;
            if (L >= 0 && L < _ && O >= 0 && O < v) {
              const N = L * v + O, H = S[D * C + I];
              T += x[N] * H;
            }
          }
        d[E] = T >= 255 * 4 ? 255 : 0;
      }
    return d;
  }
  function b(x, v, _) {
    const S = [0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111], C = Math.round(Math.sqrt(S.length)), F = Math.floor(C / 2), d = [];
    for (let f = 0; f < _; f++)
      for (let m = 0; m < v; m++) {
        const E = f * v + m;
        let T = 0;
        for (let D = 0; D < C; D++)
          for (let I = 0; I < C; I++) {
            const L = f + D - F, O = m + I - F;
            if (L >= 0 && L < _ && O >= 0 && O < v) {
              const N = L * v + O, H = S[D * C + I];
              T += x[N] * H;
            }
          }
        d[E] = T;
      }
    return d;
  }
  const w = function(x) {
    let v = this.threshold(), _ = h(x, v);
    return _ && (_ = g(_, x.width, x.height), _ = p(_, x.width, x.height), _ = b(_, x.width, x.height), l(x, _)), x;
  };
  return en.Mask = w, r.Factory.addGetterSetter(a.Node, "threshold", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), en;
}
var rn = {}, Bd;
function N6() {
  if (Bd) return rn;
  Bd = 1, Object.defineProperty(rn, "__esModule", { value: !0 }), rn.Noise = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(c) {
    const s = this.noise() * 255, h = c.data, l = h.length, g = s / 2;
    for (let p = 0; p < l; p += 4)
      h[p + 0] += g - 2 * g * Math.random(), h[p + 1] += g - 2 * g * Math.random(), h[p + 2] += g - 2 * g * Math.random();
  };
  return rn.Noise = o, r.Factory.addGetterSetter(a.Node, "noise", 0.2, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), rn;
}
var nn = {}, Ud;
function G6() {
  if (Ud) return nn;
  Ud = 1, Object.defineProperty(nn, "__esModule", { value: !0 }), nn.Pixelate = void 0;
  const r = Tt(), a = Kt(), n = $t(), o = Ot(), c = function(s) {
    let h = Math.ceil(this.pixelSize()), l = s.width, g = s.height, p, b, w, x, v, _, S, C = Math.ceil(l / h), F = Math.ceil(g / h), d, f, m, E, T, D, I, L = s.data;
    if (h <= 0) {
      a.Util.error("pixelSize value can not be <= 0");
      return;
    }
    for (T = 0; T < C; T += 1)
      for (D = 0; D < F; D += 1) {
        for (x = 0, v = 0, _ = 0, S = 0, d = T * h, f = d + h, m = D * h, E = m + h, I = 0, p = d; p < f; p += 1)
          if (!(p >= l))
            for (b = m; b < E; b += 1)
              b >= g || (w = (l * b + p) * 4, x += L[w + 0], v += L[w + 1], _ += L[w + 2], S += L[w + 3], I += 1);
        for (x = x / I, v = v / I, _ = _ / I, S = S / I, p = d; p < f; p += 1)
          if (!(p >= l))
            for (b = m; b < E; b += 1)
              b >= g || (w = (l * b + p) * 4, L[w + 0] = x, L[w + 1] = v, L[w + 2] = _, L[w + 3] = S);
      }
  };
  return nn.Pixelate = c, r.Factory.addGetterSetter(n.Node, "pixelSize", 8, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), nn;
}
var an = {}, qd;
function D6() {
  if (qd) return an;
  qd = 1, Object.defineProperty(an, "__esModule", { value: !0 }), an.Posterize = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(c) {
    let s = Math.round(this.levels() * 254) + 1, h = c.data, l = h.length, g = 255 / s, p;
    for (p = 0; p < l; p += 1)
      h[p] = Math.floor(h[p] / g) * g;
  };
  return an.Posterize = o, r.Factory.addGetterSetter(a.Node, "levels", 0.5, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), an;
}
var sn = {}, Hd;
function B6() {
  if (Hd) return sn;
  Hd = 1, Object.defineProperty(sn, "__esModule", { value: !0 }), sn.RGB = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(c) {
    let s = c.data, h = s.length, l = this.red(), g = this.green(), p = this.blue(), b, w;
    for (b = 0; b < h; b += 4)
      w = (0.34 * s[b] + 0.5 * s[b + 1] + 0.16 * s[b + 2]) / 255, s[b] = w * l, s[b + 1] = w * g, s[b + 2] = w * p, s[b + 3] = s[b + 3];
  };
  return sn.RGB = o, r.Factory.addGetterSetter(a.Node, "red", 0, function(c) {
    return this._filterUpToDate = !1, c > 255 ? 255 : c < 0 ? 0 : Math.round(c);
  }), r.Factory.addGetterSetter(a.Node, "green", 0, function(c) {
    return this._filterUpToDate = !1, c > 255 ? 255 : c < 0 ? 0 : Math.round(c);
  }), r.Factory.addGetterSetter(a.Node, "blue", 0, n.RGBComponent, r.Factory.afterSetFilter), sn;
}
var on = {}, Wd;
function U6() {
  if (Wd) return on;
  Wd = 1, Object.defineProperty(on, "__esModule", { value: !0 }), on.RGBA = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(c) {
    const s = c.data, h = s.length, l = this.red(), g = this.green(), p = this.blue(), b = this.alpha();
    for (let w = 0; w < h; w += 4) {
      const x = 1 - b;
      s[w] = l * b + s[w] * x, s[w + 1] = g * b + s[w + 1] * x, s[w + 2] = p * b + s[w + 2] * x;
    }
  };
  return on.RGBA = o, r.Factory.addGetterSetter(a.Node, "red", 0, function(c) {
    return this._filterUpToDate = !1, c > 255 ? 255 : c < 0 ? 0 : Math.round(c);
  }), r.Factory.addGetterSetter(a.Node, "green", 0, function(c) {
    return this._filterUpToDate = !1, c > 255 ? 255 : c < 0 ? 0 : Math.round(c);
  }), r.Factory.addGetterSetter(a.Node, "blue", 0, n.RGBComponent, r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "alpha", 1, function(c) {
    return this._filterUpToDate = !1, c > 1 ? 1 : c < 0 ? 0 : c;
  }), on;
}
var hn = {}, Vd;
function q6() {
  if (Vd) return hn;
  Vd = 1, Object.defineProperty(hn, "__esModule", { value: !0 }), hn.Sepia = void 0;
  const r = function(a) {
    let n = a.data, o = n.length, c, s, h, l;
    for (c = 0; c < o; c += 4)
      s = n[c + 0], h = n[c + 1], l = n[c + 2], n[c + 0] = Math.min(255, s * 0.393 + h * 0.769 + l * 0.189), n[c + 1] = Math.min(255, s * 0.349 + h * 0.686 + l * 0.168), n[c + 2] = Math.min(255, s * 0.272 + h * 0.534 + l * 0.131);
  };
  return hn.Sepia = r, hn;
}
var ln = {}, zd;
function H6() {
  if (zd) return ln;
  zd = 1, Object.defineProperty(ln, "__esModule", { value: !0 }), ln.Solarize = void 0;
  const r = function(a) {
    const n = a.data, o = a.width, c = a.height, s = o * 4;
    let h = c;
    do {
      const l = (h - 1) * s;
      let g = o;
      do {
        const p = l + (g - 1) * 4;
        let b = n[p], w = n[p + 1], x = n[p + 2];
        b > 127 && (b = 255 - b), w > 127 && (w = 255 - w), x > 127 && (x = 255 - x), n[p] = b, n[p + 1] = w, n[p + 2] = x;
      } while (--g);
    } while (--h);
  };
  return ln.Solarize = r, ln;
}
var un = {}, jd;
function W6() {
  if (jd) return un;
  jd = 1, Object.defineProperty(un, "__esModule", { value: !0 }), un.Threshold = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(c) {
    const s = this.threshold() * 255, h = c.data, l = h.length;
    for (let g = 0; g < l; g += 1)
      h[g] = h[g] < s ? 0 : 255;
  };
  return un.Threshold = o, r.Factory.addGetterSetter(a.Node, "threshold", 0.5, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), un;
}
var Kd;
function V6() {
  if (Kd) return Ci;
  Kd = 1, Object.defineProperty(Ci, "__esModule", { value: !0 }), Ci.Konva = void 0;
  const r = u6(), a = c6(), n = f6(), o = g6(), c = p6(), s = _6(), h = v6(), l = $0(), g = Zh(), p = J0(), b = y6(), w = m6(), x = b6(), v = w6(), _ = Q0(), S = S6(), C = C6(), F = x6(), d = E6(), f = A6(), m = R6(), E = T6(), T = P6(), D = F6(), I = O6(), L = k6(), O = I6(), N = L6(), H = M6(), y = N6(), P = G6(), A = D6(), G = B6(), U = U6(), K = q6(), $ = H6(), X = W6();
  return Ci.Konva = r.Konva.Util._assign(r.Konva, {
    Arc: a.Arc,
    Arrow: n.Arrow,
    Circle: o.Circle,
    Ellipse: c.Ellipse,
    Image: s.Image,
    Label: h.Label,
    Tag: h.Tag,
    Line: l.Line,
    Path: g.Path,
    Rect: p.Rect,
    RegularPolygon: b.RegularPolygon,
    Ring: w.Ring,
    Sprite: x.Sprite,
    Star: v.Star,
    Text: _.Text,
    TextPath: S.TextPath,
    Transformer: C.Transformer,
    Wedge: F.Wedge,
    Filters: {
      Blur: d.Blur,
      Brighten: f.Brighten,
      Contrast: m.Contrast,
      Emboss: E.Emboss,
      Enhance: T.Enhance,
      Grayscale: D.Grayscale,
      HSL: I.HSL,
      HSV: L.HSV,
      Invert: O.Invert,
      Kaleidoscope: N.Kaleidoscope,
      Mask: H.Mask,
      Noise: y.Noise,
      Pixelate: P.Pixelate,
      Posterize: A.Posterize,
      RGB: G.RGB,
      RGBA: U.RGBA,
      Sepia: K.Sepia,
      Solarize: $.Solarize,
      Threshold: X.Threshold
    }
  }), Ci;
}
var z6 = fa.exports, Yd;
function j6() {
  if (Yd) return fa.exports;
  Yd = 1, Object.defineProperty(z6, "__esModule", { value: !0 });
  const r = V6();
  return fa.exports = r.Konva, fa.exports;
}
var K6 = j6();
const yt = /* @__PURE__ */ yn(K6);
var Y6 = j0();
const X6 = /* @__PURE__ */ yn(Y6);
var co, Xd;
function $6() {
  if (Xd) return co;
  Xd = 1;
  function r() {
    this.__data__ = [], this.size = 0;
  }
  return co = r, co;
}
var fo, $d;
function t1() {
  if ($d) return fo;
  $d = 1;
  function r(a, n) {
    return a === n || a !== a && n !== n;
  }
  return fo = r, fo;
}
var go, Zd;
function Sa() {
  if (Zd) return go;
  Zd = 1;
  var r = t1();
  function a(n, o) {
    for (var c = n.length; c--; )
      if (r(n[c][0], o))
        return c;
    return -1;
  }
  return go = a, go;
}
var po, Jd;
function Z6() {
  if (Jd) return po;
  Jd = 1;
  var r = Sa(), a = Array.prototype, n = a.splice;
  function o(c) {
    var s = this.__data__, h = r(s, c);
    if (h < 0)
      return !1;
    var l = s.length - 1;
    return h == l ? s.pop() : n.call(s, h, 1), --this.size, !0;
  }
  return po = o, po;
}
var _o, Qd;
function J6() {
  if (Qd) return _o;
  Qd = 1;
  var r = Sa();
  function a(n) {
    var o = this.__data__, c = r(o, n);
    return c < 0 ? void 0 : o[c][1];
  }
  return _o = a, _o;
}
var vo, tf;
function Q6() {
  if (tf) return vo;
  tf = 1;
  var r = Sa();
  function a(n) {
    return r(this.__data__, n) > -1;
  }
  return vo = a, vo;
}
var yo, ef;
function tv() {
  if (ef) return yo;
  ef = 1;
  var r = Sa();
  function a(n, o) {
    var c = this.__data__, s = r(c, n);
    return s < 0 ? (++this.size, c.push([n, o])) : c[s][1] = o, this;
  }
  return yo = a, yo;
}
var mo, rf;
function Ca() {
  if (rf) return mo;
  rf = 1;
  var r = $6(), a = Z6(), n = J6(), o = Q6(), c = tv();
  function s(h) {
    var l = -1, g = h == null ? 0 : h.length;
    for (this.clear(); ++l < g; ) {
      var p = h[l];
      this.set(p[0], p[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = a, s.prototype.get = n, s.prototype.has = o, s.prototype.set = c, mo = s, mo;
}
var bo, nf;
function ev() {
  if (nf) return bo;
  nf = 1;
  var r = Ca();
  function a() {
    this.__data__ = new r(), this.size = 0;
  }
  return bo = a, bo;
}
var wo, af;
function rv() {
  if (af) return wo;
  af = 1;
  function r(a) {
    var n = this.__data__, o = n.delete(a);
    return this.size = n.size, o;
  }
  return wo = r, wo;
}
var So, sf;
function iv() {
  if (sf) return So;
  sf = 1;
  function r(a) {
    return this.__data__.get(a);
  }
  return So = r, So;
}
var Co, of;
function nv() {
  if (of) return Co;
  of = 1;
  function r(a) {
    return this.__data__.has(a);
  }
  return Co = r, Co;
}
var xo, hf;
function e1() {
  if (hf) return xo;
  hf = 1;
  var r = bn(), a = mn(), n = "[object AsyncFunction]", o = "[object Function]", c = "[object GeneratorFunction]", s = "[object Proxy]";
  function h(l) {
    if (!a(l))
      return !1;
    var g = r(l);
    return g == o || g == c || g == n || g == s;
  }
  return xo = h, xo;
}
var Eo, lf;
function av() {
  if (lf) return Eo;
  lf = 1;
  var r = $e(), a = r["__core-js_shared__"];
  return Eo = a, Eo;
}
var Ao, uf;
function sv() {
  if (uf) return Ao;
  uf = 1;
  var r = av(), a = function() {
    var o = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return o ? "Symbol(src)_1." + o : "";
  }();
  function n(o) {
    return !!a && a in o;
  }
  return Ao = n, Ao;
}
var Ro, cf;
function r1() {
  if (cf) return Ro;
  cf = 1;
  var r = Function.prototype, a = r.toString;
  function n(o) {
    if (o != null) {
      try {
        return a.call(o);
      } catch {
      }
      try {
        return o + "";
      } catch {
      }
    }
    return "";
  }
  return Ro = n, Ro;
}
var To, df;
function ov() {
  if (df) return To;
  df = 1;
  var r = e1(), a = sv(), n = mn(), o = r1(), c = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, h = Function.prototype, l = Object.prototype, g = h.toString, p = l.hasOwnProperty, b = RegExp(
    "^" + g.call(p).replace(c, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function w(x) {
    if (!n(x) || a(x))
      return !1;
    var v = r(x) ? b : s;
    return v.test(o(x));
  }
  return To = w, To;
}
var Po, ff;
function hv() {
  if (ff) return Po;
  ff = 1;
  function r(a, n) {
    return a == null ? void 0 : a[n];
  }
  return Po = r, Po;
}
var Fo, gf;
function ai() {
  if (gf) return Fo;
  gf = 1;
  var r = ov(), a = hv();
  function n(o, c) {
    var s = a(o, c);
    return r(s) ? s : void 0;
  }
  return Fo = n, Fo;
}
var Oo, pf;
function Jh() {
  if (pf) return Oo;
  pf = 1;
  var r = ai(), a = $e(), n = r(a, "Map");
  return Oo = n, Oo;
}
var ko, _f;
function xa() {
  if (_f) return ko;
  _f = 1;
  var r = ai(), a = r(Object, "create");
  return ko = a, ko;
}
var Io, vf;
function lv() {
  if (vf) return Io;
  vf = 1;
  var r = xa();
  function a() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  return Io = a, Io;
}
var Lo, yf;
function uv() {
  if (yf) return Lo;
  yf = 1;
  function r(a) {
    var n = this.has(a) && delete this.__data__[a];
    return this.size -= n ? 1 : 0, n;
  }
  return Lo = r, Lo;
}
var Mo, mf;
function cv() {
  if (mf) return Mo;
  mf = 1;
  var r = xa(), a = "__lodash_hash_undefined__", n = Object.prototype, o = n.hasOwnProperty;
  function c(s) {
    var h = this.__data__;
    if (r) {
      var l = h[s];
      return l === a ? void 0 : l;
    }
    return o.call(h, s) ? h[s] : void 0;
  }
  return Mo = c, Mo;
}
var No, bf;
function dv() {
  if (bf) return No;
  bf = 1;
  var r = xa(), a = Object.prototype, n = a.hasOwnProperty;
  function o(c) {
    var s = this.__data__;
    return r ? s[c] !== void 0 : n.call(s, c);
  }
  return No = o, No;
}
var Go, wf;
function fv() {
  if (wf) return Go;
  wf = 1;
  var r = xa(), a = "__lodash_hash_undefined__";
  function n(o, c) {
    var s = this.__data__;
    return this.size += this.has(o) ? 0 : 1, s[o] = r && c === void 0 ? a : c, this;
  }
  return Go = n, Go;
}
var Do, Sf;
function gv() {
  if (Sf) return Do;
  Sf = 1;
  var r = lv(), a = uv(), n = cv(), o = dv(), c = fv();
  function s(h) {
    var l = -1, g = h == null ? 0 : h.length;
    for (this.clear(); ++l < g; ) {
      var p = h[l];
      this.set(p[0], p[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = a, s.prototype.get = n, s.prototype.has = o, s.prototype.set = c, Do = s, Do;
}
var Bo, Cf;
function pv() {
  if (Cf) return Bo;
  Cf = 1;
  var r = gv(), a = Ca(), n = Jh();
  function o() {
    this.size = 0, this.__data__ = {
      hash: new r(),
      map: new (n || a)(),
      string: new r()
    };
  }
  return Bo = o, Bo;
}
var Uo, xf;
function _v() {
  if (xf) return Uo;
  xf = 1;
  function r(a) {
    var n = typeof a;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? a !== "__proto__" : a === null;
  }
  return Uo = r, Uo;
}
var qo, Ef;
function Ea() {
  if (Ef) return qo;
  Ef = 1;
  var r = _v();
  function a(n, o) {
    var c = n.__data__;
    return r(o) ? c[typeof o == "string" ? "string" : "hash"] : c.map;
  }
  return qo = a, qo;
}
var Ho, Af;
function vv() {
  if (Af) return Ho;
  Af = 1;
  var r = Ea();
  function a(n) {
    var o = r(this, n).delete(n);
    return this.size -= o ? 1 : 0, o;
  }
  return Ho = a, Ho;
}
var Wo, Rf;
function yv() {
  if (Rf) return Wo;
  Rf = 1;
  var r = Ea();
  function a(n) {
    return r(this, n).get(n);
  }
  return Wo = a, Wo;
}
var Vo, Tf;
function mv() {
  if (Tf) return Vo;
  Tf = 1;
  var r = Ea();
  function a(n) {
    return r(this, n).has(n);
  }
  return Vo = a, Vo;
}
var zo, Pf;
function bv() {
  if (Pf) return zo;
  Pf = 1;
  var r = Ea();
  function a(n, o) {
    var c = r(this, n), s = c.size;
    return c.set(n, o), this.size += c.size == s ? 0 : 1, this;
  }
  return zo = a, zo;
}
var jo, Ff;
function i1() {
  if (Ff) return jo;
  Ff = 1;
  var r = pv(), a = vv(), n = yv(), o = mv(), c = bv();
  function s(h) {
    var l = -1, g = h == null ? 0 : h.length;
    for (this.clear(); ++l < g; ) {
      var p = h[l];
      this.set(p[0], p[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = a, s.prototype.get = n, s.prototype.has = o, s.prototype.set = c, jo = s, jo;
}
var Ko, Of;
function wv() {
  if (Of) return Ko;
  Of = 1;
  var r = Ca(), a = Jh(), n = i1(), o = 200;
  function c(s, h) {
    var l = this.__data__;
    if (l instanceof r) {
      var g = l.__data__;
      if (!a || g.length < o - 1)
        return g.push([s, h]), this.size = ++l.size, this;
      l = this.__data__ = new n(g);
    }
    return l.set(s, h), this.size = l.size, this;
  }
  return Ko = c, Ko;
}
var Yo, kf;
function Sv() {
  if (kf) return Yo;
  kf = 1;
  var r = Ca(), a = ev(), n = rv(), o = iv(), c = nv(), s = wv();
  function h(l) {
    var g = this.__data__ = new r(l);
    this.size = g.size;
  }
  return h.prototype.clear = a, h.prototype.delete = n, h.prototype.get = o, h.prototype.has = c, h.prototype.set = s, Yo = h, Yo;
}
var Xo, If;
function Cv() {
  if (If) return Xo;
  If = 1;
  var r = "__lodash_hash_undefined__";
  function a(n) {
    return this.__data__.set(n, r), this;
  }
  return Xo = a, Xo;
}
var $o, Lf;
function xv() {
  if (Lf) return $o;
  Lf = 1;
  function r(a) {
    return this.__data__.has(a);
  }
  return $o = r, $o;
}
var Zo, Mf;
function Ev() {
  if (Mf) return Zo;
  Mf = 1;
  var r = i1(), a = Cv(), n = xv();
  function o(c) {
    var s = -1, h = c == null ? 0 : c.length;
    for (this.__data__ = new r(); ++s < h; )
      this.add(c[s]);
  }
  return o.prototype.add = o.prototype.push = a, o.prototype.has = n, Zo = o, Zo;
}
var Jo, Nf;
function Av() {
  if (Nf) return Jo;
  Nf = 1;
  function r(a, n) {
    for (var o = -1, c = a == null ? 0 : a.length; ++o < c; )
      if (n(a[o], o, a))
        return !0;
    return !1;
  }
  return Jo = r, Jo;
}
var Qo, Gf;
function Rv() {
  if (Gf) return Qo;
  Gf = 1;
  function r(a, n) {
    return a.has(n);
  }
  return Qo = r, Qo;
}
var th, Df;
function n1() {
  if (Df) return th;
  Df = 1;
  var r = Ev(), a = Av(), n = Rv(), o = 1, c = 2;
  function s(h, l, g, p, b, w) {
    var x = g & o, v = h.length, _ = l.length;
    if (v != _ && !(x && _ > v))
      return !1;
    var S = w.get(h), C = w.get(l);
    if (S && C)
      return S == l && C == h;
    var F = -1, d = !0, f = g & c ? new r() : void 0;
    for (w.set(h, l), w.set(l, h); ++F < v; ) {
      var m = h[F], E = l[F];
      if (p)
        var T = x ? p(E, m, F, l, h, w) : p(m, E, F, h, l, w);
      if (T !== void 0) {
        if (T)
          continue;
        d = !1;
        break;
      }
      if (f) {
        if (!a(l, function(D, I) {
          if (!n(f, I) && (m === D || b(m, D, g, p, w)))
            return f.push(I);
        })) {
          d = !1;
          break;
        }
      } else if (!(m === E || b(m, E, g, p, w))) {
        d = !1;
        break;
      }
    }
    return w.delete(h), w.delete(l), d;
  }
  return th = s, th;
}
var eh, Bf;
function Tv() {
  if (Bf) return eh;
  Bf = 1;
  var r = $e(), a = r.Uint8Array;
  return eh = a, eh;
}
var rh, Uf;
function Pv() {
  if (Uf) return rh;
  Uf = 1;
  function r(a) {
    var n = -1, o = Array(a.size);
    return a.forEach(function(c, s) {
      o[++n] = [s, c];
    }), o;
  }
  return rh = r, rh;
}
var ih, qf;
function Fv() {
  if (qf) return ih;
  qf = 1;
  function r(a) {
    var n = -1, o = Array(a.size);
    return a.forEach(function(c) {
      o[++n] = c;
    }), o;
  }
  return ih = r, ih;
}
var nh, Hf;
function Ov() {
  if (Hf) return nh;
  Hf = 1;
  var r = ma(), a = Tv(), n = t1(), o = n1(), c = Pv(), s = Fv(), h = 1, l = 2, g = "[object Boolean]", p = "[object Date]", b = "[object Error]", w = "[object Map]", x = "[object Number]", v = "[object RegExp]", _ = "[object Set]", S = "[object String]", C = "[object Symbol]", F = "[object ArrayBuffer]", d = "[object DataView]", f = r ? r.prototype : void 0, m = f ? f.valueOf : void 0;
  function E(T, D, I, L, O, N, H) {
    switch (I) {
      case d:
        if (T.byteLength != D.byteLength || T.byteOffset != D.byteOffset)
          return !1;
        T = T.buffer, D = D.buffer;
      case F:
        return !(T.byteLength != D.byteLength || !N(new a(T), new a(D)));
      case g:
      case p:
      case x:
        return n(+T, +D);
      case b:
        return T.name == D.name && T.message == D.message;
      case v:
      case S:
        return T == D + "";
      case w:
        var y = c;
      case _:
        var P = L & h;
        if (y || (y = s), T.size != D.size && !P)
          return !1;
        var A = H.get(T);
        if (A)
          return A == D;
        L |= l, H.set(T, D);
        var G = o(y(T), y(D), L, O, N, H);
        return H.delete(T), G;
      case C:
        if (m)
          return m.call(T) == m.call(D);
    }
    return !1;
  }
  return nh = E, nh;
}
var ah, Wf;
function kv() {
  if (Wf) return ah;
  Wf = 1;
  function r(a, n) {
    for (var o = -1, c = n.length, s = a.length; ++o < c; )
      a[s + o] = n[o];
    return a;
  }
  return ah = r, ah;
}
var sh, Vf;
function Aa() {
  if (Vf) return sh;
  Vf = 1;
  var r = Array.isArray;
  return sh = r, sh;
}
var oh, zf;
function Iv() {
  if (zf) return oh;
  zf = 1;
  var r = kv(), a = Aa();
  function n(o, c, s) {
    var h = c(o);
    return a(o) ? h : r(h, s(o));
  }
  return oh = n, oh;
}
var hh, jf;
function Lv() {
  if (jf) return hh;
  jf = 1;
  function r(a, n) {
    for (var o = -1, c = a == null ? 0 : a.length, s = 0, h = []; ++o < c; ) {
      var l = a[o];
      n(l, o, a) && (h[s++] = l);
    }
    return h;
  }
  return hh = r, hh;
}
var lh, Kf;
function Mv() {
  if (Kf) return lh;
  Kf = 1;
  function r() {
    return [];
  }
  return lh = r, lh;
}
var uh, Yf;
function Nv() {
  if (Yf) return uh;
  Yf = 1;
  var r = Lv(), a = Mv(), n = Object.prototype, o = n.propertyIsEnumerable, c = Object.getOwnPropertySymbols, s = c ? function(h) {
    return h == null ? [] : (h = Object(h), r(c(h), function(l) {
      return o.call(h, l);
    }));
  } : a;
  return uh = s, uh;
}
var ch, Xf;
function Gv() {
  if (Xf) return ch;
  Xf = 1;
  function r(a, n) {
    for (var o = -1, c = Array(a); ++o < a; )
      c[o] = n(o);
    return c;
  }
  return ch = r, ch;
}
var dh, $f;
function Dv() {
  if ($f) return dh;
  $f = 1;
  var r = bn(), a = wn(), n = "[object Arguments]";
  function o(c) {
    return a(c) && r(c) == n;
  }
  return dh = o, dh;
}
var fh, Zf;
function Bv() {
  if (Zf) return fh;
  Zf = 1;
  var r = Dv(), a = wn(), n = Object.prototype, o = n.hasOwnProperty, c = n.propertyIsEnumerable, s = r(/* @__PURE__ */ function() {
    return arguments;
  }()) ? r : function(h) {
    return a(h) && o.call(h, "callee") && !c.call(h, "callee");
  };
  return fh = s, fh;
}
var cn = { exports: {} }, gh, Jf;
function Uv() {
  if (Jf) return gh;
  Jf = 1;
  function r() {
    return !1;
  }
  return gh = r, gh;
}
cn.exports;
var Qf;
function a1() {
  return Qf || (Qf = 1, function(r, a) {
    var n = $e(), o = Uv(), c = a && !a.nodeType && a, s = c && !0 && r && !r.nodeType && r, h = s && s.exports === c, l = h ? n.Buffer : void 0, g = l ? l.isBuffer : void 0, p = g || o;
    r.exports = p;
  }(cn, cn.exports)), cn.exports;
}
var ph, t0;
function qv() {
  if (t0) return ph;
  t0 = 1;
  var r = 9007199254740991, a = /^(?:0|[1-9]\d*)$/;
  function n(o, c) {
    var s = typeof o;
    return c = c == null ? r : c, !!c && (s == "number" || s != "symbol" && a.test(o)) && o > -1 && o % 1 == 0 && o < c;
  }
  return ph = n, ph;
}
var _h, e0;
function s1() {
  if (e0) return _h;
  e0 = 1;
  var r = 9007199254740991;
  function a(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= r;
  }
  return _h = a, _h;
}
var vh, r0;
function Hv() {
  if (r0) return vh;
  r0 = 1;
  var r = bn(), a = s1(), n = wn(), o = "[object Arguments]", c = "[object Array]", s = "[object Boolean]", h = "[object Date]", l = "[object Error]", g = "[object Function]", p = "[object Map]", b = "[object Number]", w = "[object Object]", x = "[object RegExp]", v = "[object Set]", _ = "[object String]", S = "[object WeakMap]", C = "[object ArrayBuffer]", F = "[object DataView]", d = "[object Float32Array]", f = "[object Float64Array]", m = "[object Int8Array]", E = "[object Int16Array]", T = "[object Int32Array]", D = "[object Uint8Array]", I = "[object Uint8ClampedArray]", L = "[object Uint16Array]", O = "[object Uint32Array]", N = {};
  N[d] = N[f] = N[m] = N[E] = N[T] = N[D] = N[I] = N[L] = N[O] = !0, N[o] = N[c] = N[C] = N[s] = N[F] = N[h] = N[l] = N[g] = N[p] = N[b] = N[w] = N[x] = N[v] = N[_] = N[S] = !1;
  function H(y) {
    return n(y) && a(y.length) && !!N[r(y)];
  }
  return vh = H, vh;
}
var yh, i0;
function Wv() {
  if (i0) return yh;
  i0 = 1;
  function r(a) {
    return function(n) {
      return a(n);
    };
  }
  return yh = r, yh;
}
var dn = { exports: {} };
dn.exports;
var n0;
function Vv() {
  return n0 || (n0 = 1, function(r, a) {
    var n = V0(), o = a && !a.nodeType && a, c = o && !0 && r && !r.nodeType && r, s = c && c.exports === o, h = s && n.process, l = function() {
      try {
        var g = c && c.require && c.require("util").types;
        return g || h && h.binding && h.binding("util");
      } catch {
      }
    }();
    r.exports = l;
  }(dn, dn.exports)), dn.exports;
}
var mh, a0;
function o1() {
  if (a0) return mh;
  a0 = 1;
  var r = Hv(), a = Wv(), n = Vv(), o = n && n.isTypedArray, c = o ? a(o) : r;
  return mh = c, mh;
}
var bh, s0;
function zv() {
  if (s0) return bh;
  s0 = 1;
  var r = Gv(), a = Bv(), n = Aa(), o = a1(), c = qv(), s = o1(), h = Object.prototype, l = h.hasOwnProperty;
  function g(p, b) {
    var w = n(p), x = !w && a(p), v = !w && !x && o(p), _ = !w && !x && !v && s(p), S = w || x || v || _, C = S ? r(p.length, String) : [], F = C.length;
    for (var d in p)
      (b || l.call(p, d)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      _ && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
      c(d, F))) && C.push(d);
    return C;
  }
  return bh = g, bh;
}
var wh, o0;
function jv() {
  if (o0) return wh;
  o0 = 1;
  var r = Object.prototype;
  function a(n) {
    var o = n && n.constructor, c = typeof o == "function" && o.prototype || r;
    return n === c;
  }
  return wh = a, wh;
}
var Sh, h0;
function Kv() {
  if (h0) return Sh;
  h0 = 1;
  function r(a, n) {
    return function(o) {
      return a(n(o));
    };
  }
  return Sh = r, Sh;
}
var Ch, l0;
function Yv() {
  if (l0) return Ch;
  l0 = 1;
  var r = Kv(), a = r(Object.keys, Object);
  return Ch = a, Ch;
}
var xh, u0;
function Xv() {
  if (u0) return xh;
  u0 = 1;
  var r = jv(), a = Yv(), n = Object.prototype, o = n.hasOwnProperty;
  function c(s) {
    if (!r(s))
      return a(s);
    var h = [];
    for (var l in Object(s))
      o.call(s, l) && l != "constructor" && h.push(l);
    return h;
  }
  return xh = c, xh;
}
var Eh, c0;
function $v() {
  if (c0) return Eh;
  c0 = 1;
  var r = e1(), a = s1();
  function n(o) {
    return o != null && a(o.length) && !r(o);
  }
  return Eh = n, Eh;
}
var Ah, d0;
function Zv() {
  if (d0) return Ah;
  d0 = 1;
  var r = zv(), a = Xv(), n = $v();
  function o(c) {
    return n(c) ? r(c) : a(c);
  }
  return Ah = o, Ah;
}
var Rh, f0;
function Jv() {
  if (f0) return Rh;
  f0 = 1;
  var r = Iv(), a = Nv(), n = Zv();
  function o(c) {
    return r(c, n, a);
  }
  return Rh = o, Rh;
}
var Th, g0;
function Qv() {
  if (g0) return Th;
  g0 = 1;
  var r = Jv(), a = 1, n = Object.prototype, o = n.hasOwnProperty;
  function c(s, h, l, g, p, b) {
    var w = l & a, x = r(s), v = x.length, _ = r(h), S = _.length;
    if (v != S && !w)
      return !1;
    for (var C = v; C--; ) {
      var F = x[C];
      if (!(w ? F in h : o.call(h, F)))
        return !1;
    }
    var d = b.get(s), f = b.get(h);
    if (d && f)
      return d == h && f == s;
    var m = !0;
    b.set(s, h), b.set(h, s);
    for (var E = w; ++C < v; ) {
      F = x[C];
      var T = s[F], D = h[F];
      if (g)
        var I = w ? g(D, T, F, h, s, b) : g(T, D, F, s, h, b);
      if (!(I === void 0 ? T === D || p(T, D, l, g, b) : I)) {
        m = !1;
        break;
      }
      E || (E = F == "constructor");
    }
    if (m && !E) {
      var L = s.constructor, O = h.constructor;
      L != O && "constructor" in s && "constructor" in h && !(typeof L == "function" && L instanceof L && typeof O == "function" && O instanceof O) && (m = !1);
    }
    return b.delete(s), b.delete(h), m;
  }
  return Th = c, Th;
}
var Ph, p0;
function t8() {
  if (p0) return Ph;
  p0 = 1;
  var r = ai(), a = $e(), n = r(a, "DataView");
  return Ph = n, Ph;
}
var Fh, _0;
function e8() {
  if (_0) return Fh;
  _0 = 1;
  var r = ai(), a = $e(), n = r(a, "Promise");
  return Fh = n, Fh;
}
var Oh, v0;
function r8() {
  if (v0) return Oh;
  v0 = 1;
  var r = ai(), a = $e(), n = r(a, "Set");
  return Oh = n, Oh;
}
var kh, y0;
function i8() {
  if (y0) return kh;
  y0 = 1;
  var r = ai(), a = $e(), n = r(a, "WeakMap");
  return kh = n, kh;
}
var Ih, m0;
function n8() {
  if (m0) return Ih;
  m0 = 1;
  var r = t8(), a = Jh(), n = e8(), o = r8(), c = i8(), s = bn(), h = r1(), l = "[object Map]", g = "[object Object]", p = "[object Promise]", b = "[object Set]", w = "[object WeakMap]", x = "[object DataView]", v = h(r), _ = h(a), S = h(n), C = h(o), F = h(c), d = s;
  return (r && d(new r(new ArrayBuffer(1))) != x || a && d(new a()) != l || n && d(n.resolve()) != p || o && d(new o()) != b || c && d(new c()) != w) && (d = function(f) {
    var m = s(f), E = m == g ? f.constructor : void 0, T = E ? h(E) : "";
    if (T)
      switch (T) {
        case v:
          return x;
        case _:
          return l;
        case S:
          return p;
        case C:
          return b;
        case F:
          return w;
      }
    return m;
  }), Ih = d, Ih;
}
var Lh, b0;
function a8() {
  if (b0) return Lh;
  b0 = 1;
  var r = Sv(), a = n1(), n = Ov(), o = Qv(), c = n8(), s = Aa(), h = a1(), l = o1(), g = 1, p = "[object Arguments]", b = "[object Array]", w = "[object Object]", x = Object.prototype, v = x.hasOwnProperty;
  function _(S, C, F, d, f, m) {
    var E = s(S), T = s(C), D = E ? b : c(S), I = T ? b : c(C);
    D = D == p ? w : D, I = I == p ? w : I;
    var L = D == w, O = I == w, N = D == I;
    if (N && h(S)) {
      if (!h(C))
        return !1;
      E = !0, L = !1;
    }
    if (N && !L)
      return m || (m = new r()), E || l(S) ? a(S, C, F, d, f, m) : n(S, C, D, F, d, f, m);
    if (!(F & g)) {
      var H = L && v.call(S, "__wrapped__"), y = O && v.call(C, "__wrapped__");
      if (H || y) {
        var P = H ? S.value() : S, A = y ? C.value() : C;
        return m || (m = new r()), f(P, A, F, d, m);
      }
    }
    return N ? (m || (m = new r()), o(S, C, F, d, f, m)) : !1;
  }
  return Lh = _, Lh;
}
var Mh, w0;
function s8() {
  if (w0) return Mh;
  w0 = 1;
  var r = a8(), a = wn();
  function n(o, c, s, h, l) {
    return o === c ? !0 : o == null || c == null || !a(o) && !a(c) ? o !== o && c !== c : r(o, c, s, h, n, l);
  }
  return Mh = n, Mh;
}
var Nh, S0;
function o8() {
  if (S0) return Nh;
  S0 = 1;
  var r = s8();
  function a(n, o) {
    return r(n, o);
  }
  return Nh = a, Nh;
}
var h8 = o8();
const C0 = /* @__PURE__ */ yn(h8);
var Gh, x0;
function l8() {
  if (x0) return Gh;
  x0 = 1;
  var r = Kh(), a = 1 / 0, n = 17976931348623157e292;
  function o(c) {
    if (!c)
      return c === 0 ? c : 0;
    if (c = r(c), c === a || c === -1 / 0) {
      var s = c < 0 ? -1 : 1;
      return s * n;
    }
    return c === c ? c : 0;
  }
  return Gh = o, Gh;
}
var Dh, E0;
function u8() {
  if (E0) return Dh;
  E0 = 1;
  var r = l8();
  function a(n) {
    var o = r(n), c = o % 1;
    return o === o ? c ? o - c : o : 0;
  }
  return Dh = a, Dh;
}
var Bh, A0;
function c8() {
  if (A0) return Bh;
  A0 = 1;
  function r(a, n) {
    for (var o = -1, c = a == null ? 0 : a.length, s = Array(c); ++o < c; )
      s[o] = n(a[o], o, a);
    return s;
  }
  return Bh = r, Bh;
}
var Uh, R0;
function d8() {
  if (R0) return Uh;
  R0 = 1;
  var r = ma(), a = c8(), n = Aa(), o = z0(), c = r ? r.prototype : void 0, s = c ? c.toString : void 0;
  function h(l) {
    if (typeof l == "string")
      return l;
    if (n(l))
      return a(l, h) + "";
    if (o(l))
      return s ? s.call(l) : "";
    var g = l + "";
    return g == "0" && 1 / l == -1 / 0 ? "-0" : g;
  }
  return Uh = h, Uh;
}
var qh, T0;
function f8() {
  if (T0) return qh;
  T0 = 1;
  var r = d8();
  function a(n) {
    return n == null ? "" : r(n);
  }
  return qh = a, qh;
}
var Hh, P0;
function g8() {
  if (P0) return Hh;
  P0 = 1;
  var r = $e(), a = u8(), n = Kh(), o = f8(), c = r.isFinite, s = Math.min;
  function h(l) {
    var g = Math[l];
    return function(p, b) {
      if (p = n(p), b = b == null ? 0 : s(a(b), 292), b && c(p)) {
        var w = (o(p) + "e").split("e"), x = g(w[0] + "e" + (+w[1] + b));
        return w = (o(x) + "e").split("e"), +(w[0] + "e" + (+w[1] - b));
      }
      return g(p);
    };
  }
  return Hh = h, Hh;
}
var Wh, F0;
function p8() {
  if (F0) return Wh;
  F0 = 1;
  var r = g8(), a = r("round");
  return Wh = a, Wh;
}
var _8 = p8();
const fn = /* @__PURE__ */ yn(_8), pa = {
  getBackgroundColor(r) {
    switch (r) {
      case tt.GREY:
        return "rgb(103, 103, 103, 0.4)";
      case tt.BLUE:
        return "rgba(0, 176, 255, 0.4)";
      default:
        Br(r);
    }
  },
  getBorderColor(r) {
    switch (r) {
      case tt.GREY:
        return "rgb(103, 103, 103)";
      case tt.BLUE:
        return "rgb(0, 176, 255)";
      default:
        Br(r);
    }
  }
}, qe = {
  loadImageFromUrl(r, a) {
    const { isPrintEnabled: n } = xt.getState();
    return new Promise((o, c) => {
      const s = document.createElement("img");
      n && (s.crossOrigin = "anonymous"), s.onload = function() {
        const h = new yt.Image({
          image: s,
          listening: !1,
          ...a
        });
        o(h);
      }, s.onerror = c, s.src = r;
    });
  }
};
function O0(r) {
  return typeof r == "string";
}
class Ue extends yt.Group {
  constructor(n, o) {
    var c;
    super(n);
    Xe(this, "HIGHLIGHT_GROUP_NAME", "highlight");
    Xe(this, "IMAGE_NAME", "image");
    Xe(this, "SPOT_NAME", "spot");
    Xe(this, "GAP", 2);
    Xe(this, "ATTRIBUTE_ICON_WIDTH", 8);
    Xe(this, "highligthColor", null);
    this.spot = o, this.highligthColor = (c = o.highlightColor) != null ? c : null;
  }
  get backgroundBorderColor() {
    var n, o, c;
    return (c = (o = (n = this.spot.style) == null ? void 0 : n.css) == null ? void 0 : o.borderColor) != null ? c : "rgb(135, 135, 135)";
  }
  get hasAttributeIcon() {
    var n;
    return O0((n = this.spot.style) == null ? void 0 : n.attributeIcon);
  }
  get isPlayfield() {
    return this.spot.subType === Ar.PLAYFIELD;
  }
  get strokeWidth() {
    var n, o, c;
    return (c = (o = (n = this.spot.style) == null ? void 0 : n.css) == null ? void 0 : o.borderWidth) != null ? c : 1;
  }
  get bgWidth() {
    return this.spot.width - this.strokeWidth;
  }
  addBackground() {
    var o, c, s, h, l;
    const n = new yt.Rect({
      width: this.bgWidth,
      height: this.spot.height - this.strokeWidth,
      fill: (s = (c = (o = this.spot.style) == null ? void 0 : o.css) == null ? void 0 : c.backgroundColor) != null ? s : "#FFF",
      cornerRadius: 4,
      stroke: this.backgroundBorderColor,
      strokeWidth: this.strokeWidth,
      ...((l = (h = this.spot.style) == null ? void 0 : h.css) == null ? void 0 : l.borderStyle) === "dashed" ? { dash: [5, 5] } : {}
    });
    this.add(n);
  }
  clearHighlight() {
    this.highligthColor = null, this.find(`.${this.HIGHLIGHT_GROUP_NAME}`).forEach((n) => n.destroy());
  }
  async highlight(n, o = !1) {
    try {
      if (this.highligthColor !== null && !o)
        return;
      this.highligthColor = n;
      const c = pa.getBackgroundColor(n), s = pa.getBorderColor(n), h = new yt.Rect({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: this.width(),
        height: this.height(),
        fill: c,
        stroke: s,
        cornerRadius: 4,
        listening: !1
      });
      this.add(h), h.zIndex(1);
      const l = await qe.loadImageFromUrl(
        `${xt.getState().assetsBaseUrl}/iconset/check.svg`
      ), g = new yt.Circle({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: 16,
        height: 16,
        fill: s,
        x: this.width() / 2,
        y: this.height() / 2,
        listening: !1
      }), p = 10;
      l.name(this.HIGHLIGHT_GROUP_NAME), l.width(p), l.height(p), l.x(this.width() / 2 - p / 2), l.y(this.height() / 2 - p / 2), this.add(g, l);
    } catch (c) {
      console.error(c);
    }
  }
  getYFromImageSize() {
    const n = this.GAP, o = this.findOne(`.${this.IMAGE_NAME}`);
    return o ? o.y() + 1 + o.height() : n;
  }
  async addAttributeIcon() {
    var n;
    try {
      const o = (n = this.spot.style) == null ? void 0 : n.attributeIcon;
      if (!O0(o))
        return;
      const { assetsBaseUrl: c } = xt.getState(), s = await qe.loadImageFromUrl(
        `${c}/iconset/${o}`
      ), h = this.ATTRIBUTE_ICON_WIDTH, l = new yt.Rect({
        width: h + this.GAP * 2,
        height: h + this.GAP * 2,
        fill: this.backgroundBorderColor,
        listening: !1
      });
      l.x(this.bgWidth - l.width()), s.width(h), s.height(h), s.x(this.bgWidth - h - this.GAP), s.y(this.GAP), s.listening(!1), this.add(l, s);
    } catch (o) {
      console.error(o);
    }
  }
}
const v8 = "background-sea", y8 = "background-sand", m8 = 100;
class b8 extends yt.Layer {
  constructor(n) {
    super({
      draggable: !1,
      listening: !1
    });
    Xe(this, "bgImage", null);
    Xe(this, "seaImage", null);
    Xe(this, "sandRect", null);
    typeof (n == null ? void 0 : n.visible) == "boolean" && this.visible(n.visible), this.init();
  }
  setVisibility(n) {
    this.visible(n);
  }
  toggleVisibility() {
    this.visible(!this.visible());
  }
  updateBgSize() {
    const { background: n, mapSize: o } = xt.getState();
    this.sandRect !== null && (this.sandRect.width(o.width), this.sandRect.height(o.height)), this.seaImage !== null && this.seaImage.width(o.width), this.bgImage !== null && (this.bgImage.width(n.width), this.bgImage.height(n.height));
  }
  init() {
    this.renderSand(), this.renderSea(() => this.renderCustomBackground());
  }
  renderSand() {
    const { mapSize: n } = xt.getState();
    this.sandRect = new yt.Rect({
      x: 0,
      y: 0,
      width: n.width,
      height: n.height,
      fill: "wheat",
      id: y8,
      listening: !1,
      draggable: !1
    }), this.add(this.sandRect);
  }
  renderSea(n) {
    const { assetsBaseUrl: o } = xt.getState();
    qe.loadImageFromUrl(`${o}/images/sea.svg`).then((c) => {
      this.seaImage = c;
      const { mapSize: s } = xt.getState();
      c.setAttrs({
        x: 0,
        y: 0,
        fillPatternRepeat: "repeat-x",
        width: s.width,
        height: m8,
        id: v8
      }), c.listening(!1), c.draggable(!1), this.add(c), n();
    }).catch((c) => {
      console.error(c);
    });
  }
  renderCustomBackground() {
    const { background: n } = xt.getState(), o = n.url;
    o && qe.loadImageFromUrl(o).then((c) => {
      this.bgImage = c, c.width(n.width), c.height(n.height), c.x(n.offset.x), c.y(n.offset.y), this.add(c);
    }).catch((c) => {
      console.error(c);
    });
  }
}
class rr extends yt.Group {
  constructor(a, n, o) {
    super({
      x: n.x,
      y: n.y,
      ...o
    }), this.decoration = n, this.add(a), this.init(a);
  }
  getSubType() {
    return this.decoration.subType;
  }
  get isSquareCell() {
    return this.decoration.width === this.decoration.cellSize.width;
  }
  get isDebugEnabled() {
    return xt.getState().debug;
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = new yt.Rect({
      dash: [5, 5],
      height: this.height(),
      listening: !1,
      stroke: "rebeccapurple",
      strokeWidth: 1,
      width: this.width(),
      x: 0,
      y: 0
    });
    this.add(a);
  }
}
const gn = (r) => r * (Math.PI / 180), w8 = (r) => r * (180 / Math.PI);
function k0(r, a) {
  const n = Math.cos(a), o = Math.sin(a);
  return {
    x: r.x * n - r.y * o,
    y: r.y * n + r.x * o
  };
}
function Gr(r, a) {
  const n = { x: -r.width() / 2, y: -r.height() / 2 }, o = k0(n, 0), c = k0(n, gn(a)), s = c.x - o.x, h = c.y - o.y;
  r.rotation(a), r.x(r.x() + s), r.y(r.y() + h);
}
class h1 extends rr {
  constructor(a, n) {
    const o = n.cellSize.width / n.width;
    super(a, n, {
      height: a.height(),
      width: a.width() * o
    }), this.add(a);
  }
  init(a) {
    this.addDebugInfo(), a.x(this.width() / 2 - a.width() / 2), this.decoration.rotation > 0 && Gr(a, this.decoration.rotation);
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = new yt.Rect({
      dash: [5, 5],
      height: this.height(),
      listening: !1,
      stroke: "yellow",
      strokeWidth: 1,
      width: this.width(),
      x: 0,
      y: 0
    });
    this.add(a);
  }
}
class S8 extends rr {
  constructor(a, n) {
    super(a, n, {
      height: n.cellSize.height,
      width: n.cellSize.width
    }), this.add(a);
  }
  init(a) {
    this.adjustImageSize(a), this.adjustImagePosition(a), this.addDebugInfo();
  }
  getCustomDecorationImageSize(a, n, o) {
    const c = a.width / n, s = a.height / o;
    return c < s ? {
      width: a.width,
      height: Math.floor(o * c)
    } : {
      width: Math.floor(n * s),
      height: a.height
    };
  }
  adjustImageSize(a) {
    a.setAttrs({
      ...this.getCustomDecorationImageSize(
        this.decoration,
        a.width(),
        a.height()
      )
    });
  }
  adjustImagePosition(a) {
    a.x(this.width() / 2 - a.width() / 2), a.y(this.height() / 2 - a.height() / 2), this.decoration.rotation > 0 && Gr(a, this.decoration.rotation);
  }
}
class C8 extends rr {
  constructor(a, n) {
    super(a, n, {
      height: n.cellSize.height,
      width: n.cellSize.width
    }), this.add(a);
  }
  init() {
  }
}
class x8 extends rr {
  constructor(a, n) {
    super(a, n, {
      height: n.height,
      width: n.width
    }), this.add(a);
  }
  init(a) {
    this.adjustLineWidth(a), this.adjustRotation(a), this.addDebugInfo();
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = gn(this.decoration.rotation), n = Math.cos(a), o = Math.sin(a);
    if (Math.abs(n) === 1 || Math.abs(o) === 1)
      return;
    const c = n < 0, s = o < 0, h = Math.abs(this.decoration.width * n), l = Math.abs(this.decoration.width * o), g = new yt.Rect({
      x: c ? -h : 0,
      y: s ? -l : 0,
      width: h,
      height: l,
      stroke: "goldenrod",
      strokeWidth: 1,
      dash: [5, 5],
      listening: !1
    }), p = this.decoration.cellSize.width / this.decoration.width;
    if (p !== 1) {
      const b = h * p, w = new yt.Rect({
        x: c ? -b : 0,
        y: s ? -l : 0,
        width: b,
        height: l,
        stroke: "deepskyblue",
        strokeWidth: 1,
        dash: [5, 5],
        listening: !1
      });
      this.add(w);
    }
    this.add(g);
  }
  adjustLineWidth(a) {
    if (this.isSquareCell || !(a instanceof yt.Group) || a.children.length < 1)
      return;
    const n = a.children[0], o = gn(this.decoration.rotation), c = Math.cos(o), s = Math.sin(o);
    if (Math.abs(s) === 1)
      return;
    if (Math.abs(c) === 1) {
      n.width(this.decoration.cellSize.width);
      return;
    }
    const h = this.decoration.width * c, l = this.decoration.width * s, g = this.decoration.cellSize.width / this.decoration.width, p = h * g, b = Math.sqrt(Math.pow(p, 2) + Math.pow(l, 2));
    n.width(b);
  }
  adjustRotation(a) {
    if (this.decoration.rotation <= 0)
      return;
    const n = gn(this.decoration.rotation), o = Math.cos(n), c = Math.sin(n);
    if (this.isSquareCell || Math.abs(o) === 1 || Math.abs(c) === 1) {
      Gr(a, this.decoration.rotation);
      return;
    }
    const s = o < 0, h = c < 0, l = Math.abs(this.decoration.width * o), g = Math.abs(this.decoration.width * c), p = this.decoration.cellSize.width / this.decoration.width, b = l * p, w = Math.atan(g / b), x = w8(w);
    s && h ? Gr(a, x + 180) : s ? Gr(a, 180 - x) : Gr(a, x);
  }
}
function E8(r) {
  const a = gn(r), n = Math.cos(a), o = Math.sin(a);
  switch (!0) {
    case n === 1:
      return "horizontal";
    case n === -1:
      return "horizontal-flip";
    case o === 1:
      return "vertical";
    case o === -1:
      return "vertical-flip";
    default:
      return "diagonal";
  }
}
class A8 extends h1 {
  constructor(a, n) {
    super(a, n);
  }
  init(a) {
    const n = E8(this.decoration.rotation);
    if (this.isSquareCell || n === "diagonal") {
      super.init(a);
      return;
    }
    this.decoration.rotation > 0 && Gr(a, this.decoration.rotation), this.handleStretch(a, n), this.addDebugInfo();
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = this.children[0];
    if (!a)
      return;
    const n = new yt.Rect({
      dash: [5, 5],
      height: a.height(),
      listening: !1,
      stroke: "hotpink",
      strokeWidth: 1,
      width: a.width(),
      x: 0,
      y: 0
    });
    this.add(n);
  }
  handleStretch(a, n) {
    const o = this.decoration.cellSize.width / this.decoration.width;
    switch (n) {
      case "vertical": {
        const c = a.height() * o, s = c - a.height();
        a.height(c), a.offsetY(s);
        break;
      }
      case "vertical-flip": {
        a.height(a.height() * o);
        break;
      }
      case "horizontal": {
        a.width(a.width() * o), a.x(0);
        break;
      }
      case "horizontal-flip": {
        a.width(a.width() * o), a.x(this.width());
        break;
      }
      default:
        Br(n);
    }
  }
}
const Se = '"Roboto", system-ui, -apple-system, "Segoe UI", "Helvetica Neue", Arial, sans-serif', R8 = "black";
class T8 {
  async createDecoration(a) {
    switch (a.subType) {
      case ge.CUSTOM:
        return P8(a);
      case ge.LABEL:
        return F8(a);
      case ge.LINE:
        return k8(a);
      case ge.BASKET_FIELD:
      case ge.BEACH_VOLLEY:
      case ge.FOOTBOARD:
      case ge.POOL:
      case ge.POOL_ROUNDED:
      case ge.SOCCER_FIELD:
      case ge.TENT:
      case ge.TENT_BIG:
        return I0(a, !0);
      default:
        return I0(a);
    }
  }
}
async function P8(r) {
  if (!r.url)
    throw new Error("Decoration URL is required");
  try {
    const a = await qe.loadImageFromUrl(r.url);
    return a.setAttrs({
      x: 0,
      y: 0
    }), new S8(a, r);
  } catch (a) {
    console.error(a);
  }
  return null;
}
async function I0(r, a = !1) {
  const n = `${xt.getState().assetsBaseUrl}/decorations/${r.subType}.svg`;
  try {
    const o = await qe.loadImageFromUrl(n), c = I8(r), s = o.width(), h = o.height();
    if (s > h) {
      const l = c.width, g = h / s * c.height;
      o.setAttrs({
        height: g,
        width: l
      });
    } else if (s < h) {
      const l = c.height, g = s / h * c.width;
      o.setAttrs({
        height: l,
        width: g
      });
    } else {
      const l = c.height, g = c.width;
      o.setAttrs({
        height: l,
        width: g
      });
    }
    return a ? new A8(o, r) : new h1(o, r);
  } catch (o) {
    console.error(o);
  }
  return null;
}
function F8(r) {
  const a = new yt.Text({
    fill: "black",
    fontFamily: Se,
    fontSize: 14,
    listening: !1,
    padding: 4,
    text: r.name,
    x: 0,
    y: 0
  });
  return new C8(a, r);
}
const O8 = (r) => r.trim().length === 0 ? R8 : r;
function k8(r) {
  const a = new yt.Group({
    listening: !1,
    x: 0,
    y: 0
  }), n = new yt.Rect({
    fill: O8(r.name),
    height: r.height,
    listening: !1,
    strokeEnabled: !1,
    width: r.width,
    x: 0,
    y: 0
  });
  return a.add(n), new x8(a, r);
}
function I8(r) {
  return r.width > r.height ? {
    width: r.height,
    height: r.height
  } : r.width < r.height ? {
    width: r.width,
    height: r.width
  } : {
    width: r.width,
    height: r.height
  };
}
function L8(r) {
  const a = r.split(" ");
  return {
    timeSlot: a[a.length - 1],
    name: a.slice(0, a.length - 1).join(" ")
  };
}
function Qh(r) {
  return r.subType === Ar.PLAYFIELD ? L8(r.name).name : r.name;
}
const ei = 1, L0 = "image";
class l1 extends Ue {
  constructor(a, n) {
    super(a, n);
  }
  get isAvailable() {
    var a;
    return ((a = this.spot.style) == null ? void 0 : a.iconColor) === tt.GREEN;
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName();
  }
  clearHighlight() {
    this.highligthColor !== null && (this.highligthColor = null, this.redrawImage());
  }
  async highlight() {
    this.highligthColor === null && (this.highligthColor = tt.BLUE, await this.redrawImage());
  }
  async redrawImage() {
    var n;
    (n = this.findOne(`.${L0}`)) == null || n.destroy();
    const a = await this.addImage();
    a !== null && a.zIndex(1);
  }
  addBackground() {
    const a = new yt.Rect({
      width: this.spot.width,
      height: this.spot.height,
      fill: "#FFF",
      cornerRadius: 4
    });
    this.add(a);
  }
  getImageName() {
    return this.highligthColor ? "checked" : this.isAvailable ? "available" : "not-available";
  }
  getImageWidth() {
    return this.spot.subType === Ar.CABIN ? 24 : this.spot.subType === Ar.UMBRELLA && this.highligthColor ? 35 : 30;
  }
  async addImage() {
    try {
      const a = `${this.spot.subType}-${this.getImageName()}`, n = `${xt.getState().assetsBaseUrl}/spots/${a}.svg`, o = await qe.loadImageFromUrl(n), c = this.getImageWidth(), s = c * o.height() / o.width();
      return o.width(c), o.height(s), o.x(this.width() / 2 - o.width() / 2), o.y(this.height() / 2 - o.height() / 2), o.name(L0), this.add(o), o;
    } catch (a) {
      console.error(a);
    }
    return null;
  }
  addSpotName() {
    if (!this.isAvailable)
      return;
    if (this.spot.subType === Ar.PLAYFIELD)
      return this.addPlayfieldName();
    const a = new yt.Text({
      text: Qh(this.spot),
      fontSize: 12,
      fontFamily: Se,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    a.width() > this.width() ? (a.width(this.width() - ei * 2), a.x(this.width() - a.width() - ei)) : a.x(this.width() - a.width() - ei * 2), a.y(this.height() - a.height());
    const n = new yt.Rect({
      cornerRadius: 4,
      fill: "white",
      height: a.height(),
      listening: !1,
      width: a.width(),
      x: a.x(),
      y: a.y()
    });
    this.add(n, a);
  }
  addPlayfieldName() {
    const [a, n] = this.spot.name.split(" "), o = new yt.Text({
      text: a,
      fontFamily: Se,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    o.x(this.width() - o.width() - ei * 2), o.y(this.height() - o.height());
    const c = new yt.Rect({
      cornerRadius: 4,
      fill: "white",
      height: o.height() * 2,
      listening: !1,
      width: this.width(),
      x: 0,
      y: o.y()
    }), s = n.indexOf("-"), h = n.substring(0, s + 1), l = n.substring(s + 1), g = new yt.Text({
      text: h,
      fontFamily: Se,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    g.x(this.width() - g.width() - ei * 2), g.y(c.y() + 10);
    const p = new yt.Text({
      text: l,
      fontFamily: Se,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    p.x(this.width() - p.width() - ei * 2), p.y(g.y() + 10), this.add(c, o, g, p);
  }
}
const tl = {
  getSpotIconByColor(r, a) {
    const n = `spots/${r}`;
    switch (a) {
      case tt.RED:
      case tt.BLUE:
      case tt.GREEN:
      case tt.YELLOW:
      case tt.ORANGE:
      case tt.WHITE:
      case tt.BLACK:
      case tt.PURPLE:
      case tt.BLACK_WHITE:
      case tt.BLACK_BLUE:
      case tt.BLACK_YELLOW:
      case tt.BLACK_GREY:
      case tt.BLACK_RED:
      case tt.BLACK_GREEN:
      case tt.BLACK_PURPLE:
      case tt.GREY:
      case tt.CYAN:
      case tt.BROWN:
      case tt.LIME:
      case tt.PINK:
        return `${n}/${a.toLowerCase()}.svg`;
      case tt.PINK_FLUO:
        return `${n}/pinkfluo.svg`;
      case tt.RED_FLUO:
        return `${n}/redfluo.svg`;
      case tt.BLUE_FLUO:
        return `${n}/bluefluo.svg`;
      case tt.GREEN_FLUO:
        return `${n}/greenfluo.svg`;
      case tt.YELLOW_FLUO:
        return `${n}/yellowfluo.svg`;
      case tt.WHITE_FLUO:
        return `${n}/whitefluo.svg`;
      case tt.PURPLE_FLUO:
        return `${n}/purplefluo.svg`;
    }
  }
};
class M8 extends Ue {
  constructor(a, n) {
    super(a, n);
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName(), this.addCustomLabel();
  }
  clearHighlight() {
  }
  async highlight() {
  }
  addBackground() {
    var n, o, c, s, h, l, g, p;
    const a = new yt.Circle({
      radius: this.width() / 2,
      fill: (c = (o = (n = this.spot.style) == null ? void 0 : n.css) == null ? void 0 : o.backgroundColor) != null ? c : "#FFF",
      stroke: "rgb(135, 135, 135)",
      strokeWidth: (l = (h = (s = this.spot.style) == null ? void 0 : s.css) == null ? void 0 : h.borderWidth) != null ? l : 1,
      x: this.width() / 2,
      y: this.height() / 2,
      ...((p = (g = this.spot.style) == null ? void 0 : g.css) == null ? void 0 : p.borderStyle) === "dashed" ? { dash: [5, 5] } : {}
    });
    this.add(a);
  }
  async addImage() {
    var a, n;
    try {
      const o = `${xt.getState().assetsBaseUrl}/${tl.getSpotIconByColor(this.spot.subType, (n = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? n : tt.GREEN)}`, c = await qe.loadImageFromUrl(o), s = 32, h = s * c.height() / c.width();
      c.width(s), c.height(h), c.x(this.width() / 2 - c.width() / 2), c.y(this.height() / 2 - c.height() / 2), this.add(c);
    } catch (o) {
      console.error(o);
    }
  }
  addSpotName() {
    const a = new yt.Text({
      text: this.spot.name,
      fontFamily: Se,
      fontSize: 10,
      fontStyle: "bold",
      fill: "#242424",
      align: "center",
      wrap: "none",
      width: this.width(),
      y: 38,
      listening: !1
    });
    this.add(a);
  }
  addCustomLabel() {
    if (typeof this.spot.customLabel != "string")
      return;
    const a = new yt.Text({
      text: this.spot.customLabel,
      fontFamily: Se,
      fontSize: 8,
      fill: "#242424",
      align: "center",
      width: this.width(),
      y: 8,
      listening: !1
    });
    this.add(a);
  }
}
const M0 = "SPOT_DATE", ua = 10, N8 = 6.6, N0 = 13;
class G8 extends Ue {
  constructor(a, n) {
    super(a, n);
  }
  async init() {
    this.addBackground(), this.addCustomerName(), this.addServiceIcons(), await this.addImage(), this.addDate(), this.addSpotName(), this.addStaging(), this.highligthColor && await this.highlight(this.highligthColor, !0), await this.addAttributeIcon();
  }
  async addImage() {
    var a, n;
    try {
      const o = `${xt.getState().assetsBaseUrl}/${tl.getSpotIconByColor(this.spot.subType, (n = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? n : tt.GREEN)}`, c = await qe.loadImageFromUrl(o, {
        name: this.IMAGE_NAME,
        y: 14
      }), s = 1 / (c.height() / N0);
      c.width(c.width() * s), c.height(N0), c.x(this.GAP), this.add(c);
    } catch (o) {
      console.error(o);
    }
  }
  getSpotNameWidth() {
    const a = this.findOne(`.${M0}`);
    return a ? this.bgWidth - a.width() + this.strokeWidth : this.bgWidth;
  }
  addSpotName() {
    const a = this.getSpotNameWidth(), n = new yt.Text({
      fill: "black",
      fontSize: ua,
      fontFamily: Se,
      fontStyle: "bold",
      letterSpacing: -0.4,
      listening: !1,
      name: this.SPOT_NAME,
      text: Qh(this.spot),
      width: a,
      wrap: "none",
      x: this.GAP / 2,
      y: 30 - this.strokeWidth
    });
    this.add(n);
  }
  addStaging() {
    if (this.spot.staging === null)
      return;
    const a = new yt.Text({
      text: this.spot.staging,
      fontFamily: Se,
      fontSize: this.isPlayfield ? N8 : ua,
      fill: "black",
      y: 20 - this.strokeWidth,
      listening: !1
    });
    a.x(
      this.width() - a.width() * 2 / this.GAP - this.strokeWidth
    ), this.add(a);
  }
  addDate() {
    var o, c, s;
    const a = (s = (o = this.spot.reservation) == null ? void 0 : o.endDate) != null ? s : (c = this.spot.reservation) == null ? void 0 : c.startDate;
    if (a === null)
      return;
    const n = new yt.Text({
      text: a,
      name: M0,
      fontFamily: Se,
      fontSize: ua,
      letterSpacing: -0.6,
      fill: "black",
      y: 30 - this.strokeWidth,
      listening: !1,
      wrap: "none"
    });
    n.x(this.width() - n.width() - this.strokeWidth), this.add(n);
  }
  addCustomerName() {
    var o;
    const a = (o = this.spot.reservation) == null ? void 0 : o.customerName;
    if (typeof a != "string")
      return;
    const n = new yt.Text({
      ellipsis: !0,
      fill: "black",
      fontFamily: Se,
      fontSize: ua,
      listening: !1,
      text: a,
      width: this.width() - 2 * this.GAP - (this.hasAttributeIcon ? this.ATTRIBUTE_ICON_WIDTH : 0),
      wrap: "none",
      x: this.GAP,
      y: this.GAP
    });
    this.add(n);
  }
  async addServiceIcons() {
    if (!Array.isArray(this.spot.serviceIcons) || this.spot.serviceIcons.length === 0)
      return;
    const { assetsBaseUrl: a } = xt.getState(), n = 7;
    let o = 0;
    for await (const c of this.spot.serviceIcons)
      try {
        const s = await qe.loadImageFromUrl(
          `${a}/services/${c}`
        ), h = s.width() * n / s.height();
        s.width(h), s.height(n), s.y(12), s.x(this.width() - s.width() - o - this.strokeWidth), s.listening(!1), o += s.width(), this.add(s);
      } catch (s) {
        console.error(s);
      }
  }
}
const D8 = "SPOT_DATE", Vh = 10, B8 = 6.6, G0 = 13;
class U8 extends Ue {
  constructor(a, n) {
    super(a, n);
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName(), this.addDate(), this.addStaging(), this.highligthColor && await this.highlight(this.highligthColor, !0), await this.addAttributeIcon();
  }
  clearHighlight() {
    this.highligthColor = null, this.find(`.${this.HIGHLIGHT_GROUP_NAME}`).forEach((a) => a.destroy());
  }
  async highlight(a, n = !1) {
    try {
      if (this.highligthColor !== null && !n)
        return;
      this.highligthColor = a;
      const o = pa.getBackgroundColor(a), c = pa.getBorderColor(a), s = new yt.Rect({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: this.width(),
        height: this.height(),
        fill: o,
        stroke: c,
        cornerRadius: 4,
        listening: !1
      });
      this.add(s), s.zIndex(1);
      const h = await qe.loadImageFromUrl(
        `${xt.getState().assetsBaseUrl}/iconset/check.svg`
      ), l = new yt.Circle({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: 16,
        height: 16,
        fill: c,
        x: this.width() / 2,
        y: this.height() / 2,
        listening: !1
      }), g = 10;
      h.name(this.HIGHLIGHT_GROUP_NAME), h.width(g), h.height(g), h.x(this.width() / 2 - g / 2), h.y(this.height() / 2 - g / 2), this.add(l, h);
    } catch (o) {
      console.error(o);
    }
  }
  getYFromSpotName() {
    const a = this.GAP, n = this.findOne(`.${this.SPOT_NAME}`);
    return n ? a + n.y() + n.height() : a;
  }
  async addImage() {
    var a, n;
    try {
      const o = `${xt.getState().assetsBaseUrl}/${tl.getSpotIconByColor(this.spot.subType, (n = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? n : tt.GREEN)}`, c = await qe.loadImageFromUrl(o, {
        name: this.IMAGE_NAME,
        y: this.GAP
      }), s = 1 / (c.height() / G0);
      c.width(c.width() * s), c.height(G0), c.x(this.spot.width / 2 - c.width() / 2), this.add(c);
    } catch (o) {
      console.error(o);
    }
  }
  getSpotNameWidth() {
    return this.spot.width;
  }
  addSpotName() {
    const a = this.getSpotNameWidth(), n = new yt.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontFamily: Se,
      fontSize: Vh,
      fontStyle: "bold",
      listening: !1,
      name: this.SPOT_NAME,
      text: Qh(this.spot),
      width: a,
      wrap: "none",
      y: this.getYFromImageSize()
    });
    this.add(n);
  }
  addStaging() {
    if (this.spot.layout !== Pe.VIEWER_STAGING || this.spot.staging === null)
      return;
    const a = new yt.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontFamily: Se,
      fontSize: this.isPlayfield ? B8 : Vh,
      listening: !1,
      text: this.spot.staging,
      width: this.spot.width,
      wrap: "none",
      y: this.getYFromSpotName()
    });
    this.add(a);
  }
  addDate() {
    var o, c, s;
    const a = (s = (o = this.spot.reservation) == null ? void 0 : o.endDate) != null ? s : (c = this.spot.reservation) == null ? void 0 : c.startDate;
    if (this.spot.layout !== Pe.VIEWER_DATE || a === null)
      return;
    const n = new yt.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontFamily: Se,
      fontSize: Vh,
      listening: !1,
      name: D8,
      text: a,
      width: this.spot.width,
      wrap: "none",
      y: this.getYFromSpotName()
    });
    this.add(n);
  }
}
class q8 {
  async createSpot(a) {
    const n = {
      id: a.id,
      x: a.x,
      y: a.y,
      width: a.width,
      height: a.height
    };
    let o;
    switch (a.layout) {
      case Pe.BOOKING_NAME:
        o = new l1(n, a);
        break;
      case Pe.VIEWER_DATE:
      case Pe.VIEWER_FULL:
      case Pe.VIEWER_NAME:
      case Pe.VIEWER_STAGING:
        o = H8(n, a);
        break;
      default:
        Br(a.layout);
    }
    return await o.init(), o;
  }
}
function H8(r, a) {
  if (a.subType === Ar.BEDS)
    return new M8(
      {
        ...r,
        height: 52,
        width: 52
      },
      a
    );
  switch (a.layout) {
    case Pe.BOOKING_NAME:
      throw new Error(`Invalid layout: ${a.layout}`);
    case Pe.VIEWER_FULL:
      return new G8(r, a);
    case Pe.VIEWER_DATE:
    case Pe.VIEWER_NAME:
    case Pe.VIEWER_STAGING:
      return new U8(r, a);
    default:
      Br(a.layout);
  }
}
class W8 extends yt.Layer {
  constructor() {
    super();
  }
  addElements(a) {
    return this.renderElements({
      elements: a,
      destroyChildren: !1
    });
  }
  removeAllElements() {
    this.children.slice().forEach((a) => {
      a.destroy();
    });
  }
  removeElementsById(a) {
    a.forEach((n) => {
      const o = this.findOne(`#${n}`);
      o == null || o.destroy();
    });
  }
  async renderElements({
    elements: a,
    destroyChildren: n = !0,
    layerConfig: o
  }) {
    var w, x, v, _;
    n && this.destroyChildren();
    const c = new q8(), s = new T8(), h = (x = (w = o == null ? void 0 : o.spots) == null ? void 0 : w.visible) != null ? x : !0, l = (_ = (v = o == null ? void 0 : o.decorations) == null ? void 0 : v.visible) != null ? _ : !0, g = a.map(
      async (S) => {
        if (W0(S)) {
          const F = await c.createSpot(S);
          return h || F.visible(!1), F;
        }
        const C = await s.createDecoration(S);
        if (C === null)
          throw new Error(
            `Cannot create decoration element from: ${JSON.stringify(S)}`
          );
        return l || C.visible(!1), C;
      }
    ), b = (await Promise.allSettled(g)).reduce((S, C) => {
      switch (C.status) {
        case "rejected":
          console.error(C.reason);
          break;
        case "fulfilled":
          S.push(C.value);
      }
      return S;
    }, []).sort((S, C) => {
      if (S instanceof Ue && C instanceof rr)
        return 1;
      if (S instanceof rr && C instanceof Ue)
        return -1;
      if (S instanceof rr && C instanceof rr) {
        const F = S.getSubType() === ge.LABEL, d = C.getSubType() === ge.LABEL;
        if (F && !d)
          return 1;
        if (!F && d)
          return -1;
      }
      return 0;
    });
    this.add(...b), this.adjustLayerPosition();
  }
  updateOffset(a) {
    this.x(a), xt.setState({
      elementsLayerOffsetX: a
    });
  }
  adjustLayerPosition() {
    if (this.children.length === 0) {
      this.updateOffset(0);
      return;
    }
    const { mapSize: a, background: n, elementsMetaData: o } = xt.getState();
    if (!n.url && o !== null && o.maxX < a.width) {
      const c = a.width / 2 - o.maxX / 2;
      this.updateOffset(c);
    } else
      this.updateOffset(0);
  }
  setSpotsVisibility(a) {
    this.children.forEach((n) => {
      n instanceof Ue && n.visible(a != null ? a : !n.visible());
    });
  }
  setDecorationsVisibility(a) {
    this.children.forEach((n) => {
      n instanceof rr && n.visible(a != null ? a : !n.visible());
    });
  }
  setVisibility(a, n) {
    switch (a) {
      case gr.SPOT: {
        this.setSpotsVisibility(n);
        break;
      }
      case gr.DECORATION: {
        this.setDecorationsVisibility(n);
        break;
      }
      default:
        Br(a);
    }
  }
  toggleVisibility(a) {
    switch (a) {
      case gr.SPOT: {
        this.setSpotsVisibility();
        break;
      }
      case gr.DECORATION: {
        this.setDecorationsVisibility();
        break;
      }
      default:
        Br(a);
    }
  }
}
const D0 = 1754, ca = "black", da = 0.5, pn = class pn extends yt.Layer {
  constructor(a) {
    super(), this.init(a);
  }
  init(a) {
    this.buildPrintPreview(a);
  }
  getPrintPreview() {
    return this.findOne(`#${pn.PRINT_PREVIEW_ID}`);
  }
  buildPrintPreview(a) {
    var v, _, S, C, F, d, f, m;
    const { mapSize: n } = xt.getState(), o = new yt.Rect({
      id: pn.PRINT_PREVIEW_ID,
      x: (_ = (v = a.initialPreview) == null ? void 0 : v.x) != null ? _ : 0,
      y: (C = (S = a.initialPreview) == null ? void 0 : S.y) != null ? C : 0,
      width: (d = (F = a.initialPreview) == null ? void 0 : F.width) != null ? d : 100,
      height: (m = (f = a.initialPreview) == null ? void 0 : f.height) != null ? m : 100,
      draggable: !0
    }), c = o.x(), s = o.y(), h = o.x() + o.width(), l = o.y() + o.height(), g = new yt.Rect({
      x: 0,
      y: 0,
      width: c,
      height: n.height,
      fill: ca,
      opacity: da,
      listening: !1
    }), p = new yt.Rect({
      x: h - 0.5,
      y: 0,
      width: n.width - h,
      height: n.height,
      fill: ca,
      opacity: da,
      listening: !1
    }), b = new yt.Rect({
      x: c,
      y: 0,
      width: o.width(),
      height: s,
      fill: ca,
      opacity: da,
      listening: !1
    }), w = new yt.Rect({
      x: c,
      y: l,
      width: o.width(),
      height: n.height - l,
      fill: ca,
      opacity: da,
      listening: !1
    }), x = new yt.Transformer({
      enabledAnchors: [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right",
        "top-center",
        "middle-right",
        "middle-left",
        "bottom-center"
      ],
      rotateEnabled: !1,
      keepRatio: !1,
      anchorFill: "white",
      anchorStroke: "black",
      borderStroke: "black",
      borderStrokeWidth: 1,
      flipEnabled: !1
    });
    this.add(
      g,
      p,
      b,
      w,
      o,
      x
    ), x.nodes([o]), o.on("transform dragmove", () => {
      const E = this.getPrintPreview();
      if (!E) {
        console.error("printPreview is not initialized");
        return;
      }
      const T = E.width() * E.scaleX(), D = E.height() * E.scaleY(), I = E.x(), L = E.y(), O = E.x() + T, N = E.y() + D;
      g.width(I), p.setAttrs({
        x: O - 0.5,
        width: n.width - O
      }), b.setAttrs({
        x: I,
        y: 0,
        width: T,
        height: L
      }), w.setAttrs({
        x: I,
        y: N,
        width: T,
        height: n.height - N
      });
    }), o.on("transformend dragend", () => {
      a.cb && this.print(this.parent).then(a.cb);
    });
  }
  print(a) {
    return new Promise((n, o) => {
      const c = this.getPrintPreview();
      if (!c) {
        o("printPreview is not initialized");
        return;
      }
      const s = a.scaleX(), h = c.width() * c.scaleX(), l = c.height() * c.scaleY(), g = c.x(), p = c.y(), b = l > h ? D0 / (l * s) : D0 / (h * s);
      this.hide();
      try {
        a.toDataURL({
          x: g * s,
          y: p * s,
          // keep at least a 5x on the image
          pixelRatio: Math.max(b, 5),
          width: h * s,
          height: l * s,
          callback: (w) => {
            this.show(), n({
              data: w,
              x: g,
              y: p,
              width: h,
              height: l,
              pixelRatio: b
            });
          }
        });
      } catch (w) {
        this.show(), o(w);
      }
    });
  }
};
Xe(pn, "PRINT_PREVIEW_ID", "print-preview");
let _a = pn;
const B0 = {
  fit(r, a) {
    const n = r.width / r.height, o = a.width / a.height;
    return n > o ? {
      width: a.width,
      height: a.width / n
    } : {
      width: a.height * n,
      height: a.height
    };
  },
  cover(r, a) {
    const n = r.width / r.height, o = a.width / a.height;
    return n < o ? {
      width: a.width,
      height: a.width / n
    } : {
      width: a.height * n,
      height: a.height
    };
  }
};
function va(r, a) {
  const { draggable: n, fit: o } = xt.getState();
  return o === vn.CONTAIN ? B0.fit(a, {
    width: r.clientWidth,
    height: r.clientHeight
  }) : n ? {
    width: r.clientWidth,
    height: r.clientHeight
  } : B0.cover(a, {
    width: r.clientWidth,
    height: r.clientHeight
  });
}
function V8(r) {
  const a = va(r.container, r.mapSize), n = new yt.Stage({
    container: r.container.id,
    width: a.width,
    height: a.height,
    draggable: r.draggable
  });
  return n.on("click tap", function(o) {
    var s, h;
    const c = o.target.getParent();
    c instanceof Ue && ((h = (s = r.events) == null ? void 0 : s.onMapElementClick) == null || h.call(s, c.id()));
  }), n.on("dragmove", function() {
    var o;
    if ((o = r.events) != null && o.onMapPanZoom) {
      const { x: c, y: s } = n.position(), h = n.scaleX();
      r.events.onMapPanZoom({
        position: {
          x: c / h,
          y: s / h
        },
        zoom: h
      });
    }
  }), n.on("mouseover", () => {
    var h, l, g, p;
    const o = n.getPointerPosition(), { isPrintEnabled: c } = xt.getState();
    if (o === null)
      return;
    let s = n.getIntersection(o);
    if (c) {
      if ((s == null ? void 0 : s.id()) === _a.PRINT_PREVIEW_ID) {
        n.container().style.cursor = "move";
        return;
      }
    } else {
      for (; s !== null; ) {
        if (s instanceof l1) {
          n.container().style.cursor = s.isAvailable ? "pointer" : "not-allowed";
          return;
        }
        if (s instanceof Ue) {
          (l = (h = r.events) == null ? void 0 : h.onMapElementHover) == null || l.call(h, s.id()), n.container().style.cursor = "pointer";
          return;
        }
        if (s instanceof rr) {
          (p = (g = r.events) == null ? void 0 : g.onMapElementHover) == null || p.call(g, s.id());
          return;
        }
        s = s.parent;
      }
      n.container().style.cursor = "move";
    }
  }), n.on("mouseout", () => {
    n.container().style.cursor = "default";
  }), n;
}
const _n = 2;
function Dr(r) {
  const { mapSize: a } = xt.getState(), n = a.width * r.scale, o = a.height * r.scale;
  return {
    x: Math.min(
      0,
      Math.max(r.stageSize.width - n, r.pos.x)
    ),
    y: Math.min(
      0,
      Math.max(r.stageSize.height - o, r.pos.y)
    )
  };
}
function jh(r) {
  const { minScale: a } = xt.getState();
  r.scale({ x: a, y: a }), r.position(
    Dr({
      scale: r.scaleX(),
      pos: r.position(),
      stageSize: { width: r.width(), height: r.height() }
    })
  );
}
function ya(r, a) {
  return Math.min(Math.max(r, a), _n);
}
function U0(r) {
  const { minScale: a } = xt.getState();
  let n = r.scale;
  n < a && (n = a), n > _n && (n = _n);
  const o = {
    x: fn((r.point.x - r.stage.x()) / r.stage.scaleX(), 2),
    y: fn((r.point.y - r.stage.y()) / r.stage.scaleX(), 2)
  };
  r.stage.scale({
    x: n,
    y: n
  });
  const c = Dr({
    scale: n,
    pos: {
      x: fn(r.point.x - o.x * n, 2),
      y: fn(r.point.y - o.y * n, 2)
    },
    stageSize: { width: r.stage.width(), height: r.stage.height() }
  });
  return r.stage.position(c), {
    position: {
      x: o.x,
      y: o.y
    },
    scale: n
  };
}
function z8(r, a) {
  return Math.sqrt(Math.pow(a.x - r.x, 2) + Math.pow(a.y - r.y, 2));
}
function q0(r, a) {
  return {
    x: (r.x + a.x) / 2,
    y: (r.y + a.y) / 2
  };
}
const H0 = 0.2;
yt.hitOnDragEnabled = !0;
const ni = (r, a) => {
  const { fit: n } = xt.getState();
  return (n === vn.CONTAIN ? Math.min : Math.max)(a.width / r.width, a.height / r.height);
};
async function yy(r) {
  var w, x, v, _, S, C, F, d, f;
  const a = document.getElementById(r.opts.containerId);
  if (!a)
    throw new Error("Canvas container not found");
  const n = {
    width: Math.max(a.clientWidth, r.opts.size.width),
    height: Math.max(a.clientHeight, r.opts.size.height)
  }, o = (x = (w = r.opts.print) == null ? void 0 : w.enabled) != null ? x : !1, c = (v = r.opts.draggable) != null ? v : !0;
  xt.setState({
    assetsBaseUrl: r.opts.assetsBaseUrl,
    background: r.opts.background,
    debug: !!r.opts.debug,
    fit: (_ = r.opts.fit) != null ? _ : vn.COVER,
    draggable: c,
    mapSize: n,
    isPrintEnabled: o,
    ...r.opts.elementsMetaData ? { elementsMetaData: r.opts.elementsMetaData } : {}
  });
  const s = V8({
    container: a,
    draggable: c,
    events: r.events,
    mapSize: n
  }), h = ni(n, {
    width: s.width(),
    height: s.height()
  });
  xt.setState({
    minScale: h
  });
  const l = new b8(
    (S = r.opts.layersConfig) == null ? void 0 : S.background
  );
  s.add(l);
  const g = new W8();
  await g.renderElements({
    elements: r.opts.elements,
    layerConfig: (C = r.opts.layersConfig) == null ? void 0 : C.elements
  }), s.add(g);
  let p;
  if (o && (p = new _a({
    initialPreview: (F = r.opts.print) == null ? void 0 : F.initialPreview,
    cb: (d = r.events) == null ? void 0 : d.onPrintPreview
  }), s.add(p)), o)
    s.scale({ x: h, y: h });
  else {
    if (j8(s, (f = r.events) == null ? void 0 : f.onMapPanZoom), r.opts.initialZoom) {
      const m = ya(h, r.opts.initialZoom);
      s.scale({ x: m, y: m });
    }
    r.opts.initialPosition && s.position(
      Dr({
        scale: s.scaleX(),
        pos: {
          x: r.opts.initialPosition.x * s.scaleX(),
          y: r.opts.initialPosition.y * s.scaleY()
        },
        stageSize: {
          height: s.height(),
          width: s.width()
        }
      })
    );
  }
  const b = X6(K8(s, a), 250);
  return window.addEventListener("resize", b), {
    addElements(m) {
      return g.addElements(m);
    },
    destroy() {
      s.destroy();
    },
    getStageInfo() {
      const { fit: m } = xt.getState(), E = s.scaleX();
      return {
        fit: m,
        rect: {
          height: s.height() / E,
          width: s.width() / E,
          x: Math.abs(s.x()) / E,
          y: Math.abs(s.y()) / E
        },
        size: {
          height: s.height(),
          width: s.width()
        },
        zoom: E
      };
    },
    removeAllElements() {
      g.removeAllElements();
    },
    removeElementsById(m) {
      g.removeElementsById(m);
    },
    renderElements(m, E) {
      return g.renderElements({
        elements: m,
        layerConfig: E
      });
    },
    setBackgroundVisibility(m) {
      l.setVisibility(m);
    },
    setDecorationsVisibility(m) {
      g.setVisibility(gr.DECORATION, m);
    },
    setSpotsVisibility(m) {
      g.setVisibility(gr.SPOT, m);
    },
    toggleBackgroundVisibility() {
      l.toggleVisibility();
    },
    toggleDecorationsVisibility() {
      g.toggleVisibility(gr.DECORATION);
    },
    toggleSpotsVisibility() {
      g.toggleVisibility(gr.SPOT);
    },
    updateFit(m) {
      const { mapSize: E } = xt.getState();
      xt.setState({ fit: m });
      const T = va(a, E);
      xt.setState({
        minScale: ni(E, T)
      }), s.size(T), jh(s);
    },
    zoomIn() {
      var D, I;
      const m = s.scaleX(), E = fn(
        Math.min(m + H0, _n),
        2
      ), T = U0({
        scale: E,
        point: {
          x: s.width() / 2,
          y: s.height() / 2
        },
        stage: s
      });
      (I = (D = r.events) == null ? void 0 : D.onMapPanZoom) == null || I.call(D, {
        position: T.position,
        zoom: T.scale
      });
    },
    zoomOut() {
      var I, L;
      const { minScale: m } = xt.getState(), E = s.scaleX(), T = Math.max(m, E - H0), D = U0({
        stage: s,
        scale: T,
        point: {
          x: s.width() / 2,
          y: s.height() / 2
        }
      });
      (L = (I = r.events) == null ? void 0 : I.onMapPanZoom) == null || L.call(I, {
        position: D.position,
        zoom: D.scale
      });
    },
    updateBgSize(m, E) {
      const T = {
        width: Math.max(a.clientWidth, m.width),
        height: Math.max(a.clientHeight, m.height)
      }, D = xt.getState();
      if (C0(T, D.mapSize) && C0(E, {
        width: D.background.width,
        height: D.background.height
      }))
        return;
      const I = va(a, T);
      s.width(I.width), s.height(I.height), xt.setState((L) => ({
        ...L,
        mapSize: T,
        background: {
          ...L.background,
          width: E.width,
          height: E.height
        },
        minScale: ni(m, {
          width: I.width,
          height: I.height
        })
      })), l.updateBgSize(), jh(s);
    },
    highlightElement(m, E) {
      const T = s.findOne(`#${m}`);
      T instanceof Ue && T.highlight(E);
    },
    clearHighlight(m) {
      Array.isArray(m) ? m.forEach((E) => {
        const T = s.findOne(`#${E}`);
        T instanceof Ue && T.clearHighlight();
      }) : g.children.filter((E) => E instanceof Ue).forEach((E) => {
        E.clearHighlight();
      });
    },
    goToPosition(m, E) {
      if (E) {
        const { minScale: T } = xt.getState(), D = ya(T, E);
        s.scale({ x: D, y: D });
      }
      s.position(
        Dr({
          scale: s.scaleX(),
          pos: {
            x: m.x * s.scaleX(),
            y: m.y * s.scaleY()
          },
          stageSize: {
            height: s.height(),
            width: s.width()
          }
        })
      );
    },
    print() {
      if (!p)
        throw new Error("Print mode is not enabled");
      return p.print(s);
    },
    updatePrintPreview(m) {
      var E;
      if (!p)
        throw new Error("Print mode is not enabled");
      p.destroyChildren(), p.buildPrintPreview({
        initialPreview: m,
        cb: (E = r.events) == null ? void 0 : E.onPrintPreview
      });
    },
    handleResize() {
      b();
    }
  };
}
function j8(r, a) {
  const { mapSize: n, minScale: o } = xt.getState(), c = 1.05;
  r.scale({ x: o, y: o }), r.on("wheel", (g) => {
    g.evt.preventDefault();
    const p = r.scaleX(), b = r.getPointerPosition();
    if (!b) return;
    const w = {
      x: (b.x - r.x()) / p,
      y: (b.y - r.y()) / p
    }, x = g.evt.deltaY > 0 ? -1 : 1, { mapSize: v } = xt.getState(), _ = x > 0 ? p * c : p / c, S = ni(v, {
      width: r.width(),
      height: r.height()
    }), C = ya(S, _);
    if (_ > C || _ < S) return;
    r.scale({
      x: C,
      y: C
    });
    const F = b.x - w.x * _, d = b.y - w.y * _, f = {
      x: Math.min(0, F),
      // bound to the left of the bg
      y: Math.min(0, d)
      // bound to the top of the bg
    };
    r.position(
      Dr({
        scale: C,
        pos: f,
        stageSize: {
          height: r.height(),
          width: r.width()
        }
      })
    ), a && a({
      position: {
        x: f.x / C,
        y: f.y / C
      },
      zoom: C
    });
  }), r.dragBoundFunc(
    (g) => Dr({
      stageSize: { width: r.width(), height: r.height() },
      pos: g,
      scale: r.scaleX()
    })
  );
  let s = null, h = 0, l = !1;
  r.on("touchmove", function(g) {
    g.evt.preventDefault();
    const p = g.evt.touches[0], b = g.evt.touches[1];
    if (p && !b && !r.isDragging() && l && (r.startDrag(), l = !1), p && b) {
      r.isDragging() && (l = !0, r.stopDrag());
      const w = {
        x: p.clientX,
        y: p.clientY
      }, x = {
        x: b.clientX,
        y: b.clientY
      };
      if (!s) {
        s = q0(w, x);
        return;
      }
      const v = q0(w, x), _ = z8(w, x);
      h || (h = _);
      const S = r.scaleX() * (_ / h), C = {
        x: (v.x - r.x()) / r.scaleX(),
        y: (v.y - r.y()) / r.scaleX()
      }, F = ni(n, {
        width: r.width(),
        height: r.height()
      }), d = ya(F, S);
      if (r.scale({
        x: d,
        y: d
      }), S >= _n || S <= F)
        return;
      const f = v.x - s.x, m = v.y - s.y, E = {
        x: v.x - C.x * S + f,
        y: v.y - C.y * S + m
      };
      r.position(
        Dr({
          scale: r.scaleX(),
          pos: E,
          stageSize: {
            height: r.height(),
            width: r.width()
          }
        })
      ), h = _, s = v;
    }
  }), r.on("touchend", function() {
    h = 0, s = null;
  });
}
const K8 = (r, a) => () => {
  const n = a.clientWidth, o = a.clientHeight, c = va(a, xt.getState().mapSize);
  r.width(c.width), r.height(c.height), xt.setState((s) => ({
    ...s,
    minScale: ni(s.mapSize, {
      width: n,
      height: o
    })
  })), jh(r);
};
export {
  vn as Fit,
  Pe as SpotLayout,
  a6 as addElementsToClusters,
  yy as init,
  X8 as initializeClusters,
  s6 as updateClustersVisibility,
  $8 as updateRenderedElements
};
